var E2 = Object.defineProperty, P2 = Object.defineProperties;
var A2 = Object.getOwnPropertyDescriptors;
var nn = Object.getOwnPropertySymbols;
var vs = Object.prototype.hasOwnProperty, gs = Object.prototype.propertyIsEnumerable;
var Ut = Math.pow, or = (t, e, o) => e in t ? E2(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o, j = (t, e) => {
  for (var o in e || (e = {}))
    vs.call(e, o) && or(t, o, e[o]);
  if (nn)
    for (var o of nn(e))
      gs.call(e, o) && or(t, o, e[o]);
  return t;
}, R = (t, e) => P2(t, A2(e));
var Be = (t, e) => {
  var o = {};
  for (var n in t)
    vs.call(t, n) && e.indexOf(n) < 0 && (o[n] = t[n]);
  if (t != null && nn)
    for (var n of nn(t))
      e.indexOf(n) < 0 && gs.call(t, n) && (o[n] = t[n]);
  return o;
};
var st = (t, e, o) => or(t, typeof e != "symbol" ? e + "" : e, o);
var Q = (t, e, o) => new Promise((n, r) => {
  var s = (c) => {
    try {
      a(o.next(c));
    } catch (u) {
      r(u);
    }
  }, i = (c) => {
    try {
      a(o.throw(c));
    } catch (u) {
      r(u);
    }
  }, a = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(s, i);
  a((o = o.apply(t, e)).next());
});
import { openBlock as d, createElementBlock as h, createElementVNode as l, createStaticVNode as W, defineComponent as A, computed as z, createBlock as P, unref as _, normalizeClass as S, Transition as Ro, mergeProps as Oe, withCtx as O, renderSlot as C, createVNode as $, withDirectives as se, vShow as yt, pushScopeId as L2, popScopeId as H2, nextTick as En, normalizeProps as V2, guardReactiveProps as F2, withScopeId as I2, resolveComponent as be, normalizeStyle as re, withKeys as q, Fragment as oe, createCommentVNode as E, ref as I, createApp as D2, h as N2, toDisplayString as F, toRefs as Ke, resolveDynamicComponent as ro, renderList as ce, withModifiers as _e, onUpdated as R2, onMounted as ht, createTextVNode as K, vModelText as yi, watch as Je, onUnmounted as xi, Teleport as Ur, TransitionGroup as yo, getCurrentScope as q2, onScopeDispose as W2, isRef as U2, shallowRef as Z2, watchEffect as Ci, getCurrentInstance as G2, useCssVars as Mi, reactive as Y2, createSlots as X2, onBeforeMount as K2, defineAsyncComponent as J2, toHandlers as Q2 } from "vue";
var ec = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function tc(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
(function(t, e) {
  (function(o, n) {
    n();
  })(ec, function() {
    function o(r) {
      var s = !0, i = !1, a = null, c = {
        text: !0,
        search: !0,
        url: !0,
        tel: !0,
        email: !0,
        password: !0,
        number: !0,
        date: !0,
        month: !0,
        week: !0,
        time: !0,
        datetime: !0,
        "datetime-local": !0
      };
      function u(b) {
        return !!(b && b !== document && b.nodeName !== "HTML" && b.nodeName !== "BODY" && "classList" in b && "contains" in b.classList);
      }
      function f(b) {
        var N = b.type, Z = b.tagName;
        return !!(Z === "INPUT" && c[N] && !b.readOnly || Z === "TEXTAREA" && !b.readOnly || b.isContentEditable);
      }
      function p(b) {
        b.classList.contains("focus-visible") || (b.classList.add("focus-visible"), b.setAttribute("data-focus-visible-added", ""));
      }
      function v(b) {
        b.hasAttribute("data-focus-visible-added") && (b.classList.remove("focus-visible"), b.removeAttribute("data-focus-visible-added"));
      }
      function m(b) {
        b.metaKey || b.altKey || b.ctrlKey || (u(r.activeElement) && p(r.activeElement), s = !0);
      }
      function g(b) {
        s = !1;
      }
      function w(b) {
        u(b.target) && (s || f(b.target)) && p(b.target);
      }
      function y(b) {
        u(b.target) && (b.target.classList.contains("focus-visible") || b.target.hasAttribute("data-focus-visible-added")) && (i = !0, window.clearTimeout(a), a = window.setTimeout(function() {
          i = !1;
        }, 100), v(b.target));
      }
      function M(b) {
        document.visibilityState === "hidden" && (i && (s = !0), B());
      }
      function B() {
        document.addEventListener("mousemove", x), document.addEventListener("mousedown", x), document.addEventListener("mouseup", x), document.addEventListener("pointermove", x), document.addEventListener("pointerdown", x), document.addEventListener("pointerup", x), document.addEventListener("touchmove", x), document.addEventListener("touchstart", x), document.addEventListener("touchend", x);
      }
      function k() {
        document.removeEventListener("mousemove", x), document.removeEventListener("mousedown", x), document.removeEventListener("mouseup", x), document.removeEventListener("pointermove", x), document.removeEventListener("pointerdown", x), document.removeEventListener("pointerup", x), document.removeEventListener("touchmove", x), document.removeEventListener("touchstart", x), document.removeEventListener("touchend", x);
      }
      function x(b) {
        b.target.nodeName && b.target.nodeName.toLowerCase() === "html" || (s = !1, k());
      }
      document.addEventListener("keydown", m, !0), document.addEventListener("mousedown", g, !0), document.addEventListener("pointerdown", g, !0), document.addEventListener("touchstart", g, !0), document.addEventListener("visibilitychange", M, !0), B(), r.addEventListener("focus", w, !0), r.addEventListener("blur", y, !0), r.nodeType === Node.DOCUMENT_FRAGMENT_NODE && r.host ? r.host.setAttribute("data-js-focus-visible", "") : r.nodeType === Node.DOCUMENT_NODE && (document.documentElement.classList.add("js-focus-visible"), document.documentElement.setAttribute("data-js-focus-visible", ""));
    }
    if (typeof window != "undefined" && typeof document != "undefined") {
      window.applyFocusVisiblePolyfill = o;
      var n;
      try {
        n = new CustomEvent("focus-visible-polyfill-ready");
      } catch (r) {
        n = document.createEvent("CustomEvent"), n.initCustomEvent("focus-visible-polyfill-ready", !1, !1, {});
      }
      window.dispatchEvent(n);
    }
    typeof document != "undefined" && o(document);
  });
})();
const oc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "actions",
  viewBox: "0 0 20 20"
};
function $i(t, e) {
  return d(), h("svg", oc, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.917 2.5a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333m3 1.667c0-.46.373-.834.833-.834h9.24a.833.833 0 0 1 0 1.667H5.75a.833.833 0 0 1-.833-.833M6.96 10c0-.46.373-.833.833-.833h9.241a.833.833 0 0 1 0 1.666h-9.24A.833.833 0 0 1 6.96 10m2.878 5a.833.833 0 0 0 0 1.667h9.24a.833.833 0 0 0 0-1.667zM4 8.333a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334m2.083 5.834a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const nc = { render: $i }, rc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nc,
  render: $i
}, Symbol.toStringTag, { value: "Module" })), sc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "add-reaction",
  viewBox: "-0.625 -0.625 17.5 17.5"
};
function Si(t, e) {
  return d(), h("svg", sc, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-width="1.25"><path stroke-linejoin="round" d="M12.769 6.674a6.08 6.08 0 1 0-5.67 6.066"></path><path stroke-linejoin="round" d="M3.603 7.61c.468 1.683 2.339 2.712 4.022 2.244 1.028-.374 1.87-1.216 2.15-2.244"></path><path d="M4.21 4.826v.683m4.957-.683v.683"></path><path stroke-linejoin="round" d="M12.739 9.852v5.804m-2.902-2.902h5.804"></path></g>', 1)
  ]));
}
const ic = { render: Si }, ac = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ic,
  render: Si
}, Symbol.toStringTag, { value: "Module" })), lc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "add-square",
  viewBox: "0 0 20 20"
};
function ji(t, e) {
  return d(), h("svg", lc, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M10 6.25v7.5M6.25 10h7.5M16.875.625H3.125a2.5 2.5 0 0 0-2.5 2.5v13.75a2.5 2.5 0 0 0 2.5 2.5h13.75a2.5 2.5 0 0 0 2.5-2.5V3.125a2.5 2.5 0 0 0-2.5-2.5"
    }, null, -1)
  ]));
}
const dc = { render: ji }, uc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dc,
  render: ji
}, Symbol.toStringTag, { value: "Module" })), cc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "add",
  viewBox: "0 0 20 20"
};
function Oi(t, e) {
  return d(), h("svg", cc, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.5 10h15M10 2.5v15"
    }, null, -1)
  ]));
}
const hc = { render: Oi }, fc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hc,
  render: Oi
}, Symbol.toStringTag, { value: "Module" })), pc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "alarm-bell",
  viewBox: "0 0 20 20"
};
function Ti(t, e) {
  return d(), h("svg", pc, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M8.333 18.125a1.74 1.74 0 0 0 3.338 0M10 2.5V.625M10 2.5a6.25 6.25 0 0 1 6.25 6.25c0 5.872 1.25 6.875 1.25 6.875h-15s1.25-1.597 1.25-6.875A6.25 6.25 0 0 1 10 2.5m-9 1L4.125 1M18.5 3.5 15.375 1"
    }, null, -1)
  ]));
}
const mc = { render: Ti }, vc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mc,
  render: Ti
}, Symbol.toStringTag, { value: "Module" })), gc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "alarm-clock",
  viewBox: "0 0 20 20"
};
function zi(t, e) {
  return d(), h("svg", gc, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M2.5 10.625a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0m2.5 8.75 1.155-2.31M10 10.625H7.174M10 6.25v4.375m-8.75-7.5 3.125-2.5M15 19.375l-1.155-2.31m4.905-13.94-3.125-2.5"
    }, null, -1)
  ]));
}
const _c = { render: zi }, wc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _c,
  render: zi
}, Symbol.toStringTag, { value: "Module" })), bc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "alert-circle",
  viewBox: "0 0 20 20"
};
function Bi(t, e) {
  return d(), h("svg", bc, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M10 13.75a.312.312 0 1 0 0 .624.312.312 0 0 0 0-.624"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.25",
      d: "M10 11.25V4.375"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-width": "1.25",
      d: "M.625 10a9.375 9.375 0 1 0 18.75 0 9.375 9.375 0 0 0-18.75 0Z"
    }, null, -1)
  ]));
}
const kc = { render: Bi }, yc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kc,
  render: Bi
}, Symbol.toStringTag, { value: "Module" })), xc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "align-bottom",
  viewBox: "0 0 20 20"
};
function Ei(t, e) {
  return d(), h("svg", xc, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3.11 1.458v14.584c0 .46.373.833.833.833h3.349c.46 0 .833-.373.833-.833V1.458a.833.833 0 0 0-.833-.833H3.943a.833.833 0 0 0-.833.833m8.765 6.875v7.709c0 .46.373.833.833.833h3.349c.46 0 .833-.373.833-.833V8.333a.833.833 0 0 0-.833-.833h-3.349a.833.833 0 0 0-.833.833m7.5 11.042H.625"
    }, null, -1)
  ]));
}
const Cc = { render: Ei }, Mc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cc,
  render: Ei
}, Symbol.toStringTag, { value: "Module" })), $c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "align-horizontal",
  viewBox: "0 0 20 20"
};
function Pi(t, e) {
  return d(), h("svg", $c, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M10 3.125v-2.5m0 11.25v-3.75m0 11.25v-2.5m-7.292-8.75h14.584c.46 0 .833-.373.833-.833V3.958a.833.833 0 0 0-.833-.833H2.708a.833.833 0 0 0-.833.833v3.334c0 .46.373.833.833.833m2.5 8.75h9.584c.46 0 .833-.373.833-.833v-3.334a.833.833 0 0 0-.833-.833H5.208a.833.833 0 0 0-.833.833v3.334c0 .46.373.833.833.833" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M20 0v20H0V0z"
        })
      ])
    ], -1)
  ]));
}
const Sc = { render: Pi }, jc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sc,
  render: Pi
}, Symbol.toStringTag, { value: "Module" })), Oc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "align-left",
  viewBox: "0 0 20 20"
};
function Ai(t, e) {
  return d(), h("svg", Oc, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.542 11.875H3.958a.833.833 0 0 0-.833.833v3.349c0 .46.373.833.833.833h14.584c.46 0 .833-.373.833-.833v-3.349a.833.833 0 0 0-.833-.833M11.667 3.11H3.958a.833.833 0 0 0-.833.833v3.349c0 .46.373.833.833.833h7.709c.46 0 .833-.373.833-.833V3.943a.833.833 0 0 0-.833-.833M.625.625v18.75"
    }, null, -1)
  ]));
}
const Tc = { render: Ai }, zc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Tc,
  render: Ai
}, Symbol.toStringTag, { value: "Module" })), Bc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "align-right",
  viewBox: "0 0 20 20"
};
function Li(t, e) {
  return d(), h("svg", Bc, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.458 16.89h14.584c.46 0 .833-.373.833-.833v-3.349a.833.833 0 0 0-.833-.833H1.458a.833.833 0 0 0-.833.833v3.349c0 .46.373.833.833.833m6.875-8.765h7.709c.46 0 .833-.373.833-.833V3.943a.833.833 0 0 0-.833-.833H8.333a.833.833 0 0 0-.833.833v3.349c0 .46.373.833.833.833m11.042-7.5v18.75"
    }, null, -1)
  ]));
}
const Ec = { render: Li }, Pc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ec,
  render: Li
}, Symbol.toStringTag, { value: "Module" })), Ac = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "align-top",
  viewBox: "0 0 20 20"
};
function Hi(t, e) {
  return d(), h("svg", Ac, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M8.125 18.542V3.958a.833.833 0 0 0-.833-.833H3.943a.833.833 0 0 0-.833.833v14.584c0 .46.373.833.833.833h3.349c.46 0 .833-.373.833-.833m8.765-6.875V3.958a.833.833 0 0 0-.833-.833h-3.349a.833.833 0 0 0-.833.833v7.709c0 .46.373.833.833.833h3.349c.46 0 .833-.373.833-.833M19.375.625H.625"
    }, null, -1)
  ]));
}
const Lc = { render: Hi }, Hc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Lc,
  render: Hi
}, Symbol.toStringTag, { value: "Module" })), Vc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "align",
  viewBox: "0 0 20 20"
};
function Vi(t, e) {
  return d(), h("svg", Vc, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3.125 10h-2.5m11.25 0h-3.75m11.25 0h-2.5m-8.75 7.292V2.708a.833.833 0 0 0-.833-.833H3.958a.833.833 0 0 0-.833.833v14.584c0 .46.373.833.833.833h3.334c.46 0 .833-.373.833-.833m8.75-2.5V5.208a.833.833 0 0 0-.833-.833h-3.334a.833.833 0 0 0-.833.833v9.584c0 .46.373.833.833.833h3.334c.46 0 .833-.373.833-.833"
    }, null, -1)
  ]));
}
const Fc = { render: Vi }, Ic = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fc,
  render: Vi
}, Symbol.toStringTag, { value: "Module" })), Dc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "analytics-heart",
  viewBox: "0 0 20 20"
};
function Fi(t, e) {
  return d(), h("svg", Dc, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M19.375 15V9.375H13.75"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m19.375 9.375-6.616 6.616a1.25 1.25 0 0 1-1.768 0l-2.607-2.607a1.25 1.25 0 0 0-1.768 0L.625 19.375m5-10L1.363 4.929a2.52 2.52 0 0 1-.471-2.91v0a2.52 2.52 0 0 1 4.037-.655l.696.696.696-.696a2.522 2.522 0 0 1 4.038.655v0a2.52 2.52 0 0 1-.472 2.91z"
    }, null, -1)
  ]));
}
const Nc = { render: Fi }, Rc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nc,
  render: Fi
}, Symbol.toStringTag, { value: "Module" })), qc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "analytics",
  viewBox: "0 0 20 20"
};
function Ii(t, e) {
  return d(), h("svg", qc, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M19.375 10.625V5H13.75"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m19.375 5-6.616 6.616a1.25 1.25 0 0 1-1.768 0L8.384 9.009a1.25 1.25 0 0 0-1.768 0L.625 15"
    }, null, -1)
  ]));
}
const Wc = { render: Ii }, Uc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wc,
  render: Ii
}, Symbol.toStringTag, { value: "Module" })), Zc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "archive",
  viewBox: "0 0 20 20"
};
function Di(t, e) {
  return d(), h("svg", Zc, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M14.308 13.125a4.998 4.998 0 0 1-8.616 0H1.875a1.25 1.25 0 0 0-1.25 1.25v3.75a1.25 1.25 0 0 0 1.25 1.25h16.25a1.25 1.25 0 0 0 1.25-1.25v-3.75a1.25 1.25 0 0 0-1.25-1.25zm2.567-.208V1.875a1.25 1.25 0 0 0-1.25-1.25H4.375a1.25 1.25 0 0 0-1.25 1.25v11.042m3.333-8.959h2.917M6.458 6.875h7.084M6.458 9.792h7.084" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const Gc = { render: Di }, Yc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gc,
  render: Di
}, Symbol.toStringTag, { value: "Module" })), Xc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "data-token-name": "arrow-bar-left",
  viewBox: "-0.625 -0.625 20 20"
};
function Ni(t, e) {
  return d(), h("svg", Xc, e[0] || (e[0] = [
    l("path", {
      "stroke-width": "1.25",
      d: "M7.813 9.375h7.812m-7.812 0 3.125 3.125M7.813 9.375l3.125-3.125M3.125 3.125v12.5"
    }, null, -1)
  ]));
}
const Kc = { render: Ni }, Jc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Kc,
  render: Ni
}, Symbol.toStringTag, { value: "Module" })), Qc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "data-token-name": "arrow-bar-right",
  viewBox: "0 0 20 20"
};
function Ri(t, e) {
  return d(), h("svg", Qc, e[0] || (e[0] = [
    l("path", {
      "stroke-width": "1.25",
      d: "M4.375 9.375h7.813m0 0L9.063 12.5m3.125-3.125L9.063 6.25m7.812-3.125v12.5"
    }, null, -1)
  ]));
}
const e5 = { render: Ri }, t5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e5,
  render: Ri
}, Symbol.toStringTag, { value: "Module" })), o5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-bend-down-left",
  viewBox: "0 0 20 20"
};
function qi(t, e) {
  return d(), h("svg", o5, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m4.375 18.123-3.75-3.75 3.75-3.75"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 14.373h12.5a6.25 6.25 0 0 0 0-12.5h-5"
    }, null, -1)
  ]));
}
const n5 = { render: qi }, r5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n5,
  render: qi
}, Symbol.toStringTag, { value: "Module" })), s5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-circle-down",
  viewBox: "0 0 20 20"
};
function Wi(t, e) {
  return d(), h("svg", s5, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.875 11.875 10 15l3.125-3.125M10 5.625V15"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 10a9.375 9.375 0 1 0 18.75 0 9.375 9.375 0 0 0-18.75 0"
    }, null, -1)
  ]));
}
const i5 = { render: Wi }, a5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: i5,
  render: Wi
}, Symbol.toStringTag, { value: "Module" })), l5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-collapse",
  viewBox: "0 0 20 20"
};
function Ui(t, e) {
  return d(), h("svg", l5, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "m19.375.623-5 5m-8.75 13.75v-5h-5M14.375.623v5h5m-13.75 8.75-5 5m0-18.75 5 5m8.75 13.75v-5h5M5.625.623v5h-5m13.75 8.75 5 5" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const d5 = { render: Ui }, u5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: d5,
  render: Ui
}, Symbol.toStringTag, { value: "Module" })), c5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-cross",
  viewBox: "0 0 20 20"
};
function Zi(t, e) {
  return d(), h("svg", c5, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M10 .625v18.75M7.5 3.125l2.5-2.5 2.5 2.5m-5 13.75 2.5 2.5 2.5-2.5M19.375 10H.625m16.25-2.5 2.5 2.5-2.5 2.5m-13.75-5L.625 10l2.5 2.5" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const h5 = { render: Zi }, f5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: h5,
  render: Zi
}, Symbol.toStringTag, { value: "Module" })), p5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-down-lines",
  viewBox: "0 0 20 20"
};
function Gi(t, e) {
  return d(), h("svg", p5, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-width="1.25" clip-path="url(#a)"><path stroke-linejoin="round" d="M6.2 19.398v-18m-3.6 14.4 3.6 3.6 3.6-3.6"></path><path d="M9.4 5.4h8.4M9.4 2.2H19M9.4 8.6h6.4m-6.4 3.2h4.8"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const m5 = { render: Gi }, v5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: m5,
  render: Gi
}, Symbol.toStringTag, { value: "Module" })), g5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "data-token-name": "arrow-down",
  viewBox: "0 0 20 20"
};
function Yi(t, e) {
  return d(), h("svg", g5, e[0] || (e[0] = [
    l("path", {
      "fill-rule": "evenodd",
      d: "M10 2.375c.345 0 .625.28.625.625v14a.625.625 0 1 1-1.25 0V3c0-.345.28-.625.625-.625",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      d: "M2.543 10.038a.625.625 0 0 1 .883-.03L10 16.143l6.574-6.135a.625.625 0 0 1 .852.914l-7 6.533a.625.625 0 0 1-.852 0l-7-6.533a.625.625 0 0 1-.03-.884Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const _5 = { render: Yi }, w5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _5,
  render: Yi
}, Symbol.toStringTag, { value: "Module" })), b5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-expand-horizontal",
  viewBox: "0 0 20 20"
};
function Xi(t, e) {
  return d(), h("svg", b5, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M.627 9.998h6.875m5 0h6.875M3.752 6.873.627 9.998l3.125 3.125m12.5-6.25 3.125 3.125-3.125 3.125m-6.25-6.875v7.5" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const k5 = { render: Xi }, y5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: k5,
  render: Xi
}, Symbol.toStringTag, { value: "Module" })), x5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-expand",
  viewBox: "0 0 20 20"
};
function Ki(t, e) {
  return d(), h("svg", x5, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "m8.125 11.873-7.5 7.5m18.75-13.125V.623H13.75M.625 13.748v5.625H6.25M19.375.623l-7.5 7.5m0 3.75 7.5 7.5M.625 6.248V.623H6.25m13.125 13.125v5.625H13.75M.625.623l7.5 7.5" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const C5 = { render: Ki }, M5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C5,
  render: Ki
}, Symbol.toStringTag, { value: "Module" })), $5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-left",
  viewBox: "0 0 20 20"
};
function Ji(t, e) {
  return d(), h("svg", $5, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16 10H4m5.6-6L4 10l5.6 6"
    }, null, -1)
  ]));
}
const S5 = { render: Ji }, j5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: S5,
  render: Ji
}, Symbol.toStringTag, { value: "Module" })), O5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-redo",
  viewBox: "0 0 20 20"
};
function Qi(t, e) {
  return d(), h("svg", O5, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m15 3.75 4.375 4.375L15 12.5"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M19.375 8.125h-17.5a1.25 1.25 0 0 0-1.25 1.25v7.5"
    }, null, -1)
  ]));
}
const T5 = { render: Qi }, z5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: T5,
  render: Qi
}, Symbol.toStringTag, { value: "Module" })), B5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-right",
  viewBox: "0 0 20 20"
};
function ea(t, e) {
  return d(), h("svg", B5, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 10h12m-5.6 6 5.6-6-5.6-6"
    }, null, -1)
  ]));
}
const E5 = { render: ea }, P5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E5,
  render: ea
}, Symbol.toStringTag, { value: "Module" })), A5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-undo",
  viewBox: "0 0 20 20"
};
function ta(t, e) {
  return d(), h("svg", A5, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M5 3.75.625 8.125 5 12.5"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 8.125h17.5a1.25 1.25 0 0 1 1.25 1.25v7.5"
    }, null, -1)
  ]));
}
const L5 = { render: ta }, H5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L5,
  render: ta
}, Symbol.toStringTag, { value: "Module" })), V5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrow-up-lines",
  viewBox: "0 0 20 20"
};
function oa(t, e) {
  return d(), h("svg", V5, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-width="1.25" clip-path="url(#a)"><path stroke-linejoin="round" d="M6.201 1.398v18M9.8 4.998l-3.6-3.6-3.6 3.6"></path><path d="M9.4 12.4h8.4M9.4 9.2H19m-9.6 6.4h6.4m-6.4 3.2h4.8"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const F5 = { render: oa }, I5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F5,
  render: oa
}, Symbol.toStringTag, { value: "Module" })), D5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "arrows-left-and-right",
  viewBox: "0 0 20 20"
};
function na(t, e) {
  return d(), h("svg", D5, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M8.75 12.5h10.625m-2.5-2.5 2.5 2.5-2.5 2.5M11.25 7.5H.625m2.5 2.5-2.5-2.5 2.5-2.5"
    }, null, -1)
  ]));
}
const N5 = { render: na }, R5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: N5,
  render: na
}, Symbol.toStringTag, { value: "Module" })), q5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "attachment",
  viewBox: "0 0 20 20"
};
function ra(t, e) {
  return d(), h("svg", q5, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M15.625 13.124V6.25a5.625 5.625 0 1 0-11.25 0v9.375a3.75 3.75 0 1 0 7.5 0V6.25a1.875 1.875 0 1 0-3.75 0v8.125"
    }, null, -1)
  ]));
}
const W5 = { render: ra }, U5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: W5,
  render: ra
}, Symbol.toStringTag, { value: "Module" })), Z5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "bars",
  viewBox: "0 0 20 20"
};
function sa(t, e) {
  return d(), h("svg", Z5, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.21 17.617h17.58M5.313 9.414H2.969a.586.586 0 0 0-.586.586v7.617h3.515V10a.586.586 0 0 0-.585-.586m5.859-7.031H8.828a.586.586 0 0 0-.586.586v14.648h3.516V2.97a.586.586 0 0 0-.586-.586Zm5.859 3.515h-2.343a.586.586 0 0 0-.586.586v11.133h3.515V6.484a.586.586 0 0 0-.586-.586"
    }, null, -1)
  ]));
}
const G5 = { render: sa }, Y5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G5,
  render: sa
}, Symbol.toStringTag, { value: "Module" })), X5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "block",
  viewBox: "0 0 20 20"
};
function ia(t, e) {
  return d(), h("svg", X5, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 10a9.375 9.375 0 1 0 18.75 0 9.375 9.375 0 0 0-18.75 0m2.745 6.63L16.63 3.37"
    }, null, -1)
  ]));
}
const K5 = { render: ia }, J5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: K5,
  render: ia
}, Symbol.toStringTag, { value: "Module" })), Q5 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "bold-check-mark",
  viewBox: "0 0 22 19"
};
function aa(t, e) {
  return d(), h("svg", Q5, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "M20 2 8.808 16.922 2 10.118"
    }, null, -1)
  ]));
}
const eh = { render: aa }, th = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: eh,
  render: aa
}, Symbol.toStringTag, { value: "Module" })), oh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "calendar-edit",
  viewBox: "0 0 20 20"
};
function la(t, e) {
  return d(), h("svg", oh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.858 12.322 12.5 18.68l-3.125.625L10 16.18l6.358-6.358a1.763 1.763 0 0 1 2.494 0l.006.006a1.76 1.76 0 0 1 0 2.494M7.5 14.375H1.875a1.25 1.25 0 0 1-1.25-1.25V3.137a1.25 1.25 0 0 1 1.25-1.25h11.25a1.25 1.25 0 0 1 1.25 1.25v3.738"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 5.625h13.75"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M4.37 3.125v-2.5m6.25 2.5v-2.5"
    }, null, -1)
  ]));
}
const nh = { render: la }, rh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nh,
  render: la
}, Symbol.toStringTag, { value: "Module" })), sh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "calendar-money",
  viewBox: "0 0 20 20"
};
function da(t, e) {
  return d(), h("svg", sh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.125 3.125H1.875c-.69 0-1.25.56-1.25 1.25v13.75c0 .69.56 1.25 1.25 1.25h16.25c.69 0 1.25-.56 1.25-1.25V4.375c0-.69-.56-1.25-1.25-1.25Zm-17.5 5h18.75"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M5.625 5V.625M14.375 5V.625M11.25 11.25H9.556a1.118 1.118 0 0 0-.417 2.157l1.72.687a1.118 1.118 0 0 1-.417 2.156H8.75m1.25-5v-.625m0 6.25v-.625"
    }, null, -1)
  ]));
}
const ih = { render: da }, ah = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ih,
  render: da
}, Symbol.toStringTag, { value: "Module" })), lh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "calendar-search",
  viewBox: "0 0 20 20"
};
function ua(t, e) {
  return d(), h("svg", lh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.232 14.355H1.875a1.25 1.25 0 0 1-1.25-1.25V3.123a1.25 1.25 0 0 1 1.25-1.25h11.25a1.25 1.25 0 0 1 1.25 1.25v3.112"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.63 5.623h13.75"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M4.375 3.123V.625m6.25 2.498V.625M8.75 13.13a4.375 4.375 0 1 0 8.75 0 4.375 4.375 0 0 0-8.75 0m10.625 6.245-3.157-3.154"
    }, null, -1)
  ]));
}
const dh = { render: ua }, uh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dh,
  render: ua
}, Symbol.toStringTag, { value: "Module" })), ch = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "calendar",
  viewBox: "0 0 16 16"
};
function ca(t, e) {
  return d(), h("svg", ch, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M14.501 2.5h-13a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1m-14 4h15m-11-2.5V.5m7 3.5V.5" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]));
}
const hh = { render: ca }, fh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hh,
  render: ca
}, Symbol.toStringTag, { value: "Module" })), ph = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "camera",
  viewBox: "0 0 20 20"
};
function ha(t, e) {
  return d(), h("svg", ph, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M10.625 4.384h-7.5a2.5 2.5 0 0 0-2.5 2.5v6.25a2.5 2.5 0 0 0 2.5 2.5h7.5a2.5 2.5 0 0 0 2.5-2.5v-6.25a2.5 2.5 0 0 0-2.5-2.5m5 8.126 2.846 1.422a.625.625 0 0 0 .904-.56V6.646a.625.625 0 0 0-.904-.558L15.625 7.51"
    }, null, -1)
  ]));
}
const mh = { render: ha }, vh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mh,
  render: ha
}, Symbol.toStringTag, { value: "Module" })), gh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "card",
  viewBox: "0 0 20 20"
};
function fa(t, e) {
  return d(), h("svg", gh, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M6.875.625h-5c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25m0 11.25h-5c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25M18.125.625h-5c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25m0 11.25h-5c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const _h = { render: fa }, wh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _h,
  render: fa
}, Symbol.toStringTag, { value: "Module" })), bh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "chat-bubble",
  viewBox: "0 0 20 20"
};
function pa(t, e) {
  return d(), h("svg", bh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.125 15.625h-8.75l-5 3.75v-3.75h-2.5a1.25 1.25 0 0 1-1.25-1.25v-12.5a1.25 1.25 0 0 1 1.25-1.25h16.25a1.25 1.25 0 0 1 1.25 1.25v12.5a1.25 1.25 0 0 1-1.25 1.25"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.25 7.813a.312.312 0 1 0 0 .624.312.312 0 0 0 0-.624m3.75 0a.312.312 0 1 0 0 .624.312.312 0 0 0 0-.624m3.75 0a.312.312 0 1 0 0 .624.312.312 0 0 0 0-.624"
    }, null, -1)
  ]));
}
const kh = { render: pa }, yh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kh,
  render: pa
}, Symbol.toStringTag, { value: "Module" })), xh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "check-circle-fried",
  viewBox: "0 0 20 20"
};
function ma(t, e) {
  return d(), h("svg", xh, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="m6 10.955 1.633 2.318a.7.7 0 0 0 1.138.034L14 6.69"></path><path d="M.625 10a9.375 9.375 0 1 0 18.75 0 9.375 9.375 0 0 0-18.75 0"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const Ch = { render: ma }, Mh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ch,
  render: ma
}, Symbol.toStringTag, { value: "Module" })), $h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "check-circle",
  viewBox: "0 0 20 20"
};
function va(t, e) {
  return d(), h("svg", $h, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m5.625 7.5 2.745 3.843a1.27 1.27 0 0 0 2.012.075L19.375.624"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M13.986 3.187a8.74 8.74 0 1 0 3.347 3.794"
    }, null, -1)
  ]));
}
const Sh = { render: va }, jh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sh,
  render: va
}, Symbol.toStringTag, { value: "Module" })), Oh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "check-mark",
  viewBox: "0 0 20 17"
};
function ga(t, e) {
  return d(), h("svg", Oh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M19 1 7.808 15.922 1 9.118"
    }, null, -1)
  ]));
}
const Th = { render: ga }, zh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Th,
  render: ga
}, Symbol.toStringTag, { value: "Module" })), Bh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "checkbox",
  viewBox: "0 0 20 20"
};
function _a(t, e) {
  return d(), h("svg", Bh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.125.624H1.875c-.69 0-1.25.56-1.25 1.25v16.25c0 .69.56 1.25 1.25 1.25h16.25c.69 0 1.25-.56 1.25-1.25V1.874c0-.69-.56-1.25-1.25-1.25"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m14.598 6.422-5.11 7.154L5.4 9.488"
    }, null, -1)
  ]));
}
const Eh = { render: _a }, Ph = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Eh,
  render: _a
}, Symbol.toStringTag, { value: "Module" })), Ah = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "chevron-down-line",
  viewBox: "0 0 20 20"
};
function wa(t, e) {
  return d(), h("svg", Ah, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m2.8 6.398 6.965 7.109a.343.343 0 0 0 .469 0L17.2 6.398"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.25",
      d: "M.625 18.375h18.75"
    }, null, -1)
  ]));
}
const Lh = { render: wa }, Hh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Lh,
  render: wa
}, Symbol.toStringTag, { value: "Module" })), Vh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "chevron-down",
  viewBox: "0 0 20 20"
};
function ba(t, e) {
  return d(), h("svg", Vh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m2.8 6.398 6.965 7.109a.343.343 0 0 0 .469 0L17.2 6.398"
    }, null, -1)
  ]));
}
const Fh = { render: ba }, Ih = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fh,
  render: ba
}, Symbol.toStringTag, { value: "Module" })), Dh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "chevron-left",
  viewBox: "0 0 20 20"
};
function ka(t, e) {
  return d(), h("svg", Dh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M13.602 2.8 6.493 9.765a.3.3 0 0 0-.07.106.34.34 0 0 0 .07.363l7.11 6.966"
    }, null, -1)
  ]));
}
const Nh = { render: ka }, Rh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nh,
  render: ka
}, Symbol.toStringTag, { value: "Module" })), qh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "chevron-right",
  viewBox: "0 0 20 20"
};
function ya(t, e) {
  return d(), h("svg", qh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m6.398 17.2 7.109-6.965a.34.34 0 0 0 0-.469L6.397 2.8"
    }, null, -1)
  ]));
}
const Wh = { render: ya }, Uh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wh,
  render: ya
}, Symbol.toStringTag, { value: "Module" })), Zh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "chevron-up-and-down",
  viewBox: "0 0 20 20"
};
function xa(t, e) {
  return d(), h("svg", Zh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M16.875 7.242 10.442.81a.625.625 0 0 0-.884 0L3.125 7.242m13.75 5.518-6.433 6.432a.626.626 0 0 1-.884 0l-6.433-6.433"
    }, null, -1)
  ]));
}
const Gh = { render: xa }, Yh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gh,
  render: xa
}, Symbol.toStringTag, { value: "Module" })), Xh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "chevron-up-line",
  viewBox: "0 0 20 20"
};
function Ca(t, e) {
  return d(), h("svg", Xh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m17.2 13.602-6.965-7.109a.3.3 0 0 0-.106-.07.34.34 0 0 0-.363.07L2.8 13.602"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.25",
      d: "M19.375 1.625H.625"
    }, null, -1)
  ]));
}
const Kh = { render: Ca }, Jh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Kh,
  render: Ca
}, Symbol.toStringTag, { value: "Module" })), Qh = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "chevron-up",
  viewBox: "0 0 20 20"
};
function Ma(t, e) {
  return d(), h("svg", Qh, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m17.2 13.602-6.965-7.109a.3.3 0 0 0-.106-.07.34.34 0 0 0-.363.07L2.8 13.603"
    }, null, -1)
  ]));
}
const e3 = { render: Ma }, t3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e3,
  render: Ma
}, Symbol.toStringTag, { value: "Module" })), o3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "click",
  viewBox: "0 0 20 20"
};
function $a(t, e) {
  return d(), h("svg", o3, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M7.18 4.056A3.374 3.374 0 0 1 10.703 6.6a.674.674 0 1 0 1.31-.324 4.72 4.72 0 0 0-4.919-3.568 4.804 4.804 0 0 0-4.378 4.35 4.72 4.72 0 0 0 3.468 4.917.675.675 0 0 0 .823-.472.674.674 0 0 0-.473-.803 3.374 3.374 0 0 1-2.476-3.513 3.426 3.426 0 0 1 3.124-3.13Z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M6.817 13.458a6.07 6.07 0 0 1-5.465-6.212 6.144 6.144 0 0 1 5.896-5.894 6.07 6.07 0 0 1 6.213 5.463.677.677 0 0 0 .994.529.675.675 0 0 0 .349-.664A7.42 7.42 0 0 0 7.214.003a7.51 7.51 0 0 0-7.21 7.203 7.42 7.42 0 0 0 6.65 7.594.678.678 0 1 0 .136-1.349z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M15.823 14.163 13.3 11.641a.17.17 0 0 1-.048-.135.15.15 0 0 1 .068-.122l1.592-1.099a.62.62 0 0 0-.162-1.1L7.66 7.069a.49.49 0 0 0-.479.115.47.47 0 0 0-.115.472l2.119 7.095a.63.63 0 0 0 .499.432.63.63 0 0 0 .6-.263l1.093-1.599a.15.15 0 0 1 .121-.067.15.15 0 0 1 .135.047l2.523 2.522a.62.62 0 0 0 .877 0l.783-.789a.613.613 0 0 0 .007-.87Z"
    }, null, -1)
  ]));
}
const n3 = { render: $a }, r3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n3,
  render: $a
}, Symbol.toStringTag, { value: "Module" })), s3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "clipboard-add",
  viewBox: "0 0 18 17"
};
function Sa(t, e) {
  return d(), h("svg", s3, e[0] || (e[0] = [
    W('<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25" d="M3 6h4M3 9h2m-2 3h1"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="1.25" d="M7.5 16H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h.5m7 0h.5a2 2 0 0 1 2 2v.5"></path><rect width="6.75" height="2.75" x="3.625" y=".625" stroke="currentColor" stroke-linecap="round" stroke-width="1.25" rx="1.375"></rect><circle cx="12" cy="11" r="5" stroke="currentColor" stroke-width="1.25"></circle><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="M12 9v4m-2-2h4"></path>', 5)
  ]));
}
const i3 = { render: Sa }, a3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: i3,
  render: Sa
}, Symbol.toStringTag, { value: "Module" })), l3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "clipboard-check",
  viewBox: "0 0 18 17"
};
function ja(t, e) {
  return d(), h("svg", l3, e[0] || (e[0] = [
    W('<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25" d="M3 6h4M3 9h2m-2 3h1"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="1.25" d="M7.5 16H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h.5m7 0h.5a2 2 0 0 1 2 2v.5"></path><rect width="6.75" height="2.75" x="3.625" y=".625" stroke="currentColor" stroke-linecap="round" stroke-width="1.25" rx="1.375"></rect><circle cx="12" cy="11" r="5" stroke="currentColor" stroke-width="1.25"></circle><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="m14 9-2.487 3L10 10.632"></path>', 5)
  ]));
}
const d3 = { render: ja }, u3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: d3,
  render: ja
}, Symbol.toStringTag, { value: "Module" })), c3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "clipboard-deadline",
  viewBox: "0 0 18 17"
};
function Oa(t, e) {
  return d(), h("svg", c3, e[0] || (e[0] = [
    W('<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25" d="M3 6h4M3 9h2m-2 3h1"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="1.25" d="M7.5 16H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h.5m7 0h.5a2 2 0 0 1 2 2v.5"></path><rect width="6.75" height="2.75" x="3.625" y=".625" stroke="currentColor" stroke-linecap="round" stroke-width="1.25" rx="1.375"></rect><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25" d="M12 11.5V9m0 2.5 1.768 1.768"></path><circle cx="12" cy="11" r="5" stroke="currentColor" stroke-width="1.25"></circle>', 5)
  ]));
}
const h3 = { render: Oa }, f3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: h3,
  render: Oa
}, Symbol.toStringTag, { value: "Module" })), p3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "clipboard-remove",
  viewBox: "0 0 18 17"
};
function Ta(t, e) {
  return d(), h("svg", p3, e[0] || (e[0] = [
    W('<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25" d="M3 6h4M3 9h2m-2 3h1"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="1.25" d="M7.5 16H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h.5m7 0h.5a2 2 0 0 1 2 2v.5"></path><rect width="6.75" height="2.75" x="3.625" y=".625" stroke="currentColor" stroke-linecap="round" stroke-width="1.25" rx="1.375"></rect><circle cx="12" cy="11" r="5" stroke="currentColor" stroke-width="1.25"></circle><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="m13.414 9.586-2.828 2.828m0-2.828 2.828 2.828"></path>', 5)
  ]));
}
const m3 = { render: Ta }, v3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: m3,
  render: Ta
}, Symbol.toStringTag, { value: "Module" })), g3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "clipboard-undo",
  viewBox: "0 0 18 17"
};
function za(t, e) {
  return d(), h("svg", g3, e[0] || (e[0] = [
    W('<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="M10.154 13 9 11.846m0 0 1.154-1.154M9 11.846h3.846a1.923 1.923 0 0 0 0-3.846h-1.538"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.25" d="M3 6h4M3 9h2m-2 3h1"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="1.25" d="M7.5 16H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h.5m7 0h.5a2 2 0 0 1 2 2v.5"></path><rect width="6.75" height="2.75" x="3.625" y=".625" stroke="currentColor" stroke-linecap="round" stroke-width="1.25" rx="1.375"></rect><circle cx="12" cy="11" r="5" stroke="currentColor" stroke-width="1.25"></circle>', 5)
  ]));
}
const _3 = { render: za }, w3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _3,
  render: za
}, Symbol.toStringTag, { value: "Module" })), b3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "clipboard",
  viewBox: "0 0 16 17"
};
function Ba(t, e) {
  return d(), h("svg", b3, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.25",
      d: "M4 6h8M4 9h6m-6 3h8"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.25",
      d: "M4.5 2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-.5"
    }, null, -1),
    l("rect", {
      width: "6.75",
      height: "2.75",
      x: "4.625",
      y: ".625",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.25",
      rx: "1.375"
    }, null, -1)
  ]));
}
const k3 = { render: Ba }, y3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: k3,
  render: Ba
}, Symbol.toStringTag, { value: "Module" })), x3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "clock",
  viewBox: "0 0 20 20"
};
function Ea(t, e) {
  return d(), h("svg", x3, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.25 10a8.75 8.75 0 1 0 17.5 0 8.75 8.75 0 0 0-17.5 0M10 10V6.875M10 10l3.906 3.907"
    }, null, -1)
  ]));
}
const C3 = { render: Ea }, M3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C3,
  render: Ea
}, Symbol.toStringTag, { value: "Module" })), $3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "close-circle",
  viewBox: "0 0 20 20"
};
function Pa(t, e) {
  return d(), h("svg", $3, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m12.652 7.348-5.304 5.303m0-5.303 5.304 5.303M.625 10a9.375 9.375 0 1 0 18.75 0 9.375 9.375 0 0 0-18.75 0"
    }, null, -1)
  ]));
}
const S3 = { render: Pa }, j3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: S3,
  render: Pa
}, Symbol.toStringTag, { value: "Module" })), O3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "close",
  viewBox: "0 0 14 14"
};
function Aa(t, e) {
  return d(), h("svg", O3, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M1 13 13 1m0 12L1 1"
    }, null, -1)
  ]));
}
const T3 = { render: Aa }, z3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: T3,
  render: Aa
}, Symbol.toStringTag, { value: "Module" })), B3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "coins",
  viewBox: "0 0 22 22"
};
function La(t, e) {
  return d(), h("svg", B3, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.984 12.667H6.207a1.19 1.19 0 0 0-.445 2.302l1.831.73A1.191 1.191 0 0 1 7.15 18H5.371m1.28-5.333V12m0 6.667V18m8.571-5.444a5.777 5.777 0 1 0-5.778-5.778m7.174 3a2.889 2.889 0 0 1 0-5.778M13 6.889h3.618m-4.062 8.333a5.778 5.778 0 1 1-11.556 0 5.778 5.778 0 0 1 11.556 0"
    }, null, -1)
  ]));
}
const E3 = { render: La }, P3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E3,
  render: La
}, Symbol.toStringTag, { value: "Module" })), A3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "collapse",
  viewBox: "0 0 16 16"
};
function Ha(t, e) {
  return d(), h("svg", A3, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.815 9.647 6.462 8 4.815 6.353a.5.5 0 1 1 .707-.706l2 2a.5.5 0 0 1 0 .706l-2 2a.5.5 0 0 1-.707-.706",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.501 1.334a1.167 1.167 0 0 0-1.167 1.167v11c0 .644.523 1.167 1.167 1.167h11a1.167 1.167 0 0 0 1.167-1.167v-11A1.167 1.167 0 0 0 13.5 1.334zm-.167 1.167a.167.167 0 0 1 .167-.167h7.5v11.334h-7.5a.167.167 0 0 1-.167-.167zm8.667 11.167V2.334h2.5a.167.167 0 0 1 .167.167v11a.167.167 0 0 1-.167.167z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const L3 = { render: Ha }, H3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L3,
  render: Ha
}, Symbol.toStringTag, { value: "Module" })), V3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "column-count-1",
  viewBox: "0 0 20 20"
};
function Va(t, e) {
  return d(), h("svg", V3, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6 6h8v8H6z"
    }, null, -1)
  ]));
}
const F3 = { render: Va }, I3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F3,
  render: Va
}, Symbol.toStringTag, { value: "Module" })), D3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "column-count-2",
  viewBox: "0 0 20 20"
};
function Fa(t, e) {
  return d(), h("svg", D3, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M2.5 5.992h6v8h-6zm9 .008h6v8h-6z"
    }, null, -1)
  ]));
}
const N3 = { render: Fa }, R3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: N3,
  render: Fa
}, Symbol.toStringTag, { value: "Module" })), q3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "column-count-3",
  viewBox: "0 0 20 20"
};
function Ia(t, e) {
  return d(), h("svg", q3, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1 6h4v8H1zm7 0h4v8H8zm7 0h4v8h-4z"
    }, null, -1)
  ]));
}
const W3 = { render: Ia }, U3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: W3,
  render: Ia
}, Symbol.toStringTag, { value: "Module" })), Z3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "column-count-4",
  viewBox: "0 0 20 20"
};
function Da(t, e) {
  return d(), h("svg", Z3, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1 6h3v8H1zm5 0h3v8H6zm5 0h3v8h-3zm5 0h3v8h-3z"
    }, null, -1)
  ]));
}
const G3 = { render: Da }, Y3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G3,
  render: Da
}, Symbol.toStringTag, { value: "Module" })), X3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "column-count",
  viewBox: "0 0 20 20"
};
function Na(t, e) {
  return d(), h("svg", X3, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.25 1.246h17.5v17.5H1.25zm2 8.879H8M5.625 7.75v4.75M10 1.5v17"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 1h9v18h-9zm2 8.5a.625.625 0 1 0 0 1.25h4.75a.625.625 0 1 0 0-1.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const K3 = { render: Na }, J3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: K3,
  render: Na
}, Symbol.toStringTag, { value: "Module" })), Q3 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "column-image-and-text",
  viewBox: "0 0 20 20"
};
function Ra(t, e) {
  return d(), h("svg", Q3, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3 2h14v7H3z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.5 12h7M4 18h12M4 15h12"
    }, null, -1)
  ]));
}
const ef = { render: Ra }, tf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ef,
  render: Ra
}, Symbol.toStringTag, { value: "Module" })), of = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "column-image-only",
  viewBox: "0 0 20 20"
};
function qa(t, e) {
  return d(), h("svg", of, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3 4h14v12H3z"
    }, null, -1)
  ]));
}
const nf = { render: qa }, rf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nf,
  render: qa
}, Symbol.toStringTag, { value: "Module" })), sf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "column-sidebyside",
  viewBox: "0 0 20 20"
};
function Wa(t, e) {
  return d(), h("svg", sf, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M11.656 2.5h7.719m-7.719 3.75h5.514M11.656 10h7.719m-7.719 3.75h5.514m-5.514 3.75h7.719M.633 1.383h7.5v17.25h-7.5z"
    }, null, -1)
  ]));
}
const af = { render: Wa }, lf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: af,
  render: Wa
}, Symbol.toStringTag, { value: "Module" })), df = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "column-text-only",
  viewBox: "0 0 20 20"
};
function Ua(t, e) {
  return d(), h("svg", df, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.5 6h7m-7 6h7M3 15h14M3 9h14"
    }, null, -1)
  ]));
}
const uf = { render: Ua }, cf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uf,
  render: Ua
}, Symbol.toStringTag, { value: "Module" })), hf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "columns",
  viewBox: "0 0 20 20"
};
function Za(t, e) {
  return d(), h("svg", hf, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M2 11h2m5 0h2m5 0h2M1 14h4m-4 3h4m3 0h4m3 0h4M8 14h4m3 0h4M1 3h4v4H1zm7 0h4v4H8zm7 0h4v4h-4z"
    }, null, -1)
  ]));
}
const ff = { render: Za }, pf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ff,
  render: Za
}, Symbol.toStringTag, { value: "Module" })), mf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "comment-history",
  viewBox: "0 0 22 21"
};
function Ga(t, e) {
  return d(), h("svg", mf, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.25",
      d: "m10.333 17-3.2 2.4C6.254 20.06 5 19.432 5 18.333v0C5 17.597 4.403 17 3.667 17H2.333C1.623 17 1 16.378 1 15.667V2.333C1 1.623 1.622 1 2.333 1h17.334C20.377 1 21 1.622 21 2.333V6.5M16 4h2M4 7h6m2-3h2M4 4h6m6 8V9.5m0 2.5 1.768 1.768"
    }, null, -1),
    l("circle", {
      cx: "16",
      cy: "12",
      r: "5",
      stroke: "currentColor",
      "stroke-width": "1.25"
    }, null, -1)
  ]));
}
const vf = { render: Ga }, gf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vf,
  render: Ga
}, Symbol.toStringTag, { value: "Module" })), _f = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "comments-locked",
  viewBox: "0 0 22 21"
};
function Ya(t, e) {
  return d(), h("svg", _f, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.25",
      d: "m10.333 17-3.2 2.4C6.254 20.06 5 19.432 5 18.333v0C5 17.597 4.403 17 3.667 17H2.333C1.623 17 1 16.378 1 15.667V2.333C1 1.623 1.622 1 2.333 1h17.334C20.377 1 21 1.622 21 2.333V7.5M16 4h2M4 7h7m1-3h2M4 4h6m7 10v-1"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-width": "1.25",
      d: "M13 12a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.25",
      d: "M14 11s0-3 3-3 3 3 3 3"
    }, null, -1)
  ]));
}
const wf = { render: Ya }, bf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wf,
  render: Ya
}, Symbol.toStringTag, { value: "Module" })), kf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "comments",
  viewBox: "0 0 22 21"
};
function Xa(t, e) {
  return d(), h("svg", kf, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.25",
      d: "M19.667 17H11a2 2 0 0 0-1.2.4l-2.667 2C6.254 20.06 5 19.432 5 18.333v0C5 17.597 4.403 17 3.667 17H2.333C1.623 17 1 16.378 1 15.667V2.333C1 1.623 1.622 1 2.333 1h17.334C20.377 1 21 1.622 21 2.333v13.334c0 .71-.622 1.333-1.333 1.333M16 4h2m-5 3h4M4 7h7m1-3h2M4 4h6"
    }, null, -1)
  ]));
}
const yf = { render: Xa }, xf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yf,
  render: Xa
}, Symbol.toStringTag, { value: "Module" })), Cf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "company",
  viewBox: "0 0 20 20"
};
function Ka(t, e) {
  return d(), h("svg", Cf, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M2.5 11.875h3.75m-3.75 2.5h3.75m-3.75 2.5h3.75m-3.75-10h3.75m-3.75 2.5h3.75m9.375 2.5h1.25m-1.25 2.5h1.25m-1.25 2.5h1.25m-1.25-7.5h1.25M1.042 3.125h6.666a.417.417 0 0 1 .417.417v15.833H1.042a.417.417 0 0 1-.417-.417V3.542a.417.417 0 0 1 .417-.417m12.083 7.5h-5v8.75h5z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M13.542 5.625h5.416a.417.417 0 0 1 .417.417v12.916a.417.417 0 0 1-.417.417h-5.833V6.042a.417.417 0 0 1 .417-.417"
    }, null, -1)
  ]));
}
const Mf = { render: Ka }, $f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mf,
  render: Ka
}, Symbol.toStringTag, { value: "Module" })), Sf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "conditional-logic",
  viewBox: "0 0 20 20"
};
function Ja(t, e) {
  return d(), h("svg", Sf, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.22 14.836H13a4.84 4.84 0 0 1-3.96-2.063l-.497-.71A4.84 4.84 0 0 0 4.58 10H.812M18.22 5.165h-5.217c-1.58 0-3.059.77-3.963 2.064l-.494.706A4.84 4.84 0 0 1 4.584 10H.813"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m15.32 8.066 2.9-2.902-2.9-2.9m0 15.473 2.9-2.901-2.9-2.902"
    }, null, -1)
  ]));
}
const jf = { render: Ja }, Of = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jf,
  render: Ja
}, Symbol.toStringTag, { value: "Module" })), Tf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "contracts",
  viewBox: "0 0 25 24"
};
function Qa(t, e) {
  return d(), h("svg", Tf, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M22.784 4.756a2.2 2.2 0 1 0-3.111-3.112L8.655 12.66l3.112 3.112z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m18.572 2.745 3.112 3.111M4.36 18.6h-.73a2.2 2.2 0 1 0 0 4.4h15.4M8.655 12.66l-1.362 4.474 4.474-1.363-3.112-3.11Z"
    }, null, -1)
  ]));
}
const zf = { render: Qa }, Bf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zf,
  render: Qa
}, Symbol.toStringTag, { value: "Module" })), Ef = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "conversation",
  viewBox: "0 0 20 20"
};
function el(t, e) {
  return d(), h("svg", Ef, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M16.422 5.623a7.584 7.584 0 1 0-13.57 6.575L.625 16.875l4.677-2.227a7.6 7.6 0 0 0 2.823 1.053"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M14.902 8.75a4.453 4.453 0 0 1 3.355 7.405l.559 3.22-2.917-1.798a4.47 4.47 0 1 1-1-8.827z"
    }, null, -1)
  ]));
}
const Pf = { render: el }, Af = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pf,
  render: el
}, Symbol.toStringTag, { value: "Module" })), Lf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "copy-paste",
  viewBox: "0 0 24 24"
};
function tl(t, e) {
  return d(), h("svg", Lf, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 1.75C0 .783.784 0 1.75 0h14c.966 0 1.75.784 1.75 1.75V4.5a.75.75 0 0 1-1.5 0V1.75a.25.25 0 0 0-.25-.25h-14a.25.25 0 0 0-.25.25v14c0 .138.112.25.25.25h10.69l-1.72-1.72a.75.75 0 1 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H1.75A1.75 1.75 0 0 1 0 15.75z",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.25 8a.25.25 0 0 0-.25.25v4a.75.75 0 0 1-1.5 0v-4c0-.967.784-1.75 1.75-1.75h14c.966 0 1.75.784 1.75 1.75v14A1.75 1.75 0 0 1 22.25 24h-14a1.75 1.75 0 0 1-1.75-1.75v-1a.75.75 0 0 1 1.5 0v1c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25v-14a.25.25 0 0 0-.25-.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Hf = { render: tl }, Vf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hf,
  render: tl
}, Symbol.toStringTag, { value: "Module" })), Ff = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "copy",
  viewBox: "0 0 20 20"
};
function ol(t, e) {
  return d(), h("svg", Ff, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M13.958 3.75V1.458a.833.833 0 0 0-.833-.833H1.458a.833.833 0 0 0-.833.833v11.667c0 .46.373.833.833.833H3.75"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.042 6.875c0-.46.373-.833.833-.833h11.667c.46 0 .833.373.833.833v11.667c0 .46-.373.833-.833.833H6.875a.833.833 0 0 1-.833-.833z"
    }, null, -1)
  ]));
}
const If = { render: ol }, Df = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: If,
  render: ol
}, Symbol.toStringTag, { value: "Module" })), Nf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "create-contextual-comment",
  viewBox: "0 0 20 20"
};
function nl(t, e) {
  return d(), h("svg", Nf, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.25",
      d: "M18.125 15.625h-8.083a2 2 0 0 0-1.2.4l-2.467 1.85c-.824.618-2 .03-2-1v0c0-.69-.56-1.25-1.25-1.25h-1.25c-.667 0-1.25-.583-1.25-1.25v-12.5c0-.667.583-1.25 1.25-1.25h16.25c.667 0 1.25.583 1.25 1.25v12.5c0 .667-.583 1.25-1.25 1.25M3.458 10.209h6.25m2.334 0h4.416m-13 2.582h4.417m6.417 0h2.166m-6.416 0h2.25"
    }, null, -1)
  ]));
}
const Rf = { render: nl }, qf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rf,
  render: nl
}, Symbol.toStringTag, { value: "Module" })), Wf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "custom-input",
  viewBox: "0 0 16 16"
};
function rl(t, e) {
  return d(), h("svg", Wf, e[0] || (e[0] = [
    l("desc", null, "Input Streamline Icon: https://streamlinehq.com", -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.933 1.067a.533.533 0 0 0 0 1.066c.669 0 1.021.214 1.233.51.237.333.367.865.367 1.624v7.466c0 .76-.13 1.291-.367 1.624-.212.296-.564.51-1.233.51a.533.533 0 0 0 0 1.066c.932 0 1.646-.32 2.101-.956l.033-.047.032.047c.455.637 1.17.956 2.101.956a.533.533 0 0 0 0-1.066c-.668 0-1.021-.214-1.233-.51-.237-.333-.367-.865-.367-1.624V4.267c0-.76.13-1.291.367-1.624.212-.296.565-.51 1.233-.51a.533.533 0 0 0 0-1.066c-.932 0-1.646.32-2.1.956l-.033.047-.033-.047c-.455-.637-1.17-.956-2.1-.956m8 4.266h-3.2V4.267h3.2c.59 0 1.067.477 1.067 1.066v5.334c0 .589-.478 1.066-1.067 1.066h-3.2v-1.066h3.2zM6.4 4.267v1.066H1.067v5.334H6.4v1.066H1.067c-.59 0-1.067-.477-1.067-1.066V5.333c0-.589.478-1.066 1.067-1.066z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Uf = { render: rl }, Zf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Uf,
  render: rl
}, Symbol.toStringTag, { value: "Module" })), Gf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "custom",
  viewBox: "0 0 20 20"
};
function sl(t, e) {
  return d(), h("svg", Gf, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M1.385 5.089c1.835-.37 3.312-1.865 3.682-3.747.37 1.882 1.847 3.378 3.682 3.747m0 .002c-1.835.369-3.313 1.864-3.682 3.747C4.697 6.955 3.22 5.46 1.385 5.09"></path><path stroke-miterlimit="10" d="m13.051 6.538 3.688 3.688m-7.266 7.15-4.887 1.278 1.275-4.9 8.328-8.356c.991-.995 2.62-1.066 3.683 0 .991.994.991 2.627 0 3.693z"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const Yf = { render: sl }, Xf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yf,
  render: sl
}, Symbol.toStringTag, { value: "Module" })), Kf = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "delete-bin",
  viewBox: "0 0 20 20"
};
function il(t, e) {
  return d(), h("svg", Kf, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.833 4.167h18.334M11.875.833h-3.75a1.25 1.25 0 0 0-1.25 1.25v2.084h6.25V2.083a1.25 1.25 0 0 0-1.25-1.25m-3.75 13.959v-6.25m3.75 6.25v-6.25m3.842 9.475a1.24 1.24 0 0 1-1.242 1.15h-8.95a1.24 1.24 0 0 1-1.242-1.15L3.125 4.167h13.75z"
    }, null, -1)
  ]));
}
const Jf = { render: il }, Qf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jf,
  render: il
}, Symbol.toStringTag, { value: "Module" })), ep = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "delete-column",
  viewBox: "0 0 20 20"
};
function al(t, e) {
  return d(), h("svg", ep, e[0] || (e[0] = [
    W('<g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="M.621 19.375V.625h3.75v18.75z"></path><path fill="currentColor" fill-rule="evenodd" d="M8.121 20a.625.625 0 0 1-.625-.625v-.938a.625.625 0 1 1 1.25 0v.313h.313a.625.625 0 1 1 0 1.25H8.12Zm0-2.813a.625.625 0 0 1-.625-.625v-1.875a.625.625 0 1 1 1.25 0v1.876c0 .345-.28.625-.625.625Zm0-11.25a.625.625 0 0 1-.625-.625V3.438a.625.625 0 0 1 1.25 0v1.876c0 .345-.28.625-.625.625Zm0-3.75a.625.625 0 0 1-.625-.624V.625c0-.345.28-.625.625-.625h.938a.625.625 0 1 1 0 1.25h-.313v.313c0 .345-.28.625-.625.625Zm2.188 17.188c0-.345.28-.625.625-.625h.312v-.313a.625.625 0 1 1 1.25 0v.938c0 .345-.28.625-.625.625h-.937a.625.625 0 0 1-.625-.625m0-18.75c0-.345.28-.625.625-.625h.937c.345 0 .625.28.625.625v.938a.625.625 0 1 1-1.25 0V1.25h-.312a.625.625 0 0 1-.625-.625m1.562 16.563a.625.625 0 0 1-.625-.625v-1.875a.625.625 0 1 1 1.25 0v1.874c0 .346-.28.625-.625.625Zm0-11.25a.625.625 0 0 1-.625-.625V3.438a.625.625 0 1 1 1.25 0v1.874c0 .346-.28.625-.625.625Z" clip-rule="evenodd"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="M15.621 19.375V.625h3.75v18.75z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.85" d="m7.813 7.836 4.364 4.364m-4.364-.013 4.364-4.364"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const tp = { render: al }, op = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tp,
  render: al
}, Symbol.toStringTag, { value: "Module" })), np = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "delete-row",
  viewBox: "0 0 20 20"
};
function ll(t, e) {
  return d(), h("svg", np, e[0] || (e[0] = [
    W('<g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="M.625.621h18.75v3.75H.625z"></path><path fill="currentColor" fill-rule="evenodd" d="M0 8.121c0-.345.28-.625.625-.625h.938a.625.625 0 0 1 0 1.25H1.25v.313a.625.625 0 1 1-1.25 0V8.12Zm2.813 0c0-.345.28-.625.624-.625h1.876a.625.625 0 0 1 0 1.25H3.438a.625.625 0 0 1-.626-.625Zm11.25 0c0-.345.28-.625.624-.625h1.876a.625.625 0 1 1 0 1.25h-1.875a.625.625 0 0 1-.626-.625Zm3.75 0c0-.345.28-.625.625-.625h.937c.345 0 .625.28.625.625v.938a.625.625 0 1 1-1.25 0v-.313h-.313a.625.625 0 0 1-.625-.625ZM.625 10.31c.345 0 .625.28.625.625v.312h.313a.625.625 0 1 1 0 1.25H.625A.625.625 0 0 1 0 11.871v-.937c0-.346.28-.625.625-.625Zm18.75 0c.345 0 .625.28.625.625v.937c0 .345-.28.625-.625.625h-.938a.625.625 0 1 1 0-1.25h.313v-.312c0-.346.28-.625.625-.625M2.812 11.87c0-.345.28-.625.626-.625h1.874a.625.625 0 1 1 0 1.25H3.438a.625.625 0 0 1-.624-.625Zm11.25 0c0-.345.28-.625.626-.625h1.874a.625.625 0 1 1 0 1.25h-1.875a.625.625 0 0 1-.624-.625Z" clip-rule="evenodd"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="M.625 15.621h18.75v3.75H.625z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.85" d="M12.164 7.813 7.8 12.177m.013-4.364 4.364 4.364"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const rp = { render: ll }, sp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rp,
  render: ll
}, Symbol.toStringTag, { value: "Module" })), ip = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "divider-dashed",
  viewBox: "0 0 20 20"
};
function dl(t, e) {
  return d(), h("svg", ip, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17 9.875h-2v1.25h2zm1 1.25h1.375a.625.625 0 1 0 0-1.25H18zm-6-1.25h2v1.25h-2zm-1 0H9v1.25h2zm-5 0h2v1.25H6zm-4 0H.625a.625.625 0 1 0 0 1.25H2zm1 1.25h2v-1.25H3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ap = { render: dl }, lp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ap,
  render: dl
}, Symbol.toStringTag, { value: "Module" })), dp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "divider-padding",
  viewBox: "0 0 20 20"
};
function ul(t, e) {
  return d(), h("svg", dp, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.363",
      d: "M10 5v10M6.805 7.195 10 4l3.195 3.195m0 5.618L10 16.008l-3.195-3.195M1 .715h18M1 19.313h18"
    }, null, -1)
  ]));
}
const up = { render: ul }, cp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: up,
  render: ul
}, Symbol.toStringTag, { value: "Module" })), hp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "divider-thick",
  viewBox: "0 0 20 20"
};
function cl(t, e) {
  return d(), h("svg", hp, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "M1.516 10.5H18.5"
    }, null, -1)
  ]));
}
const fp = { render: cl }, pp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fp,
  render: cl
}, Symbol.toStringTag, { value: "Module" })), mp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "divider-thin",
  viewBox: "0 0 20 20"
};
function hl(t, e) {
  return d(), h("svg", mp, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 10.5h18.75"
    }, null, -1)
  ]));
}
const vp = { render: hl }, gp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vp,
  render: hl
}, Symbol.toStringTag, { value: "Module" })), _p = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "document-check",
  viewBox: "0 0 20 20"
};
function fl(t, e) {
  return d(), h("svg", _p, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M9.375 14.375a5 5 0 1 0 10 0 5 5 0 0 0-10 0"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m16.603 12.922-2.42 3.227a.626.626 0 0 1-.943.068l-1.25-1.25M3.125 5.625h8.75m-8.75 3.75h5m-5 3.75H6.25m0 3.75H1.875a1.25 1.25 0 0 1-1.25-1.25V1.875a1.25 1.25 0 0 1 1.25-1.25h8.857c.332 0 .65.132.884.366l2.393 2.393c.234.235.366.552.366.884V6.25"
    }, null, -1)
  ]));
}
const wp = { render: fl }, bp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wp,
  render: fl
}, Symbol.toStringTag, { value: "Module" })), kp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "document-create",
  viewBox: "0 0 20 20"
};
function pl(t, e) {
  return d(), h("svg", kp, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M9.375 14.375a5 5 0 1 0 10 0 5 5 0 0 0-10 0m5-2.5v5m-2.5-2.5h5m-13.75-8.75h8.75m-8.75 3.75h5m-5 3.75H6.25"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.25 16.875H1.875a1.25 1.25 0 0 1-1.25-1.25V1.875a1.25 1.25 0 0 1 1.25-1.25h8.857c.332 0 .65.132.884.366l2.393 2.393c.234.235.366.552.366.884V6.25"
    }, null, -1)
  ]));
}
const yp = { render: pl }, xp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yp,
  render: pl
}, Symbol.toStringTag, { value: "Module" })), Cp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  "data-token-name": "document-dsr",
  viewBox: "0 0 24 24"
};
function ml(t, e) {
  return d(), h("svg", Cp, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      d: "M8.625 12.381a.375.375 0 1 1 0-.75m0 .75a.375.375 0 1 0 0-.75"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 3h4.5a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5h-4.5m-3.86 2.24-9-1.24a.75.75 0 0 1-.64-.75V3.72A.75.75 0 0 1 2.84 3l9-2.22a.75.75 0 0 1 .91.73v21a.74.74 0 0 1-.86.73"
    }, null, -1)
  ]));
}
const Mp = { render: ml }, $p = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mp,
  render: ml
}, Symbol.toStringTag, { value: "Module" })), Sp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "document-edit",
  viewBox: "0 0 20 20"
};
function vl(t, e) {
  return d(), h("svg", Sp, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.858 12.392 12.5 18.75l-3.125.625L10 16.25l6.358-6.358a1.763 1.763 0 0 1 2.494 0l.006.006a1.76 1.76 0 0 1 0 2.494M6.875 16.875h-5a1.25 1.25 0 0 1-1.25-1.25V1.875a1.25 1.25 0 0 1 1.25-1.25h8.857c.332 0 .65.132.884.366l2.393 2.393c.234.235.366.552.366.884v2.607"
    }, null, -1)
  ]));
}
const jp = { render: vl }, Op = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jp,
  render: vl
}, Symbol.toStringTag, { value: "Module" })), Tp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "document-hr",
  viewBox: "0 0 20 20"
};
function gl(t, e) {
  return d(), h("svg", Tp, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M11.877 17.608H2.05a.833.833 0 0 1-.833-.834V1.452A.833.833 0 0 1 2.049.62h11.132a.833.833 0 0 1 .833.833v2.25"></path><path d="M9.212 9.84a1.666 1.666 0 1 0 0-3.332 1.666 1.666 0 0 0 0 3.332m3.561 3.525c-1.036-3.454-6.194-3.277-7.228.167"></path><path d="M9.07 14.9a5.237 5.237 0 1 0 0-10.474 5.237 5.237 0 0 0 0 10.473Zm3.703-1.535 1.665 1.67m-.856.855 1.708-1.709 3.138 3.137a1.21 1.21 0 0 1-1.712 1.711l-3.137-3.137z"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const zp = { render: gl }, Bp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zp,
  render: gl
}, Symbol.toStringTag, { value: "Module" })), Ep = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "document-other",
  viewBox: "0 0 20 20"
};
function _l(t, e) {
  return d(), h("svg", Ep, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.73 18.125a1.25 1.25 0 0 1-1.25 1.25H2.52a1.25 1.25 0 0 1-1.25-1.25V1.875A1.25 1.25 0 0 1 2.52.625h12.5c.325 0 .638.127.872.355l2.462 2.402a1.25 1.25 0 0 1 .377.895z"
    }, null, -1)
  ]));
}
const Pp = { render: _l }, Ap = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pp,
  render: _l
}, Symbol.toStringTag, { value: "Module" })), Lp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "document-play",
  viewBox: "0 0 20 20"
};
function wl(t, e) {
  return d(), h("svg", Lp, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.75 18.125a1.25 1.25 0 0 1-1.25 1.25h-15a1.25 1.25 0 0 1-1.25-1.25V1.875A1.25 1.25 0 0 1 2.5.625H15c.326 0 .64.127.873.355l2.5 2.402a1.25 1.25 0 0 1 .377.895z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M8.532 13.675a.713.713 0 0 1-1.032-.638V8.213a.713.713 0 0 1 1.032-.638l4.824 2.412a.713.713 0 0 1 0 1.275z"
    }, null, -1)
  ]));
}
const Hp = { render: wl }, Vp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hp,
  render: wl
}, Symbol.toStringTag, { value: "Module" })), Fp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "document-presentation",
  viewBox: "0 0 20 20"
};
function bl(t, e) {
  return d(), h("svg", Fp, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M10 14.375v2.5m0 0-2.5 2.5m2.5-2.5 2.5 2.5m5-18.75h-15c-.69 0-1.25.56-1.25 1.25v11.25c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25V1.875c0-.69-.56-1.25-1.25-1.25"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3.75 8.125h2.5l1.25-2.5L10 10l1.875-3.125 1.875 1.25L16.25 5"
    }, null, -1)
  ]));
}
const Ip = { render: bl }, Dp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ip,
  render: bl
}, Symbol.toStringTag, { value: "Module" })), Np = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "document-sales",
  viewBox: "0 0 20 20"
};
function kl(t, e) {
  return d(), h("svg", Np, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 10a9.375 9.375 0 1 0 18.75 0 9.375 9.375 0 0 0-18.75 0"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M8.125 11.875A1.875 1.875 0 1 0 10 10a1.875 1.875 0 1 1 1.875-1.875M10 5v1.25m0 7.5V15"
    }, null, -1)
  ]));
}
const Rp = { render: kl }, qp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rp,
  render: kl
}, Symbol.toStringTag, { value: "Module" })), Wp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "document-search",
  viewBox: "0 0 20 20"
};
function yl(t, e) {
  return d(), h("svg", Wp, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.25 16.875H1.875a1.25 1.25 0 0 1-1.25-1.25V1.875a1.25 1.25 0 0 1 1.25-1.25h8.857c.332 0 .65.132.884.366l2.393 2.393c.234.235.366.552.366.884V6.25"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M8.762 13.125a4.375 4.375 0 1 0 8.75 0 4.375 4.375 0 0 0-8.75 0m10.613 6.25-3.145-3.157"
    }, null, -1)
  ]));
}
const Up = { render: yl }, Zp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Up,
  render: yl
}, Symbol.toStringTag, { value: "Module" })), Gp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "document-view",
  viewBox: "0 0 20 20"
};
function xl(t, e) {
  return d(), h("svg", Gp, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M5.75 19.38h-2.5A1.25 1.25 0 0 1 2 18.13V1.88A1.25 1.25 0 0 1 3.25.63h8.858a1.25 1.25 0 0 1 .884.367l4.892 4.892a1.25 1.25 0 0 1 .366.884v3.857"></path><path d="M18.25 6.88h-5A1.25 1.25 0 0 1 12 5.63v-5m.874 11.376c-1.68-.029-3.416 1.145-4.508 2.347a.693.693 0 0 0 0 .928c1.068 1.176 2.8 2.377 4.508 2.348 1.709.029 3.441-1.172 4.51-2.349a.693.693 0 0 0 0-.927c-1.093-1.202-2.83-2.376-4.51-2.347"></path><path d="M14.437 14.818a1.563 1.563 0 1 1-3.126-.001 1.563 1.563 0 0 1 3.126 0"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const Yp = { render: xl }, Xp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yp,
  render: xl
}, Symbol.toStringTag, { value: "Module" })), Kp = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "door-plus",
  viewBox: "0 0 20 20"
};
function Cl(t, e) {
  return d(), h("svg", Kp, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-width": "1.25",
      d: "M5.214 9.184a.265.265 0 0 1-.26-.27c0-.149.116-.27.26-.27m.001.54c.144 0 .26-.12.26-.27a.265.265 0 0 0-.26-.27"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M10.164 2.418h3.125c.276 0 .54.114.736.316a1.1 1.1 0 0 1 .305.763v2.504M8.08 8.912V1.356a.56.56 0 0 0-.195-.419.51.51 0 0 0-.437-.106l-6.25 1.597a.52.52 0 0 0-.291.186.55.55 0 0 0-.118.332v12.615a.55.55 0 0 0 .125.356.5.5 0 0 0 .32.184l3.124.446 1.562.223.782.112M14 11.5v5M11.5 14h5M9 14a5 5 0 1 0 10 0 5 5 0 0 0-10 0"
    }, null, -1)
  ]));
}
const Jp = { render: Cl }, Qp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jp,
  render: Cl
}, Symbol.toStringTag, { value: "Module" })), em = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "door",
  viewBox: "0 0 20 20"
};
function Ml(t, e) {
  return d(), h("svg", em, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-width": "1.25",
      d: "M7.47 10.31a.3.3 0 0 1-.298-.304.3.3 0 0 1 .298-.303"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-width": "1.25",
      d: "M7.469 10.31a.3.3 0 0 0 .298-.304.3.3 0 0 0-.298-.303"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M13.14 2.707h3.582c.316 0 .62.128.844.355.224.228.35.536.35.858v12.128c0 .322-.126.63-.35.858a1.18 1.18 0 0 1-.844.355H13.14m-3.07 1.823-7.162-1.003a.6.6 0 0 1-.367-.206.6.6 0 0 1-.143-.4V3.301a.6.6 0 0 1 .136-.374.6.6 0 0 1 .334-.208L10.03.924a.59.59 0 0 1 .5.12.6.6 0 0 1 .224.47v16.98a.6.6 0 0 1-.208.456.6.6 0 0 1-.476.134"
    }, null, -1)
  ]));
}
const tm = { render: Ml }, om = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tm,
  render: Ml
}, Symbol.toStringTag, { value: "Module" })), nm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "download",
  viewBox: "0 0 20 20"
};
function $l(t, e) {
  return d(), h("svg", nm, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M10 3.125v10m-3.75-3.75 3.75 3.75 3.75-3.75m5.626 3.75v1.25a2.5 2.5 0 0 1-2.5 2.5H3.126a2.5 2.5 0 0 1-2.5-2.5v-1.25"
    }, null, -1)
  ]));
}
const rm = { render: $l }, sm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rm,
  render: $l
}, Symbol.toStringTag, { value: "Module" })), im = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "drag-handle",
  viewBox: "0 0 20 20"
};
function Sl(t, e) {
  return d(), h("svg", im, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4-8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0M9 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
    }, null, -1)
  ]));
}
const am = { render: Sl }, lm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: am,
  render: Sl
}, Symbol.toStringTag, { value: "Module" })), dm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "dropdown",
  viewBox: "0 0 20 20"
};
function jl(t, e) {
  return d(), h("svg", dm, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.542 5.872H1.458c-.46 0-.833.36-.833.803v9.643c0 .444.373.804.833.804h17.084c.46 0 .833-.36.833-.804V6.675c0-.443-.373-.803-.833-.803M.625 2.878h7"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m17 10.71-2.382 2.382a.17.17 0 0 1-.182.036.2.2 0 0 1-.054-.036L12 10.71"
    }, null, -1)
  ]));
}
const um = { render: jl }, cm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: um,
  render: jl
}, Symbol.toStringTag, { value: "Module" })), hm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "duplicate",
  viewBox: "0 0 20 20"
};
function Ol(t, e) {
  return d(), h("svg", hm, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M18.125.622H4.375c-.69 0-1.25.56-1.25 1.25v13.75c0 .69.56 1.25 1.25 1.25h13.75c.69 0 1.25-.56 1.25-1.25V1.872c0-.69-.56-1.25-1.25-1.25"></path><path d="M16.875 19.372h-15a1.25 1.25 0 0 1-1.25-1.25v-15m11.25 1.25v7.5m-3.75-3.75h7.5"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const fm = { render: Ol }, pm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fm,
  render: Ol
}, Symbol.toStringTag, { value: "Module" })), mm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "edit",
  viewBox: "0 0 20 20"
};
function Tl(t, e) {
  return d(), h("svg", mm, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.492 1.508a3.034 3.034 0 0 0-4.309.03L2.1 13.62.625 19.375l5.754-1.476L18.462 5.816a3.03 3.03 0 0 0 .03-4.308m-4.654.375 4.279 4.279M2.1 13.62l4.283 4.275"
    }, null, -1)
  ]));
}
const vm = { render: Tl }, gm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vm,
  render: Tl
}, Symbol.toStringTag, { value: "Module" })), _m = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "editor-block",
  viewBox: "0 0 20 20"
};
function zl(t, e) {
  return d(), h("svg", _m, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.25 13.75v-5M3.75 10V8.75h5V10m3.124 2.5h4.375m-4.375-3.75h4.375M3.75 16.25h12.5M5 13.75h2.5"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M19.008 4.634a1.25 1.25 0 0 1 .366.884v11.983a1.875 1.875 0 0 1-1.874 1.874h-15a1.876 1.876 0 0 1-1.876-1.874v-15A1.875 1.875 0 0 1 2.5.625h11.98a1.25 1.25 0 0 1 .885.367z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M14.374.625v3.75a1.25 1.25 0 0 0 1.25 1.25h3.75"
    }, null, -1)
  ]));
}
const wm = { render: zl }, bm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wm,
  render: zl
}, Symbol.toStringTag, { value: "Module" })), km = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "eid",
  viewBox: "0 0 18 18"
};
function Bl(t, e) {
  return d(), h("svg", km, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.769 4.078H5.307c-.68 0-1.23.551-1.23 1.23V7.77c0 .68.55 1.231 1.23 1.231H7.77c.68 0 1.23-.551 1.23-1.23V5.308c0-.68-.55-1.23-1.23-1.23ZM4.077 1H2.23A1.23 1.23 0 0 0 1 2.23v1.847M13.923 1h1.846a1.23 1.23 0 0 1 1.23 1.23v1.847M4.077 16.999H2.23A1.23 1.23 0 0 1 1 15.768v-1.846m12.923 3.077h1.846a1.23 1.23 0 0 0 1.23-1.231v-1.846M4.077 12.078v1.846h1.846m3.077 0v-1.846H7.154m6.769-6.154h-1.846V4.078m1.846 6.143V8.375h-1.846m0 3.703v1.846h1.846"
    }, null, -1)
  ]));
}
const ym = { render: Bl }, xm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ym,
  render: Bl
}, Symbol.toStringTag, { value: "Module" })), Cm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "ellipsis",
  viewBox: "0 0 20 20"
};
function El(t, e) {
  return d(), h("svg", Cm, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M0 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0m16 0a2 2 0 1 0 4.001 0A2 2 0 0 0 16 10m-8 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
    }, null, -1)
  ]));
}
const Mm = { render: El }, $m = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mm,
  render: El
}, Symbol.toStringTag, { value: "Module" })), Sm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "email-action-reply",
  viewBox: "0 0 16 16"
};
function Pl(t, e) {
  return d(), h("svg", Sm, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.667 5.636S15 4.636 15 12.97c-2.667-5-8.333-3.334-8.333-3.334v2.667L1 7.636 6.667 2.97z"
    }, null, -1)
  ]));
}
const jm = { render: Pl }, Om = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jm,
  render: Pl
}, Symbol.toStringTag, { value: "Module" })), Tm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "data-token-name": "eraser",
  viewBox: "-0.625 -0.625 20 20"
};
function Al(t, e) {
  return d(), h("svg", Tm, e[0] || (e[0] = [
    l("path", {
      "stroke-width": "1.25",
      d: "M15.669 17.116H5.509l-4.073-4.16a.967.967 0 0 1 0-1.365l9.676-9.675a.967.967 0 0 1 1.364 0l4.838 4.837a.967.967 0 0 1 0 1.365l-8.902 8.998m6.289-6.483L8.606 4.538"
    }, null, -1)
  ]));
}
const zm = { render: Al }, Bm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zm,
  render: Al
}, Symbol.toStringTag, { value: "Module" })), Em = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "file-blank",
  viewBox: "0 0 20 20"
};
function Ll(t, e) {
  return d(), h("svg", Em, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.125 19.375h-15a1.25 1.25 0 0 1-1.25-1.25V1.875a1.25 1.25 0 0 1 1.25-1.25h8.857a1.25 1.25 0 0 1 .885.366l4.892 4.893c.234.234.366.552.366.883z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.125 6.875h-5a1.25 1.25 0 0 1-1.25-1.25v-5"
    }, null, -1)
  ]));
}
const Pm = { render: Ll }, Am = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pm,
  render: Ll
}, Symbol.toStringTag, { value: "Module" })), Lm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "file-doc",
  viewBox: "0 0 20 20"
};
function Hl(t, e) {
  return d(), h("svg", Lm, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M4.373 19.373h-2.5a1.25 1.25 0 0 1-1.25-1.25V1.873a1.25 1.25 0 0 1 1.25-1.25h8.857a1.25 1.25 0 0 1 .884.366l4.893 4.893c.234.235.365.553.366.884v3.857"></path><path d="M16.873 6.873h-5a1.25 1.25 0 0 1-1.25-1.25v-5m-3.75 18.75a2.5 2.5 0 0 0 2.5-2.5v-1.25a2.5 2.5 0 0 0-2.5-2.5zm6.25-6.25a1.25 1.25 0 0 0-1.25 1.25v3.75a1.25 1.25 0 0 0 2.5 0v-3.75a1.25 1.25 0 0 0-1.25-1.25m6.25 0a2.5 2.5 0 0 0-2.5 2.5v1.25a2.5 2.5 0 0 0 2.5 2.5"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const Hm = { render: Hl }, Vm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hm,
  render: Hl
}, Symbol.toStringTag, { value: "Module" })), Fm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "file-pdf",
  viewBox: "0 0 20 20"
};
function Vl(t, e) {
  return d(), h("svg", Fm, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M4.372 19.373h-2.5a1.25 1.25 0 0 1-1.25-1.25V1.873a1.25 1.25 0 0 1 1.25-1.25h8.857a1.25 1.25 0 0 1 .884.367l4.893 4.892a1.25 1.25 0 0 1 .366.885v3.856"></path><path d="M16.872 6.873h-5a1.25 1.25 0 0 1-1.25-1.25v-5m-3.75 18.75v-6.25m0 0H7.5a1.875 1.875 0 1 1 0 3.75h-.625m4.997 2.5a2.5 2.5 0 0 0 2.5-2.5v-1.25a2.5 2.5 0 0 0-2.5-2.5zm5 0v-5a1.25 1.25 0 0 1 1.25-1.25h1.25m-2.5 3.75h1.875"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const Im = { render: Vl }, Dm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Im,
  render: Vl
}, Symbol.toStringTag, { value: "Module" })), Nm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "file-ppt",
  viewBox: "0 0 20 20"
};
function Fl(t, e) {
  return d(), h("svg", Nm, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M4.374 19.373h-2.5a1.25 1.25 0 0 1-1.25-1.25V1.873a1.25 1.25 0 0 1 1.25-1.25h8.858a1.25 1.25 0 0 1 .884.366l4.892 4.893c.235.235.366.553.366.884v3.857"></path><path d="M16.874 6.873h-5a1.25 1.25 0 0 1-1.25-1.25v-5m-3.75 18.75v-6.25m0 0H7.5a1.875 1.875 0 1 1 0 3.75h-.625m4.999 2.5v-6.25m0 0h.626a1.875 1.875 0 1 1 0 3.75h-.625m6.249 2.5v-6.25m-1.25 0h2.5"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const Rm = { render: Fl }, qm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rm,
  render: Fl
}, Symbol.toStringTag, { value: "Module" })), Wm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "file-txt",
  viewBox: "0 0 20 20"
};
function Il(t, e) {
  return d(), h("svg", Wm, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M4.373 19.373h-2.5a1.25 1.25 0 0 1-1.25-1.25V1.873a1.25 1.25 0 0 1 1.25-1.25h8.857c.331 0 .65.132.883.366l4.894 4.893c.234.235.365.553.366.884v3.857"></path><path d="M16.873 6.873h-5a1.25 1.25 0 0 1-1.25-1.25v-5m7.5 18.75v-6.25m-1.25 0h2.5m-11.25 6.25v-6.25m-1.25 0h2.5m2.5 0 2.5 6.25m0-6.25-2.5 6.25"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const Um = { render: Il }, Zm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Um,
  render: Il
}, Symbol.toStringTag, { value: "Module" })), Gm = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "file-xls",
  viewBox: "0 0 20 20"
};
function Dl(t, e) {
  return d(), h("svg", Gm, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M4.374 19.373h-2.5a1.25 1.25 0 0 1-1.25-1.25V1.873a1.25 1.25 0 0 1 1.25-1.25h8.858c.331 0 .649.132.883.366l4.893 4.893c.235.235.366.553.366.884v3.857"></path><path d="M16.874 6.873h-5a1.25 1.25 0 0 1-1.25-1.25v-5m-3.75 12.5 2.5 6.25m0-6.25-2.5 6.25m5-6.25v5a1.25 1.25 0 0 0 1.25 1.25h1.25m5-6.25h-1.25a1.25 1.25 0 0 0-1.25 1.25c0 1.875 2.5 1.875 2.5 3.75a1.25 1.25 0 0 1-1.25 1.25h-1.25"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const Ym = { render: Dl }, Xm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ym,
  render: Dl
}, Symbol.toStringTag, { value: "Module" })), Km = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "file-zip",
  viewBox: "0 0 20 20"
};
function Nl(t, e) {
  return d(), h("svg", Km, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.875 19.375h-5a1.25 1.25 0 0 1-1.25-1.25V1.875a1.25 1.25 0 0 1 1.25-1.25h8.857c.332 0 .65.132.884.366l4.893 4.893c.234.234.366.552.366.883v3.858"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M16.875 6.875h-5a1.25 1.25 0 0 1-1.25-1.25v-5m-1.25 12.5h1.577a.625.625 0 0 1 .583.857L9.72 18.517a.626.626 0 0 0 .583.858h1.572m2.5 0v-6.25m2.5 6.25v-6.25m0 0h.625a1.875 1.875 0 1 1 0 3.75h-.625"
    }, null, -1)
  ]));
}
const Jm = { render: Nl }, Qm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jm,
  render: Nl
}, Symbol.toStringTag, { value: "Module" })), e6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "filled-square",
  viewBox: "0 0 20 20"
};
function Rl(t, e) {
  return d(), h("svg", e6, e[0] || (e[0] = [
    l("rect", {
      width: "20",
      height: "20",
      fill: "currentColor",
      rx: "2"
    }, null, -1)
  ]));
}
const t6 = { render: Rl }, o6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t6,
  render: Rl
}, Symbol.toStringTag, { value: "Module" })), n6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "filter",
  viewBox: "0 0 20 20"
};
function ql(t, e) {
  return d(), h("svg", n6, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 3.577h18.75M2.622 7.86h14.756M7.267 16.422h5.466M4.62 12.14h10.76"
    }, null, -1)
  ]));
}
const r6 = { render: ql }, s6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r6,
  render: ql
}, Symbol.toStringTag, { value: "Module" })), i6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "folder-open-fill",
  viewBox: "0 0 20 20"
};
function Wl(t, e) {
  return d(), h("svg", i6, e[0] || (e[0] = [
    W('<g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" d="M16.875 8.125v-2.5a1.25 1.25 0 0 0-1.25-1.25h-8.75v-1.25a1.25 1.25 0 0 0-1.25-1.25h-3.75a1.25 1.25 0 0 0-1.25 1.25v13.583a1.417 1.417 0 0 0 2.78.365l1.96-8.047a1.25 1.25 0 0 1 1.2-.901h11.56a1.25 1.25 0 0 1 1.208 1.572l-1.833 7.5a1.25 1.25 0 0 1-1.208.928H2.039"></path><path fill="currentColor" d="m3.333 17.917 2.5-9.584h12.5l1.25.834-2.5 8.75z"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const a6 = { render: Wl }, l6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a6,
  render: Wl
}, Symbol.toStringTag, { value: "Module" })), d6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "folder-open",
  viewBox: "0 0 20 20"
};
function Ul(t, e) {
  return d(), h("svg", d6, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M16.875 8.125v-2.5a1.25 1.25 0 0 0-1.25-1.25h-8.75v-1.25a1.25 1.25 0 0 0-1.25-1.25h-3.75a1.25 1.25 0 0 0-1.25 1.25v13.583a1.417 1.417 0 0 0 2.78.365l1.96-8.047a1.25 1.25 0 0 1 1.2-.901h11.56a1.25 1.25 0 0 1 1.208 1.572l-1.833 7.5a1.25 1.25 0 0 1-1.208.928H2.039"
    }, null, -1)
  ]));
}
const u6 = { render: Ul }, c6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u6,
  render: Ul
}, Symbol.toStringTag, { value: "Module" })), h6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "form",
  viewBox: "0 0 20 20"
};
function Zl(t, e) {
  return d(), h("svg", h6, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.542 5.872H1.458c-.46 0-.833.36-.833.804v9.643c0 .443.373.803.833.803h17.084c.46 0 .833-.36.833-.803V6.675c0-.444-.373-.804-.833-.804ZM.625 2.878h7"
    }, null, -1)
  ]));
}
const f6 = { render: Zl }, p6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: f6,
  render: Zl
}, Symbol.toStringTag, { value: "Module" })), m6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "forward-circle",
  viewBox: "0 0 20 20"
};
function Gl(t, e) {
  return d(), h("svg", m6, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M.625 9.998a9.375 9.375 0 1 0 18.75 0 9.375 9.375 0 0 0-18.75 0"></path><path d="M15.625 8.123H7.5a3.125 3.125 0 0 0 0 6.25"></path><path d="m13.125 5.623 2.5 2.5-2.5 2.5"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const v6 = { render: Gl }, g6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v6,
  render: Gl
}, Symbol.toStringTag, { value: "Module" })), _6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "gauge",
  viewBox: "0 0 20 20"
};
function Yl(t, e) {
  return d(), h("svg", _6, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M7.5 12.743v-.237a2.5 2.5 0 1 1 5 0v.237m-.623-8.363-1.875 5.626"></path><path fill="currentColor" d="M5.314 6.256a.312.312 0 1 0 0 .625.312.312 0 0 0 0-.625M15.94 9.38a.312.312 0 1 0 0 .626.312.312 0 0 0 0-.625Z"></path><path d="M14.69 6.256a.313.313 0 1 0 .219.091.3.3 0 0 0-.222-.091"></path><path fill="currentColor" d="M7.814 3.756a.312.312 0 1 0 0 .625.312.312 0 0 0 0-.625"></path><path d="M17.86 15.118a13.13 13.13 0 0 0-15.72 0"></path><path d="M.625 10.006a9.375 9.375 0 1 0 18.75 0 9.375 9.375 0 0 0-18.75 0"></path><path fill="currentColor" d="M4.064 9.38a.312.312 0 1 0 0 .626.312.312 0 0 0 0-.625Z"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const w6 = { render: Yl }, b6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: w6,
  render: Yl
}, Symbol.toStringTag, { value: "Module" })), k6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "ghost",
  viewBox: "0 0 15 18"
};
function Xl(t, e) {
  return d(), h("svg", k6, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M14.167 15.033c0 .228-.065.45-.187.64s-.296.337-.499.424-.426.11-.641.066a1.1 1.1 0 0 1-.569-.315l-.652-.675a1.075 1.075 0 0 0-1.57 0l-1.763 1.49a1.075 1.075 0 0 1-1.57 0l-1.764-1.49a1.074 1.074 0 0 0-1.57 0l-.652.675a1.075 1.075 0 0 1-1.21.25 1.1 1.1 0 0 1-.498-.425 1.2 1.2 0 0 1-.188-.64V7.917c0-1.834.702-3.594 1.953-4.891A6.55 6.55 0 0 1 7.5 1c1.768 0 3.463.729 4.714 2.026a7.05 7.05 0 0 1 1.952 4.891z"
    }, null, -1),
    l("circle", {
      cx: "5.168",
      cy: "8",
      r: "1",
      fill: "currentColor"
    }, null, -1),
    l("circle", {
      cx: "9.834",
      cy: "8",
      r: "1",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const y6 = { render: Xl }, x6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: y6,
  render: Xl
}, Symbol.toStringTag, { value: "Module" })), C6 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-token-name": "globe",
  viewBox: "0.25 0.25 23.5 23.5"
};
function Kl(t, e) {
  return d(), h("svg", C6, e[0] || (e[0] = [
    l("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      l("circle", {
        cx: "12",
        cy: "12",
        r: "11.25"
      }),
      l("path", { d: "M9.88 23.05c-1.57-2.2-2.63-6.33-2.63-11S8.31 3.15 9.88 1m4.24 22.05c1.57-2.2 2.63-6.33 2.63-11S15.69 3.15 14.12 1M.75 12h22.5m-21.2 5.25h19.9M2.05 6.75h19.9" })
    ], -1)
  ]));
}
const M6 = { render: Kl }, $6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M6,
  render: Kl
}, Symbol.toStringTag, { value: "Module" })), S6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "google-docs",
  viewBox: "0 0 20 20"
};
function Jl(t, e) {
  return d(), h("svg", S6, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M15.083 12.25h-3.858V8.775h8.15v1.717a9.39 9.39 0 1 1-2.5-6.909l-2.833 2.609A5.5 5.5 0 0 0 10 4.442a5.558 5.558 0 1 0 5.083 7.808M5.15 7.258 2.158 4.867m3 7.9L2.292 15.35m10.975-.858 2.558 2.875" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const j6 = { render: Jl }, O6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j6,
  render: Jl
}, Symbol.toStringTag, { value: "Module" })), T6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "google-drive-edit",
  viewBox: "0 0 21 20"
};
function Ql(t, e) {
  return d(), h("svg", T6, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M4.227 16.52h5.82m3.136-4.467h-6.4m6.461.03S7.65 2.051 7.41 1.63h5.278l4.503 7.446"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m7.401 1.63-5.836 10.1 2.662 4.79s5.572-9.769 5.82-10.183m9.557 6.743-5.45 5.436-2.678.534.536-2.672 5.45-5.436a1.51 1.51 0 0 1 2.137 0l.005.006a1.505 1.505 0 0 1 0 2.131v0Z"
    }, null, -1)
  ]));
}
const z6 = { render: Ql }, B6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z6,
  render: Ql
}, Symbol.toStringTag, { value: "Module" })), E6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "google-drive",
  viewBox: "0 0 20 20"
};
function e0(t, e) {
  return d(), h("svg", E6, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3.567 18.25H16.55l2.825-4.95H6.392"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M13.533 13.333h5.834L12.917 1.75H7.083c.267.467 6.45 11.583 6.45 11.583"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M7.075 1.75.625 12.942l2.942 5.308S9.725 7.425 10 6.967"
    }, null, -1)
  ]));
}
const P6 = { render: e0 }, A6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: P6,
  render: e0
}, Symbol.toStringTag, { value: "Module" })), L6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "hamburger-menu",
  viewBox: "0 0 20 20"
};
function t0(t, e) {
  return d(), h("svg", L6, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.875 15.002h16.25m-16.25-5h16.25m-16.25-5h16.25"
    }, null, -1)
  ]));
}
const H6 = { render: t0 }, V6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: H6,
  render: t0
}, Symbol.toStringTag, { value: "Module" })), F6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "handwritten",
  viewBox: "0 0 16 16"
};
function o0(t, e) {
  return d(), h("svg", F6, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.718 1.916c.377-.235.797-.258 1.245-.105.465.158.925.5 1.262.92.338.421.729 1.376 1.048 2.518q.06.213.113.423c-1.807.864-3.1 2.266-4.1 3.872-.75 1.202-1.592 2.844-1.289 4.62.152.885.684 1.48 1.422 1.718.663.214 1.387.11 1.982-.098 1.42-.494 2.38-1.884 2.94-2.845.905-1.552 1.253-3.176 1.178-4.929a10 10 0 0 0-.147-1.243 4 4 0 0 1 .518-.092q.886-.097 1.316.308c.076.071.155.206.199.466.043.263.038.582.004.935-.021.23-.046.405-.07.582-.019.13-.037.26-.054.414a3 3 0 0 0-.024.486c.005.083.018.205.06.335a.98.98 0 0 0 .364.497c.31.219.644.186.853.11.178-.064.304-.168.367-.225.134-.119.256-.274.346-.393.092-.121.174-.234.255-.347.121-.168.243-.337.403-.538.247-.31.485-.56.707-.716.219-.152.33-.15.379-.139.085.018.243.081.424.174a5 5 0 0 1 .258.142l.013.008v.001h.002a.857.857 0 0 0 .903-1.457l-.452.729.452-.729h-.002l-.002-.002-.008-.005-.024-.014a6 6 0 0 0-.36-.2 3.6 3.6 0 0 0-.856-.325c-.682-.142-1.274.11-1.706.41a4 4 0 0 0-.495.413 4 4 0 0 0-.046-.426c-.08-.48-.272-1.018-.717-1.436-.807-.757-1.844-.854-2.676-.762a6 6 0 0 0-.696.121l-.083-.305c-.32-1.146-.784-2.41-1.362-3.13C6.054 1.026 5.336.468 4.516.189c-.837-.285-1.81-.285-2.705.274C.647 1.187-.157 2.612.026 4.067c.087.69.289 1.248.678 1.752.363.472.858.85 1.41 1.24a.857.857 0 1 0 .989-1.401c-.551-.39-.851-.639-1.042-.886-.165-.214-.277-.466-.334-.919-.09-.712.323-1.52.99-1.937Zm1.022 8.535c.805-1.293 1.763-2.34 3-3.032.035.256.058.482.066.664.062 1.459-.223 2.752-.946 3.992-.556.953-1.247 1.82-2.023 2.09-.4.14-.715.143-.891.086a.3.3 0 0 1-.15-.092.6.6 0 0 1-.109-.283c-.187-1.097.323-2.253 1.053-3.425m5.403 2.406a.857.857 0 0 0 0 1.714h5.714a.857.857 0 0 0 0-1.714z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const I6 = { render: o0 }, D6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: I6,
  render: o0
}, Symbol.toStringTag, { value: "Module" })), N6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "heading-1",
  viewBox: "0 0 18 19"
};
function n0(t, e) {
  return d(), h("svg", N6, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M8.941 15H7.78v-4.71H2.53V15H1.367V5.006H2.53v4.259h5.25v-4.26h1.162zm5.594 0h-.95V8.338l.013-.457q.01-.21.029-.428a5 5 0 0 1-.34.322l-.393.323-.978.785-.51-.662 2.32-1.787h.81V15Z"
    }, null, -1)
  ]));
}
const R6 = { render: n0 }, q6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: R6,
  render: n0
}, Symbol.toStringTag, { value: "Module" })), W6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "heading-2",
  viewBox: "0 0 18 19"
};
function r0(t, e) {
  return d(), h("svg", W6, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M8.941 15H7.78v-4.71H2.53V15H1.367V5.006H2.53v4.259h5.25v-4.26h1.162zm7.586 0h-5.613v-.815l2.291-2.326q.639-.644 1.072-1.148.44-.504.668-.99a2.5 2.5 0 0 0 .229-1.078q0-.727-.434-1.108-.428-.387-1.13-.387-.616 0-1.09.211t-.973.598l-.522-.656a4.7 4.7 0 0 1 .739-.51 3.7 3.7 0 0 1 1.845-.48q.792 0 1.366.275.573.276.884.785.317.51.317 1.213 0 .68-.27 1.266-.27.58-.756 1.154a19 19 0 0 1-1.136 1.207l-1.864 1.857v.041h4.377z"
    }, null, -1)
  ]));
}
const U6 = { render: r0 }, Z6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U6,
  render: r0
}, Symbol.toStringTag, { value: "Module" })), G6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "history",
  viewBox: "0 0 20 20"
};
function s0(t, e) {
  return d(), h("svg", G6, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m7.636 14.67 2.499-2.5V8.002m1.663-2.292L8.465 3.004 12.215.71"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3.09 15.5A8.198 8.198 0 1 0 8.517 3.03M5.71 4.114a8.3 8.3 0 0 0-2.536 2.447M1.947 9.584a8.5 8.5 0 0 0 .108 3.522"
    }, null, -1)
  ]));
}
const Y6 = { render: s0 }, X6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y6,
  render: s0
}, Symbol.toStringTag, { value: "Module" })), K6 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "house",
  viewBox: "0 0 20 20"
};
function i0(t, e) {
  return d(), h("svg", K6, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3.557 11.519v6.445h4.688v-4.687a1.17 1.17 0 0 1 1.171-1.172h1.172a1.17 1.17 0 0 1 1.172 1.172v4.687h4.688V11.52M1.213 10.347l7.96-7.96a1.17 1.17 0 0 1 1.658 0l7.96 7.96"
    }, null, -1)
  ]));
}
const J6 = { render: i0 }, Q6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J6,
  render: i0
}, Symbol.toStringTag, { value: "Module" })), ev = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "image-caption",
  viewBox: "0 0 20 20"
};
function a0(t, e) {
  return d(), h("svg", ev, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M4.367 17.75h11.25"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1 3h18v11H1z"
    }, null, -1)
  ]));
}
const tv = { render: a0 }, ov = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tv,
  render: a0
}, Symbol.toStringTag, { value: "Module" })), nv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "image-cover",
  viewBox: "0 0 20 20"
};
function l0(t, e) {
  return d(), h("svg", nv, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1 3h18v14H1z"
    }, null, -1)
  ]));
}
const rv = { render: l0 }, sv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rv,
  render: l0
}, Symbol.toStringTag, { value: "Module" })), iv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "image-crop",
  viewBox: "0 0 20 20"
};
function d0(t, e) {
  return d(), h("svg", iv, e[0] || (e[0] = [
    W('<path fill="currentColor" d="M1 1.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0z"></path><path fill="currentColor" d="M3.5 2a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1zm16 0a.5.5 0 0 0 0-1h-3a.5.5 0 0 0 0 1z"></path><path fill="currentColor" d="M19 4.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0zm0 14a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0z"></path><path fill="currentColor" d="M16.5 18a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-16 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"></path><path fill="currentColor" d="M1 15.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M6 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0m9 5.99-3.24-3.774a.6.6 0 0 0-.222-.157.77.77 0 0 0-.584-.005.6.6 0 0 0-.226.153l-1.664 1.85-1.03-.642a.7.7 0 0 0-.23-.09.8.8 0 0 0-.497.06.6.6 0 0 0-.184.14L5 14"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M3.933 4a.9.9 0 0 0-.66.294A1.04 1.04 0 0 0 3 5.003v9.994c0 .266.098.521.273.71a.9.9 0 0 0 .66.293h12.134a.9.9 0 0 0 .66-.294c.175-.188.273-.443.273-.709v-8.02c0-.262-.095-.513-.265-.7L14.94 4.302a.9.9 0 0 0-.306-.223.9.9 0 0 0-.362-.079z"></path>', 7)
  ]));
}
const av = { render: d0 }, lv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: av,
  render: d0
}, Symbol.toStringTag, { value: "Module" })), dv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "image-full",
  viewBox: "0 0 20 20"
};
function u0(t, e) {
  return d(), h("svg", dv, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1 3h18v14H1z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M17 3H3v14h14z"
    }, null, -1)
  ]));
}
const uv = { render: u0 }, cv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uv,
  render: u0
}, Symbol.toStringTag, { value: "Module" })), hv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "image-half",
  viewBox: "0 0 20 20"
};
function c0(t, e) {
  return d(), h("svg", hv, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1 3h18v14H1z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M15 5H5v10h10z"
    }, null, -1)
  ]));
}
const fv = { render: c0 }, pv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fv,
  render: c0
}, Symbol.toStringTag, { value: "Module" })), mv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "image-original",
  viewBox: "0 0 20 20"
};
function h0(t, e) {
  return d(), h("svg", mv, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1 3h18v14H1z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M7.192 14H5.683V9.87l.015-.68.024-.742a8 8 0 0 1-.522.493l-.82.66-.728-.909 2.3-1.83h1.24zm1.953-.698q0-.41.22-.62t.64-.21q.405 0 .625.215.225.215.224.615 0 .385-.224.61-.225.22-.625.22-.41 0-.635-.215-.225-.22-.225-.615m0-4.033q0-.41.22-.62t.64-.21q.405 0 .625.214.225.216.224.616 0 .395-.23.615-.224.215-.62.215-.41 0-.634-.215t-.225-.615M15.357 14h-1.51V9.87l.015-.68.025-.742q-.376.375-.523.493l-.82.66-.728-.909 2.3-1.83h1.24z"
    }, null, -1)
  ]));
}
const vv = { render: h0 }, gv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vv,
  render: h0
}, Symbol.toStringTag, { value: "Module" })), _v = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "image-placeholder",
  viewBox: "0 0 20 20"
};
function f0(t, e) {
  return d(), h("svg", _v, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.731 18.125a1.25 1.25 0 0 1-1.25 1.25H2.519a1.25 1.25 0 0 1-1.25-1.25V1.875A1.25 1.25 0 0 1 2.52.625h12.5c.326 0 .64.127.873.355l2.462 2.402a1.25 1.25 0 0 1 .377.895z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M5.02 6.25a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0m10.658 8.917-3.271-4.907a.843.843 0 0 0-1.393-.016l-2.242 3.204-1.39-1.115a.84.84 0 0 0-1.229.191l-1.759 2.643"
    }, null, -1)
  ]));
}
const wv = { render: f0 }, bv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wv,
  render: f0
}, Symbol.toStringTag, { value: "Module" })), kv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "image-text-over",
  viewBox: "0 0 20 20"
};
function p0(t, e) {
  return d(), h("svg", kv, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 2.375A.625.625 0 0 0 .375 3v14c0 .345.28.625.625.625h18c.345 0 .625-.28.625-.625V3A.625.625 0 0 0 19 2.375zm3.742 9.375c0-.345.28-.625.625-.625h9.25a.625.625 0 1 1 0 1.25h-9.25a.625.625 0 0 1-.625-.625m-.875-3.875a.625.625 0 1 0 0 1.25h12.25a.625.625 0 1 0 0-1.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const yv = { render: p0 }, xv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yv,
  render: p0
}, Symbol.toStringTag, { value: "Module" })), Cv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "image",
  viewBox: "0 0 20 20"
};
function m0(t, e) {
  return d(), h("svg", Cv, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M4.336 7.082a1.563 1.563 0 1 0 3.125 0 1.563 1.563 0 0 0-3.125 0m12.499 7.048L13.19 8.668a.703.703 0 0 0-1.16-.013l-1.871 2.68-1.158-.931a.703.703 0 0 0-1.025.159L5.59 14.146"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.875 2.52a1.25 1.25 0 0 0-1.25 1.25v12.46a1.25 1.25 0 0 0 1.25 1.25h16.25a1.25 1.25 0 0 0 1.25-1.25v-10c0-.326-.127-.639-.355-.872l-2.402-2.463a1.25 1.25 0 0 0-.895-.376z"
    }, null, -1)
  ]));
}
const Mv = { render: m0 }, $v = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mv,
  render: m0
}, Symbol.toStringTag, { value: "Module" })), Sv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "info-circle",
  viewBox: "0 0 20 20"
};
function v0(t, e) {
  return d(), h("svg", Sv, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M11.875 13.75h-.625A1.25 1.25 0 0 1 10 12.5V9.375a.625.625 0 0 0-.625-.625H8.75"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M9.688 5.625a.312.312 0 1 0 0 .625.312.312 0 0 0 0-.625"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 10a9.375 9.375 0 1 0 18.75 0 9.375 9.375 0 0 0-18.75 0"
    }, null, -1)
  ]));
}
const jv = { render: v0 }, Ov = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jv,
  render: v0
}, Symbol.toStringTag, { value: "Module" })), Tv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "initials",
  viewBox: "0 0 20 20"
};
function g0(t, e) {
  return d(), h("svg", Tv, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M1.453 17.5V3.223h1.66V17.5zm16.748 0h-1.914L8.504 5.508h-.078l.068 1.094q.04.605.059 1.298.03.684.029 1.397V17.5H7.039V3.223h1.904l7.754 11.953h.069q-.02-.342-.05-.967l-.058-1.357q-.02-.733-.02-1.358V3.223h1.563z"
    }, null, -1)
  ]));
}
const zv = { render: g0 }, Bv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zv,
  render: g0
}, Symbol.toStringTag, { value: "Module" })), Ev = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "link-block",
  viewBox: "0 0 20 20"
};
function _0(t, e) {
  return d(), h("svg", Ev, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.133 6.877v-5a1.25 1.25 0 0 0-1.25-1.25h-15a1.25 1.25 0 0 0-1.25 1.25v13.75a1.25 1.25 0 0 0 1.25 1.25h5m-6.25-12.5h17.5m-3.746 11.774a1.9 1.9 0 0 1-.532 1.6l-1.077 1.077a2.013 2.013 0 0 1-2.846-2.845l1.077-1.077a1.9 1.9 0 0 1 1.565-.537m3.583.011a1.9 1.9 0 0 0 1.6-.532l1.076-1.077a2.013 2.013 0 0 0-2.845-2.845l-1.071 1.077a1.9 1.9 0 0 0-.537 1.565m-1.872 3.684 3.75-3.75"
    }, null, -1)
  ]));
}
const Pv = { render: _0 }, Av = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pv,
  render: _0
}, Symbol.toStringTag, { value: "Module" })), Lv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "link-broken",
  viewBox: "0 0 20 20"
};
function w0(t, e) {
  return d(), h("svg", Lv, e[0] || (e[0] = [
    l("g", {
      fill: "currentColor",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M5.036 4.68a.791.791 0 1 0 1.117-1.116L4.569 1.98a.792.792 0 0 0-1.116 1.117zm2.984-.617a.79.79 0 0 0 .793-.792V1.29a.792.792 0 0 0-1.584 0v1.98a.79.79 0 0 0 .792.792M2.804 7.625h1.979a.792.792 0 0 0 0-1.583h-1.98a.792.792 0 0 0 0 1.583m6.192 7.022-2.7 2.692a2.027 2.027 0 0 1-2.795 0l-.839-.84a1.97 1.97 0 0 1-.578-1.4 1.94 1.94 0 0 1 .578-1.394l2.692-2.7A.792.792 0 0 0 4.237 9.89l-2.7 2.692a3.586 3.586 0 0 0 0 5.043l.84.83a3.56 3.56 0 0 0 5.042 0l2.692-2.69a.792.792 0 0 0-1.116-1.117m6.848-8.606H12.28a.792.792 0 1 0 0 1.583h3.563a2.137 2.137 0 0 1 2.074 2.042v1.584a2.043 2.043 0 0 1-2.098 1.915H12.28a.792.792 0 1 0 0 1.584h3.539a3.6 3.6 0 0 0 3.681-3.5V9.668a3.697 3.697 0 0 0-3.658-3.625" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const Hv = { render: w0 }, Vv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hv,
  render: w0
}, Symbol.toStringTag, { value: "Module" })), Fv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "link",
  viewBox: "0 0 20 20"
};
function b0(t, e) {
  return d(), h("svg", Fv, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M8.402 7.917a3.73 3.73 0 0 0-2.777-1.25h-1.25a3.75 3.75 0 1 0 0 7.5h1.25a3.73 3.73 0 0 0 2.777-1.25m3.196-5a3.72 3.72 0 0 1 2.777-1.25h1.25a3.75 3.75 0 0 1 0 7.5h-1.25a3.73 3.73 0 0 1-2.777-1.25m-5.973-2.501h8.75"
    }, null, -1)
  ]));
}
const Iv = { render: b0 }, Dv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Iv,
  render: b0
}, Symbol.toStringTag, { value: "Module" })), Nv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "list",
  viewBox: "0 0 20 20"
};
function k0(t, e) {
  return d(), h("svg", Nv, e[0] || (e[0] = [
    l("circle", {
      cx: "5",
      cy: "4",
      r: "1.375",
      stroke: "currentColor",
      "stroke-width": "1.25"
    }, null, -1),
    l("circle", {
      cx: "5",
      cy: "10",
      r: "1.375",
      stroke: "currentColor",
      "stroke-width": "1.25"
    }, null, -1),
    l("circle", {
      cx: "5",
      cy: "16",
      r: "1.375",
      stroke: "currentColor",
      "stroke-width": "1.25"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.25",
      d: "M5 8V6m12-2H9m8 6H9m8 6H9m-4-2v-2"
    }, null, -1)
  ]));
}
const Rv = { render: k0 }, qv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rv,
  render: k0
}, Symbol.toStringTag, { value: "Module" })), Wv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "lock-shield",
  viewBox: "0 0 20 20"
};
function y0(t, e) {
  return d(), h("svg", Wv, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.875 3.27v6.344a9.92 9.92 0 0 0 6.36 9.261l.867.333a2.5 2.5 0 0 0 1.796 0l.867-.333a9.92 9.92 0 0 0 6.36-9.26V3.268a1.24 1.24 0 0 0-.723-1.135A18.1 18.1 0 0 0 10 .625a18.1 18.1 0 0 0-7.402 1.51 1.24 1.24 0 0 0-.723 1.134Z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M12.5 8.125h-5c-.69 0-1.25.56-1.25 1.25v3.75c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-3.75c0-.69-.56-1.25-1.25-1.25M10 4.375a2.5 2.5 0 0 0-2.5 2.5v1.25h5v-1.25a2.5 2.5 0 0 0-2.5-2.5"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.25",
      d: "M10 11.587a.312.312 0 1 1 0-.625m0 .625a.312.312 0 1 0 0-.625"
    }, null, -1)
  ]));
}
const Uv = { render: y0 }, Zv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Uv,
  render: y0
}, Symbol.toStringTag, { value: "Module" })), Gv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "lock",
  viewBox: "0 0 20 20"
};
function x0(t, e) {
  return d(), h("svg", Gv, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M15.625 8.125H4.375c-.69 0-1.25.56-1.25 1.25v8.75c0 .69.56 1.25 1.25 1.25h11.25c.69 0 1.25-.56 1.25-1.25v-8.75c0-.69-.56-1.25-1.25-1.25m-10 0V5a4.375 4.375 0 0 1 8.75 0v3.125M10 12.5V15"
    }, null, -1)
  ]));
}
const Yv = { render: x0 }, Xv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yv,
  render: x0
}, Symbol.toStringTag, { value: "Module" })), Kv = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "logout",
  viewBox: "0 0 20 20"
};
function C0(t, e) {
  return d(), h("svg", Kv, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M6.25 10.003h13.125m-3.125 3.125 3.125-3.125-3.125-3.125m-3.125 6.872v3.75a1.197 1.197 0 0 1-1.137 1.25H1.761A1.197 1.197 0 0 1 .625 17.5v-15a1.197 1.197 0 0 1 1.136-1.25h10.227a1.197 1.197 0 0 1 1.137 1.25v3.75" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const Jv = { render: C0 }, Qv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jv,
  render: C0
}, Symbol.toStringTag, { value: "Module" })), e7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "magnifying-glass-info",
  viewBox: "0 0 20 20"
};
function M0(t, e) {
  return d(), h("svg", e7, e[0] || (e[0] = [
    l("g", { "clip-path": "url(#clip0_4268_40995)" }, [
      l("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.25",
        d: "m13.518 13.517 5.857 5.859M1.227 11.13a7.553 7.553 0 1 0 13.902-5.908 7.553 7.553 0 0 0-13.902 5.909Z"
      })
    ], -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M9.5 11h-.4a.75.75 0 0 1-.566-.27 1 1 0 0 1-.234-.653V7.769a.5.5 0 0 0-.117-.326.38.38 0 0 0-.283-.135h-.4M8.1 5a.2.2 0 0 0-.111.039.23.23 0 0 0-.074.103.26.26 0 0 0-.011.134.24.24 0 0 0 .055.118.2.2 0 0 0 .102.063.18.18 0 0 0 .116-.013.2.2 0 0 0 .09-.085.26.26 0 0 0-.026-.291A.2.2 0 0 0 8.1 5"
    }, null, -1),
    l("circle", {
      cx: "8.1",
      cy: "5.199",
      r: ".5",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const t7 = { render: M0 }, o7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t7,
  render: M0
}, Symbol.toStringTag, { value: "Module" })), n7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "mail-sign-at",
  viewBox: "0 0 20 20"
};
function $0(t, e) {
  return d(), h("svg", n7, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M14.375 10a4.375 4.375 0 1 1-8.75 0 4.375 4.375 0 0 1 8.75 0"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M14.375 10v1.875a2.5 2.5 0 0 0 5 0V10a9.374 9.374 0 1 0-3.75 7.5"
    }, null, -1)
  ]));
}
const r7 = { render: $0 }, s7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r7,
  render: $0
}, Symbol.toStringTag, { value: "Module" })), i7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "mailbox",
  viewBox: "0 0 20 20"
};
function S0(t, e) {
  return d(), h("svg", i7, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M10.625 13.625v5.75M4 1h12.846c.571 0 1.12.362 1.523 1.005.404.643.631 1.515.631 2.424v7.714c0 .227-.057.445-.158.606-.1.16-.238.251-.38.251H7V4.819c0-2.182-.88-2.815-.88-2.815C5.378.94 4.571 1.001 4 1.001Z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M7 13H1.75a.7.7 0 0 1-.53-.251.92.92 0 0 1-.22-.606V4.429c0-.91.316-1.782.879-2.425C2.44 1.361 3.204 1 4 1s1.559.361 2.121 1.004S7 3.52 7 4.43zm2.709-7.125h7m-3.999.005v3.5c0 .399.21.78.586 1.061.375.282.884.44 1.414.44s1.04-.158 1.414-.44c.375-.28.586-.662.586-1.06v-3.5z"
    }, null, -1)
  ]));
}
const a7 = { render: S0 }, l7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a7,
  render: S0
}, Symbol.toStringTag, { value: "Module" })), d7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "megaphone",
  viewBox: "0 0 20 20"
};
function j0(t, e) {
  return d(), h("svg", d7, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m6.684 12.732 10.187 3.396a1.33 1.33 0 0 0 1.194-.185 1.33 1.33 0 0 0 .557-1.075V3.951a1.33 1.33 0 0 0-1.133-1.305c-.207-.03-.42-.01-.618.058L6.684 6.1zM1.377 9.416a3.316 3.316 0 0 0 3.317 3.316h1.99V6.1h-1.99a3.316 3.316 0 0 0-3.317 3.316m2.908 3.441v1.225c0 .402.037.8.11 1.171.07.372.176.71.309.994.132.284.29.51.463.663s.36.233.547.233"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.143 12.857v1.225c0 .402-.037.8-.11 1.171a4.3 4.3 0 0 1-.309.994 2 2 0 0 1-.463.663c-.174.154-.36.233-.547.233"
    }, null, -1)
  ]));
}
const u7 = { render: j0 }, c7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u7,
  render: j0
}, Symbol.toStringTag, { value: "Module" })), h7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "merge-tag",
  viewBox: "0 0 20 20"
};
function O0(t, e) {
  return d(), h("svg", h7, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M5.159.554C5.775.149 6.5 0 7.144 0a.65.65 0 0 1 .44.165.6.6 0 0 1 .135.186.54.54 0 0 1-.136.627.65.65 0 0 1-.44.164c-.428 0-.931.114-1.275.34s-.565.517-.565 1.09v4.57c0 1.116-.455 1.97-1.151 2.5-.209.16-.457.246-.69.358.233.111.481.198.69.357.696.53 1.15 1.384 1.15 2.5v4.571c0 .572.223.863.566 1.09.344.225.847.339 1.276.339a.65.65 0 0 1 .44.164.6.6 0 0 1 .135.186.54.54 0 0 1-.136.628.65.65 0 0 1-.44.165c-.643 0-1.368-.15-1.984-.554a2.39 2.39 0 0 1-1.084-2.018v-4.571c0-.853-.274-1.284-.71-1.616s-1.096-.538-1.86-.679a.63.63 0 0 1-.362-.196A.55.55 0 0 1 1 10c0-.134.05-.264.143-.367a.63.63 0 0 1 .362-.196c.764-.14 1.425-.347 1.86-.678s.71-.763.71-1.616V2.57c0-.904.468-1.612 1.084-2.017ZM12.797 0a.65.65 0 0 0-.426.187.54.54 0 0 0-.102.629.6.6 0 0 0 .143.18.63.63 0 0 0 .442.147c.429 0 .932.114 1.276.34s.565.517.565 1.089v4.571c0 1.116.455 1.97 1.151 2.5.209.16.456.246.69.357-.234.112-.481.198-.69.357-.696.531-1.15 1.385-1.15 2.5v4.572c0 .572-.223.863-.566 1.089-.344.226-.847.34-1.276.34a.65.65 0 0 0-.44.164.6.6 0 0 0-.135.186.54.54 0 0 0 .136.628.65.65 0 0 0 .44.164c.643 0 1.368-.149 1.984-.554a2.39 2.39 0 0 0 1.084-2.017v-4.572c0-.853.274-1.284.71-1.616.435-.331 1.096-.538 1.86-.678a.63.63 0 0 0 .362-.196.55.55 0 0 0 .143-.367.55.55 0 0 0-.143-.366.63.63 0 0 0-.363-.196c-.763-.14-1.424-.347-1.86-.679-.435-.331-.71-.763-.71-1.616V2.572c0-.904-.467-1.613-1.083-2.018S13.498.001 12.854.001h-.057Z"
    }, null, -1)
  ]));
}
const f7 = { render: O0 }, p7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: f7,
  render: O0
}, Symbol.toStringTag, { value: "Module" })), m7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "data-token-name": "microphone",
  viewBox: "-0.625 -0.625 20 20"
};
function T0(t, e) {
  return d(), h("svg", m7, e[0] || (e[0] = [
    l("path", {
      "stroke-width": "1.25",
      d: "M6.75 3.688a2.625 2.625 0 0 1 2.625-2.626h0A2.625 2.625 0 0 1 12 3.688v4.376a2.625 2.625 0 0 1-2.625 2.624h0A2.625 2.625 0 0 1 6.75 8.063Z"
    }, null, -1),
    l("path", {
      "stroke-width": "1.25",
      d: "M3.25 8.063c0 4.714 5.104 7.661 9.188 5.304A6.13 6.13 0 0 0 15.5 8.062m-9.625 9.626h7m-3.5-3.5v3.5"
    }, null, -1)
  ]));
}
const v7 = { render: T0 }, g7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v7,
  render: T0
}, Symbol.toStringTag, { value: "Module" })), _7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "minus-bold",
  viewBox: "0 0 20 20"
};
function z0(t, e) {
  return d(), h("svg", _7, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M5 10h10"
    }, null, -1)
  ]));
}
const w7 = { render: z0 }, b7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: w7,
  render: z0
}, Symbol.toStringTag, { value: "Module" })), k7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "minus-large",
  viewBox: "0 0 20 20"
};
function B0(t, e) {
  return d(), h("svg", k7, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M1 10h18"
    }, null, -1)
  ]));
}
const y7 = { render: B0 }, x7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: y7,
  render: B0
}, Symbol.toStringTag, { value: "Module" })), C7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "money-bag",
  viewBox: "-0.69 -0.69 22 22"
};
function E0(t, e) {
  return d(), h("svg", C7, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.38",
      d: "M11.662 10.954H9.916a1.153 1.153 0 0 0-.43 2.223l1.773.71a1.153 1.153 0 0 1-.43 2.222H9.086m1.288-5.155v-.644m0 6.444v-.645M5.863 7.088h9.021m-1.455-2.761 1.235-2.471A.644.644 0 0 0 13.8.99l-1.632.815a.644.644 0 0 1-.824-.22L10.91.932a.645.645 0 0 0-1.072 0l-.437.656a.644.644 0 0 1-.824.219L6.948.99a.645.645 0 0 0-.865.865l1.211 2.423"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.38",
      d: "m6.218 9.021-2.372 2.75a5.096 5.096 0 0 0 4.039 8.204h4.974a5.096 5.096 0 0 0 4.038-8.204l-2.371-2.75"
    }, null, -1)
  ]));
}
const M7 = { render: E0 }, $7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M7,
  render: E0
}, Symbol.toStringTag, { value: "Module" })), S7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "move-folder",
  viewBox: "0 0 20 20"
};
function P0(t, e) {
  return d(), h("svg", S7, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.823 9.375H1.427m8.573-5V2.583a.71.71 0 0 0-.708-.708H4.375v-.542a.71.71 0 0 0-.708-.708H1.333a.71.71 0 0 0-.708.708v7.241a.802.802 0 0 0 1.576.206l1.11-3.892a.71.71 0 0 1 .68-.513h6.55a.71.71 0 0 1 .686.89L10.44 7.98m7.685 6.395v-1.792a.71.71 0 0 0-.708-.708h-4.292v-.542a.71.71 0 0 0-.708-.708h-2.334a.71.71 0 0 0-.708.708v7.241a.802.802 0 0 0 1.576.206l1.11-3.893a.71.71 0 0 1 .68-.512h5.926a.71.71 0 0 1 .685.89l-1.04 3.584a.71.71 0 0 1-.684.526h-7.451M15.625 1.25l-2.373 1.3L14.375 5"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M19.375 6.875a5.624 5.624 0 0 0-5.824-3.673M4.375 19.375l2.373-1.3-1.123-2.45"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 13.75a5.63 5.63 0 0 0 5.825 3.673"
    }, null, -1)
  ]));
}
const j7 = { render: P0 }, O7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j7,
  render: P0
}, Symbol.toStringTag, { value: "Module" })), T7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "move-item",
  viewBox: "0 0 20 20"
};
function A0(t, e) {
  return d(), h("svg", T7, e[0] || (e[0] = [
    W('<g fill="currentColor" fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M16.911.304a.625.625 0 0 1-.214.857l-2.59 1.553 1.554 2.59a.625.625 0 0 1-1.072.643l-1.875-3.125a.625.625 0 0 1 .214-.858L16.053.09a.625.625 0 0 1 .858.215Z"></path><path d="M13.586 2.52a6.25 6.25 0 0 1 6.375 4.09.625.625 0 0 1-1.175.428 5 5 0 0 0-5.099-3.272.625.625 0 1 1-.1-1.246ZM4.554 13.84a.625.625 0 0 1 .857.213l1.875 3.125a.625.625 0 0 1-.214.858l-3.125 1.875a.625.625 0 0 1-.643-1.072l2.589-1.553-1.554-2.59a.625.625 0 0 1 .215-.857Z"></path><path d="M.411 12.589a.625.625 0 0 1 .801.373 5 5 0 0 0 5.1 3.272.625.625 0 0 1 .1 1.246 6.25 6.25 0 0 1-6.374-4.09.625.625 0 0 1 .373-.801M0 .625C0 .28.28 0 .625 0h10c.345 0 .625.28.625.625v10c0 .345-.28.625-.625.625h-10A.625.625 0 0 1 0 10.625zm1.25.625V10H10V1.25z"></path><path d="M12.5 9.375c0-.345.28-.625.625-.625h5A1.875 1.875 0 0 1 20 10.625v7.5A1.875 1.875 0 0 1 18.125 20h-7.5a1.875 1.875 0 0 1-1.875-1.875v-5a.625.625 0 1 1 1.25 0v5a.624.624 0 0 0 .625.625h7.5a.624.624 0 0 0 .625-.625v-7.5a.624.624 0 0 0-.625-.625h-5a.625.625 0 0 1-.625-.625"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const z7 = { render: A0 }, B7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z7,
  render: A0
}, Symbol.toStringTag, { value: "Module" })), E7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "move-to-block-above",
  viewBox: "0 0 20 20"
};
function L0(t, e) {
  return d(), h("svg", E7, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M2.2 1h15.6s1.2 0 1.2.81v2.427s0 .81-1.2.81H2.2s-1.2 0-1.2-.81V1.81S1 1 2.2 1M10 9.047V19m-3.555-6.398L10 9.047l3.555 3.555" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const P7 = { render: L0 }, A7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: P7,
  render: L0
}, Symbol.toStringTag, { value: "Module" })), L7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "move-to-block-below",
  viewBox: "0 0 20 20"
};
function H0(t, e) {
  return d(), h("svg", L7, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M10 10.953V1M6.445 7.398 10 10.953l3.555-3.555M2.2 14.953h15.6s1.2 0 1.2.81v2.428S19 19 17.8 19H2.2S1 19 1 18.19v-2.428s0-.809 1.2-.809" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const H7 = { render: H0 }, V7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: H7,
  render: H0
}, Symbol.toStringTag, { value: "Module" })), F7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "move-to-first-block",
  viewBox: "0 0 20 20"
};
function V0(t, e) {
  return d(), h("svg", F7, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-width="1.25" clip-path="url(#a)"><path d="M1 1h18"></path><path stroke-linejoin="round" d="M2.2 5h15.6S19 5 19 6v3s0 1-1.2 1H2.2S1 10 1 9V6s0-1 1.2-1m7.8 9v5m-3-3 3-2 3 2"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const I7 = { render: V0 }, D7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: I7,
  render: V0
}, Symbol.toStringTag, { value: "Module" })), N7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "move-to-last-block",
  viewBox: "0 0 20 20"
};
function F0(t, e) {
  return d(), h("svg", N7, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-width="1.25" clip-path="url(#a)"><path d="M1 19h18"></path><path stroke-linejoin="round" d="M2.2 15h15.6s1.2 0 1.2-1v-3s0-1-1.2-1H2.2S1 10 1 11v3s0 1 1.2 1M10 6V1M7 4l3 2 3-2"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 20h20V0H0z"></path></clipPath></defs>', 2)
  ]));
}
const R7 = { render: F0 }, q7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: R7,
  render: F0
}, Symbol.toStringTag, { value: "Module" })), W7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "normal-text",
  viewBox: "0 0 18 19"
};
function I0(t, e) {
  return d(), h("svg", W7, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M9.18 15H7.855L2.393 6.612h-.055q.11 1.477.11 2.707V15H1.373V5.006h1.313l5.448 8.353h.054a76 76 0 0 1-.061-1.182 21 21 0 0 1-.034-1.436V5.006H9.18zm5.19 0h-.997V7.318H10.66v-.884h6.422v.884h-2.713z"
    }, null, -1)
  ]));
}
const U7 = { render: I0 }, Z7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U7,
  render: I0
}, Symbol.toStringTag, { value: "Module" })), G7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "ordered-list",
  viewBox: "0 0 20 20"
};
function D0(t, e) {
  return d(), h("svg", G7, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.875 3.125h12.5m-12.5 7.5h12.5m-12.5 7.5h12.5M.668 15.302a1.25 1.25 0 1 1 1.208 1.573 1.25 1.25 0 1 1-1.204 1.583M.625 9.375a1.25 1.25 0 1 1 2.5 0c0 .405-.137.797-.39 1.113l-2.11 1.387h2.5M.625.625h.625a.625.625 0 0 1 .625.625v4.375m-1.25 0h2.5"
    }, null, -1)
  ]));
}
const Y7 = { render: D0 }, X7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y7,
  render: D0
}, Symbol.toStringTag, { value: "Module" })), K7 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "outline-square",
  viewBox: "0 0 20 20"
};
function N0(t, e) {
  return d(), h("svg", K7, e[0] || (e[0] = [
    l("g", { "clip-path": "url(#a)" }, [
      l("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.25",
        d: "M16.875.625H3.125a2.5 2.5 0 0 0-2.5 2.5v13.75a2.5 2.5 0 0 0 2.5 2.5h13.75a2.5 2.5 0 0 0 2.5-2.5V3.125a2.5 2.5 0 0 0-2.5-2.5"
      })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const J7 = { render: N0 }, Q7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J7,
  render: N0
}, Symbol.toStringTag, { value: "Module" })), eg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "page-break",
  viewBox: "0 0 20 20"
};
function R0(t, e) {
  return d(), h("svg", eg, e[0] || (e[0] = [
    W('<g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.125 7.5V2.431c0-.309.105-.605.293-.824a1 1 0 0 1 .324-.252.9.9 0 0 1 .382-.09h7.58c.264 0 3.997-.083 4.184.135l2.108 2.46c.187.218.129 2.081.129 2.39V7.5m-15 8v2.084c0 .31.105.606.293.825a.93.93 0 0 0 .706.341h12.988a.9.9 0 0 0 .383-.089q.183-.088.324-.252.14-.165.216-.379a1.3 1.3 0 0 0 .076-.446l.014-2.084"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.375 1.25v3.115a.635.635 0 0 0 .634.635h3.116"></path><path stroke="currentColor" stroke-dasharray="2 2" stroke-linecap="round" stroke-width="2" d="M1.303 11.563h17.5"></path><path fill="currentColor" d="M3.531 11.043a.6.6 0 0 1 0 1.04l-2.419 1.396a.6.6 0 0 1-.9-.52v-2.793a.6.6 0 0 1 .9-.52z"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 20h20V0H0z"></path></clipPath></defs>', 2)
  ]));
}
const tg = { render: R0 }, og = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tg,
  render: R0
}, Symbol.toStringTag, { value: "Module" })), ng = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "paintbrush",
  viewBox: "0 0 16 16"
};
function q0(t, e) {
  return d(), h("svg", ng, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M7.094 13.265c-1.592 1.603-4.298 2.134-5.86.53 2.082-2.154 0-3.194 1.562-4.756a3.018 3.018 0 1 1 4.257 4.268z"></path><path d="m5.607 8.083 5.522-6.158c.785-.882 2.201-.926 3.04-.093.832.837.788 2.254-.095 3.039L7.98 10.329"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"></path></clipPath></defs>', 2)
  ]));
}
const rg = { render: q0 }, sg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rg,
  render: q0
}, Symbol.toStringTag, { value: "Module" })), ig = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "painting-palette",
  viewBox: "0 0 20 20"
};
function W0(t, e) {
  return d(), h("svg", ig, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M11.946 7.261a1.391 1.391 0 1 0 0-2.782 1.391 1.391 0 0 0 0 2.782M6.38 14.218a.696.696 0 1 0 0-1.391.696.696 0 0 0 0 1.391m0-4.87a1.391 1.391 0 1 0 0-2.783 1.391 1.391 0 0 0 0 2.783"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M13.365 17.39a1.39 1.39 0 0 0-.904-1.224 2.783 2.783 0 0 1 .876-5.426h2.602a2.783 2.783 0 0 0 2.63-3.715 9.043 9.043 0 1 0-8.53 12.063 8.8 8.8 0 0 0 2.422-.334 1.25 1.25 0 0 0 .904-1.364"
    }, null, -1)
  ]));
}
const ag = { render: W0 }, lg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ag,
  render: W0
}, Symbol.toStringTag, { value: "Module" })), dg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "pen-circle",
  viewBox: "0 0 20 20"
};
function U0(t, e) {
  return d(), h("svg", dg, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M8.47 12.587 6 12.941l.353-2.471 5.031-5.031a1.497 1.497 0 0 1 2.117 2.117z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 10a9.375 9.375 0 1 0 18.75 0 9.375 9.375 0 0 0-18.75 0"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 15.25h5.953c.214 0 .427-.035.63-.105v0c.274-.095.524-.252.73-.457L14 14"
    }, null, -1)
  ]));
}
const ug = { render: U0 }, cg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ug,
  render: U0
}, Symbol.toStringTag, { value: "Module" })), hg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "pen-to-square",
  viewBox: "0 0 20 20"
};
function Z0(t, e) {
  return d(), h("svg", hg, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m7 10-1 4 4-1 6-6-3-3z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m15.037 8 3.544-3.543a1.43 1.43 0 0 0 0-2.025l-1.013-1.013a1.43 1.43 0 0 0-2.024 0L12 4.962"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M19 10v7.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1H10"
    }, null, -1)
  ]));
}
const fg = { render: Z0 }, pg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fg,
  render: Z0
}, Symbol.toStringTag, { value: "Module" })), mg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "pen-write",
  viewBox: "0 0 24 24"
};
function G0(t, e) {
  return d(), h("svg", mg, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M22.588 4.591a2.25 2.25 0 1 0-3.182-3.182L8.14 12.675l3.182 3.182z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.14 12.675 6.747 17.25l4.575-1.393m6.959-13.323 3.182 3.182M3.747 18.75H3a2.25 2.25 0 1 0 0 4.5h15.75"
    }, null, -1)
  ]));
}
const vg = { render: G0 }, gg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vg,
  render: G0
}, Symbol.toStringTag, { value: "Module" })), _g = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "percentage",
  viewBox: "0 0 20 20"
};
function Y0(t, e) {
  return d(), h("svg", _g, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1 19 19 1zm12.25-3.25a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0M2 4.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0"
    }, null, -1)
  ]));
}
const wg = { render: Y0 }, bg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wg,
  render: Y0
}, Symbol.toStringTag, { value: "Module" })), kg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "phone-call",
  viewBox: "0 0 20 20"
};
function X0(t, e) {
  return d(), h("svg", kg, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M14.7 14.483c-.45-.367-.942-.7-1.425-1.033-.958-.675-1.833-.725-2.55.358a1.11 1.11 0 0 1-1.558.358 6.88 6.88 0 0 1-3.592-3.5 1.36 1.36 0 0 1 .442-1.9 1.34 1.34 0 0 0 .766-1.191C6.742 6.8 4.858 4.242 4.117 3.933a1.33 1.33 0 0 0-.934 0c-8.941 3.242 8.642 22.25 12.55 12.5.375-1.05-.408-1.466-1.033-1.966zm4.559-5.091A12.24 12.24 0 0 0 10.834.958M9.025 6.425a5.175 5.175 0 0 1 4.767 4.758m2.791-.791a8.72 8.72 0 0 0-6.666-6.734"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M13.792 11.183a5.175 5.175 0 0 0-4.767-4.758"
    }, null, -1)
  ]));
}
const yg = { render: X0 }, xg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yg,
  render: X0
}, Symbol.toStringTag, { value: "Module" })), Cg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "phone",
  viewBox: "0 0 20 20"
};
function K0(t, e) {
  return d(), h("svg", Cg, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M13.125.625h-6.25a2.5 2.5 0 0 0-2.5 2.5v13.75a2.5 2.5 0 0 0 2.5 2.5h6.25a2.5 2.5 0 0 0 2.5-2.5V3.125a2.5 2.5 0 0 0-2.5-2.5m-8.75 14.167h11.25"
    }, null, -1)
  ]));
}
const Mg = { render: K0 }, $g = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mg,
  render: K0
}, Symbol.toStringTag, { value: "Module" })), Sg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "pin",
  viewBox: "0 0 20 20"
};
function J0(t, e) {
  return d(), h("svg", Sg, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.125",
      d: "M4.986 7.713a1.067 1.067 0 0 0-.213 1.676l5.84 5.84a1.066 1.066 0 0 0 1.675-.213 5.35 5.35 0 0 0 .576-3.94l4.643-2.955a1.066 1.066 0 0 0 .182-1.654l-4.155-4.155a1.067 1.067 0 0 0-1.654.182L8.925 7.137a5.35 5.35 0 0 0-3.94.576ZM7.69 12.31 2 18"
    }, null, -1)
  ]));
}
const jg = { render: J0 }, Og = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jg,
  render: J0
}, Symbol.toStringTag, { value: "Module" })), Tg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "play",
  viewBox: "0 0 27 29"
};
function Q0(t, e) {
  return d(), h("svg", Tg, e[0] || (e[0] = [
    W('<g filter="url(#a)"><path fill="currentColor" d="M20.346 12.134a1 1 0 0 1 0 1.732l-12 6.928a1 1 0 0 1-1.5-.866V6.072a1 1 0 0 1 1.5-.866z"></path></g><defs><filter id="a" width="26" height="27.859" x=".846" y=".57" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix><feOffset dy="1.5"></feOffset><feGaussianBlur stdDeviation="3"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix values="0 0 0 0 0.1728 0 0 0 0 0.230776 0 0 0 0 0.3072 0 0 0 0.2 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5651_36797"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_5651_36797" result="shape"></feBlend></filter></defs>', 2)
  ]));
}
const zg = { render: Q0 }, Bg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zg,
  render: Q0
}, Symbol.toStringTag, { value: "Module" })), Eg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "plus-bold",
  viewBox: "0 0 20 20"
};
function e1(t, e) {
  return d(), h("svg", Eg, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M4.1 10h11.8M10 4.1v11.8"
    }, null, -1)
  ]));
}
const Pg = { render: e1 }, Ag = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pg,
  render: e1
}, Symbol.toStringTag, { value: "Module" })), Lg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "plus-large",
  viewBox: "0 0 20 20"
};
function t1(t, e) {
  return d(), h("svg", Lg, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 10h18.75M10 .625v18.75"
    }, null, -1)
  ]));
}
const Hg = { render: t1 }, Vg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hg,
  render: t1
}, Symbol.toStringTag, { value: "Module" })), Fg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "plus-small-bold",
  viewBox: "0 0 20 20"
};
function o1(t, e) {
  return d(), h("svg", Fg, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M5 10h10m-5-5v10"
    }, null, -1)
  ]));
}
const Ig = { render: o1 }, Dg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ig,
  render: o1
}, Symbol.toStringTag, { value: "Module" })), Ng = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "plus-xsmall-bold",
  viewBox: "0 0 20 20"
};
function n1(t, e) {
  return d(), h("svg", Ng, e[0] || (e[0] = [
    l("circle", {
      cx: "10",
      cy: "10",
      r: "9"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M10.059 7v6m-3-3h6"
    }, null, -1)
  ]));
}
const Rg = { render: n1 }, qg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rg,
  render: n1
}, Symbol.toStringTag, { value: "Module" })), Wg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "plus",
  viewBox: "0 0 20 20"
};
function r1(t, e) {
  return d(), h("svg", Wg, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 10h12m-6-6v12"
    }, null, -1)
  ]));
}
const Ug = { render: r1 }, Zg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ug,
  render: r1
}, Symbol.toStringTag, { value: "Module" })), Gg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "presentation",
  viewBox: "0 0 20 20"
};
function s1(t, e) {
  return d(), h("svg", Gg, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M13.125.625h-6.25c-.69 0-1.25.56-1.25 1.25v16.25c0 .69.56 1.25 1.25 1.25h6.25c.69 0 1.25-.56 1.25-1.25V1.875c0-.69-.56-1.25-1.25-1.25M2.5 3.125H1.25a.625.625 0 0 0-.625.625v12.5c0 .345.28.625.625.625H2.5c.345 0 .625-.28.625-.625V3.75a.625.625 0 0 0-.625-.625m16.25 0H17.5a.625.625 0 0 0-.625.625v12.5c0 .345.28.625.625.625h1.25c.345 0 .625-.28.625-.625V3.75a.625.625 0 0 0-.625-.625" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const Yg = { render: s1 }, Xg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yg,
  render: s1
}, Symbol.toStringTag, { value: "Module" })), Kg = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "pricing-group",
  viewBox: "0 0 20 20"
};
function i1(t, e) {
  return d(), h("svg", Kg, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.875 16.875h-5a1.25 1.25 0 0 1-1.25-1.25V1.875a1.25 1.25 0 0 1 1.25-1.25h12.5a1.25 1.25 0 0 1 1.25 1.25V7.5"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 14.375H4.375a.625.625 0 0 1-.625-.625v-3.125A.625.625 0 0 1 4.375 10H10.5m1.375-6.875h-7.5a.625.625 0 0 0-.625.625v3.125c0 .345.28.625.625.625h7.5c.345 0 .625-.28.625-.625V3.75a.625.625 0 0 0-.625-.625M14 19a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.8 13.4h-1.084a.716.716 0 0 0-.267 1.38l1.101.44a.716.716 0 0 1-.267 1.38H13.2m.8-3.201v-.8m0 4.8v-.8"
    }, null, -1)
  ]));
}
const Jg = { render: i1 }, Qg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jg,
  render: i1
}, Symbol.toStringTag, { value: "Module" })), e8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "print",
  viewBox: "0 0 20 20"
};
function a1(t, e) {
  return d(), h("svg", e8, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M4.375 14.374h-2.5a1.25 1.25 0 0 1-1.25-1.25v-6.25a1.25 1.25 0 0 1 1.25-1.25h16.25a1.25 1.25 0 0 1 1.25 1.25v6.25a1.25 1.25 0 0 1-1.25 1.25h-2.5m-12.5-6.25h1.25"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M4.375 10.624h11.25v8.75H4.375zm11.25-5H4.375v-3.75a1.25 1.25 0 0 1 1.25-1.25h8.75a1.25 1.25 0 0 1 1.25 1.25z"
    }, null, -1)
  ]));
}
const t8 = { render: a1 }, o8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t8,
  render: a1
}, Symbol.toStringTag, { value: "Module" })), n8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "processing",
  viewBox: "0 0 20 20"
};
function l1(t, e) {
  return d(), h("svg", n8, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M15.302 5.833a6.875 6.875 0 0 0-12.177 4.373v1.877M5 14.923a6.875 6.875 0 0 0 11.875-4.717v-1.25"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m.625 9.58 2.5 2.5 2.5-2.5m13.75 1.876-2.5-2.5-2.5 2.5"
    }, null, -1)
  ]));
}
const r8 = { render: l1 }, s8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r8,
  render: l1
}, Symbol.toStringTag, { value: "Module" })), i8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "product-library",
  viewBox: "0 0 20 20"
};
function d1(t, e) {
  return d(), h("svg", i8, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.514 3.77 9.098.797a2.45 2.45 0 0 1 1.801 0l7.584 2.973a1.47 1.47 0 0 1 .892 1.385v9.69a1.47 1.47 0 0 1-.89 1.385l-7.582 2.974a2.46 2.46 0 0 1-1.802 0L1.518 16.23a1.47 1.47 0 0 1-.893-1.385v-9.69a1.47 1.47 0 0 1 .89-1.385ZM10 7.794.92 4.234M10 7.794l9.08-3.56M10 19.375V7.794"
    }, null, -1)
  ]));
}
const a8 = { render: d1 }, l8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a8,
  render: d1
}, Symbol.toStringTag, { value: "Module" })), d8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "publish",
  viewBox: "0 0 20 20"
};
function u1(t, e) {
  return d(), h("svg", d8, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.125",
      d: "m17.888 2.168-1.618.18a5.63 5.63 0 0 0-3.356 1.613l-7.356 7.355 3.18 3.182 7.357-7.355a5.62 5.62 0 0 0 1.613-3.357z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.125",
      d: "m5.558 11.317-2.716-.906a.562.562 0 0 1-.22-.93l.174-.174a4.5 4.5 0 0 1 4.605-1.088l.941.314z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.125",
      d: "m5.558 11.317-2.716-.906a.562.562 0 0 1-.22-.93l.174-.174a4.5 4.5 0 0 1 4.605-1.088l.941.314zm3.181 3.18.906 2.716a.562.562 0 0 0 .93.22l.175-.174a4.5 4.5 0 0 0 1.087-4.605l-.312-.937z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.125",
      d: "m8.739 14.497.906 2.716a.562.562 0 0 0 .93.22l.175-.174a4.5 4.5 0 0 0 1.087-4.605l-.312-.937zm-1.891.4a1.68 1.68 0 0 1-.495 1.193c-.658.659-3.975 1.591-3.975 1.591s.933-3.319 1.591-3.975c.29-.29.674-.464 1.083-.491"
    }, null, -1)
  ]));
}
const u8 = { render: u1 }, c8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u8,
  render: u1
}, Symbol.toStringTag, { value: "Module" })), h8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "data-token-name": "puzzle",
  viewBox: "-0.5 -0.5 20 20"
};
function c1(t, e) {
  return d(), h("svg", h8, e[0] || (e[0] = [
    l("path", { d: "M2.052 4.845h2.793a.93.93 0 0 0 .931-.931v-.931c0-1.433 1.552-2.33 2.793-1.613.576.333.931.948.931 1.613v.931c0 .514.417.931.931.931h2.793c.514 0 .931.417.931.931v2.793c0 .514.417.931.931.931h.931c1.433 0 2.33 1.552 1.612 2.793a1.86 1.86 0 0 1-1.612.931h-.931a.93.93 0 0 0-.931.931v2.793a.93.93 0 0 1-.931.931h-2.793a.93.93 0 0 1-.931-.931v-.931c0-1.433-1.552-2.33-2.793-1.613a1.86 1.86 0 0 0-.931 1.613v.931a.93.93 0 0 1-.931.931H2.052a.93.93 0 0 1-.931-.931v-2.793c0-.514.417-.931.931-.931h.931c1.433 0 2.33-1.552 1.613-2.793A1.86 1.86 0 0 0 2.983 9.5h-.931a.93.93 0 0 1-.931-.931V5.776c0-.514.417-.931.931-.931" }, null, -1)
  ]));
}
const f8 = { render: c1 }, p8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: f8,
  render: c1
}, Symbol.toStringTag, { value: "Module" })), m8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "question-circle",
  viewBox: "0 0 20 20"
};
function h1(t, e) {
  return d(), h("svg", m8, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M7.5 7.5a2.5 2.5 0 1 1 3.333 2.357 1.25 1.25 0 0 0-.833 1.18v.838"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-width": "1.25",
      d: "M10 15a.312.312 0 1 1 0-.625M10 15a.312.312 0 1 0 0-.625"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      "stroke-width": "1.25",
      d: "M10 19.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75Z"
    }, null, -1)
  ]));
}
const v8 = { render: h1 }, g8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v8,
  render: h1
}, Symbol.toStringTag, { value: "Module" })), _8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "replace-item",
  viewBox: "0 0 20 20"
};
function f1(t, e) {
  return d(), h("svg", _8, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.911.304a.625.625 0 0 1-.214.857l-2.59 1.553 1.554 2.59a.625.625 0 0 1-1.072.643l-1.875-3.125a.625.625 0 0 1 .214-.858L16.053.09a.625.625 0 0 1 .858.215Z",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.586 2.52a6.25 6.25 0 0 1 6.375 4.09.625.625 0 0 1-1.175.428 5 5 0 0 0-5.099-3.272.625.625 0 1 1-.1-1.246ZM4.554 13.84a.625.625 0 0 1 .857.213l1.875 3.125a.625.625 0 0 1-.214.858l-3.125 1.875a.625.625 0 0 1-.643-1.072l2.589-1.553-1.554-2.59a.625.625 0 0 1 .215-.857Z",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.411 12.589a.625.625 0 0 1 .801.373 5 5 0 0 0 5.1 3.272.625.625 0 0 1 .1 1.246 6.25 6.25 0 0 1-6.374-4.09.625.625 0 0 1 .373-.801M12.5 9.375c0-.345.28-.625.625-.625h5A1.875 1.875 0 0 1 20 10.625v7.5A1.875 1.875 0 0 1 18.125 20h-7.5a1.875 1.875 0 0 1-1.875-1.875v-5a.625.625 0 1 1 1.25 0v5a.624.624 0 0 0 .625.625h7.5a.624.624 0 0 0 .625-.625v-7.5a.624.624 0 0 0-.625-.625h-5a.625.625 0 0 1-.625-.625",
      "clip-rule": "evenodd"
    }, null, -1),
    l("rect", {
      width: "9.75",
      height: "9.75",
      x: ".625",
      y: ".625",
      stroke: "currentColor",
      "stroke-width": "1.25",
      rx: "1.375"
    }, null, -1)
  ]));
}
const w8 = { render: f1 }, b8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: w8,
  render: f1
}, Symbol.toStringTag, { value: "Module" })), k8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "replace-video",
  viewBox: "0 0 20 20"
};
function p1(t, e) {
  return d(), h("svg", k8, e[0] || (e[0] = [
    W('<path fill="currentColor" fill-rule="evenodd" d="M16.911.304a.625.625 0 0 1-.214.857l-2.59 1.553 1.554 2.59a.625.625 0 0 1-1.072.643l-1.875-3.125a.625.625 0 0 1 .214-.858L16.053.09a.625.625 0 0 1 .858.215Z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M13.586 2.52a6.25 6.25 0 0 1 6.375 4.09.625.625 0 0 1-1.175.428 5 5 0 0 0-5.099-3.272.625.625 0 1 1-.1-1.246ZM4.554 13.84a.625.625 0 0 1 .857.213l1.875 3.125a.625.625 0 0 1-.214.858l-3.125 1.875a.625.625 0 0 1-.643-1.072l2.589-1.553-1.554-2.59a.625.625 0 0 1 .215-.857Z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M.411 12.589a.625.625 0 0 1 .801.373 5 5 0 0 0 5.1 3.272.625.625 0 0 1 .1 1.246 6.25 6.25 0 0 1-6.374-4.09.625.625 0 0 1 .373-.801M12.5 9.375c0-.345.28-.625.625-.625h5A1.875 1.875 0 0 1 20 10.625v7.5A1.875 1.875 0 0 1 18.125 20h-7.5a1.875 1.875 0 0 1-1.875-1.875v-5a.625.625 0 1 1 1.25 0v5a.624.624 0 0 0 .625.625h7.5a.624.624 0 0 0 .625-.625v-7.5a.624.624 0 0 0-.625-.625h-5a.625.625 0 0 1-.625-.625" clip-rule="evenodd"></path><rect width="9.75" height="9.75" x=".625" y=".625" stroke="currentColor" stroke-width="1.25" rx="1.375"></rect><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M4.16 7.453a.456.456 0 0 1-.66-.409V3.957a.457.457 0 0 1 .66-.409l3.087 1.544a.456.456 0 0 1 0 .816zm9 8.998a.456.456 0 0 1-.66-.408v-3.087a.457.457 0 0 1 .66-.409l3.087 1.544a.456.456 0 0 1 0 .817L13.16 16.45Z"></path>', 5)
  ]));
}
const y8 = { render: p1 }, x8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: y8,
  render: p1
}, Symbol.toStringTag, { value: "Module" })), C8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "reverse",
  viewBox: "0 0 20 20"
};
function m1(t, e) {
  return d(), h("svg", C8, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.25",
      d: "M5.5 4.248A8.2 8.2 0 0 0 4.017 5.5a8.195 8.195 0 1 0 4.778-2.511"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M11.798 5.71 8.465 3.004 12.215.71"
    }, null, -1)
  ]));
}
const M8 = { render: m1 }, $8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M8,
  render: m1
}, Symbol.toStringTag, { value: "Module" })), S8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "rocket",
  viewBox: "0 0 24 24"
};
function v1(t, e) {
  return d(), h("svg", S8, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.263 21.423c-1.434 1.435-4.321.807-4.321.807s-.629-2.888.806-4.322c1.434-1.435 2.737-.338 3.3.215s1.66 1.857.215 3.3M19.305 5.091l1.218-1.228M10.436 16.995l.16 2.682a.53.53 0 0 0 .337.375.45.45 0 0 0 .46-.094l3.112-2.597a1.77 1.77 0 0 0 .375-1.875l-.403-1.013 3.206-1.94a3.84 3.84 0 0 0 1.819-3.16l-.16-4.284-4.284-.16a3.86 3.86 0 0 0-3.169 1.773l-2.156 3.571-1.031-.365a1.78 1.78 0 0 0-1.875.365l-2.353 2.72a.43.43 0 0 0-.094.468.55.55 0 0 0 .366.337l2.915.422z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M15.055 9.688a.351.351 0 1 1 0-.704m0 .704a.352.352 0 0 0 0-.704"
    }, null, -1)
  ]));
}
const j8 = { render: v1 }, O8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j8,
  render: v1
}, Symbol.toStringTag, { value: "Module" })), T8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "rows",
  viewBox: "0 0 20 20"
};
function g1(t, e) {
  return d(), h("svg", T8, e[0] || (e[0] = [
    W('<g stroke="currentColor" clip-path="url(#a)"><path stroke-miterlimit="10" d="M18.542 1.117H1.458a.833.833 0 0 0-.833.834V18.2c0 .46.373.833.833.833h17.084c.46 0 .833-.373.833-.833V1.95a.833.833 0 0 0-.833-.834Z"></path><path stroke-linecap="round" stroke-linejoin="round" d="M17 7.078H3v2h14zm0 4H3v2h14z"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 .078h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const z8 = { render: g1 }, B8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z8,
  render: g1
}, Symbol.toStringTag, { value: "Module" })), E8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "search",
  viewBox: "0 0 20 20"
};
function _1(t, e) {
  return d(), h("svg", E8, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M1.227 11.13a7.552 7.552 0 1 0 13.9-5.907 7.552 7.552 0 0 0-13.9 5.908Zm12.291 2.387 5.857 5.858" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const P8 = { render: _1 }, A8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: P8,
  render: _1
}, Symbol.toStringTag, { value: "Module" })), L8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "select-frame",
  viewBox: "0 0 20 20"
};
function w1(t, e) {
  return d(), h("svg", L8, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M19.379 6.25V1.873a1.25 1.25 0 0 0-1.25-1.25h-4.375m0 18.749h4.375a1.25 1.25 0 0 0 1.25-1.25V13.75m-18.75 0v4.375a1.25 1.25 0 0 0 1.25 1.25h4.375m0-18.752H1.879a1.25 1.25 0 0 0-1.25 1.25V6.25" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const H8 = { render: w1 }, V8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: H8,
  render: w1
}, Symbol.toStringTag, { value: "Module" })), F8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "send-arrow",
  viewBox: "0 0 20 20"
};
function b1(t, e) {
  return d(), h("svg", F8, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.167 3.12A1.25 1.25 0 0 1 2.81 1.387l15.845 8.05a.625.625 0 0 1 0 1.114L2.81 18.612a1.25 1.25 0 0 1-1.644-1.731l4.215-6.887zm17.83 6.874H5.377"
    }, null, -1)
  ]));
}
const I8 = { render: b1 }, D8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: I8,
  render: b1
}, Symbol.toStringTag, { value: "Module" })), N8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "send",
  viewBox: "0 0 20 20"
};
function k1(t, e) {
  return d(), h("svg", N8, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M2.3 13.024a1.387 1.387 0 0 1-.736-2.562L16.967.833a1.386 1.386 0 0 1 2.096 1.434l-3 15.977a1.386 1.386 0 0 1-2.471.576L9.25 13.024z"></path><path d="M9.25 13.024H7.167v4.31a1.386 1.386 0 0 0 2.166 1.144l2.649-1.805zm0 0L18.482.866"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const R8 = { render: k1 }, q8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: R8,
  render: k1
}, Symbol.toStringTag, { value: "Module" })), W8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "setting-slider",
  viewBox: "0 0 20 20"
};
function y1(t, e) {
  return d(), h("svg", W8, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.125.625H1.875c-.69 0-1.25.56-1.25 1.25v16.25c0 .69.56 1.25 1.25 1.25h16.25c.69 0 1.25-.56 1.25-1.25V1.875c0-.69-.56-1.25-1.25-1.25m-7.292 12.5h4.792m-11.25 0h2.292"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M10.833 13.125a2.083 2.083 0 1 1-4.167 0 2.083 2.083 0 0 1 4.167 0",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M11.667 6.875H4.375"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M15.833 6.875a2.083 2.083 0 1 0-4.167 0 2.083 2.083 0 0 0 4.167 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const U8 = { render: y1 }, Z8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U8,
  render: y1
}, Symbol.toStringTag, { value: "Module" })), G8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "settings-cog",
  viewBox: "0 0 20 20"
};
function x1(t, e) {
  return d(), h("svg", G8, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M8.788 2.032a1.63 1.63 0 0 0 2.424 0L12 1.167a1.633 1.633 0 0 1 2.842 1.177l-.06 1.167a1.63 1.63 0 0 0 1.71 1.712l1.166-.06a1.632 1.632 0 0 1 1.175 2.842l-.868.783a1.634 1.634 0 0 0 0 2.425l.868.783a1.633 1.633 0 0 1-1.177 2.841l-1.167-.059a1.63 1.63 0 0 0-1.713 1.714l.059 1.166A1.632 1.632 0 0 1 12 18.833l-.784-.867a1.63 1.63 0 0 0-2.424 0l-.787.867a1.633 1.633 0 0 1-2.838-1.173l.06-1.167a1.63 1.63 0 0 0-1.714-1.713l-1.166.06A1.632 1.632 0 0 1 1.167 12l.867-.783a1.633 1.633 0 0 0 0-2.424l-.867-.788A1.632 1.632 0 0 1 2.34 5.167l1.166.059a1.63 1.63 0 0 0 1.715-1.717l-.055-1.167a1.632 1.632 0 0 1 2.838-1.175z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.25 10.001a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 0 0-7.5 0"
    }, null, -1)
  ]));
}
const Y8 = { render: x1 }, X8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y8,
  render: x1
}, Symbol.toStringTag, { value: "Module" })), K8 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "settings-toggle",
  viewBox: "0 0 20 20"
};
function C1(t, e) {
  return d(), h("svg", K8, e[0] || (e[0] = [
    l("rect", {
      width: "15",
      height: "7",
      x: "2.5",
      y: ".5",
      stroke: "currentColor",
      rx: "3.5"
    }, null, -1),
    l("rect", {
      width: "4",
      height: "4",
      x: "12",
      y: "2",
      fill: "currentColor",
      rx: "2"
    }, null, -1),
    l("rect", {
      width: "15",
      height: "7",
      x: "2.5",
      y: "12.5",
      stroke: "currentColor",
      rx: "3.5"
    }, null, -1),
    l("rect", {
      width: "4",
      height: "4",
      x: "4",
      y: "14",
      fill: "currentColor",
      rx: "2"
    }, null, -1)
  ]));
}
const J8 = { render: C1 }, Q8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J8,
  render: C1
}, Symbol.toStringTag, { value: "Module" })), e4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "share",
  viewBox: "0 0 20 20"
};
function M1(t, e) {
  return d(), h("svg", e4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M7.708 12.102 19.375.625m0 6.559V.625h-6.667m-2.604 4.167h-8.75a.73.73 0 0 0-.729.729v13.125a.73.73 0 0 0 .73.729h13.124a.73.73 0 0 0 .73-.73v-8.75"
    }, null, -1)
  ]));
}
const t4 = { render: M1 }, o4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t4,
  render: M1
}, Symbol.toStringTag, { value: "Module" })), n4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "signature",
  viewBox: "0 0 20 20"
};
function $1(t, e) {
  return d(), h("svg", n4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m7.077 10.637-.885 3.535 3.536-.884 5.303-5.303-2.651-2.652zm11.048-5.745.884.884a1.25 1.25 0 0 1 0 1.767l-2.759 2.76m-1.219-2.318 3.094-3.093a1.25 1.25 0 0 0 0-1.768l-.884-.884a1.25 1.25 0 0 0-1.768 0L12.38 5.333"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3.75 13.124H1.875a1.25 1.25 0 0 0-1.25 1.25v2.5a1.25 1.25 0 0 0 1.25 1.25h16.25a1.25 1.25 0 0 0 1.25-1.25v-2.5a1.25 1.25 0 0 0-1.25-1.25H13.75"
    }, null, -1)
  ]));
}
const r4 = { render: $1 }, s4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r4,
  render: $1
}, Symbol.toStringTag, { value: "Module" })), i4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "smiley",
  viewBox: "0 0 20 20"
};
function S1(t, e) {
  return d(), h("svg", i4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M10 19.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.25",
      d: "M6.875 7.813a.312.312 0 1 1 0-.625m0 .625a.312.312 0 1 0 0-.625m6.25.625a.312.312 0 1 1 0-.625m0 .625a.312.312 0 1 0 0-.625"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M15.04 12.5a5.627 5.627 0 0 1-10.083 0"
    }, null, -1)
  ]));
}
const a4 = { render: S1 }, l4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a4,
  render: S1
}, Symbol.toStringTag, { value: "Module" })), d4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "sms-document",
  viewBox: "0 0 17 18"
};
function j1(t, e) {
  return d(), h("svg", d4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8 17v-3a1 1 0 1 1 2 0 1 1 0 0 1 2 0v3m4-4h-1.25c-.199 0-.39.105-.53.293A1.2 1.2 0 0 0 14 14c0 .265.079.52.22.707.14.188.331.293.53.293h.5c.199 0 .39.105.53.293.141.187.22.442.22.707s-.079.52-.22.707c-.14.188-.331.293-.53.293H14m-8-4H4.75c-.199 0-.39.105-.53.293A1.2 1.2 0 0 0 4 14c0 .265.079.52.22.707.14.188.331.293.53.293h.5c.199 0 .39.105.53.293.141.187.22.442.22.707s-.079.52-.22.707c-.14.188-.331.293-.53.293H4m9.666-15.5H3.848c-.578 0-1.133.225-1.542.625s-.64.943-.64 1.508v12.8m2.182-11.91h4.91m-4.91 2.485h4.91M3.848 9.5h2.444"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12.03 11.1v-8c0-.424.173-.831.48-1.131.306-.3.723-.469 1.157-.469s.85.169 1.157.469.479.707.479 1.131v1.067H12.03"
    }, null, -1)
  ]));
}
const u4 = { render: j1 }, c4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u4,
  render: j1
}, Symbol.toStringTag, { value: "Module" })), h4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "sparkle",
  viewBox: "0 0 20 20"
};
function O1(t, e) {
  return d(), h("svg", h4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M13.613 11.347c-3.897 1.312-5.181 2.775-6.131 6.416-.95-3.64-2.235-5.103-6.131-6.416 3.896-1.313 5.18-2.775 6.13-6.417.95 3.642 2.235 5.104 6.132 6.417m4.835-6.075c-2.199.737-2.923 1.56-3.46 3.605-.535-2.046-1.26-2.867-3.458-3.605 2.198-.738 2.922-1.56 3.459-3.606.536 2.047 1.26 2.868 3.459 3.606m.285 10.636c-1.627.534-2.163 1.13-2.56 2.612-.396-1.482-.933-2.078-2.56-2.612 1.627-.534 2.164-1.13 2.56-2.613.397 1.483.933 2.079 2.56 2.613"
    }, null, -1)
  ]));
}
const f4 = { render: O1 }, p4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: f4,
  render: O1
}, Symbol.toStringTag, { value: "Module" })), m4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "striped-table",
  viewBox: "0 0 20 20"
};
function T1(t, e) {
  return d(), h("svg", m4, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path fill="currentColor" d="M.625.621h18.75v3.75H.625z"></path><path d="M.625 8.121h18.75v3.75H.625z"></path><path fill="currentColor" d="M.625 15.621h18.75v3.75H.625z"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const v4 = { render: T1 }, g4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v4,
  render: T1
}, Symbol.toStringTag, { value: "Module" })), _4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "sub-heading",
  viewBox: "0 0 17 19"
};
function z1(t, e) {
  return d(), h("svg", _4, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M7.007 12.34q0 .89-.444 1.518-.438.623-1.231.95-.793.33-1.866.329-.567 0-1.073-.055a7 7 0 0 1-.93-.157 4 4 0 0 1-.745-.253v-1.114q.513.21 1.25.396a6.6 6.6 0 0 0 1.546.178q.752 0 1.271-.198.52-.205.786-.582.274-.383.274-.915 0-.513-.226-.855-.225-.348-.752-.629-.519-.287-1.422-.608a7.6 7.6 0 0 1-1.12-.492 3.5 3.5 0 0 1-.814-.616 2.3 2.3 0 0 1-.5-.793 3 3 0 0 1-.163-1.032q0-.8.403-1.367.41-.575 1.128-.875.725-.308 1.661-.308.8 0 1.477.15a6.5 6.5 0 0 1 1.25.404l-.362.998a8 8 0 0 0-1.148-.376 5 5 0 0 0-1.244-.15q-.643 0-1.087.191a1.5 1.5 0 0 0-.67.526 1.4 1.4 0 0 0-.233.814q0 .526.22.875.225.348.71.622a10 10 0 0 0 1.299.56 9 9 0 0 1 1.497.684q.615.356.937.875.32.513.32 1.306Zm8.34 2.66h-.995v-4.037h-4.5V15h-.997V6.434h.997v3.65h4.5v-3.65h.996V15Z"
    }, null, -1)
  ]));
}
const w4 = { render: z1 }, b4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: w4,
  render: z1
}, Symbol.toStringTag, { value: "Module" })), k4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "summarize",
  viewBox: "0 0 20 20"
};
function B1(t, e) {
  return d(), h("svg", k4, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.978 3.44a.833.833 0 0 1-.324 1.134c-.61.339-.987.86-.987 1.355l.001.086c.205-.11.433-.168.665-.17.438 0 .805.211 1.048.453a1.5 1.5 0 0 1 .452 1.047c0 .439-.21.806-.453 1.048a1.5 1.5 0 0 1-1.047.452q-.143 0-.275-.027C1.317 8.696.788 8.251.464 7.715.126 7.156 0 6.495 0 5.929c0-1.34.955-2.318 1.845-2.812a.833.833 0 0 1 1.133.323m6.737.572a.833.833 0 0 1 .833-.833h8.497a.833.833 0 0 1 0 1.666h-8.497a.833.833 0 0 1-.833-.833m0 4a.833.833 0 0 1 .833-.833h8.497a.833.833 0 0 1 0 1.666h-8.497a.833.833 0 0 1-.833-.833m-7.587 3.083a.834.834 0 0 0 0 1.667h16.917a.833.833 0 0 0 0-1.667zm-.833 4.834a.833.833 0 0 1 .833-.834h16.917a.834.834 0 0 1 0 1.667H2.128a.833.833 0 0 1-.833-.833m5.79-7.084a1 1 0 0 1-.103-.002c-.853-.066-1.45-.543-1.804-1.128-.338-.559-.465-1.219-.465-1.786 0-1.34.956-2.318 1.846-2.812a.833.833 0 1 1 .808 1.457c-.609.339-.986.86-.986 1.355q0 .066.004.132c.21-.127.463-.216.746-.216.437 0 .806.211 1.047.453a1.5 1.5 0 0 1 .453 1.047 1.5 1.5 0 0 1-.453 1.048c-.241.242-.61.452-1.047.452z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const y4 = { render: B1 }, x4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: y4,
  render: B1
}, Symbol.toStringTag, { value: "Module" })), C4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "support-headset",
  viewBox: "0 0 20 20"
};
function E1(t, e) {
  return d(), h("svg", C4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3.75 15h-.625a2.5 2.5 0 0 1-2.5-2.5V10a2.5 2.5 0 0 1 2.5-2.5h.625a.625.625 0 0 1 .625.625v6.25A.625.625 0 0 1 3.75 15m13.125 0h-.625a.624.624 0 0 1-.625-.625v-6.25a.625.625 0 0 1 .625-.625h.625a2.5 2.5 0 0 1 2.5 2.5v2.5a2.5 2.5 0 0 1-2.5 2.5M3.125 7.5A6.875 6.875 0 0 1 10 .625v0A6.875 6.875 0 0 1 16.875 7.5"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M12.5 18.125h1.875a2.5 2.5 0 0 0 2.5-2.5V15"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M11.25 19.375H10a1.25 1.25 0 0 1 0-2.5h1.25a1.25 1.25 0 0 1 0 2.5"
    }, null, -1)
  ]));
}
const M4 = { render: E1 }, $4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M4,
  render: E1
}, Symbol.toStringTag, { value: "Module" })), S4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "table-border",
  viewBox: "0 0 20 20"
};
function P1(t, e) {
  return d(), h("svg", S4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-dasharray": "2 3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.25 1.246h17.5v17.5H1.25zm0 5h17.5m-12.223 0v12.5m6.957-12.5v12.5"
    }, null, -1)
  ]));
}
const j4 = { render: P1 }, O4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j4,
  render: P1
}, Symbol.toStringTag, { value: "Module" })), T4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "table",
  viewBox: "0 0 20 20"
};
function A1(t, e) {
  return d(), h("svg", T4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.25 1.246h17.5v17.5H1.25zm0 5h17.5m-11.629 0v12.5m5.801-12.5v12.5"
    }, null, -1)
  ]));
}
const z4 = { render: A1 }, B4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z4,
  render: A1
}, Symbol.toStringTag, { value: "Module" })), E4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "tag",
  viewBox: "0 0 20 20"
};
function L1(t, e) {
  return d(), h("svg", E4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.884 2.133v5.214a2.5 2.5 0 0 0 .732 1.768l9.634 9.635a1.25 1.25 0 0 0 1.768 0l5.732-5.733a1.25 1.25 0 0 0 0-1.768L9.116 1.615A2.5 2.5 0 0 0 7.348.883H2.134a1.25 1.25 0 0 0-1.25 1.25"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M4.01 5.258a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0"
    }, null, -1)
  ]));
}
const P4 = { render: L1 }, A4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: P4,
  render: L1
}, Symbol.toStringTag, { value: "Module" })), L4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "tags",
  viewBox: "0 0 20 20"
};
function H1(t, e) {
  return d(), h("svg", L4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3.75.883h5.732c.332 0 .65.131.884.366l8.384 8.384M7.607 3.383H2.5a1.25 1.25 0 0 0-1.25 1.25v5.106a1.25 1.25 0 0 0 .366.885l8.125 8.125a1.25 1.25 0 0 0 1.768 0l5.107-5.108a1.25 1.25 0 0 0 0-1.767L8.49 3.749a1.25 1.25 0 0 0-.883-.366"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M5 6.82a.312.312 0 1 0 0 .625.312.312 0 0 0 0-.625"
    }, null, -1)
  ]));
}
const H4 = { render: H1 }, V4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: H4,
  render: H1
}, Symbol.toStringTag, { value: "Module" })), F4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "template",
  viewBox: "0 0 20 20"
};
function V1(t, e) {
  return d(), h("svg", F4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1.25 3.246a2 2 0 0 1 2-2h13.5a2 2 0 0 1 2 2v13.5a2 2 0 0 1-2 2H3.25a2 2 0 0 1-2-2zm0 3h17.5m-8.75 0v12.5"
    }, null, -1)
  ]));
}
const I4 = { render: V1 }, D4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: I4,
  render: V1
}, Symbol.toStringTag, { value: "Module" })), N4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-align-center",
  viewBox: "0 0 20 20"
};
function F1(t, e) {
  return d(), h("svg", N4, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.592 2.5c0-.335.271-.606.606-.606h15.6a.606.606 0 1 1 0 1.212h-15.6a.606.606 0 0 1-.606-.606M5.99 6.252c0-.335.272-.607.607-.607h6.825a.606.606 0 1 1 0 1.213H6.597a.606.606 0 0 1-.607-.606M.395 10c0-.335.271-.606.606-.606h18a.606.606 0 1 1 0 1.212H1A.606.606 0 0 1 .395 10m5.295 3.751c0-.335.27-.606.606-.606h7.425a.606.606 0 0 1 0 1.213H6.296a.606.606 0 0 1-.607-.607ZM1.592 17.5c0-.335.271-.606.606-.606h15.6a.606.606 0 1 1 0 1.212h-15.6a.606.606 0 0 1-.606-.606",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const R4 = { render: F1 }, q4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: R4,
  render: F1
}, Symbol.toStringTag, { value: "Module" })), W4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-align-justify",
  viewBox: "0 0 20 20"
};
function I1(t, e) {
  return d(), h("svg", W4, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 2.512h18.75M.625 6.262h18.75m-18.75 3.75h18.75m-18.75 3.75h18.75m-18.75 3.75h18.75"
    }, null, -1)
  ]));
}
const U4 = { render: I1 }, Z4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U4,
  render: I1
}, Symbol.toStringTag, { value: "Module" })), G4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-align-left",
  viewBox: "0 0 20 20"
};
function D1(t, e) {
  return d(), h("svg", G4, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.375 2.5c0-.345.28-.625.625-.625h18a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 2.5m0 3.75c0-.345.28-.625.625-.625h12.054a.625.625 0 0 1 0 1.25H1a.625.625 0 0 1-.625-.625m0 3.75c0-.345.28-.625.625-.625h14.063a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 10m0 3.75c0-.345.28-.625.625-.625h9.643a.625.625 0 0 1 0 1.25H1a.625.625 0 0 1-.625-.625m0 3.75c0-.345.28-.625.625-.625h14.866a.625.625 0 0 1 0 1.25H1a.625.625 0 0 1-.625-.625",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Y4 = { render: D1 }, X4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y4,
  render: D1
}, Symbol.toStringTag, { value: "Module" })), K4 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-align-right",
  viewBox: "0 0 20 20"
};
function N1(t, e) {
  return d(), h("svg", K4, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.375 2.5c0-.345.28-.625.625-.625h18a.625.625 0 1 1 0 1.25H1A.625.625 0 0 1 .375 2.5m5.947 3.751c0-.345.28-.625.625-.625h12.054a.625.625 0 1 1 0 1.25H6.947a.625.625 0 0 1-.625-.625M4.313 10c0-.346.28-.626.625-.626H19a.625.625 0 1 1 0 1.25H4.937A.625.625 0 0 1 4.313 10m4.378 3.75c0-.345.28-.625.625-.625H19a.625.625 0 1 1 0 1.25H9.316a.625.625 0 0 1-.625-.625M3.51 17.5c0-.345.28-.625.625-.625H19a.625.625 0 1 1 0 1.25H4.135a.625.625 0 0 1-.625-.625",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const J4 = { render: N1 }, Q4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J4,
  render: N1
}, Symbol.toStringTag, { value: "Module" })), e_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-bold",
  viewBox: "0 0 20 20"
};
function R1(t, e) {
  return d(), h("svg", e_, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.75",
      d: "M3 19h8.273c1.519 0 2.976-.569 4.05-1.582C16.396 16.406 17 15.032 17 13.6s-.603-2.806-1.678-3.818C14.25 8.769 12.793 8.2 11.273 8.2h.637a4 4 0 0 0 1.461-.274 3.8 3.8 0 0 0 1.239-.78c.354-.335.636-.732.828-1.168a3.42 3.42 0 0 0 0-2.756 3.6 3.6 0 0 0-.828-1.168 3.8 3.8 0 0 0-1.239-.78A4 4 0 0 0 11.91 1H3m2.545 0v18m5.728-10.8H5.545"
    }, null, -1)
  ]));
}
const t_ = { render: R1 }, o_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t_,
  render: R1
}, Symbol.toStringTag, { value: "Module" })), n_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-case",
  viewBox: "0 0 20 20"
};
function q1(t, e) {
  return d(), h("svg", n_, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 10.624h8.75m3.75 3.75h6.25m-6.25 3.75V11.25a3.125 3.125 0 1 1 6.25 0v6.875m-18.75-.001V6.25a4.375 4.375 0 0 1 8.75 0v11.875"
    }, null, -1)
  ]));
}
const r_ = { render: q1 }, s_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r_,
  render: q1
}, Symbol.toStringTag, { value: "Module" })), i_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-check",
  viewBox: "0 0 20 20"
};
function W1(t, e) {
  return d(), h("svg", i_, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.813 2.987v-.409a1.24 1.24 0 0 1 .356-.87 1.22 1.22 0 0 1 .862-.362h8.938a1.2 1.2 0 0 1 .862.361 1.23 1.23 0 0 1 .357.871v.41M6.5 1.346v12.305m-2.437 0h4.875M8 16.63l2.5 2.5a.623.623 0 0 0 .883 0l7.059-7.058"
    }, null, -1)
  ]));
}
const a_ = { render: W1 }, l_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a_,
  render: W1
}, Symbol.toStringTag, { value: "Module" })), d_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-clear-formatting",
  viewBox: "0 0 20 20"
};
function U1(t, e) {
  return d(), h("svg", d_, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M4.375.625H17.5a1.875 1.875 0 0 1 1.875 1.877v.625M8.954 13.156l-.829 6.218M10.623.625l-.744 5.58m-5.504 13.17h7.5M.625.625l18.75 18.75"
    }, null, -1)
  ]));
}
const u_ = { render: U1 }, c_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u_,
  render: U1
}, Symbol.toStringTag, { value: "Module" })), h_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-divider",
  viewBox: "0 0 20 20"
};
function Z1(t, e) {
  return d(), h("svg", h_, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M5.625 2.5h8.75m-8.75 3.75h6.25M5.625 10h8.75m-8.75 3.75h6.25M.625 17.5h18.75"
    }, null, -1)
  ]));
}
const f_ = { render: Z1 }, p_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: f_,
  render: Z1
}, Symbol.toStringTag, { value: "Module" })), m_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-italic",
  viewBox: "0 0 20 20"
};
function G1(t, e) {
  return d(), h("svg", m_, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M19.375.625h-8.75m-1.25 18.75H.625m4.375 0L15 .625"
    }, null, -1)
  ]));
}
const v_ = { render: G1 }, g_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v_,
  render: G1
}, Symbol.toStringTag, { value: "Module" })), __ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-multiple-styles",
  viewBox: "0 0 20 19"
};
function Y1(t, e) {
  return d(), h("svg", __, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M5.763 15 2.406 6.154h-.054q.027.28.047.684a40 40 0 0 1 .048 1.846V15h-1.08V5.006H3.09l3.165 8.312h.048l3.213-8.312h1.709V15h-1.149V8.602q0-.445.014-.89a41 41 0 0 1 .075-1.544h-.055L6.713 15zm12.835-2.28q0 .762-.381 1.301-.375.534-1.055.815t-1.6.281q-.486 0-.92-.047a6 6 0 0 1-.796-.135 3.4 3.4 0 0 1-.639-.216v-.955a8 8 0 0 0 1.072.34q.633.152 1.325.152.645 0 1.09-.17.444-.175.673-.498.234-.328.235-.785 0-.44-.194-.733-.194-.299-.644-.539a8.5 8.5 0 0 0-1.22-.521 6.6 6.6 0 0 1-.96-.422 3 3 0 0 1-.697-.527 2 2 0 0 1-.428-.68 2.6 2.6 0 0 1-.14-.885q0-.686.345-1.172a2.2 2.2 0 0 1 .967-.75q.621-.263 1.424-.263a5.65 5.65 0 0 1 2.338.474l-.311.856a7 7 0 0 0-.984-.323 4.4 4.4 0 0 0-1.067-.129q-.55 0-.931.165-.375.157-.575.45a1.2 1.2 0 0 0-.199.698q0 .45.188.75.194.3.609.533.422.229 1.113.48.756.276 1.284.587.527.304.802.75.276.44.276 1.119Z"
    }, null, -1)
  ]));
}
const w_ = { render: Y1 }, b_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: w_,
  render: Y1
}, Symbol.toStringTag, { value: "Module" })), k_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-small",
  viewBox: "0 0 15 19"
};
function X1(t, e) {
  return d(), h("svg", k_, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M7.007 12.34q0 .89-.444 1.518-.438.623-1.231.95-.793.33-1.866.329-.567 0-1.073-.055a7 7 0 0 1-.93-.157 4 4 0 0 1-.745-.253v-1.114q.513.21 1.25.396a6.6 6.6 0 0 0 1.546.178q.752 0 1.271-.198.52-.205.786-.582.274-.383.274-.915 0-.513-.226-.855-.225-.348-.752-.629-.519-.287-1.422-.608a7.6 7.6 0 0 1-1.12-.492 3.5 3.5 0 0 1-.814-.616 2.3 2.3 0 0 1-.5-.793 3 3 0 0 1-.163-1.032q0-.8.403-1.367.41-.575 1.128-.875.725-.308 1.661-.308.8 0 1.477.15a6.5 6.5 0 0 1 1.25.404l-.362.998a8 8 0 0 0-1.148-.376 5 5 0 0 0-1.244-.15q-.643 0-1.087.191a1.5 1.5 0 0 0-.67.526 1.4 1.4 0 0 0-.233.814q0 .526.22.875.225.348.71.622a10 10 0 0 0 1.299.56 9 9 0 0 1 1.497.684q.615.356.937.875.32.513.32 1.306Zm4.48 2.66h-1.003V7.312H7.79v-.878h6.38v.878h-2.683z"
    }, null, -1)
  ]));
}
const y_ = { render: X1 }, x_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: y_,
  render: X1
}, Symbol.toStringTag, { value: "Module" })), C_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-strike",
  viewBox: "0 0 20 20"
};
function K1(t, e) {
  return d(), h("svg", C_, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M15.625.625H9.773c-2.071 0-4.148 1.678-4.148 3.75 0 5.625 10 5.625 10 11.25a3.75 3.75 0 0 1-3.75 3.75h-6.25m-5-8.75h18.75"
    }, null, -1)
  ]));
}
const M_ = { render: K1 }, $_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M_,
  render: K1
}, Symbol.toStringTag, { value: "Module" })), S_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text-underline",
  viewBox: "0 0 20 20"
};
function J1(t, e) {
  return d(), h("svg", S_, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 19.375h18.75M3.125.625h2.5m8.75 0h2.5m-1.25 0v9.377a5.625 5.625 0 1 1-11.25 0V.625"
    }, null, -1)
  ]));
}
const j_ = { render: J1 }, O_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j_,
  render: J1
}, Symbol.toStringTag, { value: "Module" })), T_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "text",
  viewBox: "0 0 20 20"
};
function Q1(t, e) {
  return d(), h("svg", T_, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M1.25 3.123V2.5A1.875 1.875 0 0 1 3.125.623h13.75A1.875 1.875 0 0 1 18.75 2.5v.625M10 .623v18.75m-3.75 0h7.5" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const z_ = { render: Q1 }, B_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z_,
  render: Q1
}, Symbol.toStringTag, { value: "Module" })), E_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "thumb-down",
  viewBox: "0 0 20 20"
};
function ed(t, e) {
  return d(), h("svg", E_, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M15.625 1.873a5 5 0 0 1-1.298-.19L11.298.817A5 5 0 0 0 9.926.625h-4.07a5 5 0 0 0-4.976 4.5l-.25 4.25a3.75 3.75 0 0 0 2.833 3.828l1.213.265a1.25 1.25 0 0 1 .95 1.213V17.5a1.875 1.875 0 1 0 3.75 0v-1.295a6.25 6.25 0 0 1 6.25-6.25V1.873Z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M19.375.625h-3.75v11.25h3.75z"
    }, null, -1)
  ]));
}
const P_ = { render: ed }, A_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: P_,
  render: ed
}, Symbol.toStringTag, { value: "Module" })), L_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "thumb-up",
  viewBox: "0 0 20 20"
};
function td(t, e) {
  return d(), h("svg", L_, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M4.375 18.125c.44.015.877.085 1.3.208 3.333.95 3.517 1.059 4.4 1.059h4.092a5 5 0 0 0 5-4.5l.25-4.25a3.74 3.74 0 0 0-2.834-3.825c-.9-.225-2.158-.225-2.158-1.484V2.5a1.875 1.875 0 1 0-3.75 0v1.292a6.25 6.25 0 0 1-6.25 6.25zm0-10H.625v11.25h3.75z" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ]));
}
const H_ = { render: td }, V_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: H_,
  render: td
}, Symbol.toStringTag, { value: "Module" })), F_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "time-reverse",
  viewBox: "0 0 20 20"
};
function od(t, e) {
  return d(), h("svg", F_, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m7.636 14.67 2.499-2.5V8.003m1.663-2.293L8.465 3.004 12.215.71"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M3.09 15.5A8.197 8.197 0 1 0 8.517 3.029M5.71 4.114a8.3 8.3 0 0 0-2.536 2.447M1.947 9.583a8.5 8.5 0 0 0 .108 3.522"
    }, null, -1)
  ]));
}
const I_ = { render: od }, D_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: I_,
  render: od
}, Symbol.toStringTag, { value: "Module" })), N_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "top-row-background",
  viewBox: "0 0 20 20"
};
function nd(t, e) {
  return d(), h("svg", N_, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path fill="currentColor" d="M.625.621h18.75v3.75H.625z"></path><path d="M.625 8.121h18.75v3.75H.625zm0 7.5h18.75v3.75H.625z"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const R_ = { render: nd }, q_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: R_,
  render: nd
}, Symbol.toStringTag, { value: "Module" })), W_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "data-token-name": "translate",
  viewBox: "0 0 16 16"
};
function rd(t, e) {
  return d(), h("svg", W_, e[0] || (e[0] = [
    l("path", { d: "m15.78 14.19-3.92-7.84a.56.56 0 0 0-1.001 0l-1.52 3.04A6.16 6.16 0 0 1 6.04 8.204 7.26 7.26 0 0 0 7.978 3.8H9.68a.56.56 0 0 0 0-1.12H5.76V1.56a.56.56 0 1 0-1.12 0v1.12H.72a.56.56 0 0 0 0 1.12h6.134A6.14 6.14 0 0 1 5.2 7.464a6.1 6.1 0 0 1-1.33-2.17.56.56 0 1 0-1.056.374c.335.945.86 1.81 1.546 2.542A6.13 6.13 0 0 1 .72 9.4a.56.56 0 1 0 0 1.12A7.24 7.24 0 0 0 5.2 8.974a7.3 7.3 0 0 0 3.601 1.492L6.939 14.19a.56.56 0 0 0 1.002.502l.965-1.931h4.908l.965 1.93a.56.56 0 0 0 1.002-.5Zm-6.314-2.55 1.894-3.788 1.894 3.788Z" }, null, -1)
  ]));
}
const U_ = { render: rd }, Z_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U_,
  render: rd
}, Symbol.toStringTag, { value: "Module" })), G_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "triangle-down",
  viewBox: "0 0 8 6"
};
function sd(t, e) {
  return d(), h("svg", G_, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M4 6 0 0h8z"
    }, null, -1)
  ]));
}
const Y_ = { render: sd }, X_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y_,
  render: sd
}, Symbol.toStringTag, { value: "Module" })), K_ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "type",
  viewBox: "0 0 16 16"
};
function id(t, e) {
  return d(), h("svg", K_, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M8.571 5.719h6.286a.57.57 0 0 1 .571.571v3.43a.57.57 0 0 1-.571.571H8.571m-5.714-.001H1.143a.57.57 0 0 1-.573-.57V6.29a.57.57 0 0 1 .572-.571h1.714M4.571 2.86h2.286M4.571 13.148h2.286M5.714 2.86v10.285" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]));
}
const J_ = { render: id }, Q_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J_,
  render: id
}, Symbol.toStringTag, { value: "Module" })), ew = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "underline",
  viewBox: "0 0 20 20"
};
function ad(t, e) {
  return d(), h("svg", ew, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 19h18.75"
    }, null, -1)
  ]));
}
const tw = { render: ad }, ow = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tw,
  render: ad
}, Symbol.toStringTag, { value: "Module" })), nw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "unlock",
  viewBox: "0 0 20 20"
};
function ld(t, e) {
  return d(), h("svg", nw, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 8.125V5a4.375 4.375 0 0 1 8.75 0v3.125m8.75 0H6.875c-.69 0-1.25.56-1.25 1.25v8.75c0 .69.56 1.25 1.25 1.25h11.25c.69 0 1.25-.56 1.25-1.25v-8.75c0-.69-.56-1.25-1.25-1.25M12.5 12.5V15"
    }, null, -1)
  ]));
}
const rw = { render: ld }, sw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rw,
  render: ld
}, Symbol.toStringTag, { value: "Module" })), iw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "unordered-list",
  viewBox: "0 0 20 20"
};
function dd(t, e) {
  return d(), h("svg", iw, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M.625 2.5a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0m0 7.5a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0m0 7.5a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 0 0-3.75 0m6.25-14.375h12.5m-12.5 7.5h12.5m-12.5 7.5h12.5"
    }, null, -1)
  ]));
}
const aw = { render: dd }, lw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: aw,
  render: dd
}, Symbol.toStringTag, { value: "Module" })), dw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "upload",
  viewBox: "0 0 20 20"
};
function ud(t, e) {
  return d(), h("svg", dw, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M10 13.125v-10m3.75 3.75L10 3.125l-3.75 3.75m13.126 6.25v1.25a2.5 2.5 0 0 1-2.5 2.5H3.126a2.5 2.5 0 0 1-2.5-2.5v-1.25"
    }, null, -1)
  ]));
}
const uw = { render: ud }, cw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uw,
  render: ud
}, Symbol.toStringTag, { value: "Module" })), hw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "user-add",
  viewBox: "0 0 20 20"
};
function cd(t, e) {
  return d(), h("svg", hw, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M9.375 14.375a5 5 0 1 0 10 0 5 5 0 0 0-10 0m5-2.5v5m-2.5-2.5h5m-16.25 0a5.628 5.628 0 0 1 7.833-5.173M2.813 4.063a3.437 3.437 0 1 0 6.874 0 3.437 3.437 0 0 0-6.874 0"
    }, null, -1)
  ]));
}
const fw = { render: cd }, pw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fw,
  render: cd
}, Symbol.toStringTag, { value: "Module" })), mw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "user-coin",
  viewBox: "0 0 22 22"
};
function hd(t, e) {
  return d(), h("svg", mw, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M1 15.666a6.002 6.002 0 0 1 8.356-5.518M7 8.333A3.667 3.667 0 1 0 7 1a3.667 3.667 0 0 0 0 7.333M17 13h-1.808a1.193 1.193 0 0 0-.444 2.3l1.833.733a1.193 1.193 0 0 1-.444 2.3h-1.804m1.333-5.334v-.667m0 6.667v-.667"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M15.667 20.999a5.333 5.333 0 1 0 0-10.667 5.333 5.333 0 0 0 0 10.667"
    }, null, -1)
  ]));
}
const vw = { render: hd }, gw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vw,
  render: hd
}, Symbol.toStringTag, { value: "Module" })), _w = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "user-lock",
  viewBox: "0 0 20 20"
};
function fd(t, e) {
  return d(), h("svg", _w, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M6.458 7.292a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667m2.5 7.916H.625a5.833 5.833 0 0 1 9.167-4.787m8.333 2.704h-5.417c-.69 0-1.25.56-1.25 1.25v3.75c0 .69.56 1.25 1.25 1.25h5.417c.69 0 1.25-.56 1.25-1.25v-3.75c0-.69-.56-1.25-1.25-1.25"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M12.5 13.143v-1.268a2.917 2.917 0 1 1 5.833 0v1.268m-4.166 3.107.833.833 1.667-1.666"
    }, null, -1)
  ]));
}
const ww = { render: fd }, bw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ww,
  render: fd
}, Symbol.toStringTag, { value: "Module" })), kw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "user-move",
  viewBox: "0 0 16 16"
};
function pd(t, e) {
  return d(), h("svg", kw, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-width="1.25" clip-path="url(#a)"><path stroke-linejoin="round" d="M15.5 16a4.5 4.5 0 1 0-9 0m-1.042-3.455A3.685 3.685 0 0 0 .5 16m13.25-8.25a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0m-7.318 1.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"></path><path d="m5 1 2 2-2 2m1-2H1"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M16 0H0v16h16z"></path></clipPath></defs>', 2)
  ]));
}
const yw = { render: pd }, xw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yw,
  render: pd
}, Symbol.toStringTag, { value: "Module" })), Cw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "user-remove",
  viewBox: "0 0 16 16"
};
function md(t, e) {
  return d(), h("svg", Cw, e[0] || (e[0] = [
    l("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      "clip-path": "url(#a)"
    }, [
      l("path", { d: "M7.5 11.5a4 4 0 1 0 8 0 4 4 0 0 0-8 0m2 0h4m-13 0a4.502 4.502 0 0 1 6.267-4.14M2.25 3.25a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0" })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]));
}
const Mw = { render: md }, $w = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mw,
  render: md
}, Symbol.toStringTag, { value: "Module" })), Sw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "user-shield",
  viewBox: "0 0 20 20"
};
function vd(t, e) {
  return d(), h("svg", Sw, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M19.375 8.28A11.25 11.25 0 0 1 10 19.376 11.25 11.25 0 0 1 .625 8.281V1.875a1.25 1.25 0 0 1 1.25-1.25h16.25a1.25 1.25 0 0 1 1.25 1.25z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M7.188 7.188a2.813 2.813 0 1 0 5.625 0 2.813 2.813 0 0 0-5.626 0v0Zm7.302 6.77a5.027 5.027 0 0 0-8.98 0"
    }, null, -1)
  ]));
}
const jw = { render: vd }, Ow = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jw,
  render: vd
}, Symbol.toStringTag, { value: "Module" })), Tw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "user",
  viewBox: "0 0 20 20"
};
function gd(t, e) {
  return d(), h("svg", Tw, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M5.625 5a4.375 4.375 0 1 0 8.75 0 4.375 4.375 0 0 0-8.75 0m-3.75 14.375a8.125 8.125 0 1 1 16.25 0"
    }, null, -1)
  ]));
}
const zw = { render: gd }, Bw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zw,
  render: gd
}, Symbol.toStringTag, { value: "Module" })), Ew = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "users-search",
  viewBox: "0 0 20 20"
};
function _d(t, e) {
  return d(), h("svg", Ew, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M8.75 13.125a4.375 4.375 0 1 0 8.75 0 4.375 4.375 0 0 0-8.75 0m10.625 6.25-3.157-3.157M8.352 8.285A5.06 5.06 0 0 0 5.625 7.5a5 5 0 0 0-5 4.375m2.188-8.437a2.813 2.813 0 1 0 5.625 0 2.813 2.813 0 0 0-5.626 0Zm8.75-.625a2.188 2.188 0 1 0 4.375 0 2.188 2.188 0 0 0-4.376 0Z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M17 7.5a3.75 3.75 0 0 0-6.07-.592"
    }, null, -1)
  ]));
}
const Pw = { render: _d }, Aw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pw,
  render: _d
}, Symbol.toStringTag, { value: "Module" })), Lw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "users",
  viewBox: "0 0 20 20"
};
function wd(t, e) {
  return d(), h("svg", Lw, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M2.813 6.563a3.437 3.437 0 1 0 6.874 0 3.437 3.437 0 0 0-6.874 0M.625 16.875a5.625 5.625 0 0 1 11.25 0m.085-8.437a2.812 2.812 0 1 0 5.625 0 2.812 2.812 0 0 0-5.625 0m1.218 4.119a4.605 4.605 0 0 1 6.197 4.318"
    }, null, -1)
  ]));
}
const Hw = { render: wd }, Vw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hw,
  render: wd
}, Symbol.toStringTag, { value: "Module" })), Fw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "video-block",
  viewBox: "0 0 20 20"
};
function bd(t, e) {
  return d(), h("svg", Fw, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.75 18.125a1.25 1.25 0 0 1-1.25 1.25h-15a1.25 1.25 0 0 1-1.25-1.25V1.875A1.25 1.25 0 0 1 2.5.625H15c.326 0 .64.127.873.355l2.5 2.402a1.25 1.25 0 0 1 .377.895z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M8.532 13.675a.713.713 0 0 1-1.032-.638V8.213a.713.713 0 0 1 1.032-.638l4.824 2.412a.713.713 0 0 1 0 1.275z"
    }, null, -1)
  ]));
}
const Iw = { render: bd }, Dw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Iw,
  render: bd
}, Symbol.toStringTag, { value: "Module" })), Nw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "view-check-circle",
  viewBox: "0 0 16 16"
};
function kd(t, e) {
  return d(), h("svg", Nw, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14.74 6.24q.252-.25.473-.5a1.1 1.1 0 0 0 0-1.48C13.467 2.333 10.667.453 8 .5S2.533 2.333.787 4.26a1.1 1.1 0 0 0 0 1.48A12.8 12.8 0 0 0 5.133 8.9"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.88 7.24A2.5 2.5 0 1 1 10.5 5c-.002.225-.033.45-.093.667M11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m13.28 10.34-1.947 2.58a.5.5 0 0 1-.753.053L9.593 12"
    }, null, -1)
  ]));
}
const Rw = { render: kd }, qw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rw,
  render: kd
}, Symbol.toStringTag, { value: "Module" })), Ww = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "view-hide",
  viewBox: "0 0 20 20"
};
function yd(t, e) {
  return d(), h("svg", Ww, e[0] || (e[0] = [
    W('<g fill="currentColor" fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path d="M18.394 1.49a.61.61 0 0 1-.018.87L2.751 17.129a.63.63 0 0 1-.884-.018.61.61 0 0 1 .019-.87L17.51 1.471a.63.63 0 0 1 .884.019m-2.44 4.887a.63.63 0 0 1 .874-.134 17.7 17.7 0 0 1 2.655 2.344l.002.003a1.96 1.96 0 0 1 0 2.65l-.002.002c-2.183 2.366-5.804 4.885-9.485 4.827a9 9 0 0 1-2.712-.396.614.614 0 0 1-.412-.77.627.627 0 0 1 .782-.405 7.8 7.8 0 0 0 2.34.34h.015c3.15.053 6.454-2.155 8.546-4.422a.743.743 0 0 0 0-1.001 16.4 16.4 0 0 0-2.466-2.178.61.61 0 0 1-.137-.86M10 3.763a8.7 8.7 0 0 1 2.16.25c.335.081.54.415.456.745a.626.626 0 0 1-.758.449 7.4 7.4 0 0 0-1.853-.213h-.017c-3.094-.051-6.408 2.108-8.543 4.42a.743.743 0 0 0 0 1.001 16.5 16.5 0 0 0 2.086 1.896.61.61 0 0 1 .11.864.63.63 0 0 1-.877.109 18 18 0 0 1-2.244-2.04l-.003-.004A1.96 1.96 0 0 1 0 9.915c0-.49.184-.961.517-1.325l.002-.002c2.23-2.416 5.86-4.88 9.481-4.825"></path><path d="M9.997 7.453a2.53 2.53 0 0 0-1.767.72 2.43 2.43 0 0 0-.732 1.74.62.62 0 0 1-.625.616.62.62 0 0 1-.625-.615 3.67 3.67 0 0 1 1.098-2.611 3.8 3.8 0 0 1 1.216-.8 3.8 3.8 0 0 1 1.436-.281.62.62 0 0 1 .625.615.62.62 0 0 1-.626.616M13.125 9.3a.62.62 0 0 1 .625.615c0 .485-.097.965-.285 1.414a3.7 3.7 0 0 1-.813 1.198A3.8 3.8 0 0 1 10 13.609a.62.62 0 0 1-.625-.616c0-.34.28-.615.625-.615a2.53 2.53 0 0 0 1.768-.722 2.43 2.43 0 0 0 .732-1.741c0-.34.28-.615.625-.615"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h20v20H0z"></path></clipPath></defs>', 2)
  ]));
}
const Uw = { render: yd }, Zw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Uw,
  render: yd
}, Symbol.toStringTag, { value: "Module" })), Gw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "view",
  viewBox: "0 0 16 16"
};
function xd(t, e) {
  return d(), h("svg", Gw, e[0] || (e[0] = [
    W('<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25" clip-path="url(#a)"><path d="M8 3.5C5.313 3.456 2.533 5.334.786 7.258a1.11 1.11 0 0 0 0 1.484C2.496 10.625 5.266 12.546 8 12.5c2.733.046 5.505-1.876 7.216-3.758a1.11 1.11 0 0 0 0-1.484C13.466 5.333 10.687 3.455 8 3.5"></path><path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 .001Z"></path></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"></path></clipPath></defs>', 2)
  ]));
}
const Yw = { render: xd }, Xw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yw,
  render: xd
}, Symbol.toStringTag, { value: "Module" })), Kw = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "wallet",
  viewBox: "0 0 20 20"
};
function Cd(t, e) {
  return d(), h("svg", Kw, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.125 15.417v1.25a2.5 2.5 0 0 1-2.5 2.5h-12.5a2.5 2.5 0 0 1-2.5-2.5v-8.75a2.5 2.5 0 0 1 2.5-2.5h12.5a2.5 2.5 0 0 1 2.5 2.5v1.25"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "m15.625 5.417-1.94-3.882a1.25 1.25 0 0 0-1.678-.56L3.125 5.418m15 9.999a1.25 1.25 0 0 0 1.25-1.25v-3.75a1.25 1.25 0 0 0-1.25-1.25H15a3.125 3.125 0 1 0 0 6.25z"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M15 11.98a.313.313 0 1 1 0 .625.313.313 0 0 1 0-.626"
    }, null, -1)
  ]));
}
const Jw = { render: Cd }, Qw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jw,
  render: Cd
}, Symbol.toStringTag, { value: "Module" })), e9 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "data-token-name": "write-document",
  viewBox: "0 0 18 18"
};
function Md(t, e) {
  return d(), h("svg", e9, e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.11 9.865a1.533 1.533 0 0 1 2.14-.061 1.533 1.533 0 0 1-.061 2.14c-.588.589-3.168 1.088-3.168 1.088s.5-2.58 1.088-3.167Zm2.377-5.152 2.426-2.426a.98.98 0 0 1 1.386 0l.693.693"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m8.447 8.52 5.545-5.544a1.474 1.474 0 0 1 2.08 0v0a1.475 1.475 0 0 1 0 2.08L10.525 10.6l-2.08-2.08Zm3.466-3.457 2.079 2.079"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15.146 10.001c0 2.694.284 4.217-1.172 5.672l-.754.754a.25.25 0 0 1-.178.073H1.75a.25.25 0 0 1-.177-.427l.4-.4c1.51-1.51 1.173-2.476 1.173-10.516 0-2.098 1.566-3.222 2-3.657h2.966"
    }, null, -1)
  ]));
}
const t9 = { render: Md }, o9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t9,
  render: Md
}, Symbol.toStringTag, { value: "Module" }));
var He = /* @__PURE__ */ ((t) => (t.Medium = "medium", t.Small = "small", t))(He || {});
const n9 = /* @__PURE__ */ A({
  __name: "FriedIcon",
  props: {
    icon: {},
    size: { default: He.Medium }
  },
  setup(t) {
    const e = t, o = /* @__PURE__ */ Object.assign({ "../../assets/icons/actions.svg": rc, "../../assets/icons/add-reaction.svg": ac, "../../assets/icons/add-square.svg": uc, "../../assets/icons/add.svg": fc, "../../assets/icons/alarm-bell.svg": vc, "../../assets/icons/alarm-clock.svg": wc, "../../assets/icons/alert-circle.svg": yc, "../../assets/icons/align-bottom.svg": Mc, "../../assets/icons/align-horizontal.svg": jc, "../../assets/icons/align-left.svg": zc, "../../assets/icons/align-right.svg": Pc, "../../assets/icons/align-top.svg": Hc, "../../assets/icons/align.svg": Ic, "../../assets/icons/analytics-heart.svg": Rc, "../../assets/icons/analytics.svg": Uc, "../../assets/icons/archive.svg": Yc, "../../assets/icons/arrow-bar-left.svg": Jc, "../../assets/icons/arrow-bar-right.svg": t5, "../../assets/icons/arrow-bend-down-left.svg": r5, "../../assets/icons/arrow-circle-down.svg": a5, "../../assets/icons/arrow-collapse.svg": u5, "../../assets/icons/arrow-cross.svg": f5, "../../assets/icons/arrow-down-lines.svg": v5, "../../assets/icons/arrow-down.svg": w5, "../../assets/icons/arrow-expand-horizontal.svg": y5, "../../assets/icons/arrow-expand.svg": M5, "../../assets/icons/arrow-left.svg": j5, "../../assets/icons/arrow-redo.svg": z5, "../../assets/icons/arrow-right.svg": P5, "../../assets/icons/arrow-undo.svg": H5, "../../assets/icons/arrow-up-lines.svg": I5, "../../assets/icons/arrows-left-and-right.svg": R5, "../../assets/icons/attachment.svg": U5, "../../assets/icons/bars.svg": Y5, "../../assets/icons/block.svg": J5, "../../assets/icons/bold-check-mark.svg": th, "../../assets/icons/calendar-edit.svg": rh, "../../assets/icons/calendar-money.svg": ah, "../../assets/icons/calendar-search.svg": uh, "../../assets/icons/calendar.svg": fh, "../../assets/icons/camera.svg": vh, "../../assets/icons/card.svg": wh, "../../assets/icons/chat-bubble.svg": yh, "../../assets/icons/check-circle-fried.svg": Mh, "../../assets/icons/check-circle.svg": jh, "../../assets/icons/check-mark.svg": zh, "../../assets/icons/checkbox.svg": Ph, "../../assets/icons/chevron-down-line.svg": Hh, "../../assets/icons/chevron-down.svg": Ih, "../../assets/icons/chevron-left.svg": Rh, "../../assets/icons/chevron-right.svg": Uh, "../../assets/icons/chevron-up-and-down.svg": Yh, "../../assets/icons/chevron-up-line.svg": Jh, "../../assets/icons/chevron-up.svg": t3, "../../assets/icons/click.svg": r3, "../../assets/icons/clipboard-add.svg": a3, "../../assets/icons/clipboard-check.svg": u3, "../../assets/icons/clipboard-deadline.svg": f3, "../../assets/icons/clipboard-remove.svg": v3, "../../assets/icons/clipboard-undo.svg": w3, "../../assets/icons/clipboard.svg": y3, "../../assets/icons/clock.svg": M3, "../../assets/icons/close-circle.svg": j3, "../../assets/icons/close.svg": z3, "../../assets/icons/coins.svg": P3, "../../assets/icons/collapse.svg": H3, "../../assets/icons/column-count-1.svg": I3, "../../assets/icons/column-count-2.svg": R3, "../../assets/icons/column-count-3.svg": U3, "../../assets/icons/column-count-4.svg": Y3, "../../assets/icons/column-count.svg": J3, "../../assets/icons/column-image-and-text.svg": tf, "../../assets/icons/column-image-only.svg": rf, "../../assets/icons/column-sidebyside.svg": lf, "../../assets/icons/column-text-only.svg": cf, "../../assets/icons/columns.svg": pf, "../../assets/icons/comment-history.svg": gf, "../../assets/icons/comments-locked.svg": bf, "../../assets/icons/comments.svg": xf, "../../assets/icons/company.svg": $f, "../../assets/icons/conditional-logic.svg": Of, "../../assets/icons/contracts.svg": Bf, "../../assets/icons/conversation.svg": Af, "../../assets/icons/copy-paste.svg": Vf, "../../assets/icons/copy.svg": Df, "../../assets/icons/create-contextual-comment.svg": qf, "../../assets/icons/custom-input.svg": Zf, "../../assets/icons/custom.svg": Xf, "../../assets/icons/delete-bin.svg": Qf, "../../assets/icons/delete-column.svg": op, "../../assets/icons/delete-row.svg": sp, "../../assets/icons/divider-dashed.svg": lp, "../../assets/icons/divider-padding.svg": cp, "../../assets/icons/divider-thick.svg": pp, "../../assets/icons/divider-thin.svg": gp, "../../assets/icons/document-check.svg": bp, "../../assets/icons/document-create.svg": xp, "../../assets/icons/document-dsr.svg": $p, "../../assets/icons/document-edit.svg": Op, "../../assets/icons/document-hr.svg": Bp, "../../assets/icons/document-other.svg": Ap, "../../assets/icons/document-play.svg": Vp, "../../assets/icons/document-presentation.svg": Dp, "../../assets/icons/document-sales.svg": qp, "../../assets/icons/document-search.svg": Zp, "../../assets/icons/document-view.svg": Xp, "../../assets/icons/door-plus.svg": Qp, "../../assets/icons/door.svg": om, "../../assets/icons/download.svg": sm, "../../assets/icons/drag-handle.svg": lm, "../../assets/icons/dropdown.svg": cm, "../../assets/icons/duplicate.svg": pm, "../../assets/icons/edit.svg": gm, "../../assets/icons/editor-block.svg": bm, "../../assets/icons/eid.svg": xm, "../../assets/icons/ellipsis.svg": $m, "../../assets/icons/email-action-reply.svg": Om, "../../assets/icons/eraser.svg": Bm, "../../assets/icons/file-blank.svg": Am, "../../assets/icons/file-doc.svg": Vm, "../../assets/icons/file-pdf.svg": Dm, "../../assets/icons/file-ppt.svg": qm, "../../assets/icons/file-txt.svg": Zm, "../../assets/icons/file-xls.svg": Xm, "../../assets/icons/file-zip.svg": Qm, "../../assets/icons/filled-square.svg": o6, "../../assets/icons/filter.svg": s6, "../../assets/icons/folder-open-fill.svg": l6, "../../assets/icons/folder-open.svg": c6, "../../assets/icons/form.svg": p6, "../../assets/icons/forward-circle.svg": g6, "../../assets/icons/gauge.svg": b6, "../../assets/icons/ghost.svg": x6, "../../assets/icons/globe.svg": $6, "../../assets/icons/google-docs.svg": O6, "../../assets/icons/google-drive-edit.svg": B6, "../../assets/icons/google-drive.svg": A6, "../../assets/icons/hamburger-menu.svg": V6, "../../assets/icons/handwritten.svg": D6, "../../assets/icons/heading-1.svg": q6, "../../assets/icons/heading-2.svg": Z6, "../../assets/icons/history.svg": X6, "../../assets/icons/house.svg": Q6, "../../assets/icons/image-caption.svg": ov, "../../assets/icons/image-cover.svg": sv, "../../assets/icons/image-crop.svg": lv, "../../assets/icons/image-full.svg": cv, "../../assets/icons/image-half.svg": pv, "../../assets/icons/image-original.svg": gv, "../../assets/icons/image-placeholder.svg": bv, "../../assets/icons/image-text-over.svg": xv, "../../assets/icons/image.svg": $v, "../../assets/icons/info-circle.svg": Ov, "../../assets/icons/initials.svg": Bv, "../../assets/icons/link-block.svg": Av, "../../assets/icons/link-broken.svg": Vv, "../../assets/icons/link.svg": Dv, "../../assets/icons/list.svg": qv, "../../assets/icons/lock-shield.svg": Zv, "../../assets/icons/lock.svg": Xv, "../../assets/icons/logout.svg": Qv, "../../assets/icons/magnifying-glass-info.svg": o7, "../../assets/icons/mail-sign-at.svg": s7, "../../assets/icons/mailbox.svg": l7, "../../assets/icons/megaphone.svg": c7, "../../assets/icons/merge-tag.svg": p7, "../../assets/icons/microphone.svg": g7, "../../assets/icons/minus-bold.svg": b7, "../../assets/icons/minus-large.svg": x7, "../../assets/icons/money-bag.svg": $7, "../../assets/icons/move-folder.svg": O7, "../../assets/icons/move-item.svg": B7, "../../assets/icons/move-to-block-above.svg": A7, "../../assets/icons/move-to-block-below.svg": V7, "../../assets/icons/move-to-first-block.svg": D7, "../../assets/icons/move-to-last-block.svg": q7, "../../assets/icons/normal-text.svg": Z7, "../../assets/icons/ordered-list.svg": X7, "../../assets/icons/outline-square.svg": Q7, "../../assets/icons/page-break.svg": og, "../../assets/icons/paintbrush.svg": sg, "../../assets/icons/painting-palette.svg": lg, "../../assets/icons/pen-circle.svg": cg, "../../assets/icons/pen-to-square.svg": pg, "../../assets/icons/pen-write.svg": gg, "../../assets/icons/percentage.svg": bg, "../../assets/icons/phone-call.svg": xg, "../../assets/icons/phone.svg": $g, "../../assets/icons/pin.svg": Og, "../../assets/icons/play.svg": Bg, "../../assets/icons/plus-bold.svg": Ag, "../../assets/icons/plus-large.svg": Vg, "../../assets/icons/plus-small-bold.svg": Dg, "../../assets/icons/plus-xsmall-bold.svg": qg, "../../assets/icons/plus.svg": Zg, "../../assets/icons/presentation.svg": Xg, "../../assets/icons/pricing-group.svg": Qg, "../../assets/icons/print.svg": o8, "../../assets/icons/processing.svg": s8, "../../assets/icons/product-library.svg": l8, "../../assets/icons/publish.svg": c8, "../../assets/icons/puzzle.svg": p8, "../../assets/icons/question-circle.svg": g8, "../../assets/icons/replace-item.svg": b8, "../../assets/icons/replace-video.svg": x8, "../../assets/icons/reverse.svg": $8, "../../assets/icons/rocket.svg": O8, "../../assets/icons/rows.svg": B8, "../../assets/icons/search.svg": A8, "../../assets/icons/select-frame.svg": V8, "../../assets/icons/send-arrow.svg": D8, "../../assets/icons/send.svg": q8, "../../assets/icons/setting-slider.svg": Z8, "../../assets/icons/settings-cog.svg": X8, "../../assets/icons/settings-toggle.svg": Q8, "../../assets/icons/share.svg": o4, "../../assets/icons/signature.svg": s4, "../../assets/icons/smiley.svg": l4, "../../assets/icons/sms-document.svg": c4, "../../assets/icons/sparkle.svg": p4, "../../assets/icons/striped-table.svg": g4, "../../assets/icons/sub-heading.svg": b4, "../../assets/icons/summarize.svg": x4, "../../assets/icons/support-headset.svg": $4, "../../assets/icons/table-border.svg": O4, "../../assets/icons/table.svg": B4, "../../assets/icons/tag.svg": A4, "../../assets/icons/tags.svg": V4, "../../assets/icons/template.svg": D4, "../../assets/icons/text-align-center.svg": q4, "../../assets/icons/text-align-justify.svg": Z4, "../../assets/icons/text-align-left.svg": X4, "../../assets/icons/text-align-right.svg": Q4, "../../assets/icons/text-bold.svg": o_, "../../assets/icons/text-case.svg": s_, "../../assets/icons/text-check.svg": l_, "../../assets/icons/text-clear-formatting.svg": c_, "../../assets/icons/text-divider.svg": p_, "../../assets/icons/text-italic.svg": g_, "../../assets/icons/text-multiple-styles.svg": b_, "../../assets/icons/text-small.svg": x_, "../../assets/icons/text-strike.svg": $_, "../../assets/icons/text-underline.svg": O_, "../../assets/icons/text.svg": B_, "../../assets/icons/thumb-down.svg": A_, "../../assets/icons/thumb-up.svg": V_, "../../assets/icons/time-reverse.svg": D_, "../../assets/icons/top-row-background.svg": q_, "../../assets/icons/translate.svg": Z_, "../../assets/icons/triangle-down.svg": X_, "../../assets/icons/type.svg": Q_, "../../assets/icons/underline.svg": ow, "../../assets/icons/unlock.svg": sw, "../../assets/icons/unordered-list.svg": lw, "../../assets/icons/upload.svg": cw, "../../assets/icons/user-add.svg": pw, "../../assets/icons/user-coin.svg": gw, "../../assets/icons/user-lock.svg": bw, "../../assets/icons/user-move.svg": xw, "../../assets/icons/user-remove.svg": $w, "../../assets/icons/user-shield.svg": Ow, "../../assets/icons/user.svg": Bw, "../../assets/icons/users-search.svg": Aw, "../../assets/icons/users.svg": Vw, "../../assets/icons/video-block.svg": Dw, "../../assets/icons/view-check-circle.svg": qw, "../../assets/icons/view-hide.svg": Zw, "../../assets/icons/view.svg": Xw, "../../assets/icons/wallet.svg": Qw, "../../assets/icons/write-document.svg": o9 }), n = z(() => o[`../../assets/icons/${e.icon}.svg`]), r = z(() => `svg-icon--${e.icon}`);
    return (s, i) => (d(), P(_(n), {
      class: S(["svg-icon", r.value, s.size])
    }, null, 8, ["class"]));
  }
}), T = (t, e) => {
  const o = t.__vccOpts || t;
  for (const [n, r] of e)
    o[n] = r;
  return o;
}, U = /* @__PURE__ */ T(n9, [["__scopeId", "data-v-711e74f0"]]), r9 = /* @__PURE__ */ A({
  __name: "TransitionExpand",
  setup(t) {
    const e = (s) => {
      s._parent = s.parentNode, s._initialStyle = {
        transition: s.style.transition,
        visibility: s.style.visibility,
        overflow: s.style.overflow,
        height: s.style.height
      };
    }, o = (s) => {
      const i = s._initialStyle;
      s.style.setProperty("transition", "none", "important"), s.style.visibility = "hidden";
      const a = `${s.offsetHeight}px`;
      s.style.visibility = i.visibility, s.style.overflow = "hidden", s.style.height = 0, s.offsetHeight, s.style.transition = i.transition, requestAnimationFrame(() => {
        s.style.height = a;
      });
    }, n = (s) => {
      s._initialStyle = {
        overflow: s.style.overflow,
        height: s.style.height
      }, s.style.overflow = "hidden", s.style.height = `${s.offsetHeight}px`, s.offsetHeight, requestAnimationFrame(() => s.style.height = 0);
    }, r = (s) => {
      s.style.overflow = s._initialStyle.overflow, s.style.height = s._initialStyle.height, delete s._initialStyle;
    };
    return (s, i) => (d(), P(Ro, Oe({ name: "expand" }, s.$attrs, {
      onBeforeEnter: e,
      onEnter: o,
      onAfterEnter: r,
      onEnterCancelled: r,
      onLeave: n,
      onAfterLeave: r,
      onLeaveCancelled: r
    }), {
      default: O(() => [
        C(s.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16));
  }
}), $d = /* @__PURE__ */ T(r9, [["__scopeId", "data-v-606139cf"]]), s9 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let xe = (t = 21) => {
  let e = "", o = crypto.getRandomValues(new Uint8Array(t |= 0));
  for (; t--; )
    e += s9[o[t] & 63];
  return e;
};
const i9 = ["aria-expanded", "aria-disabled", "disabled"], a9 = /* @__PURE__ */ A({
  __name: "FriedAccordion",
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean, default: !1 },
    showBorder: { type: Boolean, default: !1 },
    showShadow: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const o = `accordion-${xe(5)}`, n = t, r = e, s = () => {
      n.disabled || r("update:modelValue", !n.modelValue);
    };
    return (i, a) => (d(), h("div", {
      class: S(["accordion-container", { disabled: i.disabled }])
    }, [
      l("button", {
        class: S(["accordion-header", { border: i.showBorder }]),
        "aria-expanded": i.modelValue ? "true" : "false",
        "aria-disabled": i.disabled,
        disabled: i.disabled,
        "aria-controls": o,
        onClick: s
      }, [
        C(i.$slots, "header", {}, void 0, !0),
        $(U, {
          icon: "chevron-down",
          class: S(["icon", { "icon-point-up": i.modelValue }])
        }, null, 8, ["class"])
      ], 10, i9),
      $($d, null, {
        default: O(() => [
          se(l("div", {
            id: o,
            class: S(["accordion-content", { shadow: i.showShadow }])
          }, [
            C(i.$slots, "content", {}, void 0, !0)
          ], 2), [
            [yt, i.modelValue]
          ])
        ]),
        _: 3
      })
    ], 2));
  }
}), l9 = /* @__PURE__ */ T(a9, [["__scopeId", "data-v-cf54bd96"]]);
var so = /* @__PURE__ */ ((t) => (t.Tiny = "tiny", t.Small = "small", t.Medium = "medium", t.Large = "large", t))(so || {});
const d9 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
};
function u9(t, e) {
  return d(), h("svg", d9, e[0] || (e[0] = [
    W('<circle cx="20" cy="20" r="20" fill="#F1F4F9"></circle><mask id="a" width="40" height="40" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha;"><circle cx="20" cy="20" r="20" fill="#C4C4C4"></circle></mask><g mask="url(#a)"><ellipse cx="20" cy="35.2" fill="#DAE2EC" rx="15.2" ry="8.8"></ellipse></g><circle cx="20" cy="17" r="7.2" fill="#DAE2EC"></circle>', 4)
  ]));
}
const c9 = { render: u9 };
function Sd(t) {
  for (const { el: e, binding: o, vnode: n } of Kt)
    h9(e, o, n, t);
}
function h9(t, e, o, n) {
  !(t == n.target || t.contains(n.target)) && typeof e.value == "function" && e.value(n, t);
}
const f9 = (t, e, o) => {
  if (typeof e.value != "function") {
    console.error(
      "v-ga-click-outside: provided expression",
      e.expression,
      "is not a function."
    );
    return;
  }
  Kt.length === 0 && document.body.addEventListener("mousedown", Sd), Kt.push({
    el: t,
    binding: e,
    vnode: o
  });
}, p9 = (t) => {
  Kt = Kt.filter((e) => e.el !== t), Kt.length === 0 && document.body.removeEventListener("mousedown", Sd);
};
let Kt = [];
const io = {
  beforeMount: f9,
  unmounted: p9
}, m9 = (t) => {
  document.body.appendChild(t);
}, v9 = {
  mounted: m9
}, g9 = (t) => {
  t.focus();
}, _9 = {
  mounted: g9
};
var yr = /* @__PURE__ */ ((t) => (t[t.Enter = 13] = "Enter", t[t.Tab = 9] = "Tab", t[t.Delete = 46] = "Delete", t[t.Esc = 27] = "Esc", t[t.Space = 32] = "Space", t[t.Up = 38] = "Up", t[t.Down = 40] = "Down", t[t.Left = 37] = "Left", t[t.Right = 39] = "Right", t[t.End = 35] = "End", t[t.Home = 36] = "Home", t[t.Backspace = 8] = "Backspace", t[t.Insert = 45] = "Insert", t[t.Pageup = 33] = "Pageup", t[t.Pagedown = 34] = "Pagedown", t))(yr || {});
const w9 = 80;
function _s(t, e) {
  t.style.transform = e, t.style.webkitTransform = e;
}
function nr(t, e) {
  t.style.opacity = e.toString();
}
function xr(t) {
  return t.constructor.name === "TouchEvent";
}
function jd(t) {
  return t.constructor.name === "KeyboardEvent";
}
const b9 = (t, e, o = {}) => {
  let n = 0, r = 0;
  if (!jd(t)) {
    const p = e.getBoundingClientRect(), v = xr(t) ? t.touches[t.touches.length - 1] : t;
    n = v.clientX - p.left, r = v.clientY - p.top;
  }
  let s = 0, i = 0.3;
  e._wave && e._wave.circle ? (i = 0.15, s = e.clientWidth / 2, s = o.center ? s : s + Math.sqrt(Ut(n - s, 2) + Ut(r - s, 2)) / 4) : s = Math.sqrt(Ut(e.clientWidth, 2) + Ut(e.clientHeight, 2)) / 2;
  const a = `${(e.clientWidth - s * 2) / 2}px`, c = `${(e.clientHeight - s * 2) / 2}px`, u = o.center ? a : `${n - s}px`, f = o.center ? c : `${r - s}px`;
  return { radius: s, scale: i, x: u, y: f, centerX: a, centerY: c };
}, gn = {
  show(t, e, o = {}) {
    if (!e._wave || !e._wave.enabled)
      return;
    const n = document.createElement("span"), r = document.createElement("span");
    n.appendChild(r), n.className = "v-wave__container", o.class && (n.className += ` ${o.class}`);
    const { radius: s, scale: i, x: a, y: c, centerX: u, centerY: f } = b9(t, e, o), p = `${s * 2}px`;
    r.className = "v-wave__animation", r.style.width = p, r.style.height = p, e.appendChild(n);
    const v = window.getComputedStyle(e);
    v && v.position === "static" && (e.style.position = "relative", e.dataset.previousPosition = "static"), r.classList.add("v-wave__animation--enter"), r.classList.add("v-wave__animation--visible"), _s(r, `translate(${a}, ${c}) scale3d(${i},${i},${i})`), nr(r, 0), r.dataset.activated = String(performance.now()), setTimeout(() => {
      r.classList.remove("v-wave__animation--enter"), r.classList.add("v-wave__animation--in"), _s(r, `translate(${u}, ${f}) scale3d(1,1,1)`), nr(r, 0.25);
    }, 0);
  },
  hide(t) {
    if (!t || !t._wave || !t._wave.enabled) return;
    const e = t.getElementsByClassName("v-wave__animation");
    if (e.length === 0) return;
    const o = e[e.length - 1];
    if (o.dataset.isHiding) return;
    o.dataset.isHiding = "true";
    const n = performance.now() - Number(o.dataset.activated), r = Math.max(250 - n, 0);
    setTimeout(() => {
      o.classList.remove("v-wave__animation--in"), o.classList.add("v-wave__animation--out"), nr(o, 0), setTimeout(() => {
        t.getElementsByClassName("v-wave__animation").length === 1 && t.dataset.previousPosition && (t.style.position = t.dataset.previousPosition, delete t.dataset.previousPosition), o.parentNode && t.removeChild(o.parentNode);
      }, 300);
    }, r);
  }
};
function Od(t) {
  return typeof t == "undefined" || !!t;
}
function Lo(t) {
  const e = {}, o = t.currentTarget;
  if (!(!o || !o._wave || o._wave.touched)) {
    if (xr(t))
      o._wave.touched = !0, o._wave.isTouch = !0;
    else if (o._wave.isTouch) return;
    if (e.center = o._wave.centered || jd(t), o._wave.class && (e.class = o._wave.class), xr(t)) {
      if (o._wave.showTimerCommit) return;
      o._wave.showTimerCommit = () => {
        gn.show(t, o, e);
      }, o._wave.showTimer = window.setTimeout(() => {
        o && o._wave && o._wave.showTimerCommit && (o._wave.showTimerCommit(), o._wave.showTimerCommit = null);
      }, w9);
    } else
      gn.show(t, o, e);
  }
}
function Le(t) {
  const e = t.currentTarget;
  if (!(!e || !e._wave)) {
    if (window.clearTimeout(e._wave.showTimer), t.type === "touchend" && e._wave.showTimerCommit) {
      e._wave.showTimerCommit(), e._wave.showTimerCommit = null, e._wave.showTimer = setTimeout(() => {
        Le(t);
      });
      return;
    }
    window.setTimeout(() => {
      e._wave && (e._wave.touched = !1);
    }), gn.hide(e);
  }
}
function Td(t) {
  const e = t.currentTarget;
  !e || !e._wave || (e._wave.showTimerCommit && (e._wave.showTimerCommit = null), window.clearTimeout(e._wave.showTimer));
}
let Cr = !1;
function zd(t) {
  !Cr && (t.keyCode === yr.Enter || t.keyCode === yr.Space) && (Cr = !0, Lo(t));
}
function Bd(t) {
  Cr = !1, Le(t);
}
function Ed(t, e, o) {
  const n = Od(e.value);
  n || gn.hide(t), t._wave = t._wave || {}, t._wave.enabled = n;
  const r = e.value || {};
  r.center && (t._wave.centered = !0), r.class && (t._wave.class = e.value.class), r.circle && (t._wave.circle = r.circle), n && !o ? (t.addEventListener("touchstart", Lo, { passive: !0 }), t.addEventListener("touchend", Le, { passive: !0 }), t.addEventListener("touchmove", Td, { passive: !0 }), t.addEventListener("touchcancel", Le), t.addEventListener("mousedown", Lo), t.addEventListener("mouseup", Le), t.addEventListener("mouseleave", Le), t.addEventListener("keydown", zd), t.addEventListener("keyup", Bd), t.addEventListener("dragstart", Le, { passive: !0 })) : !n && o && Pd(t);
}
function Pd(t) {
  t.removeEventListener("mousedown", Lo), t.removeEventListener("touchstart", Lo), t.removeEventListener("touchend", Le), t.removeEventListener("touchmove", Td), t.removeEventListener("touchcancel", Le), t.removeEventListener("mouseup", Le), t.removeEventListener("mouseleave", Le), t.removeEventListener("keydown", zd), t.removeEventListener("keyup", Bd), t.removeEventListener("dragstart", Le);
}
function k9(t, e, o) {
  Ed(t, e, !1), process.env.NODE_ENV === "development" && o.context && o.context.$nextTick(() => {
    const n = window.getComputedStyle(t);
    n && n.display === "inline" && console.warn(`v-wave can only be used on block-level elements, but current el is ${t}`);
  });
}
function y9(t) {
  delete t._wave, Pd(t);
}
function x9(t, e) {
  if (e.value === e.oldValue)
    return;
  const o = Od(e.oldValue);
  Ed(t, e, o);
}
const ut = {
  beforeMount: k9,
  unmounted: y9,
  updated: x9
}, C9 = ["top", "right", "bottom", "left"], ws = ["start", "end"], bs = /* @__PURE__ */ C9.reduce((t, e) => t.concat(e, e + "-" + ws[0], e + "-" + ws[1]), []), It = Math.min, Lt = Math.max, M9 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, $9 = {
  start: "end",
  end: "start"
};
function Mr(t, e, o) {
  return Lt(t, It(e, o));
}
function Rt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function ot(t) {
  return t.split("-")[0];
}
function Ge(t) {
  return t.split("-")[1];
}
function Ad(t) {
  return t === "x" ? "y" : "x";
}
function Zr(t) {
  return t === "y" ? "height" : "width";
}
function qo(t) {
  return ["top", "bottom"].includes(ot(t)) ? "y" : "x";
}
function Gr(t) {
  return Ad(qo(t));
}
function Ld(t, e, o) {
  o === void 0 && (o = !1);
  const n = Ge(t), r = Gr(t), s = Zr(r);
  let i = r === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (i = wn(i)), [i, wn(i)];
}
function S9(t) {
  const e = wn(t);
  return [_n(t), e, _n(e)];
}
function _n(t) {
  return t.replace(/start|end/g, (e) => $9[e]);
}
function j9(t, e, o) {
  const n = ["left", "right"], r = ["right", "left"], s = ["top", "bottom"], i = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return o ? e ? r : n : e ? n : r;
    case "left":
    case "right":
      return e ? s : i;
    default:
      return [];
  }
}
function O9(t, e, o, n) {
  const r = Ge(t);
  let s = j9(ot(t), o === "start", n);
  return r && (s = s.map((i) => i + "-" + r), e && (s = s.concat(s.map(_n)))), s;
}
function wn(t) {
  return t.replace(/left|right|bottom|top/g, (e) => M9[e]);
}
function T9(t) {
  return j({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, t);
}
function Hd(t) {
  return typeof t != "number" ? T9(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function $o(t) {
  const {
    x: e,
    y: o,
    width: n,
    height: r
  } = t;
  return {
    width: n,
    height: r,
    top: o,
    left: e,
    right: e + n,
    bottom: o + r,
    x: e,
    y: o
  };
}
function ks(t, e, o) {
  let {
    reference: n,
    floating: r
  } = t;
  const s = qo(e), i = Gr(e), a = Zr(i), c = ot(e), u = s === "y", f = n.x + n.width / 2 - r.width / 2, p = n.y + n.height / 2 - r.height / 2, v = n[a] / 2 - r[a] / 2;
  let m;
  switch (c) {
    case "top":
      m = {
        x: f,
        y: n.y - r.height
      };
      break;
    case "bottom":
      m = {
        x: f,
        y: n.y + n.height
      };
      break;
    case "right":
      m = {
        x: n.x + n.width,
        y: p
      };
      break;
    case "left":
      m = {
        x: n.x - r.width,
        y: p
      };
      break;
    default:
      m = {
        x: n.x,
        y: n.y
      };
  }
  switch (Ge(e)) {
    case "start":
      m[i] -= v * (o && u ? -1 : 1);
      break;
    case "end":
      m[i] += v * (o && u ? -1 : 1);
      break;
  }
  return m;
}
const z9 = (t, e, o) => Q(void 0, null, function* () {
  const {
    placement: n = "bottom",
    strategy: r = "absolute",
    middleware: s = [],
    platform: i
  } = o, a = s.filter(Boolean), c = yield i.isRTL == null ? void 0 : i.isRTL(e);
  let u = yield i.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: f,
    y: p
  } = ks(u, n, c), v = n, m = {}, g = 0;
  for (let w = 0; w < a.length; w++) {
    const {
      name: y,
      fn: M
    } = a[w], {
      x: B,
      y: k,
      data: x,
      reset: b
    } = yield M({
      x: f,
      y: p,
      initialPlacement: n,
      placement: v,
      strategy: r,
      middlewareData: m,
      rects: u,
      platform: i,
      elements: {
        reference: t,
        floating: e
      }
    });
    f = B != null ? B : f, p = k != null ? k : p, m = R(j({}, m), {
      [y]: j(j({}, m[y]), x)
    }), b && g <= 50 && (g++, typeof b == "object" && (b.placement && (v = b.placement), b.rects && (u = b.rects === !0 ? yield i.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : b.rects), {
      x: f,
      y: p
    } = ks(u, v, c)), w = -1);
  }
  return {
    x: f,
    y: p,
    placement: v,
    strategy: r,
    middlewareData: m
  };
});
function Pn(t, e) {
  return Q(this, null, function* () {
    var o;
    e === void 0 && (e = {});
    const {
      x: n,
      y: r,
      platform: s,
      rects: i,
      elements: a,
      strategy: c
    } = t, {
      boundary: u = "clippingAncestors",
      rootBoundary: f = "viewport",
      elementContext: p = "floating",
      altBoundary: v = !1,
      padding: m = 0
    } = Rt(e, t), g = Hd(m), y = a[v ? p === "floating" ? "reference" : "floating" : p], M = $o(yield s.getClippingRect({
      element: (o = yield s.isElement == null ? void 0 : s.isElement(y)) == null || o ? y : y.contextElement || (yield s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
      boundary: u,
      rootBoundary: f,
      strategy: c
    })), B = p === "floating" ? {
      x: n,
      y: r,
      width: i.floating.width,
      height: i.floating.height
    } : i.reference, k = yield s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating), x = (yield s.isElement == null ? void 0 : s.isElement(k)) ? (yield s.getScale == null ? void 0 : s.getScale(k)) || {
      x: 1,
      y: 1
    } : {
      x: 1,
      y: 1
    }, b = $o(s.convertOffsetParentRelativeRectToViewportRelativeRect ? yield s.convertOffsetParentRelativeRectToViewportRelativeRect({
      elements: a,
      rect: B,
      offsetParent: k,
      strategy: c
    }) : B);
    return {
      top: (M.top - b.top + g.top) / x.y,
      bottom: (b.bottom - M.bottom + g.bottom) / x.y,
      left: (M.left - b.left + g.left) / x.x,
      right: (b.right - M.right + g.right) / x.x
    };
  });
}
const B9 = (t) => ({
  name: "arrow",
  options: t,
  fn(o) {
    return Q(this, null, function* () {
      const {
        x: n,
        y: r,
        placement: s,
        rects: i,
        platform: a,
        elements: c,
        middlewareData: u
      } = o, {
        element: f,
        padding: p = 0
      } = Rt(t, o) || {};
      if (f == null)
        return {};
      const v = Hd(p), m = {
        x: n,
        y: r
      }, g = Gr(s), w = Zr(g), y = yield a.getDimensions(f), M = g === "y", B = M ? "top" : "left", k = M ? "bottom" : "right", x = M ? "clientHeight" : "clientWidth", b = i.reference[w] + i.reference[g] - m[g] - i.floating[w], N = m[g] - i.reference[g], Z = yield a.getOffsetParent == null ? void 0 : a.getOffsetParent(f);
      let ne = Z ? Z[x] : 0;
      (!ne || !(yield a.isElement == null ? void 0 : a.isElement(Z))) && (ne = c.floating[x] || i.floating[w]);
      const V = b / 2 - N / 2, J = ne / 2 - y[w] / 2 - 1, le = It(v[B], J), te = It(v[k], J), ie = le, ve = ne - y[w] - te, he = ne / 2 - y[w] / 2 + V, fe = Mr(ie, he, ve), ze = !u.arrow && Ge(s) != null && he !== fe && i.reference[w] / 2 - (he < ie ? le : te) - y[w] / 2 < 0, ke = ze ? he < ie ? he - ie : he - ve : 0;
      return {
        [g]: m[g] + ke,
        data: j({
          [g]: fe,
          centerOffset: he - fe - ke
        }, ze && {
          alignmentOffset: ke
        }),
        reset: ze
      };
    });
  }
});
function E9(t, e, o) {
  return (t ? [...o.filter((r) => Ge(r) === t), ...o.filter((r) => Ge(r) !== t)] : o.filter((r) => ot(r) === r)).filter((r) => t ? Ge(r) === t || (e ? _n(r) !== r : !1) : !0);
}
const P9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "autoPlacement",
    options: t,
    fn(o) {
      return Q(this, null, function* () {
        var n, r, s;
        const {
          rects: i,
          middlewareData: a,
          placement: c,
          platform: u,
          elements: f
        } = o, le = Rt(t, o), {
          crossAxis: p = !1,
          alignment: v,
          allowedPlacements: m = bs,
          autoAlignment: g = !0
        } = le, w = Be(le, [
          "crossAxis",
          "alignment",
          "allowedPlacements",
          "autoAlignment"
        ]), y = v !== void 0 || m === bs ? E9(v || null, g, m) : m, M = yield Pn(o, w), B = ((n = a.autoPlacement) == null ? void 0 : n.index) || 0, k = y[B];
        if (k == null)
          return {};
        const x = Ld(k, i, yield u.isRTL == null ? void 0 : u.isRTL(f.floating));
        if (c !== k)
          return {
            reset: {
              placement: y[0]
            }
          };
        const b = [M[ot(k)], M[x[0]], M[x[1]]], N = [...((r = a.autoPlacement) == null ? void 0 : r.overflows) || [], {
          placement: k,
          overflows: b
        }], Z = y[B + 1];
        if (Z)
          return {
            data: {
              index: B + 1,
              overflows: N
            },
            reset: {
              placement: Z
            }
          };
        const ne = N.map((te) => {
          const ie = Ge(te.placement);
          return [te.placement, ie && p ? (
            // Check along the mainAxis and main crossAxis side.
            te.overflows.slice(0, 2).reduce((ve, he) => ve + he, 0)
          ) : (
            // Check only the mainAxis.
            te.overflows[0]
          ), te.overflows];
        }).sort((te, ie) => te[1] - ie[1]), J = ((s = ne.filter((te) => te[2].slice(
          0,
          // Aligned placements should not check their opposite crossAxis
          // side.
          Ge(te[0]) ? 2 : 3
        ).every((ie) => ie <= 0))[0]) == null ? void 0 : s[0]) || ne[0][0];
        return J !== c ? {
          data: {
            index: B + 1,
            overflows: N
          },
          reset: {
            placement: J
          }
        } : {};
      });
    }
  };
}, A9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    fn(o) {
      return Q(this, null, function* () {
        var n, r;
        const {
          placement: s,
          middlewareData: i,
          rects: a,
          initialPlacement: c,
          platform: u,
          elements: f
        } = o, ie = Rt(t, o), {
          mainAxis: p = !0,
          crossAxis: v = !0,
          fallbackPlacements: m,
          fallbackStrategy: g = "bestFit",
          fallbackAxisSideDirection: w = "none",
          flipAlignment: y = !0
        } = ie, M = Be(ie, [
          "mainAxis",
          "crossAxis",
          "fallbackPlacements",
          "fallbackStrategy",
          "fallbackAxisSideDirection",
          "flipAlignment"
        ]);
        if ((n = i.arrow) != null && n.alignmentOffset)
          return {};
        const B = ot(s), k = ot(c) === c, x = yield u.isRTL == null ? void 0 : u.isRTL(f.floating), b = m || (k || !y ? [wn(c)] : S9(c));
        !m && w !== "none" && b.push(...O9(c, y, w, x));
        const N = [c, ...b], Z = yield Pn(o, M), ne = [];
        let V = ((r = i.flip) == null ? void 0 : r.overflows) || [];
        if (p && ne.push(Z[B]), v) {
          const ve = Ld(s, a, x);
          ne.push(Z[ve[0]], Z[ve[1]]);
        }
        if (V = [...V, {
          placement: s,
          overflows: ne
        }], !ne.every((ve) => ve <= 0)) {
          var J, le;
          const ve = (((J = i.flip) == null ? void 0 : J.index) || 0) + 1, he = N[ve];
          if (he)
            return {
              data: {
                index: ve,
                overflows: V
              },
              reset: {
                placement: he
              }
            };
          let fe = (le = V.filter((ze) => ze.overflows[0] <= 0).sort((ze, ke) => ze.overflows[1] - ke.overflows[1])[0]) == null ? void 0 : le.placement;
          if (!fe)
            switch (g) {
              case "bestFit": {
                var te;
                const ze = (te = V.map((ke) => [ke.placement, ke.overflows.filter((rt) => rt > 0).reduce((rt, on) => rt + on, 0)]).sort((ke, rt) => ke[1] - rt[1])[0]) == null ? void 0 : te[0];
                ze && (fe = ze);
                break;
              }
              case "initialPlacement":
                fe = c;
                break;
            }
          if (s !== fe)
            return {
              reset: {
                placement: fe
              }
            };
        }
        return {};
      });
    }
  };
};
function L9(t, e) {
  return Q(this, null, function* () {
    const {
      placement: o,
      platform: n,
      elements: r
    } = t, s = yield n.isRTL == null ? void 0 : n.isRTL(r.floating), i = ot(o), a = Ge(o), c = qo(o) === "y", u = ["left", "top"].includes(i) ? -1 : 1, f = s && c ? -1 : 1, p = Rt(e, t);
    let {
      mainAxis: v,
      crossAxis: m,
      alignmentAxis: g
    } = typeof p == "number" ? {
      mainAxis: p,
      crossAxis: 0,
      alignmentAxis: null
    } : j({
      mainAxis: 0,
      crossAxis: 0,
      alignmentAxis: null
    }, p);
    return a && typeof g == "number" && (m = a === "end" ? g * -1 : g), c ? {
      x: m * f,
      y: v * u
    } : {
      x: v * u,
      y: m * f
    };
  });
}
const H9 = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    fn(o) {
      return Q(this, null, function* () {
        var n, r;
        const {
          x: s,
          y: i,
          placement: a,
          middlewareData: c
        } = o, u = yield L9(o, t);
        return a === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
          x: s + u.x,
          y: i + u.y,
          data: R(j({}, u), {
            placement: a
          })
        };
      });
    }
  };
}, V9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    fn(o) {
      return Q(this, null, function* () {
        const {
          x: n,
          y: r,
          placement: s
        } = o, M = Rt(t, o), {
          mainAxis: i = !0,
          crossAxis: a = !1,
          limiter: c = {
            fn: (B) => {
              let {
                x: k,
                y: x
              } = B;
              return {
                x: k,
                y: x
              };
            }
          }
        } = M, u = Be(M, [
          "mainAxis",
          "crossAxis",
          "limiter"
        ]), f = {
          x: n,
          y: r
        }, p = yield Pn(o, u), v = qo(ot(s)), m = Ad(v);
        let g = f[m], w = f[v];
        if (i) {
          const B = m === "y" ? "top" : "left", k = m === "y" ? "bottom" : "right", x = g + p[B], b = g - p[k];
          g = Mr(x, g, b);
        }
        if (a) {
          const B = v === "y" ? "top" : "left", k = v === "y" ? "bottom" : "right", x = w + p[B], b = w - p[k];
          w = Mr(x, w, b);
        }
        const y = c.fn(R(j({}, o), {
          [m]: g,
          [v]: w
        }));
        return R(j({}, y), {
          data: {
            x: y.x - n,
            y: y.y - r
          }
        });
      });
    }
  };
}, F9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    fn(o) {
      return Q(this, null, function* () {
        const {
          placement: n,
          rects: r,
          platform: s,
          elements: i
        } = o, V = Rt(t, o), {
          apply: a = () => {
          }
        } = V, c = Be(V, [
          "apply"
        ]), u = yield Pn(o, c), f = ot(n), p = Ge(n), v = qo(n) === "y", {
          width: m,
          height: g
        } = r.floating;
        let w, y;
        f === "top" || f === "bottom" ? (w = f, y = p === ((yield s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (y = f, w = p === "end" ? "top" : "bottom");
        const M = g - u.top - u.bottom, B = m - u.left - u.right, k = It(g - u[w], M), x = It(m - u[y], B), b = !o.middlewareData.shift;
        let N = k, Z = x;
        if (v ? Z = p || b ? It(x, B) : B : N = p || b ? It(k, M) : M, b && !p) {
          const J = Lt(u.left, 0), le = Lt(u.right, 0), te = Lt(u.top, 0), ie = Lt(u.bottom, 0);
          v ? Z = m - 2 * (J !== 0 || le !== 0 ? J + le : Lt(u.left, u.right)) : N = g - 2 * (te !== 0 || ie !== 0 ? te + ie : Lt(u.top, u.bottom));
        }
        yield a(R(j({}, o), {
          availableWidth: Z,
          availableHeight: N
        }));
        const ne = yield s.getDimensions(i.floating);
        return m !== ne.width || g !== ne.height ? {
          reset: {
            rects: !0
          }
        } : {};
      });
    }
  };
};
function Ve(t) {
  var e;
  return ((e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Qe(t) {
  return Ve(t).getComputedStyle(t);
}
const ys = Math.min, So = Math.max, bn = Math.round;
function Vd(t) {
  const e = Qe(t);
  let o = parseFloat(e.width), n = parseFloat(e.height);
  const r = t.offsetWidth, s = t.offsetHeight, i = bn(o) !== r || bn(n) !== s;
  return i && (o = r, n = s), { width: o, height: n, fallback: i };
}
function Tt(t) {
  return Id(t) ? (t.nodeName || "").toLowerCase() : "";
}
let rn;
function Fd() {
  if (rn) return rn;
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? (rn = t.brands.map((e) => e.brand + "/" + e.version).join(" "), rn) : navigator.userAgent;
}
function et(t) {
  return t instanceof Ve(t).HTMLElement;
}
function Mt(t) {
  return t instanceof Ve(t).Element;
}
function Id(t) {
  return t instanceof Ve(t).Node;
}
function xs(t) {
  return typeof ShadowRoot == "undefined" ? !1 : t instanceof Ve(t).ShadowRoot || t instanceof ShadowRoot;
}
function An(t) {
  const { overflow: e, overflowX: o, overflowY: n, display: r } = Qe(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + o) && !["inline", "contents"].includes(r);
}
function I9(t) {
  return ["table", "td", "th"].includes(Tt(t));
}
function $r(t) {
  const e = /firefox/i.test(Fd()), o = Qe(t), n = o.backdropFilter || o.WebkitBackdropFilter;
  return o.transform !== "none" || o.perspective !== "none" || !!n && n !== "none" || e && o.willChange === "filter" || e && !!o.filter && o.filter !== "none" || ["transform", "perspective"].some((r) => o.willChange.includes(r)) || ["paint", "layout", "strict", "content"].some((r) => {
    const s = o.contain;
    return s != null && s.includes(r);
  });
}
function Dd() {
  return !/^((?!chrome|android).)*safari/i.test(Fd());
}
function Yr(t) {
  return ["html", "body", "#document"].includes(Tt(t));
}
function Nd(t) {
  return Mt(t) ? t : t.contextElement;
}
const Rd = { x: 1, y: 1 };
function Jt(t) {
  const e = Nd(t);
  if (!et(e)) return Rd;
  const o = e.getBoundingClientRect(), { width: n, height: r, fallback: s } = Vd(e);
  let i = (s ? bn(o.width) : o.width) / n, a = (s ? bn(o.height) : o.height) / r;
  return i && Number.isFinite(i) || (i = 1), a && Number.isFinite(a) || (a = 1), { x: i, y: a };
}
function Ho(t, e, o, n) {
  var r, s;
  e === void 0 && (e = !1), o === void 0 && (o = !1);
  const i = t.getBoundingClientRect(), a = Nd(t);
  let c = Rd;
  e && (n ? Mt(n) && (c = Jt(n)) : c = Jt(t));
  const u = a ? Ve(a) : window, f = !Dd() && o;
  let p = (i.left + (f && ((r = u.visualViewport) == null ? void 0 : r.offsetLeft) || 0)) / c.x, v = (i.top + (f && ((s = u.visualViewport) == null ? void 0 : s.offsetTop) || 0)) / c.y, m = i.width / c.x, g = i.height / c.y;
  if (a) {
    const w = Ve(a), y = n && Mt(n) ? Ve(n) : n;
    let M = w.frameElement;
    for (; M && n && y !== w; ) {
      const B = Jt(M), k = M.getBoundingClientRect(), x = getComputedStyle(M);
      k.x += (M.clientLeft + parseFloat(x.paddingLeft)) * B.x, k.y += (M.clientTop + parseFloat(x.paddingTop)) * B.y, p *= B.x, v *= B.y, m *= B.x, g *= B.y, p += k.x, v += k.y, M = Ve(M).frameElement;
    }
  }
  return { width: m, height: g, top: v, right: p + m, bottom: v + g, left: p, x: p, y: v };
}
function $t(t) {
  return ((Id(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function Ln(t) {
  return Mt(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function qd(t) {
  return Ho($t(t)).left + Ln(t).scrollLeft;
}
function Vo(t) {
  if (Tt(t) === "html") return t;
  const e = t.assignedSlot || t.parentNode || xs(t) && t.host || $t(t);
  return xs(e) ? e.host : e;
}
function Wd(t) {
  const e = Vo(t);
  return Yr(e) ? e.ownerDocument.body : et(e) && An(e) ? e : Wd(e);
}
function kn(t, e) {
  var o;
  e === void 0 && (e = []);
  const n = Wd(t), r = n === ((o = t.ownerDocument) == null ? void 0 : o.body), s = Ve(n);
  return r ? e.concat(s, s.visualViewport || [], An(n) ? n : []) : e.concat(n, kn(n));
}
function Cs(t, e, o) {
  return e === "viewport" ? $o(function(n, r) {
    const s = Ve(n), i = $t(n), a = s.visualViewport;
    let c = i.clientWidth, u = i.clientHeight, f = 0, p = 0;
    if (a) {
      c = a.width, u = a.height;
      const v = Dd();
      (v || !v && r === "fixed") && (f = a.offsetLeft, p = a.offsetTop);
    }
    return { width: c, height: u, x: f, y: p };
  }(t, o)) : Mt(e) ? $o(function(n, r) {
    const s = Ho(n, !0, r === "fixed"), i = s.top + n.clientTop, a = s.left + n.clientLeft, c = et(n) ? Jt(n) : { x: 1, y: 1 };
    return { width: n.clientWidth * c.x, height: n.clientHeight * c.y, x: a * c.x, y: i * c.y };
  }(e, o)) : $o(function(n) {
    const r = $t(n), s = Ln(n), i = n.ownerDocument.body, a = So(r.scrollWidth, r.clientWidth, i.scrollWidth, i.clientWidth), c = So(r.scrollHeight, r.clientHeight, i.scrollHeight, i.clientHeight);
    let u = -s.scrollLeft + qd(n);
    const f = -s.scrollTop;
    return Qe(i).direction === "rtl" && (u += So(r.clientWidth, i.clientWidth) - a), { width: a, height: c, x: u, y: f };
  }($t(t)));
}
function Ms(t) {
  return et(t) && Qe(t).position !== "fixed" ? t.offsetParent : null;
}
function $s(t) {
  const e = Ve(t);
  let o = Ms(t);
  for (; o && I9(o) && Qe(o).position === "static"; ) o = Ms(o);
  return o && (Tt(o) === "html" || Tt(o) === "body" && Qe(o).position === "static" && !$r(o)) ? e : o || function(n) {
    let r = Vo(n);
    for (; et(r) && !Yr(r); ) {
      if ($r(r)) return r;
      r = Vo(r);
    }
    return null;
  }(t) || e;
}
function D9(t, e, o) {
  const n = et(e), r = $t(e), s = Ho(t, !0, o === "fixed", e);
  let i = { scrollLeft: 0, scrollTop: 0 };
  const a = { x: 0, y: 0 };
  if (n || !n && o !== "fixed") if ((Tt(e) !== "body" || An(r)) && (i = Ln(e)), et(e)) {
    const c = Ho(e, !0);
    a.x = c.x + e.clientLeft, a.y = c.y + e.clientTop;
  } else r && (a.x = qd(r));
  return { x: s.left + i.scrollLeft - a.x, y: s.top + i.scrollTop - a.y, width: s.width, height: s.height };
}
const N9 = { getClippingRect: function(t) {
  let { element: e, boundary: o, rootBoundary: n, strategy: r } = t;
  const s = o === "clippingAncestors" ? function(u, f) {
    const p = f.get(u);
    if (p) return p;
    let v = kn(u).filter((y) => Mt(y) && Tt(y) !== "body"), m = null;
    const g = Qe(u).position === "fixed";
    let w = g ? Vo(u) : u;
    for (; Mt(w) && !Yr(w); ) {
      const y = Qe(w), M = $r(w);
      (g ? M || m : M || y.position !== "static" || !m || !["absolute", "fixed"].includes(m.position)) ? m = y : v = v.filter((B) => B !== w), w = Vo(w);
    }
    return f.set(u, v), v;
  }(e, this._c) : [].concat(o), i = [...s, n], a = i[0], c = i.reduce((u, f) => {
    const p = Cs(e, f, r);
    return u.top = So(p.top, u.top), u.right = ys(p.right, u.right), u.bottom = ys(p.bottom, u.bottom), u.left = So(p.left, u.left), u;
  }, Cs(e, a, r));
  return { width: c.right - c.left, height: c.bottom - c.top, x: c.left, y: c.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  let { rect: e, offsetParent: o, strategy: n } = t;
  const r = et(o), s = $t(o);
  if (o === s) return e;
  let i = { scrollLeft: 0, scrollTop: 0 }, a = { x: 1, y: 1 };
  const c = { x: 0, y: 0 };
  if ((r || !r && n !== "fixed") && ((Tt(o) !== "body" || An(s)) && (i = Ln(o)), et(o))) {
    const u = Ho(o);
    a = Jt(o), c.x = u.x + o.clientLeft, c.y = u.y + o.clientTop;
  }
  return { width: e.width * a.x, height: e.height * a.y, x: e.x * a.x - i.scrollLeft * a.x + c.x, y: e.y * a.y - i.scrollTop * a.y + c.y };
}, isElement: Mt, getDimensions: function(t) {
  return et(t) ? Vd(t) : t.getBoundingClientRect();
}, getOffsetParent: $s, getDocumentElement: $t, getScale: Jt, getElementRects(t) {
  return Q(this, null, function* () {
    let { reference: e, floating: o, strategy: n } = t;
    const r = this.getOffsetParent || $s, s = this.getDimensions;
    return { reference: D9(e, yield r(o), n), floating: j({ x: 0, y: 0 }, yield s(o)) };
  });
}, getClientRects: (t) => Array.from(t.getClientRects()), isRTL: (t) => Qe(t).direction === "rtl" }, R9 = (t, e, o) => {
  const n = /* @__PURE__ */ new Map(), r = j({ platform: N9 }, o), s = R(j({}, r.platform), { _c: n });
  return z9(t, e, R(j({}, r), { platform: s }));
}, St = {
  // Disable popper components
  disabled: !1,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: !1,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 150,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: !0,
  // Flip to the opposite placement if needed
  flip: !0,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: !0,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: !0,
  /**
   * By default, compute autohide on 'click'.
   */
  autoHideOnMousedown: !1,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (t) => [...t, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: !1,
      // Enable HTML content in directive
      html: !1,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: !0,
      // Hide on clock outside
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function Fo(t, e) {
  let o = St.themes[t] || {}, n;
  do
    n = o[e], typeof n > "u" ? o.$extend ? o = St.themes[o.$extend] || {} : (o = null, n = St[e]) : o = null;
  while (o);
  return n;
}
function q9(t) {
  const e = [t];
  let o = St.themes[t] || {};
  do
    o.$extend && !o.$resetCss ? (e.push(o.$extend), o = St.themes[o.$extend] || {}) : o = null;
  while (o);
  return e.map((n) => `v-popper--theme-${n}`);
}
function Ss(t) {
  const e = [t];
  let o = St.themes[t] || {};
  do
    o.$extend ? (e.push(o.$extend), o = St.themes[o.$extend] || {}) : o = null;
  while (o);
  return e;
}
let Io = !1;
if (typeof window < "u") {
  Io = !1;
  try {
    const t = Object.defineProperty({}, "passive", {
      get() {
        Io = !0;
      }
    });
    window.addEventListener("test", null, t);
  } catch (t) {
  }
}
let Ud = !1;
typeof window < "u" && typeof navigator < "u" && (Ud = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const Zd = ["auto", "top", "bottom", "left", "right"].reduce((t, e) => t.concat([
  e,
  `${e}-start`,
  `${e}-end`
]), []), js = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, Os = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function Ts(t, e) {
  const o = t.indexOf(e);
  o !== -1 && t.splice(o, 1);
}
function rr() {
  return new Promise((t) => requestAnimationFrame(() => {
    requestAnimationFrame(t);
  }));
}
const Ue = [];
let Et = null;
const zs = {};
function Bs(t) {
  let e = zs[t];
  return e || (e = zs[t] = []), e;
}
let Sr = function() {
};
typeof window < "u" && (Sr = window.Element);
function G(t) {
  return function(e) {
    return Fo(e.theme, t);
  };
}
const sr = "__floating-vue__popper", Gd = () => A({
  name: "VPopper",
  provide() {
    return {
      [sr]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [sr]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: G("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: G("positioningDisabled")
    },
    placement: {
      type: String,
      default: G("placement"),
      validator: (o) => Zd.includes(o)
    },
    delay: {
      type: [String, Number, Object],
      default: G("delay")
    },
    distance: {
      type: [Number, String],
      default: G("distance")
    },
    skidding: {
      type: [Number, String],
      default: G("skidding")
    },
    triggers: {
      type: Array,
      default: G("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: G("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: G("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: G("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: G("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: G("popperHideTriggers")
    },
    container: {
      type: [String, Object, Sr, Boolean],
      default: G("container")
    },
    boundary: {
      type: [String, Sr],
      default: G("boundary")
    },
    strategy: {
      type: String,
      validator: (o) => ["absolute", "fixed"].includes(o),
      default: G("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: G("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: G("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: G("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: G("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: G("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: G("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: G("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: G("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: G("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: G("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: G("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: G("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: G("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: G("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: G("flip")
    },
    shift: {
      type: Boolean,
      default: G("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: G("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: G("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: G("disposeTimeout")
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (o) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      randomId: `popper_${[Math.random(), Date.now()].map((o) => o.toString(36).substring(2, 10)).join("_")}`,
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0,
      pendingHide: !1,
      containsGlobalTarget: !1,
      isDisposed: !0,
      mouseDownContains: !1
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: R(j({}, this.classes), {
          popperClass: this.popperClass
        }),
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var o;
      return (o = this[sr]) == null ? void 0 : o.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var o, n;
      return ((o = this.popperTriggers) == null ? void 0 : o.includes("hover")) || ((n = this.popperShowTriggers) == null ? void 0 : n.includes("hover"));
    }
  },
  watch: j({
    shown: "$_autoShowHide",
    disabled(o) {
      o ? this.dispose() : this.init();
    },
    container() {
      return Q(this, null, function* () {
        this.isShown && (this.$_ensureTeleport(), yield this.$_computePosition());
      });
    },
    triggers: {
      handler: "$_refreshListeners",
      deep: !0
    },
    positioningDisabled: "$_refreshListeners"
  }, [
    "placement",
    "distance",
    "skidding",
    "boundary",
    "strategy",
    "overflowPadding",
    "arrowPadding",
    "preventOverflow",
    "shift",
    "shiftCrossAxis",
    "flip"
  ].reduce((o, n) => (o[n] = "$_computePosition", o), {})),
  created() {
    this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: o = null, skipDelay: n = !1, force: r = !1 } = {}) {
      var s, i;
      (s = this.parentPopper) != null && s.lockedChild && this.parentPopper.lockedChild !== this || (this.pendingHide = !1, (r || !this.disabled) && (((i = this.parentPopper) == null ? void 0 : i.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(o, n), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: o = null, skipDelay: n = !1 } = {}) {
      var r;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.pendingHide = !0;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: n }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((r = this.parentPopper) == null ? void 0 : r.lockedChild) === this && (this.parentPopper.lockedChild = null), this.pendingHide = !1, this.$_scheduleHide(o, n), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      var n;
      var o;
      this.isDisposed && (this.isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = (n = (o = this.referenceNode) == null ? void 0 : o.call(this)) != null ? n : this.$el, this.$_targetNodes = this.targetNodes().filter((r) => r.nodeType === r.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.isDisposed || (this.isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"));
    },
    onResize() {
      return Q(this, null, function* () {
        this.isShown && (yield this.$_computePosition(), this.$emit("resize"));
      });
    },
    $_computePosition() {
      return Q(this, null, function* () {
        var s;
        if (this.isDisposed || this.positioningDisabled)
          return;
        const o = {
          strategy: this.strategy,
          middleware: []
        };
        (this.distance || this.skidding) && o.middleware.push(H9({
          mainAxis: this.distance,
          crossAxis: this.skidding
        }));
        const n = this.placement.startsWith("auto");
        if (n ? o.middleware.push(P9({
          alignment: (s = this.placement.split("-")[1]) != null ? s : ""
        })) : o.placement = this.placement, this.preventOverflow && (this.shift && o.middleware.push(V9({
          padding: this.overflowPadding,
          boundary: this.boundary,
          crossAxis: this.shiftCrossAxis
        })), !n && this.flip && o.middleware.push(A9({
          padding: this.overflowPadding,
          boundary: this.boundary
        }))), o.middleware.push(B9({
          element: this.$_arrowNode,
          padding: this.arrowPadding
        })), this.arrowOverflow && o.middleware.push({
          name: "arrowOverflow",
          fn: ({ placement: i, rects: a, middlewareData: c }) => {
            let u;
            const { centerOffset: f } = c.arrow;
            return i.startsWith("top") || i.startsWith("bottom") ? u = Math.abs(f) > a.reference.width / 2 : u = Math.abs(f) > a.reference.height / 2, {
              data: {
                overflow: u
              }
            };
          }
        }), this.autoMinSize || this.autoSize) {
          const i = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
          o.middleware.push({
            name: "autoSize",
            fn: ({ rects: a, placement: c, middlewareData: u }) => {
              var f;
              if ((f = u.autoSize) != null && f.skip)
                return {};
              let p, v;
              return c.startsWith("top") || c.startsWith("bottom") ? p = a.reference.width : v = a.reference.height, this.$_innerNode.style[i === "min" ? "minWidth" : i === "max" ? "maxWidth" : "width"] = p != null ? `${p}px` : null, this.$_innerNode.style[i === "min" ? "minHeight" : i === "max" ? "maxHeight" : "height"] = v != null ? `${v}px` : null, {
                data: {
                  skip: !0
                },
                reset: {
                  rects: !0
                }
              };
            }
          });
        }
        (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, o.middleware.push(F9({
          boundary: this.boundary,
          padding: this.overflowPadding,
          apply: ({ availableWidth: i, availableHeight: a }) => {
            this.$_innerNode.style.maxWidth = i != null ? `${i}px` : null, this.$_innerNode.style.maxHeight = a != null ? `${a}px` : null;
          }
        })));
        const r = yield R9(this.$_referenceNode, this.$_popperNode, o);
        Object.assign(this.result, {
          x: r.x,
          y: r.y,
          placement: r.placement,
          strategy: r.strategy,
          arrow: j(j({}, r.middlewareData.arrow), r.middlewareData.arrowOverflow)
        });
      });
    },
    $_scheduleShow(o, n = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), Et && this.instantMove && Et.instantMove && Et !== this.parentPopper) {
        Et.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      n ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(o, n = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (Et = this), n ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(o) {
      const n = this.delay;
      return parseInt(n && n[o] || n || 0);
    },
    $_applyShow(o = !1) {
      return Q(this, null, function* () {
        clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = o, !this.isShown && (this.$_ensureTeleport(), yield rr(), yield this.$_computePosition(), yield this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
          ...kn(this.$_referenceNode),
          ...kn(this.$_popperNode)
        ], "scroll", () => {
          this.$_computePosition();
        }));
      });
    },
    $_applyShowEffect() {
      return Q(this, null, function* () {
        if (this.$_hideInProgress)
          return;
        if (this.computeTransformOrigin) {
          const n = this.$_referenceNode.getBoundingClientRect(), r = this.$_popperNode.querySelector(".v-popper__wrapper"), s = r.parentNode.getBoundingClientRect(), i = n.x + n.width / 2 - (s.left + r.offsetLeft), a = n.y + n.height / 2 - (s.top + r.offsetTop);
          this.result.transformOrigin = `${i}px ${a}px`;
        }
        this.isShown = !0, this.$_applyAttrsToTarget({
          "aria-describedby": this.popperId,
          "data-popper-shown": ""
        });
        const o = this.showGroup;
        if (o) {
          let n;
          for (let r = 0; r < Ue.length; r++)
            n = Ue[r], n.showGroup !== o && (n.hide(), n.$emit("close-group"));
        }
        Ue.push(this), document.body.classList.add("v-popper--some-open");
        for (const n of Ss(this.theme))
          Bs(n).push(this), document.body.classList.add(`v-popper--some-open--${n}`);
        this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, yield rr(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
      });
    },
    $_applyHide(o = !1) {
      return Q(this, null, function* () {
        if (this.shownChildren.size > 0) {
          this.pendingHide = !0, this.$_hideInProgress = !1;
          return;
        }
        if (clearTimeout(this.$_scheduleTimer), !this.isShown)
          return;
        this.skipTransition = o, Ts(Ue, this), Ue.length === 0 && document.body.classList.remove("v-popper--some-open");
        for (const r of Ss(this.theme)) {
          const s = Bs(r);
          Ts(s, this), s.length === 0 && document.body.classList.remove(`v-popper--some-open--${r}`);
        }
        Et === this && (Et = null), this.isShown = !1, this.$_applyAttrsToTarget({
          "aria-describedby": void 0,
          "data-popper-shown": void 0
        }), clearTimeout(this.$_disposeTimer);
        const n = this.disposeTimeout;
        n !== null && (this.$_disposeTimer = setTimeout(() => {
          this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
        }, n)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, yield rr(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
      });
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.isDisposed)
        return;
      let o = this.container;
      if (typeof o == "string" ? o = window.document.querySelector(o) : o === !1 && (o = this.$_targetNodes[0].parentNode), !o)
        throw new Error("No container for popover: " + this.container);
      o.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const o = (r) => {
        this.isShown && !this.$_hideInProgress || (r.usedByTooltip = !0, !this.$_preventShow && this.show({ event: r }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, js, this.triggers, this.showTriggers, o), this.$_registerTriggerListeners([this.$_popperNode], js, this.popperTriggers, this.popperShowTriggers, o);
      const n = (r) => {
        r.usedByTooltip || this.hide({ event: r });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, Os, this.triggers, this.hideTriggers, n), this.$_registerTriggerListeners([this.$_popperNode], Os, this.popperTriggers, this.popperHideTriggers, n);
    },
    $_registerEventListeners(o, n, r) {
      this.$_events.push({ targetNodes: o, eventType: n, handler: r }), o.forEach((s) => s.addEventListener(n, r, Io ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(o, n, r, s, i) {
      let a = r;
      s != null && (a = typeof s == "function" ? s(a) : s), a.forEach((c) => {
        const u = n[c];
        u && this.$_registerEventListeners(o, u, i);
      });
    },
    $_removeEventListeners(o) {
      const n = [];
      this.$_events.forEach((r) => {
        const { targetNodes: s, eventType: i, handler: a } = r;
        !o || o === i ? s.forEach((c) => c.removeEventListener(i, a)) : n.push(r);
      }), this.$_events = n;
    },
    $_refreshListeners() {
      this.isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(o, n = !1) {
      this.$_showFrameLocked || (this.hide({ event: o }), o.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), n && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(o, n) {
      for (const r of this.$_targetNodes) {
        const s = r.getAttribute(o);
        s && (r.removeAttribute(o), r.setAttribute(n, s));
      }
    },
    $_applyAttrsToTarget(o) {
      for (const n of this.$_targetNodes)
        for (const r in o) {
          const s = o[r];
          s == null ? n.removeAttribute(r) : n.setAttribute(r, s);
        }
    },
    $_updateParentShownChildren(o) {
      let n = this.parentPopper;
      for (; n; )
        o ? n.shownChildren.add(this.randomId) : (n.shownChildren.delete(this.randomId), n.pendingHide && n.hide()), n = n.parentPopper;
    },
    $_isAimingPopper() {
      const o = this.$_referenceNode.getBoundingClientRect();
      if (jo >= o.left && jo <= o.right && Oo >= o.top && Oo <= o.bottom) {
        const n = this.$_popperNode.getBoundingClientRect(), r = jo - mt, s = Oo - vt, i = n.left + n.width / 2 - mt + (n.top + n.height / 2) - vt + n.width + n.height, a = mt + r * i, c = vt + s * i;
        return sn(mt, vt, a, c, n.left, n.top, n.left, n.bottom) || // Left edge
        sn(mt, vt, a, c, n.left, n.top, n.right, n.top) || // Top edge
        sn(mt, vt, a, c, n.right, n.top, n.right, n.bottom) || // Right edge
        sn(mt, vt, a, c, n.left, n.bottom, n.right, n.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
if (typeof document < "u" && typeof window < "u") {
  if (Ud) {
    const t = Io ? {
      passive: !0,
      capture: !0
    } : !0;
    document.addEventListener("touchstart", (e) => Es(e), t), document.addEventListener("touchend", (e) => Ps(e, !0), t);
  } else
    window.addEventListener("mousedown", (t) => Es(t), !0), window.addEventListener("click", (t) => Ps(t, !1), !0);
  window.addEventListener("resize", Z9);
}
function Es(t, e) {
  for (let o = 0; o < Ue.length; o++) {
    const n = Ue[o];
    try {
      n.mouseDownContains = n.popperNode().contains(t.target);
    } catch (r) {
    }
  }
}
function Ps(t, e) {
  W9(t, e);
}
function W9(t, e) {
  const o = {};
  for (let n = Ue.length - 1; n >= 0; n--) {
    const r = Ue[n];
    try {
      const s = r.containsGlobalTarget = r.mouseDownContains || r.popperNode().contains(t.target);
      r.pendingHide = !1, requestAnimationFrame(() => {
        if (r.pendingHide = !1, !o[r.randomId] && As(r, s, t)) {
          if (r.$_handleGlobalClose(t, e), !t.closeAllPopover && t.closePopover && s) {
            let a = r.parentPopper;
            for (; a; )
              o[a.randomId] = !0, a = a.parentPopper;
            return;
          }
          let i = r.parentPopper;
          for (; i && As(i, i.containsGlobalTarget, t); )
            i.$_handleGlobalClose(t, e), i = i.parentPopper;
        }
      });
    } catch (s) {
    }
  }
}
function As(t, e, o) {
  return o.closeAllPopover || o.closePopover && e || U9(t, o) && !e;
}
function U9(t, e) {
  if (typeof t.autoHide == "function") {
    const o = t.autoHide(e);
    return t.lastAutoHide = o, o;
  }
  return t.autoHide;
}
function Z9() {
  for (let t = 0; t < Ue.length; t++)
    Ue[t].$_computePosition();
}
let mt = 0, vt = 0, jo = 0, Oo = 0;
typeof window < "u" && window.addEventListener("mousemove", (t) => {
  mt = jo, vt = Oo, jo = t.clientX, Oo = t.clientY;
}, Io ? {
  passive: !0
} : void 0);
function sn(t, e, o, n, r, s, i, a) {
  const c = ((i - r) * (e - s) - (a - s) * (t - r)) / ((a - s) * (o - t) - (i - r) * (n - e)), u = ((o - t) * (e - s) - (n - e) * (t - r)) / ((a - s) * (o - t) - (i - r) * (n - e));
  return c >= 0 && c <= 1 && u >= 0 && u <= 1;
}
const G9 = {
  extends: Gd()
}, Hn = (t, e) => {
  const o = t.__vccOpts || t;
  for (const [n, r] of e)
    o[n] = r;
  return o;
};
function Y9(t, e, o, n, r, s) {
  return d(), h("div", {
    ref: "reference",
    class: S(["v-popper", {
      "v-popper--shown": t.slotData.isShown
    }])
  }, [
    C(t.$slots, "default", V2(F2(t.slotData)))
  ], 2);
}
const X9 = /* @__PURE__ */ Hn(G9, [["render", Y9]]);
function K9() {
  var t = window.navigator.userAgent, e = t.indexOf("MSIE ");
  if (e > 0)
    return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
  var o = t.indexOf("Trident/");
  if (o > 0) {
    var n = t.indexOf("rv:");
    return parseInt(t.substring(n + 3, t.indexOf(".", n)), 10);
  }
  var r = t.indexOf("Edge/");
  return r > 0 ? parseInt(t.substring(r + 5, t.indexOf(".", r)), 10) : -1;
}
let fn;
function jr() {
  jr.init || (jr.init = !0, fn = K9() !== -1);
}
var Vn = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    jr(), En(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const t = document.createElement("object");
    this._resizeObject = t, t.setAttribute("aria-hidden", "true"), t.setAttribute("tabindex", -1), t.onload = this.addResizeHandlers, t.type = "text/html", fn && this.$el.appendChild(t), t.data = "about:blank", fn || this.$el.appendChild(t);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!fn && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const J9 = /* @__PURE__ */ I2("data-v-b329ee4c");
L2("data-v-b329ee4c");
const Q9 = {
  class: "resize-observer",
  tabindex: "-1"
};
H2();
const eb = /* @__PURE__ */ J9((t, e, o, n, r, s) => (d(), P("div", Q9)));
Vn.render = eb;
Vn.__scopeId = "data-v-b329ee4c";
Vn.__file = "src/components/ResizeObserver.vue";
const Yd = (t = "theme") => ({
  computed: {
    themeClass() {
      return q9(this[t]);
    }
  }
}), tb = A({
  name: "VPopperContent",
  components: {
    ResizeObserver: Vn
  },
  mixins: [
    Yd()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(t) {
      return t != null && !isNaN(t) ? `${t}px` : null;
    }
  }
}), ob = ["id", "aria-hidden", "tabindex", "data-popper-placement"], nb = {
  ref: "inner",
  class: "v-popper__inner"
}, rb = /* @__PURE__ */ l("div", { class: "v-popper__arrow-outer" }, null, -1), sb = /* @__PURE__ */ l("div", { class: "v-popper__arrow-inner" }, null, -1), ib = [
  rb,
  sb
];
function ab(t, e, o, n, r, s) {
  const i = be("ResizeObserver");
  return d(), h("div", {
    id: t.popperId,
    ref: "popover",
    class: S(["v-popper__popper", [
      t.themeClass,
      t.classes.popperClass,
      {
        "v-popper__popper--shown": t.shown,
        "v-popper__popper--hidden": !t.shown,
        "v-popper__popper--show-from": t.classes.showFrom,
        "v-popper__popper--show-to": t.classes.showTo,
        "v-popper__popper--hide-from": t.classes.hideFrom,
        "v-popper__popper--hide-to": t.classes.hideTo,
        "v-popper__popper--skip-transition": t.skipTransition,
        "v-popper__popper--arrow-overflow": t.result && t.result.arrow.overflow,
        "v-popper__popper--no-positioning": !t.result
      }
    ]]),
    style: re(t.result ? {
      position: t.result.strategy,
      transform: `translate3d(${Math.round(t.result.x)}px,${Math.round(t.result.y)}px,0)`
    } : void 0),
    "aria-hidden": t.shown ? "false" : "true",
    tabindex: t.autoHide ? 0 : void 0,
    "data-popper-placement": t.result ? t.result.placement : void 0,
    onKeyup: e[2] || (e[2] = q((a) => t.autoHide && t.$emit("hide"), ["esc"]))
  }, [
    l("div", {
      class: "v-popper__backdrop",
      onClick: e[0] || (e[0] = (a) => t.autoHide && t.$emit("hide"))
    }),
    l("div", {
      class: "v-popper__wrapper",
      style: re(t.result ? {
        transformOrigin: t.result.transformOrigin
      } : void 0)
    }, [
      l("div", nb, [
        t.mounted ? (d(), h(oe, { key: 0 }, [
          l("div", null, [
            C(t.$slots, "default")
          ]),
          t.handleResize ? (d(), P(i, {
            key: 0,
            onNotify: e[1] || (e[1] = (a) => t.$emit("resize", a))
          })) : E("", !0)
        ], 64)) : E("", !0)
      ], 512),
      l("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: re(t.result ? {
          left: t.toPx(t.result.arrow.x),
          top: t.toPx(t.result.arrow.y)
        } : void 0)
      }, ib, 4)
    ], 4)
  ], 46, ob);
}
const Xd = /* @__PURE__ */ Hn(tb, [["render", ab]]), Kd = {
  methods: {
    show(...t) {
      return this.$refs.popper.show(...t);
    },
    hide(...t) {
      return this.$refs.popper.hide(...t);
    },
    dispose(...t) {
      return this.$refs.popper.dispose(...t);
    },
    onResize(...t) {
      return this.$refs.popper.onResize(...t);
    }
  }
};
let Or = function() {
};
typeof window < "u" && (Or = window.Element);
const lb = A({
  name: "VPopperWrapper",
  components: {
    Popper: X9,
    PopperContent: Xd
  },
  mixins: [
    Kd,
    Yd("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    },
    referenceNode: {
      type: Function,
      default: null
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    positioningDisabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    delay: {
      type: [String, Number, Object],
      default: void 0
    },
    distance: {
      type: [Number, String],
      default: void 0
    },
    skidding: {
      type: [Number, String],
      default: void 0
    },
    triggers: {
      type: Array,
      default: void 0
    },
    showTriggers: {
      type: [Array, Function],
      default: void 0
    },
    hideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperTriggers: {
      type: Array,
      default: void 0
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    container: {
      type: [String, Object, Or, Boolean],
      default: void 0
    },
    boundary: {
      type: [String, Or],
      default: void 0
    },
    strategy: {
      type: String,
      default: void 0
    },
    autoHide: {
      type: [Boolean, Function],
      default: void 0
    },
    handleResize: {
      type: Boolean,
      default: void 0
    },
    instantMove: {
      type: Boolean,
      default: void 0
    },
    eagerMount: {
      type: Boolean,
      default: void 0
    },
    popperClass: {
      type: [String, Array, Object],
      default: void 0
    },
    computeTransformOrigin: {
      type: Boolean,
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: void 0
    },
    autoSize: {
      type: [Boolean, String],
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: void 0
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: void 0
    },
    preventOverflow: {
      type: Boolean,
      default: void 0
    },
    overflowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowOverflow: {
      type: Boolean,
      default: void 0
    },
    flip: {
      type: Boolean,
      default: void 0
    },
    shift: {
      type: Boolean,
      default: void 0
    },
    shiftCrossAxis: {
      type: Boolean,
      default: void 0
    },
    noAutoFocus: {
      type: Boolean,
      default: void 0
    },
    disposeTimeout: {
      type: Number,
      default: void 0
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (t) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  computed: {
    finalTheme() {
      var t;
      return (t = this.theme) != null ? t : this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((t) => t !== this.$refs.popperContent.$el);
    }
  }
});
function db(t, e, o, n, r, s) {
  const i = be("PopperContent"), a = be("Popper");
  return d(), P(a, Oe({ ref: "popper" }, t.$props, {
    theme: t.finalTheme,
    "target-nodes": t.getTargetNodes,
    "popper-node": () => t.$refs.popperContent.$el,
    class: [
      t.themeClass
    ],
    onShow: e[0] || (e[0] = () => t.$emit("show")),
    onHide: e[1] || (e[1] = () => t.$emit("hide")),
    "onUpdate:shown": e[2] || (e[2] = (c) => t.$emit("update:shown", c)),
    onApplyShow: e[3] || (e[3] = () => t.$emit("apply-show")),
    onApplyHide: e[4] || (e[4] = () => t.$emit("apply-hide")),
    onCloseGroup: e[5] || (e[5] = () => t.$emit("close-group")),
    onCloseDirective: e[6] || (e[6] = () => t.$emit("close-directive")),
    onAutoHide: e[7] || (e[7] = () => t.$emit("auto-hide")),
    onResize: e[8] || (e[8] = () => t.$emit("resize"))
  }), {
    default: O(({
      popperId: c,
      isShown: u,
      shouldMountContent: f,
      skipTransition: p,
      autoHide: v,
      show: m,
      hide: g,
      handleResize: w,
      onResize: y,
      classes: M,
      result: B
    }) => [
      C(t.$slots, "default", {
        shown: u,
        show: m,
        hide: g
      }),
      $(i, {
        ref: "popperContent",
        "popper-id": c,
        theme: t.finalTheme,
        shown: u,
        mounted: f,
        "skip-transition": p,
        "auto-hide": v,
        "handle-resize": w,
        classes: M,
        result: B,
        onHide: g,
        onResize: y
      }, {
        default: O(() => [
          C(t.$slots, "popper", {
            shown: u,
            hide: g
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 16, ["theme", "target-nodes", "popper-node", "class"]);
}
const Xr = /* @__PURE__ */ Hn(lb, [["render", db]]);
R(j({}, Xr), {
  name: "VDropdown",
  vPopperTheme: "dropdown"
});
R(j({}, Xr), {
  name: "VMenu",
  vPopperTheme: "menu"
});
const ub = R(j({}, Xr), {
  name: "VTooltip",
  vPopperTheme: "tooltip"
}), cb = A({
  name: "VTooltipDirective",
  components: {
    Popper: Gd(),
    PopperContent: Xd
  },
  mixins: [
    Kd
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (t) => Fo(t.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (t) => Fo(t.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    finalContent() {
      return Q(this, null, function* () {
        yield this.$nextTick(), this.$refs.popper.onResize();
      });
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(t) {
      if (typeof this.content == "function" && this.$_isShown && (t || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const e = ++this.$_fetchId, o = this.content(this);
        o.then ? o.then((n) => this.onResult(e, n)) : this.onResult(e, o);
      }
    },
    onResult(t, e) {
      t === this.$_fetchId && (this.$_loading = !1, this.asyncContent = e);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
}), hb = ["innerHTML"], fb = ["textContent"];
function pb(t, e, o, n, r, s) {
  const i = be("PopperContent"), a = be("Popper");
  return d(), P(a, Oe({ ref: "popper" }, t.$attrs, {
    theme: t.theme,
    "target-nodes": t.targetNodes,
    "popper-node": () => t.$refs.popperContent.$el,
    onApplyShow: t.onShow,
    onApplyHide: t.onHide
  }), {
    default: O(({
      popperId: c,
      isShown: u,
      shouldMountContent: f,
      skipTransition: p,
      autoHide: v,
      hide: m,
      handleResize: g,
      onResize: w,
      classes: y,
      result: M
    }) => [
      $(i, {
        ref: "popperContent",
        class: S({
          "v-popper--tooltip-loading": t.loading
        }),
        "popper-id": c,
        theme: t.theme,
        shown: u,
        mounted: f,
        "skip-transition": p,
        "auto-hide": v,
        "handle-resize": g,
        classes: y,
        result: M,
        onHide: m,
        onResize: w
      }, {
        default: O(() => [
          t.html ? (d(), h("div", {
            key: 0,
            innerHTML: t.finalContent
          }, null, 8, hb)) : (d(), h("div", {
            key: 1,
            textContent: F(t.finalContent)
          }, null, 8, fb))
        ]),
        _: 2
      }, 1032, ["class", "popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 1
  }, 16, ["theme", "target-nodes", "popper-node", "onApplyShow", "onApplyHide"]);
}
const mb = /* @__PURE__ */ Hn(cb, [["render", pb]]), Jd = "v-popper--has-tooltip";
function vb(t, e) {
  let o = t.placement;
  if (!o && e)
    for (const n of Zd)
      e[n] && (o = n);
  return o || (o = Fo(t.theme || "tooltip", "placement")), o;
}
function Qd(t, e, o) {
  let n;
  const r = typeof e;
  return r === "string" ? n = { content: e } : e && r === "object" ? n = e : n = { content: !1 }, n.placement = vb(n, o), n.targetNodes = () => [t], n.referenceNode = () => t, n;
}
let ir, Do, gb = 0;
function _b() {
  if (ir)
    return;
  Do = I([]), ir = D2({
    name: "VTooltipDirectiveApp",
    setup() {
      return {
        directives: Do
      };
    },
    render() {
      return this.directives.map((e) => N2(mb, R(j({}, e.options), {
        shown: e.shown || e.options.shown,
        key: e.id
      })));
    },
    devtools: {
      hide: !0
    }
  });
  const t = document.createElement("div");
  document.body.appendChild(t), ir.mount(t);
}
function wb(t, e, o) {
  _b();
  const n = I(Qd(t, e, o)), r = I(!1), s = {
    id: gb++,
    options: n,
    shown: r
  };
  return Do.value.push(s), t.classList && t.classList.add(Jd), t.$_popper = {
    options: n,
    item: s,
    show() {
      r.value = !0;
    },
    hide() {
      r.value = !1;
    }
  };
}
function eu(t) {
  if (t.$_popper) {
    const e = Do.value.indexOf(t.$_popper.item);
    e !== -1 && Do.value.splice(e, 1), delete t.$_popper, delete t.$_popperOldShown, delete t.$_popperMountTarget;
  }
  t.classList && t.classList.remove(Jd);
}
function Ls(t, { value: e, modifiers: o }) {
  const n = Qd(t, e, o);
  if (!n.content || Fo(n.theme || "tooltip", "disabled"))
    eu(t);
  else {
    let r;
    t.$_popper ? (r = t.$_popper, r.options.value = n) : r = wb(t, e, o), typeof e.shown < "u" && e.shown !== t.$_popperOldShown && (t.$_popperOldShown = e.shown, e.shown ? r.show() : r.hide());
  }
}
const bb = {
  beforeMount: Ls,
  updated: Ls,
  beforeUnmount(t) {
    eu(t);
  }
}, tu = St, kb = bb, yb = ub;
tu.themes.tooltip.delay = {
  show: 300,
  hide: 100
};
tu.themes.tooltip.arrowPadding = 8;
const yn = kb;
var jt = /* @__PURE__ */ ((t) => (t.Primary = "primary", t.Secondary = "secondary", t.Tertiary = "tertiary", t.Branding = "branding", t.Danger = "danger", t))(jt || {});
const xb = { class: "loader-circular" }, Cb = ["width", "height"], Mb = ["id"], $b = ["clip-path"], Sb = /* @__PURE__ */ A({
  __name: "FriedSpinner",
  props: {
    size: { default: 40 },
    currentColor: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, o = xe(), n = I("spinner-clip-" + o), r = z(() => `${e.size}px`), s = z(() => `${e.size}px`);
    return (i, a) => (d(), h("div", xb, [
      (d(), h("svg", {
        class: S(["loader-circular-content", { "current-color": i.currentColor }]),
        width: r.value,
        height: s.value,
        viewBox: "0 0 48 48",
        "data-external": "loader-circular"
      }, [
        l("clipPath", { id: n.value }, a[0] || (a[0] = [
          l("path", { d: "M 24 0 a 24 24 0 0 1 0 48 24 24 0 0 1 0 -48 v 4 0 a 20 20 0 0 0 0 40 20 20 0 0 0 0 -40" }, null, -1)
        ]), 8, Mb),
        a[2] || (a[2] = l("circle", {
          cx: "24",
          cy: "2",
          r: "2",
          class: "dot"
        }, null, -1)),
        (d(), h("foreignObject", {
          class: "loader-circle",
          x: "0",
          y: "0",
          width: "100%",
          height: "100%",
          "clip-path": `url(#${n.value})`
        }, a[1] || (a[1] = [
          l("div", {
            class: "gradient",
            xmlns: "http://www.w3.org/1999/xhtml"
          }, null, -1)
        ]), 8, $b))
      ], 10, Cb))
    ]));
  }
}), Kr = /* @__PURE__ */ T(Sb, [["__scopeId", "data-v-1595d32e"]]), jb = {
  key: 1,
  class: "checkmark-container"
}, Ob = /* @__PURE__ */ A({
  __name: "FriedButton",
  props: {
    buttonType: { default: jt.Primary },
    color: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loaded: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    showLoaderText: { type: Boolean, default: !1 },
    compact: { type: Boolean, default: !1 },
    to: { default: void 0 }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const o = t, n = e, { buttonType: r, disabled: s, loaded: i, loading: a, active: c, showLoaderText: u, compact: f } = Ke(o), p = z(() => o.disabled || o.loading || o.loaded), v = z(() => `ga-${r.value}`), m = z(
      () => o.color ? eo.button(o.buttonType, o.color) : ""
    ), g = z(() => o.loaded || o.loading), w = (M) => {
      o.disabled || n("click", M);
    }, y = z(() => o.to ? "router-link" : "button");
    return (M, B) => se((d(), P(ro(y.value), {
      to: M.to,
      class: S(["button", [
        v.value,
        { loading: _(a), loaded: _(i), disabled: _(s), active: _(c), "loader-text": _(u), compact: _(f), color: M.color },
        m.value
      ]]),
      disabled: p.value,
      onClick: w
    }, {
      default: O(() => [
        l("span", {
          class: S(["button-text", {
            "hide-text": g.value
          }])
        }, [
          M.$slots.leftIcon ? (d(), h("span", {
            key: 0,
            class: S(["button-icon left", { compact: _(f) }])
          }, [
            C(M.$slots, "leftIcon", {}, void 0, !0)
          ], 2)) : E("", !0),
          C(M.$slots, "default", {}, void 0, !0),
          M.$slots.rightIcon ? (d(), h("span", {
            key: 1,
            class: S(["button-icon right", { compact: _(f) }])
          }, [
            C(M.$slots, "rightIcon", {}, void 0, !0)
          ], 2)) : E("", !0)
        ], 2),
        _(a) && !_(i) ? (d(), P(_(Kr), {
          key: 0,
          class: "button-loader",
          size: 20,
          "aria-busy": _(a),
          "current-color": !0,
          "aria-label": "loading"
        }, null, 8, ["aria-busy"])) : E("", !0),
        _(i) ? (d(), h("div", jb, B[0] || (B[0] = [
          l("div", {
            class: "checkmark",
            role: "status",
            "aria-label": "done"
          }, null, -1)
        ]))) : E("", !0)
      ]),
      _: 3
    }, 8, ["to", "class", "disabled"])), [
      [_(ut)]
    ]);
  }
}), pn = /* @__PURE__ */ T(Ob, [["__scopeId", "data-v-991bc384"]]);
var ou = /* @__PURE__ */ ((t) => (t.Rose = "rose", t.Pink = "pink", t.Purple = "purple", t.Lilac = "lilac", t.Ocean = "ocean", t.Emerald = "emerald", t.Forest = "forest", t.Olive = "olive", t.Wood = "wood", t.Leather = "leather", t.Jade = "jade", t))(ou || {});
const we = class we {
};
/**
  All available colors in an array
*/
st(we, "colors", Object.values(ou)), /**
 * @description Returns classes for a button based on the type and color
 * Use for FriedButton
 */
st(we, "button", (e, o) => e === jt.Secondary ? [`color-border-${o}`, `light-hover-bg-${o}`, `color-text-${o}`] : [`light-bg-${o}`, `color-text-${o}`]), /**
 * @description Returns classes for an element based on the index passed
 * Use for all elements that shuld have a colored background with adjecent text color
 */
st(we, "getStyle", (e) => {
  const o = we.getIndex(e), n = we.colors[o];
  return [`light-bg-${n}`, `color-text-${n}`];
}), /**
 * @description Returns text color class based on the color passed
 * Use for text elements
 */
st(we, "text", (e) => `color-text-${e}`), /**
 * @description Returns background color class based on the color passed
 * Use for all elements where the color is known, and the potential text should not be in a corresponding color
 */
st(we, "background", (e) => `light-static-bg-${e}`), /**
 * @description Returns background color class based on the index passed
 * Use when color is not known but calculated based on an index
 */
st(we, "getLightBackground", (e) => {
  const o = we.getIndex(e);
  return `light-static-bg-${we.colors[o]}`;
}), /**
 * @description Returns a color based on the index passed
 * Use when color is not known but calculated based on an index
 */
st(we, "getColor", (e) => {
  const o = we.getIndex(e);
  return we.colors[o];
}), /**
 * @description Returns an available index based on the number passed or a random index, based on the length of the colors array
 */
st(we, "getIndex", (e) => e ? e % we.colors.length : Math.floor(Math.random() * we.colors.length));
let eo = we;
const Tb = ["src", "alt"], zb = {
  key: 1,
  class: "avatar-initials"
}, Bb = /* @__PURE__ */ A({
  __name: "FriedAvatar",
  props: {
    name: { default: "" },
    size: { default: so.Medium },
    thumbUrl: { default: "" },
    keepFullName: { type: Boolean }
  },
  setup(t) {
    const e = t, o = I(!1), n = I(!1), r = z(() => e.name ? e.keepFullName ? e.name : e.name.trim().split(" ").map((p) => p[0] || "").join("").toUpperCase().substring(0, 3) : ""), s = z(() => {
      const u = (e.name || "").split("").map((f) => f.charCodeAt(0)).join("");
      return parseInt(u, 10);
    }), i = z(() => e.name ? eo.getLightBackground(s.value) : "default-bg"), a = () => o.value = !0, c = () => n.value = !0;
    return (u, f) => (d(), h("div", {
      class: S(["avatar", [u.size, i.value, { loading: u.thumbUrl && !n.value }]])
    }, [
      u.thumbUrl && !o.value ? (d(), h("img", {
        key: 0,
        class: S(["avatar-image", { loaded: n.value }]),
        src: u.thumbUrl,
        alt: u.name,
        onLoad: c,
        onError: a
      }, null, 42, Tb)) : r.value ? (d(), h("span", zb, F(r.value), 1)) : C(u.$slots, "default", { key: 2 }, () => [
        $(_(c9), { class: "avatar-fallback" })
      ], !0)
    ], 2));
  }
}), To = /* @__PURE__ */ T(Bb, [["__scopeId", "data-v-c2431217"]]), Eb = { class: "avatar-counter-container" }, Pb = ["role", "tabindex"], Ab = /* @__PURE__ */ A({
  __name: "FriedAvatarCounter",
  props: {
    name: { default: "" },
    thumbUrl: { default: "" },
    size: { default: so.Medium },
    count: { default: 0 },
    counterClickable: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = () => {
      o.counterClickable && n("click");
    };
    return (s, i) => (d(), h("div", Eb, [
      $(To, {
        name: s.name,
        "thumb-url": s.thumbUrl,
        size: s.size
      }, null, 8, ["name", "thumb-url", "size"]),
      l("div", {
        class: S(["counter", { clickable: s.counterClickable }]),
        role: s.counterClickable ? "button" : "",
        tabindex: s.counterClickable ? 0 : -1,
        onClick: r,
        onKeydown: [
          q(r, ["enter"]),
          q(r, ["space"])
        ]
      }, F(s.count), 43, Pb)
    ]));
  }
}), Lb = /* @__PURE__ */ T(Ab, [["__scopeId", "data-v-f6a27a9a"]]), Hb = /* @__PURE__ */ A({
  __name: "FriedAvatarGroup",
  props: {
    avatars: {},
    visibleAvatars: { default: 2 },
    margin: { default: 8 },
    size: { default: so.Medium },
    clickable: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = (c) => {
      o.clickable && n("click", c);
    }, s = z(() => o.avatars.length < o.visibleAvatars + 1 ? o.avatars.length : o.visibleAvatars), i = z(() => o.clickable ? "button" : "div"), a = z(() => `margin-left: -${o.margin}px`);
    return (c, u) => (d(), P(ro(i.value), {
      class: S(["avatar-counter-container", { clickable: c.clickable }]),
      onClick: r
    }, {
      default: O(() => [
        c.avatars.length > 1 ? (d(), h(oe, { key: 0 }, [
          (d(!0), h(oe, null, ce(s.value, (f, p) => (d(), P(To, {
            key: p,
            class: "avatar",
            style: re(p > 0 ? a.value : ""),
            name: c.avatars[p].name || "",
            "thumb-url": c.avatars[p].thumbUrl,
            size: c.size
          }, null, 8, ["style", "name", "thumb-url", "size"]))), 128)),
          c.avatars.length > s.value ? (d(), P(To, {
            key: 0,
            class: "counter",
            style: re(a.value),
            "keep-full-name": "",
            name: `+${c.avatars.length - s.value}`,
            size: c.size
          }, null, 8, ["style", "name", "size"])) : E("", !0)
        ], 64)) : (d(), P(To, {
          key: 1,
          class: "avatar",
          name: c.avatars[0].name || "",
          "thumb-url": c.avatars[0].thumbUrl,
          size: c.size
        }, null, 8, ["name", "thumb-url", "size"]))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Vb = /* @__PURE__ */ T(Hb, [["__scopeId", "data-v-d52b6b91"]]), Fb = {};
function Ib(t, e) {
  return d(), P(Ro, Oe(t.$attrs, { name: "fade-in-out" }), {
    default: O(() => [
      C(t.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 16);
}
const nu = /* @__PURE__ */ T(Fb, [["render", Ib], ["__scopeId", "data-v-41bd8a99"]]), Db = /* @__PURE__ */ A({
  __name: "FriedBackdrop",
  props: {
    show: { type: Boolean, default: !0 },
    blur: { type: Boolean },
    opacity: { default: 0.2 }
  },
  emits: ["close"],
  setup(t) {
    return (e, o) => (d(), P(nu, { appear: "" }, {
      default: O(() => [
        e.show ? (d(), h("div", {
          key: 0,
          class: S(["backdrop-container", { blur: e.blur }]),
          onClick: o[0] || (o[0] = _e((n) => e.$emit("close"), ["prevent", "stop"])),
          onKeyup: o[1] || (o[1] = q((n) => e.$emit("close"), ["esc"]))
        }, [
          l("div", {
            class: "backdrop",
            style: re({ opacity: e.opacity })
          }, null, 4)
        ], 34)) : E("", !0)
      ]),
      _: 1
    }));
  }
}), Jr = /* @__PURE__ */ T(Db, [["__scopeId", "data-v-daa9c29b"]]), Nb = /* @__PURE__ */ A({
  __name: "FriedBreadcrumb",
  props: {
    collapseAt: { default: 5 }
  },
  setup(t) {
    const e = t, o = I(), n = I(), r = () => {
      var c;
      const a = (c = n.value) == null ? void 0 : c.querySelectorAll(".breadcrumb-item");
      a != null && a.length && (a.forEach((u) => {
        u.removeAttribute("first"), u.removeAttribute("aria-current");
      }), a.length && (a[0].setAttribute("first", ""), a[a.length - 1].setAttribute("aria-current", "")), a.length > e.collapseAt ? s() : i());
    }, s = () => {
      var u;
      const a = (u = n.value) == null ? void 0 : u.querySelectorAll(".breadcrumb-item");
      if (!(a != null && a.length)) return;
      const c = [...a].slice(1, a.length - 2);
      c[0].setAttribute("second", ""), c.forEach((f) => {
        f.setAttribute("middle", "");
      });
    }, i = () => {
      var c;
      const a = (c = n.value) == null ? void 0 : c.querySelectorAll(".breadcrumb-item");
      a != null && a.length && a.forEach((u) => {
        u.removeAttribute("second"), u.removeAttribute("middle");
      });
    };
    return R2(() => {
      r();
    }), ht(() => Q(this, null, function* () {
      yield En(), r();
    })), (a, c) => (d(), h("div", {
      ref_key: "breadcrumb",
      ref: n,
      class: "breadcrumbs",
      "aria-label": "Breadcrumb",
      role: "navigation"
    }, [
      l("div", {
        ref_key: "breadcrumbInner",
        ref: o,
        class: "breadcrumb-inner"
      }, [
        C(a.$slots, "default", {}, void 0, !0)
      ], 512)
    ], 512));
  }
}), Rb = /* @__PURE__ */ T(Nb, [["__scopeId", "data-v-ddcc16ba"]]), qb = ["disabled", "data-external"], Wb = { class: "ellipsis-content" }, Ub = /* @__PURE__ */ A({
  __name: "FriedBreadcrumbItem",
  props: {
    hideIcon: { type: Boolean, default: !1 },
    clickable: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    dataExternal: { default: void 0 }
  },
  setup(t) {
    return (e, o) => (d(), h("button", {
      disabled: !e.clickable,
      class: S(["breadcrumb-item", { clickable: e.clickable, disabled: e.disabled }]),
      "data-external": e.dataExternal
    }, [
      l("div", {
        class: S(["breadcrumb-content", { disabled: e.disabled }])
      }, [
        e.hideIcon ? E("", !0) : C(e.$slots, "icon-open", { key: 0 }, () => [
          $(_(U), {
            class: "fill-icon",
            size: _(He).Small,
            icon: "folder-open-fill"
          }, null, 8, ["size"])
        ], !0),
        e.hideIcon ? E("", !0) : C(e.$slots, "icon-closed", { key: 1 }, () => [
          $(_(U), {
            class: "non-fill-icon",
            size: _(He).Small,
            icon: "folder-open"
          }, null, 8, ["size"])
        ], !0),
        C(e.$slots, "default", {}, void 0, !0),
        $(_(U), {
          class: "separator",
          size: _(He).Small,
          icon: "chevron-right"
        }, null, 8, ["size"])
      ], 2),
      l("div", Wb, [
        o[0] || (o[0] = K(" ... ")),
        $(_(U), {
          class: "separator",
          size: _(He).Small,
          icon: "chevron-right"
        }, null, 8, ["size"])
      ])
    ], 10, qb));
  }
}), Zb = /* @__PURE__ */ T(Ub, [["__scopeId", "data-v-9a7f86cb"]]), Gb = {}, Yb = { class: "fried-bottom-bar" };
function Xb(t, e) {
  return d(), h("div", Yb, [
    C(t.$slots, "default", {}, void 0, !0)
  ]);
}
const Kb = /* @__PURE__ */ T(Gb, [["render", Xb], ["__scopeId", "data-v-9caf06de"]]), Jb = {}, Qb = { class: "card-container" };
function ek(t, e) {
  return d(), h("div", Qb, [
    C(t.$slots, "default", {}, void 0, !0)
  ]);
}
const tk = /* @__PURE__ */ T(Jb, [["render", ek], ["__scopeId", "data-v-d746f53c"]]);
var qt = /* @__PURE__ */ ((t) => (t.Small = "small", t.Medium = "medium", t))(qt || {});
const ok = ["for"], nk = /* @__PURE__ */ A({
  __name: "FriedLabel",
  props: {
    size: { default: qt.Small },
    for: { default: "" }
  },
  setup(t) {
    const e = t, o = z(() => e.for);
    return (n, r) => (d(), h("label", {
      class: S(["label", n.size]),
      for: o.value
    }, [
      C(n.$slots, "default", {}, void 0, !0)
    ], 10, ok));
  }
}), Fn = /* @__PURE__ */ T(nk, [["__scopeId", "data-v-261a5207"]]), rk = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 14"
};
function sk(t, e) {
  return d(), h("svg", rk, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.666.704c.384.32.446.904.14 1.305L7.271 13.152a.88.88 0 0 1-.63.346.87.87 0 0 1-.672-.25L.28 7.679a.96.96 0 0 1-.04-1.313.86.86 0 0 1 1.257-.042l4.987 4.884L14.417.85a.863.863 0 0 1 1.25-.145",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ik = { render: sk }, ak = ["id", "aria-labelledby", "aria-checked", "data-external", "aria-disabled"], lk = {
  key: 1,
  class: "indeterminate-line"
}, dk = /* @__PURE__ */ A({
  __name: "FriedCheckbox",
  props: {
    modelValue: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    id: { default: "" },
    labelSize: { default: qt.Medium },
    dataExternal: { default: "" },
    labelDataExternal: { default: "" }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = () => {
      o.disabled || n("update:modelValue", !o.modelValue);
    }, s = xe(), i = z(() => o.id || "input-checkbox-" + s), a = z(() => o.id || "input-checkbox-label-" + s), c = z(
      () => o.modelValue ? "true" : o.indeterminate ? "mixed" : "false"
    );
    return (u, f) => (d(), h("div", {
      class: S(["checkbox-container", { "has-label": !!u.label || u.$slots.default, error: u.error }])
    }, [
      l("div", {
        id: i.value,
        "aria-labelledby": a.value,
        tabindex: "0",
        class: S(["ga-checkbox", { checked: u.modelValue, disabled: u.disabled, indeterminate: u.indeterminate }]),
        role: "checkbox",
        "aria-checked": c.value,
        "data-external": u.dataExternal,
        "aria-disabled": !!u.disabled,
        onClick: r,
        onKeydown: [
          q(r, ["enter"]),
          q(r, ["space"])
        ],
        onFocus: f[0] || (f[0] = (p) => u.$emit("focus")),
        onBlur: f[1] || (f[1] = (p) => u.$emit("blur"))
      }, [
        u.modelValue ? (d(), P(_(ik), {
          key: 0,
          class: "svg-icon"
        })) : u.indeterminate ? (d(), h("div", lk)) : E("", !0)
      ], 42, ak),
      l("div", {
        class: S(["label-container", { disabled: u.disabled }]),
        onClick: r,
        onKeyup: q(r, ["enter"])
      }, [
        C(u.$slots, "default", {}, () => [
          u.label ? (d(), P(Fn, {
            key: 0,
            id: a.value,
            for: i.value,
            "data-external": u.labelDataExternal,
            class: S(["checkbox-label", { disabled: u.disabled }]),
            size: u.labelSize
          }, {
            default: O(() => [
              K(F(u.label), 1)
            ]),
            _: 1
          }, 8, ["id", "for", "data-external", "class", "size"])) : E("", !0)
        ], !0)
      ], 34)
    ], 2));
  }
}), Tr = /* @__PURE__ */ T(dk, [["__scopeId", "data-v-fc880c74"]]);
var Ye = /* @__PURE__ */ ((t) => (t.Small = "small", t.Medium = "medium", t.Large = "large", t))(Ye || {});
const uk = /* @__PURE__ */ A({
  __name: "FriedParagraph",
  props: {
    size: { default: Ye.Medium }
  },
  setup(t) {
    return (e, o) => (d(), h("p", {
      class: S(["paragraph", e.size])
    }, [
      C(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), Te = /* @__PURE__ */ T(uk, [["__scopeId", "data-v-15b08eb4"]]), ck = /* @__PURE__ */ A({
  __name: "FriedChip",
  props: {
    label: {},
    color: { default: "" },
    isRemovable: { type: Boolean }
  },
  emits: ["remove"],
  setup(t, { emit: e }) {
    const o = e, n = (r) => {
      o("remove", r);
    };
    return (r, s) => (d(), h("div", {
      class: S(["chip", r.color, { close: r.isRemovable }])
    }, [
      C(r.$slots, "label", {}, () => [
        $(_(Te), {
          class: "text",
          size: _(Ye).Small
        }, {
          default: O(() => [
            K(F(r.label), 1)
          ]),
          _: 1
        }, 8, ["size"])
      ], !0),
      r.isRemovable ? se((d(), h("button", {
        key: 0,
        class: "close-button",
        onClick: n
      }, [
        $(U, {
          icon: "close",
          class: "close-icon"
        })
      ])), [
        [_(ut)]
      ]) : E("", !0)
    ], 2));
  }
}), hk = /* @__PURE__ */ T(ck, [["__scopeId", "data-v-0ee3ab86"]]), fk = "";
function ao(t, e) {
  e === void 0 && (e = {});
  var o = e.insertAt;
  if (!(!t || typeof document == "undefined")) {
    var n = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
    r.type = "text/css", o === "top" && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = t : r.appendChild(document.createTextNode(t));
  }
}
const lo = function(t, e) {
  const { componentPrefix: o = fk } = e || {};
  t.component(`${o}${this.name}`, this);
}, ar = {};
var Wo = {
  name: "Checkboard",
  props: {
    size: {
      type: [Number, String],
      default: 8
    },
    white: {
      type: String,
      default: "#fff"
    },
    grey: {
      type: String,
      default: "#e6e6e6"
    }
  },
  computed: {
    bgStyle() {
      return {
        "background-image": `url(${mk(this.white, this.grey, this.size)})`
      };
    }
  }
};
function pk(t, e, o) {
  if (typeof document == "undefined")
    return null;
  const n = document.createElement("canvas");
  n.width = n.height = o * 2;
  const r = n.getContext("2d");
  return r ? (r.fillStyle = t, r.fillRect(0, 0, n.width, n.height), r.fillStyle = e, r.fillRect(0, 0, o, o), r.translate(o, o), r.fillRect(0, 0, o, o), n.toDataURL()) : null;
}
function mk(t, e, o) {
  const n = `${t},${e},${o}`;
  if (ar[n])
    return ar[n];
  const r = pk(t, e, o);
  return ar[n] = r, r;
}
function vk(t, e, o, n, r, s) {
  return d(), h(
    "div",
    {
      class: "vc-checkerboard",
      style: re(s.bgStyle)
    },
    null,
    4
    /* STYLE */
  );
}
var gk = ".vc-checkerboard{background-size:contain;bottom:0;left:0;position:absolute;right:0;top:0}";
ao(gk);
Wo.render = vk;
Wo.__file = "src/components/checkboard/checkboard.vue";
Wo.install = lo;
var In = {
  name: "Alpha",
  components: {
    Checkboard: Wo
  },
  props: {
    value: Object,
    onChange: Function
  },
  computed: {
    colors() {
      return this.value;
    },
    gradientColor() {
      const { rgba: t } = this.colors, e = [t.r, t.g, t.b].join(",");
      return `linear-gradient(to right, rgba(${e}, 0) 0%, rgba(${e}, 1) 100%)`;
    }
  },
  methods: {
    handleChange(t, e) {
      !e && t.preventDefault();
      const { container: o } = this.$refs;
      if (!o)
        return;
      const n = o.clientWidth, r = o.getBoundingClientRect().left + window.pageXOffset, i = (t.pageX || (t.touches ? t.touches[0].pageX : 0)) - r;
      let a;
      i < 0 ? a = 0 : i > n ? a = 1 : a = Math.round(i * 100 / n) / 100, this.colors.a !== a && this.$emit("change", {
        h: this.colors.hsl.h,
        s: this.colors.hsl.s,
        l: this.colors.hsl.l,
        a,
        source: "rgba"
      });
    },
    handleMouseDown(t) {
      this.handleChange(t, !0), window.addEventListener("mousemove", this.handleChange), window.addEventListener("mouseup", this.handleMouseUp);
    },
    handleMouseUp() {
      this.unbindEventListeners();
    },
    unbindEventListeners() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }
};
const _k = { class: "vc-alpha" }, wk = { class: "vc-alpha-checkboard-wrap" }, bk = /* @__PURE__ */ l(
  "div",
  { class: "vc-alpha-picker" },
  null,
  -1
  /* HOISTED */
), kk = [
  bk
];
function yk(t, e, o, n, r, s) {
  const i = be("Checkboard");
  return d(), h("div", _k, [
    l("div", wk, [
      $(i)
    ]),
    l(
      "div",
      {
        class: "vc-alpha-gradient",
        style: re({ background: s.gradientColor })
      },
      null,
      4
      /* STYLE */
    ),
    l(
      "div",
      {
        ref: "container",
        class: "vc-alpha-container",
        onMousedown: e[0] || (e[0] = (...a) => s.handleMouseDown && s.handleMouseDown(...a)),
        onTouchmove: e[1] || (e[1] = (...a) => s.handleChange && s.handleChange(...a)),
        onTouchstart: e[2] || (e[2] = (...a) => s.handleChange && s.handleChange(...a))
      },
      [
        l(
          "div",
          {
            class: "vc-alpha-pointer",
            style: re({ left: `${s.colors.a * 100}%` })
          },
          kk,
          4
          /* STYLE */
        )
      ],
      544
      /* HYDRATE_EVENTS, NEED_PATCH */
    )
  ]);
}
var xk = ".vc-alpha,.vc-alpha-checkboard-wrap{bottom:0;left:0;position:absolute;right:0;top:0}.vc-alpha-checkboard-wrap{overflow:hidden}.vc-alpha-gradient{bottom:0;left:0;position:absolute;right:0;top:0}.vc-alpha-container{cursor:pointer;height:100%;margin:0 3px;position:relative;z-index:2}.vc-alpha-pointer{position:absolute;z-index:2}.vc-alpha-picker{background:#fff;border-radius:1px;box-shadow:0 0 2px rgba(0,0,0,.6);cursor:pointer;height:8px;margin-top:1px;transform:translateX(-2px);width:4px}";
ao(xk);
In.render = yk;
In.__file = "src/components/alpha/alpha.vue";
In.install = lo;
function ye(t, e) {
  Ck(t) && (t = "100%");
  var o = Mk(t);
  return t = e === 360 ? t : Math.min(e, Math.max(0, parseFloat(t))), o && (t = parseInt(String(t * e), 10) / 100), Math.abs(t - e) < 1e-6 ? 1 : (e === 360 ? t = (t < 0 ? t % e + e : t % e) / parseFloat(String(e)) : t = t % e / parseFloat(String(e)), t);
}
function an(t) {
  return Math.min(1, Math.max(0, t));
}
function Ck(t) {
  return typeof t == "string" && t.indexOf(".") !== -1 && parseFloat(t) === 1;
}
function Mk(t) {
  return typeof t == "string" && t.indexOf("%") !== -1;
}
function ru(t) {
  return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
}
function ln(t) {
  return t <= 1 ? "".concat(Number(t) * 100, "%") : t;
}
function Dt(t) {
  return t.length === 1 ? "0" + t : String(t);
}
function $k(t, e, o) {
  return {
    r: ye(t, 255) * 255,
    g: ye(e, 255) * 255,
    b: ye(o, 255) * 255
  };
}
function Hs(t, e, o) {
  t = ye(t, 255), e = ye(e, 255), o = ye(o, 255);
  var n = Math.max(t, e, o), r = Math.min(t, e, o), s = 0, i = 0, a = (n + r) / 2;
  if (n === r)
    i = 0, s = 0;
  else {
    var c = n - r;
    switch (i = a > 0.5 ? c / (2 - n - r) : c / (n + r), n) {
      case t:
        s = (e - o) / c + (e < o ? 6 : 0);
        break;
      case e:
        s = (o - t) / c + 2;
        break;
      case o:
        s = (t - e) / c + 4;
        break;
    }
    s /= 6;
  }
  return { h: s, s: i, l: a };
}
function lr(t, e, o) {
  return o < 0 && (o += 1), o > 1 && (o -= 1), o < 1 / 6 ? t + (e - t) * (6 * o) : o < 1 / 2 ? e : o < 2 / 3 ? t + (e - t) * (2 / 3 - o) * 6 : t;
}
function Sk(t, e, o) {
  var n, r, s;
  if (t = ye(t, 360), e = ye(e, 100), o = ye(o, 100), e === 0)
    r = o, s = o, n = o;
  else {
    var i = o < 0.5 ? o * (1 + e) : o + e - o * e, a = 2 * o - i;
    n = lr(a, i, t + 1 / 3), r = lr(a, i, t), s = lr(a, i, t - 1 / 3);
  }
  return { r: n * 255, g: r * 255, b: s * 255 };
}
function Vs(t, e, o) {
  t = ye(t, 255), e = ye(e, 255), o = ye(o, 255);
  var n = Math.max(t, e, o), r = Math.min(t, e, o), s = 0, i = n, a = n - r, c = n === 0 ? 0 : a / n;
  if (n === r)
    s = 0;
  else {
    switch (n) {
      case t:
        s = (e - o) / a + (e < o ? 6 : 0);
        break;
      case e:
        s = (o - t) / a + 2;
        break;
      case o:
        s = (t - e) / a + 4;
        break;
    }
    s /= 6;
  }
  return { h: s, s: c, v: i };
}
function jk(t, e, o) {
  t = ye(t, 360) * 6, e = ye(e, 100), o = ye(o, 100);
  var n = Math.floor(t), r = t - n, s = o * (1 - e), i = o * (1 - r * e), a = o * (1 - (1 - r) * e), c = n % 6, u = [o, i, s, s, a, o][c], f = [a, o, o, i, s, s][c], p = [s, s, a, o, o, i][c];
  return { r: u * 255, g: f * 255, b: p * 255 };
}
function Fs(t, e, o, n) {
  var r = [
    Dt(Math.round(t).toString(16)),
    Dt(Math.round(e).toString(16)),
    Dt(Math.round(o).toString(16))
  ];
  return n && r[0].startsWith(r[0].charAt(1)) && r[1].startsWith(r[1].charAt(1)) && r[2].startsWith(r[2].charAt(1)) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) : r.join("");
}
function Ok(t, e, o, n, r) {
  var s = [
    Dt(Math.round(t).toString(16)),
    Dt(Math.round(e).toString(16)),
    Dt(Math.round(o).toString(16)),
    Dt(Tk(n))
  ];
  return r && s[0].startsWith(s[0].charAt(1)) && s[1].startsWith(s[1].charAt(1)) && s[2].startsWith(s[2].charAt(1)) && s[3].startsWith(s[3].charAt(1)) ? s[0].charAt(0) + s[1].charAt(0) + s[2].charAt(0) + s[3].charAt(0) : s.join("");
}
function Tk(t) {
  return Math.round(parseFloat(t) * 255).toString(16);
}
function Is(t) {
  return Se(t) / 255;
}
function Se(t) {
  return parseInt(t, 16);
}
function zk(t) {
  return {
    r: t >> 16,
    g: (t & 65280) >> 8,
    b: t & 255
  };
}
var zr = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Bk(t) {
  var e = { r: 0, g: 0, b: 0 }, o = 1, n = null, r = null, s = null, i = !1, a = !1;
  return typeof t == "string" && (t = Ak(t)), typeof t == "object" && (it(t.r) && it(t.g) && it(t.b) ? (e = $k(t.r, t.g, t.b), i = !0, a = String(t.r).substr(-1) === "%" ? "prgb" : "rgb") : it(t.h) && it(t.s) && it(t.v) ? (n = ln(t.s), r = ln(t.v), e = jk(t.h, n, r), i = !0, a = "hsv") : it(t.h) && it(t.s) && it(t.l) && (n = ln(t.s), s = ln(t.l), e = Sk(t.h, n, s), i = !0, a = "hsl"), Object.prototype.hasOwnProperty.call(t, "a") && (o = t.a)), o = ru(o), {
    ok: i,
    format: t.format || a,
    r: Math.min(255, Math.max(e.r, 0)),
    g: Math.min(255, Math.max(e.g, 0)),
    b: Math.min(255, Math.max(e.b, 0)),
    a: o
  };
}
var Ek = "[-\\+]?\\d+%?", Pk = "[-\\+]?\\d*\\.\\d+%?", xt = "(?:".concat(Pk, ")|(?:").concat(Ek, ")"), dr = "[\\s|\\(]+(".concat(xt, ")[,|\\s]+(").concat(xt, ")[,|\\s]+(").concat(xt, ")\\s*\\)?"), ur = "[\\s|\\(]+(".concat(xt, ")[,|\\s]+(").concat(xt, ")[,|\\s]+(").concat(xt, ")[,|\\s]+(").concat(xt, ")\\s*\\)?"), Re = {
  CSS_UNIT: new RegExp(xt),
  rgb: new RegExp("rgb" + dr),
  rgba: new RegExp("rgba" + ur),
  hsl: new RegExp("hsl" + dr),
  hsla: new RegExp("hsla" + ur),
  hsv: new RegExp("hsv" + dr),
  hsva: new RegExp("hsva" + ur),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Ak(t) {
  if (t = t.trim().toLowerCase(), t.length === 0)
    return !1;
  var e = !1;
  if (zr[t])
    t = zr[t], e = !0;
  else if (t === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var o = Re.rgb.exec(t);
  return o ? { r: o[1], g: o[2], b: o[3] } : (o = Re.rgba.exec(t), o ? { r: o[1], g: o[2], b: o[3], a: o[4] } : (o = Re.hsl.exec(t), o ? { h: o[1], s: o[2], l: o[3] } : (o = Re.hsla.exec(t), o ? { h: o[1], s: o[2], l: o[3], a: o[4] } : (o = Re.hsv.exec(t), o ? { h: o[1], s: o[2], v: o[3] } : (o = Re.hsva.exec(t), o ? { h: o[1], s: o[2], v: o[3], a: o[4] } : (o = Re.hex8.exec(t), o ? {
    r: Se(o[1]),
    g: Se(o[2]),
    b: Se(o[3]),
    a: Is(o[4]),
    format: e ? "name" : "hex8"
  } : (o = Re.hex6.exec(t), o ? {
    r: Se(o[1]),
    g: Se(o[2]),
    b: Se(o[3]),
    format: e ? "name" : "hex"
  } : (o = Re.hex4.exec(t), o ? {
    r: Se(o[1] + o[1]),
    g: Se(o[2] + o[2]),
    b: Se(o[3] + o[3]),
    a: Is(o[4] + o[4]),
    format: e ? "name" : "hex8"
  } : (o = Re.hex3.exec(t), o ? {
    r: Se(o[1] + o[1]),
    g: Se(o[2] + o[2]),
    b: Se(o[3] + o[3]),
    format: e ? "name" : "hex"
  } : !1)))))))));
}
function it(t) {
  return !!Re.CSS_UNIT.exec(String(t));
}
var Lk = (
  /** @class */
  function() {
    function t(e, o) {
      e === void 0 && (e = ""), o === void 0 && (o = {});
      var n;
      if (e instanceof t)
        return e;
      typeof e == "number" && (e = zk(e)), this.originalInput = e;
      var r = Bk(e);
      this.originalInput = e, this.r = r.r, this.g = r.g, this.b = r.b, this.a = r.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (n = o.format) !== null && n !== void 0 ? n : r.format, this.gradientType = o.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = r.ok;
    }
    return t.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, t.prototype.isLight = function() {
      return !this.isDark();
    }, t.prototype.getBrightness = function() {
      var e = this.toRgb();
      return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
    }, t.prototype.getLuminance = function() {
      var e = this.toRgb(), o, n, r, s = e.r / 255, i = e.g / 255, a = e.b / 255;
      return s <= 0.03928 ? o = s / 12.92 : o = Math.pow((s + 0.055) / 1.055, 2.4), i <= 0.03928 ? n = i / 12.92 : n = Math.pow((i + 0.055) / 1.055, 2.4), a <= 0.03928 ? r = a / 12.92 : r = Math.pow((a + 0.055) / 1.055, 2.4), 0.2126 * o + 0.7152 * n + 0.0722 * r;
    }, t.prototype.getAlpha = function() {
      return this.a;
    }, t.prototype.setAlpha = function(e) {
      return this.a = ru(e), this.roundA = Math.round(100 * this.a) / 100, this;
    }, t.prototype.isMonochrome = function() {
      var e = this.toHsl().s;
      return e === 0;
    }, t.prototype.toHsv = function() {
      var e = Vs(this.r, this.g, this.b);
      return { h: e.h * 360, s: e.s, v: e.v, a: this.a };
    }, t.prototype.toHsvString = function() {
      var e = Vs(this.r, this.g, this.b), o = Math.round(e.h * 360), n = Math.round(e.s * 100), r = Math.round(e.v * 100);
      return this.a === 1 ? "hsv(".concat(o, ", ").concat(n, "%, ").concat(r, "%)") : "hsva(".concat(o, ", ").concat(n, "%, ").concat(r, "%, ").concat(this.roundA, ")");
    }, t.prototype.toHsl = function() {
      var e = Hs(this.r, this.g, this.b);
      return { h: e.h * 360, s: e.s, l: e.l, a: this.a };
    }, t.prototype.toHslString = function() {
      var e = Hs(this.r, this.g, this.b), o = Math.round(e.h * 360), n = Math.round(e.s * 100), r = Math.round(e.l * 100);
      return this.a === 1 ? "hsl(".concat(o, ", ").concat(n, "%, ").concat(r, "%)") : "hsla(".concat(o, ", ").concat(n, "%, ").concat(r, "%, ").concat(this.roundA, ")");
    }, t.prototype.toHex = function(e) {
      return e === void 0 && (e = !1), Fs(this.r, this.g, this.b, e);
    }, t.prototype.toHexString = function(e) {
      return e === void 0 && (e = !1), "#" + this.toHex(e);
    }, t.prototype.toHex8 = function(e) {
      return e === void 0 && (e = !1), Ok(this.r, this.g, this.b, this.a, e);
    }, t.prototype.toHex8String = function(e) {
      return e === void 0 && (e = !1), "#" + this.toHex8(e);
    }, t.prototype.toHexShortString = function(e) {
      return e === void 0 && (e = !1), this.a === 1 ? this.toHexString(e) : this.toHex8String(e);
    }, t.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, t.prototype.toRgbString = function() {
      var e = Math.round(this.r), o = Math.round(this.g), n = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(e, ", ").concat(o, ", ").concat(n, ")") : "rgba(".concat(e, ", ").concat(o, ", ").concat(n, ", ").concat(this.roundA, ")");
    }, t.prototype.toPercentageRgb = function() {
      var e = function(o) {
        return "".concat(Math.round(ye(o, 255) * 100), "%");
      };
      return {
        r: e(this.r),
        g: e(this.g),
        b: e(this.b),
        a: this.a
      };
    }, t.prototype.toPercentageRgbString = function() {
      var e = function(o) {
        return Math.round(ye(o, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(e(this.r), "%, ").concat(e(this.g), "%, ").concat(e(this.b), "%)") : "rgba(".concat(e(this.r), "%, ").concat(e(this.g), "%, ").concat(e(this.b), "%, ").concat(this.roundA, ")");
    }, t.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var e = "#" + Fs(this.r, this.g, this.b, !1), o = 0, n = Object.entries(zr); o < n.length; o++) {
        var r = n[o], s = r[0], i = r[1];
        if (e === i)
          return s;
      }
      return !1;
    }, t.prototype.toString = function(e) {
      var o = !!e;
      e = e != null ? e : this.format;
      var n = !1, r = this.a < 1 && this.a >= 0, s = !o && r && (e.startsWith("hex") || e === "name");
      return s ? e === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (n = this.toRgbString()), e === "prgb" && (n = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (n = this.toHexString()), e === "hex3" && (n = this.toHexString(!0)), e === "hex4" && (n = this.toHex8String(!0)), e === "hex8" && (n = this.toHex8String()), e === "name" && (n = this.toName()), e === "hsl" && (n = this.toHslString()), e === "hsv" && (n = this.toHsvString()), n || this.toHexString());
    }, t.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, t.prototype.clone = function() {
      return new t(this.toString());
    }, t.prototype.lighten = function(e) {
      e === void 0 && (e = 10);
      var o = this.toHsl();
      return o.l += e / 100, o.l = an(o.l), new t(o);
    }, t.prototype.brighten = function(e) {
      e === void 0 && (e = 10);
      var o = this.toRgb();
      return o.r = Math.max(0, Math.min(255, o.r - Math.round(255 * -(e / 100)))), o.g = Math.max(0, Math.min(255, o.g - Math.round(255 * -(e / 100)))), o.b = Math.max(0, Math.min(255, o.b - Math.round(255 * -(e / 100)))), new t(o);
    }, t.prototype.darken = function(e) {
      e === void 0 && (e = 10);
      var o = this.toHsl();
      return o.l -= e / 100, o.l = an(o.l), new t(o);
    }, t.prototype.tint = function(e) {
      return e === void 0 && (e = 10), this.mix("white", e);
    }, t.prototype.shade = function(e) {
      return e === void 0 && (e = 10), this.mix("black", e);
    }, t.prototype.desaturate = function(e) {
      e === void 0 && (e = 10);
      var o = this.toHsl();
      return o.s -= e / 100, o.s = an(o.s), new t(o);
    }, t.prototype.saturate = function(e) {
      e === void 0 && (e = 10);
      var o = this.toHsl();
      return o.s += e / 100, o.s = an(o.s), new t(o);
    }, t.prototype.greyscale = function() {
      return this.desaturate(100);
    }, t.prototype.spin = function(e) {
      var o = this.toHsl(), n = (o.h + e) % 360;
      return o.h = n < 0 ? 360 + n : n, new t(o);
    }, t.prototype.mix = function(e, o) {
      o === void 0 && (o = 50);
      var n = this.toRgb(), r = new t(e).toRgb(), s = o / 100, i = {
        r: (r.r - n.r) * s + n.r,
        g: (r.g - n.g) * s + n.g,
        b: (r.b - n.b) * s + n.b,
        a: (r.a - n.a) * s + n.a
      };
      return new t(i);
    }, t.prototype.analogous = function(e, o) {
      e === void 0 && (e = 6), o === void 0 && (o = 30);
      var n = this.toHsl(), r = 360 / o, s = [this];
      for (n.h = (n.h - (r * e >> 1) + 720) % 360; --e; )
        n.h = (n.h + r) % 360, s.push(new t(n));
      return s;
    }, t.prototype.complement = function() {
      var e = this.toHsl();
      return e.h = (e.h + 180) % 360, new t(e);
    }, t.prototype.monochromatic = function(e) {
      e === void 0 && (e = 6);
      for (var o = this.toHsv(), n = o.h, r = o.s, s = o.v, i = [], a = 1 / e; e--; )
        i.push(new t({ h: n, s: r, v: s })), s = (s + a) % 1;
      return i;
    }, t.prototype.splitcomplement = function() {
      var e = this.toHsl(), o = e.h;
      return [
        this,
        new t({ h: (o + 72) % 360, s: e.s, l: e.l }),
        new t({ h: (o + 216) % 360, s: e.s, l: e.l })
      ];
    }, t.prototype.onBackground = function(e) {
      var o = this.toRgb(), n = new t(e).toRgb(), r = o.a + n.a * (1 - o.a);
      return new t({
        r: (o.r * o.a + n.r * n.a * (1 - o.a)) / r,
        g: (o.g * o.a + n.g * n.a * (1 - o.a)) / r,
        b: (o.b * o.a + n.b * n.a * (1 - o.a)) / r,
        a: r
      });
    }, t.prototype.triad = function() {
      return this.polyad(3);
    }, t.prototype.tetrad = function() {
      return this.polyad(4);
    }, t.prototype.polyad = function(e) {
      for (var o = this.toHsl(), n = o.h, r = [this], s = 360 / e, i = 1; i < e; i++)
        r.push(new t({ h: (n + i * s) % 360, s: o.s, l: o.l }));
      return r;
    }, t.prototype.equals = function(e) {
      return this.toRgbString() === new t(e).toRgbString();
    }, t;
  }()
);
function _t(...t) {
  return new Lk(...t);
}
function cr(t, e) {
  const o = t && t.a;
  let n;
  t && t.hsl ? n = _t(t.hsl) : t && t.hex && t.hex.length > 0 ? n = _t(t.hex) : t && t.hsv ? n = _t(t.hsv) : t && t.rgba ? n = _t(t.rgba) : t && t.rgb ? n = _t(t.rgb) : n = _t(t), n && (n._a === void 0 || n._a === null) && n.setAlpha(o || n.getAlpha());
  const r = n.toHsl(), s = n.toHsv();
  return r.s === 0 && (s.h = r.h = t.h || t.hsl && t.hsl.h || e || 0), s.v < 0.0164 && (s.h = t.h || t.hsv && t.hsv.h || 0, s.s = t.s || t.hsv && t.hsv.s || 0), r.l < 0.01 && (r.h = t.h || t.hsl && t.hsl.h || 0, r.s = t.s || t.hsl && t.hsl.s || 0), {
    hsl: r,
    hex: n.toHexString().toUpperCase(),
    hex8: n.toHex8String().toUpperCase(),
    rgba: n.toRgb(),
    hsv: s,
    oldHue: t.h || e || r.h,
    source: t.source,
    a: n.getAlpha()
  };
}
var Hk = {
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: ["modelValue"],
  data() {
    return {
      val: cr(this.modelValue)
    };
  },
  computed: {
    colors: {
      get() {
        return this.val;
      },
      set(t) {
        this.val = t, this.$emit("update:modelValue", t);
      }
    }
  },
  watch: {
    modelValue(t) {
      this.val = cr(t);
    }
  },
  methods: {
    colorChange(t, e) {
      this.oldHue = this.colors.hsl.h, this.colors = cr(t, e || this.oldHue);
    },
    isValidHex(t) {
      return _t(t).isValid;
    },
    simpleCheckForValidColor(t) {
      const e = ["r", "g", "b", "a", "h", "s", "l", "v"];
      let o = 0, n = 0;
      for (let r = 0; r < e.length; r++) {
        const s = e[r];
        t[s] && (o++, isNaN(t[s]) || n++);
      }
      if (o === n)
        return t;
    },
    paletteUpperCase(t) {
      return t.map((e) => e.toUpperCase());
    },
    isTransparent(t) {
      return _t(t).getAlpha() === 0;
    }
  }
}, Dn = {
  name: "EditableInput",
  props: {
    label: String,
    labelText: String,
    desc: String,
    value: [String, Number],
    max: Number,
    min: Number,
    arrowOffset: {
      type: Number,
      default: 1
    }
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(t) {
        if (this.max !== void 0 && +t > this.max)
          this.$refs.input.value = this.max;
        else
          return t;
      }
    },
    labelId() {
      return `input__label__${this.label}__${Math.random().toString().slice(2, 5)}`;
    },
    labelSpanText() {
      return this.labelText || this.label;
    }
  },
  methods: {
    update(t) {
      this.handleChange(t.target.value);
    },
    handleChange(t) {
      const e = {};
      e[this.label] = t, e.hex === void 0 && e["#"] === void 0 ? this.$emit("change", e) : t.length > 5 && this.$emit("change", e);
    },
    // **** unused
    // handleBlur (e) {
    //   console.log(e)
    // },
    handleKeyDown(t) {
      let { val: e } = this;
      const o = Number(e);
      if (o) {
        const n = this.arrowOffset || 1;
        t.keyCode === 38 && (e = o + n, this.handleChange(e), t.preventDefault()), t.keyCode === 40 && (e = o - n, this.handleChange(e), t.preventDefault());
      }
    }
    // **** unused
    // handleDrag (e) {
    //   console.log(e)
    // },
    // handleMouseDown (e) {
    //   console.log(e)
    // }
  }
};
const Vk = { class: "vc-editable-input" }, Fk = ["aria-labelledby"], Ik = ["id", "for"], Dk = { class: "vc-input__desc" };
function Nk(t, e, o, n, r, s) {
  return d(), h("div", Vk, [
    se(l("input", {
      ref: "input",
      "onUpdate:modelValue": e[0] || (e[0] = (i) => s.val = i),
      "aria-labelledby": s.labelId,
      class: "vc-input__input",
      onKeydown: e[1] || (e[1] = (...i) => s.handleKeyDown && s.handleKeyDown(...i)),
      onInput: e[2] || (e[2] = (...i) => s.update && s.update(...i))
    }, null, 40, Fk), [
      [yi, s.val]
    ]),
    l("span", {
      id: s.labelId,
      for: o.label,
      class: "vc-input__label"
    }, F(s.labelSpanText), 9, Ik),
    l(
      "span",
      Dk,
      F(o.desc),
      1
      /* TEXT */
    )
  ]);
}
var Rk = ".vc-editable-input{position:relative}.vc-input__input{border:0;outline:none;padding:0}.vc-input__label{text-transform:capitalize}";
ao(Rk);
Dn.render = Nk;
Dn.__file = "src/components/editable-input/editable-input.vue";
Dn.install = lo;
function hr(t, e, o) {
  return e < o ? t < e ? e : t > o ? o : t : t < o ? o : t > e ? e : t;
}
var Nn = {
  name: "Saturation",
  props: {
    value: Object
  },
  computed: {
    colors() {
      return this.value;
    },
    bgColor() {
      return `hsl(${this.colors.hsv.h}, 100%, 50%)`;
    },
    pointerTop() {
      return `${-(this.colors.hsv.v * 100) + 1 + 100}%`;
    },
    pointerLeft() {
      return `${this.colors.hsv.s * 100}%`;
    }
  },
  methods: {
    handleChange(t, e) {
      !e && t.preventDefault();
      const { container: o } = this.$refs;
      if (!o)
        return;
      const n = o.clientWidth, r = o.clientHeight, s = o.getBoundingClientRect().left + window.pageXOffset, i = o.getBoundingClientRect().top + window.pageYOffset, a = t.pageX || (t.touches ? t.touches[0].pageX : 0), c = t.pageY || (t.touches ? t.touches[0].pageY : 0), u = hr(a - s, 0, n), f = hr(c - i, 0, r), p = u / n, v = hr(-(f / r) + 1, 0, 1);
      this.onChange({
        h: this.colors.hsv.h,
        s: p,
        v,
        a: this.colors.hsv.a,
        source: "hsva"
      });
    },
    onChange(t) {
      this.$emit("change", t);
    },
    handleMouseDown(t) {
      window.addEventListener("mousemove", this.handleChange), window.addEventListener("mouseup", this.handleChange), window.addEventListener("mouseup", this.handleMouseUp);
    },
    handleMouseUp(t) {
      this.unbindEventListeners();
    },
    unbindEventListeners() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }
};
const qk = /* @__PURE__ */ l(
  "div",
  { class: "vc-saturation--white" },
  null,
  -1
  /* HOISTED */
), Wk = /* @__PURE__ */ l(
  "div",
  { class: "vc-saturation--black" },
  null,
  -1
  /* HOISTED */
), Uk = /* @__PURE__ */ l(
  "div",
  { class: "vc-saturation-circle" },
  null,
  -1
  /* HOISTED */
), Zk = [
  Uk
];
function Gk(t, e, o, n, r, s) {
  return d(), h(
    "div",
    {
      ref: "container",
      class: "vc-saturation",
      style: re({ background: s.bgColor }),
      onMousedown: e[0] || (e[0] = (...i) => s.handleMouseDown && s.handleMouseDown(...i)),
      onTouchmove: e[1] || (e[1] = (...i) => s.handleChange && s.handleChange(...i)),
      onTouchstart: e[2] || (e[2] = (...i) => s.handleChange && s.handleChange(...i))
    },
    [
      qk,
      Wk,
      l(
        "div",
        {
          class: "vc-saturation-pointer",
          style: re({ top: s.pointerTop, left: s.pointerLeft })
        },
        Zk,
        4
        /* STYLE */
      )
    ],
    36
    /* STYLE, HYDRATE_EVENTS */
  );
}
var Yk = ".vc-saturation,.vc-saturation--black,.vc-saturation--white{bottom:0;cursor:pointer;left:0;position:absolute;right:0;top:0}.vc-saturation--white{background:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.vc-saturation--black{background:linear-gradient(0deg,#000,transparent)}.vc-saturation-pointer{cursor:pointer;position:absolute}.vc-saturation-circle{border-radius:50%;box-shadow:0 0 0 1.5px #fff,inset 0 0 1px 1px rgba(0,0,0,.3),0 0 1px 2px rgba(0,0,0,.4);cursor:head;height:4px;transform:translate(-2px,-2px);width:4px}";
ao(Yk);
Nn.render = Gk;
Nn.__file = "src/components/saturation/saturation.vue";
Nn.install = lo;
var Rn = {
  name: "Hue",
  props: {
    value: Object,
    direction: {
      type: String,
      // [horizontal | vertical]
      default: "horizontal"
    }
  },
  data() {
    return {
      oldHue: 0,
      pullDirection: ""
    };
  },
  computed: {
    colors() {
      return this.value;
    },
    directionClass() {
      return {
        "vc-hue--horizontal": this.direction === "horizontal",
        "vc-hue--vertical": this.direction === "vertical"
      };
    },
    pointerTop() {
      return this.direction === "vertical" ? this.colors.hsl.h === 0 && this.pullDirection === "right" ? 0 : `${-(this.colors.hsl.h * 100 / 360) + 100}%` : 0;
    },
    pointerLeft() {
      return this.direction === "vertical" ? 0 : this.colors.hsl.h === 0 && this.pullDirection === "right" ? "100%" : `${this.colors.hsl.h * 100 / 360}%`;
    }
  },
  watch: {
    value: {
      handler(t, e) {
        const { h: o } = t.hsl;
        o !== 0 && o - this.oldHue > 0 && (this.pullDirection = "right"), o !== 0 && o - this.oldHue < 0 && (this.pullDirection = "left"), this.oldHue = o;
      },
      deep: !0,
      immediate: !0
    }
  },
  methods: {
    handleChange(t, e) {
      !e && t.preventDefault();
      const { container: o } = this.$refs;
      if (!o)
        return;
      const n = o.clientWidth, r = o.clientHeight, s = o.getBoundingClientRect().left + window.pageXOffset, i = o.getBoundingClientRect().top + window.pageYOffset, a = t.pageX || (t.touches ? t.touches[0].pageX : 0), c = t.pageY || (t.touches ? t.touches[0].pageY : 0), u = a - s, f = c - i;
      let p, v;
      this.direction === "vertical" ? (f < 0 ? p = 360 : f > r ? p = 0 : (v = -(f * 100 / r) + 100, p = 360 * v / 100), this.colors.hsl.h !== p && this.$emit("change", {
        h: p,
        s: this.colors.hsl.s,
        l: this.colors.hsl.l,
        a: this.colors.hsl.a,
        source: "hsl"
      })) : (u < 0 ? p = 0 : u > n ? p = 360 : (v = u * 100 / n, p = 360 * v / 100), this.colors.hsl.h !== p && this.$emit("change", {
        h: p,
        s: this.colors.hsl.s,
        l: this.colors.hsl.l,
        a: this.colors.hsl.a,
        source: "hsl"
      }));
    },
    handleMouseDown(t) {
      this.handleChange(t, !0), window.addEventListener("mousemove", this.handleChange), window.addEventListener("mouseup", this.handleChange), window.addEventListener("mouseup", this.handleMouseUp);
    },
    handleMouseUp(t) {
      this.unbindEventListeners();
    },
    unbindEventListeners() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }
};
const Xk = ["aria-valuenow"], Kk = /* @__PURE__ */ l(
  "div",
  { class: "vc-hue-picker" },
  null,
  -1
  /* HOISTED */
), Jk = [
  Kk
];
function Qk(t, e, o, n, r, s) {
  return d(), h(
    "div",
    {
      class: S(["vc-hue", [s.directionClass]])
    },
    [
      l("div", {
        ref: "container",
        class: "vc-hue-container",
        role: "slider",
        "aria-valuenow": s.colors.hsl.h,
        "aria-valuemin": "0",
        "aria-valuemax": "360",
        onMousedown: e[0] || (e[0] = (...i) => s.handleMouseDown && s.handleMouseDown(...i)),
        onTouchmove: e[1] || (e[1] = (...i) => s.handleChange && s.handleChange(...i)),
        onTouchstart: e[2] || (e[2] = (...i) => s.handleChange && s.handleChange(...i))
      }, [
        l(
          "div",
          {
            class: "vc-hue-pointer",
            style: re({ top: s.pointerTop, left: s.pointerLeft }),
            role: "presentation"
          },
          Jk,
          4
          /* STYLE */
        )
      ], 40, Xk)
    ],
    2
    /* CLASS */
  );
}
var ey = ".vc-hue{border-radius:2px;bottom:0;left:0;position:absolute;right:0;top:0}.vc-hue--horizontal{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.vc-hue--vertical{background:linear-gradient(0deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.vc-hue-container{cursor:pointer;height:100%;margin:0 2px;position:relative}.vc-hue-pointer{position:absolute;z-index:2}.vc-hue-picker{background:#fff;border-radius:1px;box-shadow:0 0 2px rgba(0,0,0,.6);cursor:pointer;height:8px;margin-top:1px;transform:translateX(-2px);width:4px}";
ao(ey);
Rn.render = Qk;
Rn.__file = "src/components/hue/hue.vue";
Rn.install = lo;
var qn = {
  name: "Chrome",
  components: {
    Saturation: Nn,
    Hue: Rn,
    Alpha: In,
    EdIn: Dn,
    Checkboard: Wo
  },
  mixins: [Hk],
  props: {
    disableAlpha: {
      type: Boolean,
      default: !1
    },
    disableFields: {
      type: Boolean,
      default: !1
    },
    format: {
      type: String,
      default: "hex"
    }
  },
  data() {
    return {
      fieldsIndex: "hex",
      highlight: !1
    };
  },
  computed: {
    hsl() {
      const { h: t, s: e, l: o } = this.colors.hsl;
      return {
        h: t.toFixed(),
        s: `${(e * 100).toFixed()}%`,
        l: `${(o * 100).toFixed()}%`
      };
    },
    activeColor() {
      const { rgba: t } = this.colors;
      return `rgba(${[t.r, t.g, t.b, t.a].join(",")})`;
    },
    hasAlpha() {
      return this.colors.a < 1;
    }
  },
  watch: {
    format: {
      handler(t) {
        this.fieldsIndex = t;
      },
      immediate: !0
    }
  },
  methods: {
    childChange(t) {
      this.colorChange(t);
    },
    inputChange(t) {
      if (t) {
        if (t.hex)
          this.isValidHex(t.hex) && this.colorChange({
            hex: t.hex,
            source: "hex"
          });
        else if (t.r || t.g || t.b || t.a)
          this.colorChange({
            r: t.r || this.colors.rgba.r,
            g: t.g || this.colors.rgba.g,
            b: t.b || this.colors.rgba.b,
            a: t.a || this.colors.rgba.a,
            source: "rgba"
          });
        else if (t.h || t.s || t.l) {
          const e = t.s ? t.s.replace("%", "") / 100 : this.colors.hsl.s, o = t.l ? t.l.replace("%", "") / 100 : this.colors.hsl.l;
          this.colorChange({
            h: t.h || this.colors.hsl.h,
            s: e,
            l: o,
            source: "hsl"
          });
        }
      }
    },
    toggleViews() {
      switch (this.fieldsIndex) {
        case "hex":
          this.fieldsIndex = `rgb${this.disableAlpha ? "" : "a"}`;
          break;
        case "rgb":
        case "rgba":
          this.fieldsIndex = `hsl${this.disableAlpha ? "" : "a"}`;
          break;
        default:
          this.fieldsIndex = "hex";
          break;
      }
      this.$emit("update:format", this.fieldsIndex);
    },
    showHighlight() {
      this.highlight = !0;
    },
    hideHighlight() {
      this.highlight = !1;
    }
  }
};
const ty = { class: "vc-chrome-saturation-wrap" }, oy = { class: "vc-chrome-body" }, ny = { class: "vc-chrome-controls" }, ry = { class: "vc-chrome-color-wrap" }, sy = ["aria-label"], iy = { class: "vc-chrome-sliders" }, ay = { class: "vc-chrome-hue-wrap" }, ly = {
  key: 0,
  class: "vc-chrome-alpha-wrap"
}, dy = {
  key: 0,
  class: "vc-chrome-fields-wrap"
}, uy = { class: "vc-chrome-fields" }, cy = { class: "vc-chrome-field" }, hy = { class: "vc-chrome-fields" }, fy = { class: "vc-chrome-field" }, py = { class: "vc-chrome-field" }, my = { class: "vc-chrome-field" }, vy = {
  key: 0,
  class: "vc-chrome-field"
}, gy = { class: "vc-chrome-fields" }, _y = { class: "vc-chrome-field" }, wy = { class: "vc-chrome-field" }, by = { class: "vc-chrome-field" }, ky = {
  key: 0,
  class: "vc-chrome-field"
}, yy = { class: "vc-chrome-toggle-icon" }, xy = /* @__PURE__ */ l(
  "path",
  {
    fill: "#333",
    d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
  },
  null,
  -1
  /* HOISTED */
), Cy = [
  xy
], My = { class: "vc-chrome-toggle-icon-highlight" };
function $y(t, e, o, n, r, s) {
  const i = be("Saturation"), a = be("Checkboard"), c = be("Hue"), u = be("Alpha"), f = be("EdIn");
  return d(), h(
    "div",
    {
      role: "application",
      "aria-label": "Chrome color picker",
      class: S(["vc-chrome", [o.disableAlpha ? "vc-chrome__disable-alpha" : ""]])
    },
    [
      l("div", ty, [
        $(i, {
          value: t.colors,
          onChange: s.childChange
        }, null, 8, ["value", "onChange"])
      ]),
      l("div", oy, [
        l("div", ny, [
          l("div", ry, [
            l("div", {
              "aria-label": `current color is ${t.colors.hex}`,
              class: "vc-chrome-active-color",
              style: re({ background: s.activeColor })
            }, null, 12, sy),
            o.disableAlpha ? E("v-if", !0) : (d(), P(a, { key: 0 }))
          ]),
          l("div", iy, [
            l("div", ay, [
              $(c, {
                value: t.colors,
                onChange: s.childChange
              }, null, 8, ["value", "onChange"])
            ]),
            o.disableAlpha ? E("v-if", !0) : (d(), h("div", ly, [
              $(u, {
                value: t.colors,
                onChange: s.childChange
              }, null, 8, ["value", "onChange"])
            ]))
          ])
        ]),
        o.disableFields ? E("v-if", !0) : (d(), h("div", dy, [
          se(l(
            "div",
            uy,
            [
              E(" hex "),
              l("div", cy, [
                s.hasAlpha ? E("v-if", !0) : (d(), P(f, {
                  key: 0,
                  label: "hex",
                  value: t.colors.hex,
                  onChange: s.inputChange
                }, null, 8, ["value", "onChange"])),
                s.hasAlpha ? (d(), P(f, {
                  key: 1,
                  label: "hex",
                  value: t.colors.hex8,
                  onChange: s.inputChange
                }, null, 8, ["value", "onChange"])) : E("v-if", !0)
              ])
            ],
            512
            /* NEED_PATCH */
          ), [
            [yt, r.fieldsIndex === "hex"]
          ]),
          se(l(
            "div",
            hy,
            [
              E(" rgba "),
              l("div", fy, [
                $(f, {
                  label: "r",
                  value: t.colors.rgba.r,
                  onChange: s.inputChange
                }, null, 8, ["value", "onChange"])
              ]),
              l("div", py, [
                $(f, {
                  label: "g",
                  value: t.colors.rgba.g,
                  onChange: s.inputChange
                }, null, 8, ["value", "onChange"])
              ]),
              l("div", my, [
                $(f, {
                  label: "b",
                  value: t.colors.rgba.b,
                  onChange: s.inputChange
                }, null, 8, ["value", "onChange"])
              ]),
              o.disableAlpha ? E("v-if", !0) : (d(), h("div", vy, [
                $(f, {
                  label: "a",
                  value: t.colors.a,
                  "arrow-offset": 0.01,
                  max: 1,
                  onChange: s.inputChange
                }, null, 8, ["value", "arrow-offset", "onChange"])
              ]))
            ],
            512
            /* NEED_PATCH */
          ), [
            [yt, ["rgb", "rgba"].includes(r.fieldsIndex)]
          ]),
          se(l(
            "div",
            gy,
            [
              E(" hsla "),
              l("div", _y, [
                $(f, {
                  label: "h",
                  value: s.hsl.h,
                  onChange: s.inputChange
                }, null, 8, ["value", "onChange"])
              ]),
              l("div", wy, [
                $(f, {
                  label: "s",
                  value: s.hsl.s,
                  onChange: s.inputChange
                }, null, 8, ["value", "onChange"])
              ]),
              l("div", by, [
                $(f, {
                  label: "l",
                  value: s.hsl.l,
                  onChange: s.inputChange
                }, null, 8, ["value", "onChange"])
              ]),
              o.disableAlpha ? E("v-if", !0) : (d(), h("div", ky, [
                $(f, {
                  label: "a",
                  value: t.colors.a,
                  "arrow-offset": 0.01,
                  max: 1,
                  onChange: s.inputChange
                }, null, 8, ["value", "arrow-offset", "onChange"])
              ]))
            ],
            512
            /* NEED_PATCH */
          ), [
            [yt, ["hsl", "hsla"].includes(r.fieldsIndex)]
          ]),
          E(" btn "),
          l("div", {
            class: "vc-chrome-toggle-btn",
            role: "button",
            "aria-label": "Change another color definition",
            onClick: e[3] || (e[3] = (...p) => s.toggleViews && s.toggleViews(...p))
          }, [
            l("div", yy, [
              (d(), h(
                "svg",
                {
                  style: { width: "24px", height: "24px" },
                  viewBox: "0 0 24 24",
                  onMouseover: e[0] || (e[0] = (...p) => s.showHighlight && s.showHighlight(...p)),
                  onMouseenter: e[1] || (e[1] = (...p) => s.showHighlight && s.showHighlight(...p)),
                  onMouseout: e[2] || (e[2] = (...p) => s.hideHighlight && s.hideHighlight(...p))
                },
                Cy,
                32
                /* HYDRATE_EVENTS */
              ))
            ]),
            se(l(
              "div",
              My,
              null,
              512
              /* NEED_PATCH */
            ), [
              [yt, r.highlight]
            ])
          ]),
          E(" btn ")
        ]))
      ])
    ],
    2
    /* CLASS */
  );
}
var Sy = ".vc-chrome{background:#fff;background-color:#fff;border-radius:2px;box-shadow:0 0 2px rgba(0,0,0,.3),0 4px 8px rgba(0,0,0,.3);box-sizing:initial;font-family:Menlo;width:225px}.vc-chrome-controls{display:flex}.vc-chrome-color-wrap{position:relative;width:36px}.vc-chrome-active-color{border-radius:15px;height:30px;overflow:hidden;position:relative;width:30px;z-index:1}.vc-chrome-color-wrap .vc-checkerboard{background-size:auto;border-radius:15px;height:30px;width:30px}.vc-chrome-sliders{flex:1}.vc-chrome-fields-wrap{display:flex;padding-top:16px}.vc-chrome-fields{display:flex;flex:1;margin-left:-6px}.vc-chrome-field{padding-left:6px;width:100%}.vc-chrome-toggle-btn{position:relative;text-align:right;width:32px}.vc-chrome-toggle-icon{cursor:pointer;margin-right:-4px;margin-top:12px;position:relative;z-index:2}.vc-chrome-toggle-icon-highlight{background:#eee;border-radius:4px;height:28px;left:12px;position:absolute;top:10px;width:24px}.vc-chrome-hue-wrap{margin-bottom:8px}.vc-chrome-alpha-wrap,.vc-chrome-hue-wrap{height:10px;position:relative}.vc-chrome-alpha-wrap .vc-alpha-gradient,.vc-chrome-hue-wrap .vc-hue{border-radius:2px}.vc-chrome-alpha-wrap .vc-alpha-picker,.vc-chrome-hue-wrap .vc-hue-picker{background-color:#f8f8f8;border-radius:6px;box-shadow:0 1px 4px 0 rgba(0,0,0,.37);height:12px;transform:translate(-6px,-2px);width:12px}.vc-chrome-body{background-color:#fff;padding:16px 16px 12px}.vc-chrome-saturation-wrap{border-radius:2px 2px 0 0;overflow:hidden;padding-bottom:55%;position:relative;width:100%}.vc-chrome-saturation-wrap .vc-saturation-circle{height:12px;width:12px}.vc-chrome-fields .vc-input__input{border:none;border-radius:2px;box-shadow:inset 0 0 0 1px #dadada;color:#333;font-size:11px;height:21px;text-align:center;width:100%}.vc-chrome-fields .vc-input__label{color:#969696;display:block;font-size:11px;line-height:11px;margin-top:12px;text-align:center;text-transform:uppercase}.vc-chrome__disable-alpha .vc-chrome-active-color{height:18px;width:18px}.vc-chrome__disable-alpha .vc-chrome-color-wrap{width:30px}.vc-chrome__disable-alpha .vc-chrome-hue-wrap{margin-bottom:4px;margin-top:4px}";
ao(Sy);
qn.render = $y;
qn.__file = "src/components/chrome/chrome.vue";
qn.install = lo;
const jy = { class: "fried-color-picker" }, su = /* @__PURE__ */ A({
  __name: "FriedColorPicker",
  props: {
    modelValue: { default: "#FFFFFF" },
    disableAlpha: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue"],
  setup(t, { expose: e, emit: o }) {
    const n = t, r = o, s = ({ hex: u, hex8: f }) => r("update:modelValue", n.disableAlpha ? u : f), i = I();
    return e({
      focus: () => {
        var u;
        (u = i.value) == null || u.focus();
      },
      blur: () => {
        var u;
        (u = i.value) == null || u.blur();
      }
    }), (u, f) => (d(), h("div", jy, [
      $(_(qn), {
        class: "color-picker",
        "model-value": u.modelValue,
        "disable-alpha": u.disableAlpha,
        "onUpdate:modelValue": s
      }, null, 8, ["model-value", "disable-alpha"]),
      C(u.$slots, "default")
    ]));
  }
});
var xn = /* @__PURE__ */ ((t) => (t.Text = "text", t.Password = "password", t.Number = "number", t.Email = "email", t.Tel = "tel", t.Search = "search", t.Url = "url", t.Date = "date", t.Time = "time", t.Month = "month", t.Week = "week", t))(xn || {});
const Oy = { class: "inner-container" }, Ty = { "aria-hidden": "true" }, zy = ["for"], By = /* @__PURE__ */ A({
  __name: "FriedFieldSet",
  props: {
    label: { default: "" },
    success: { type: Boolean, default: !1 },
    helpMessage: { default: "" },
    errorMessage: { default: "" },
    error: { type: Boolean, default: !1 },
    prefixWidth: { default: 0 },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    for: { default: "" },
    focused: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, o = z(() => e.for), n = z(
      () => e.active ? "translate(0,0)" : `translate(${e.prefixWidth}px, 0)`
    );
    return (r, s) => (d(), h("div", {
      class: S(["input-outer-container", {
        error: !!r.errorMessage || r.error,
        success: r.success,
        "has-label": !!r.label,
        "input-active": r.active,
        disabled: r.disabled,
        focused: r.focused
      }])
    }, [
      l("div", Oy, [
        C(r.$slots, "default", {}, void 0, !0),
        l("fieldset", Ty, [
          l("legend", null, F(r.label), 1)
        ]),
        l("label", {
          class: "input-label",
          for: o.value,
          style: re({ transform: n.value })
        }, F(r.label), 13, zy)
      ]),
      r.helpMessage ? (d(), P(Te, {
        key: 0,
        id: `${o.value}-hint`,
        class: "hint",
        size: _(Ye).Small
      }, {
        default: O(() => [
          K(F(r.helpMessage), 1)
        ]),
        _: 1
      }, 8, ["id", "size"])) : E("", !0),
      r.errorMessage ? (d(), P(Te, {
        key: 1,
        class: "error-message",
        size: _(Ye).Small
      }, {
        default: O(() => [
          K(F(r.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["size"])) : E("", !0)
    ], 2));
  }
}), Uo = /* @__PURE__ */ T(By, [["__scopeId", "data-v-3fb28bc8"]]), Ey = ["disabled"], Py = /* @__PURE__ */ A({
  __name: "FriedIconButton",
  props: {
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = (s) => {
      o.disabled || n("click", s);
    };
    return (s, i) => se((d(), h("button", {
      class: S(["button", { active: s.active, disabled: s.disabled }]),
      disabled: s.disabled,
      onClick: r
    }, [
      C(s.$slots, "default", {}, void 0, !0)
    ], 10, Ey)), [
      [_(ut)]
    ]);
  }
}), me = /* @__PURE__ */ T(Py, [["__scopeId", "data-v-29ec5cf4"]]), Ay = ["id", "disabled", "value", "type", "max", "min", "maxLength", "minLength", "autocomplete", "placeholder", "readonly", "data-external", "aria-haspopup", "aria-expanded", "aria-activedescendant", "aria-invalid", "aria-errormessage", "aria-describedby", "pattern"], Ly = {
  key: 2,
  class: "suffix"
}, Hy = {
  key: 3,
  class: "append"
}, Vy = /* @__PURE__ */ A({
  __name: "FriedInput",
  props: {
    label: { default: "" },
    id: { default: "" },
    autocomplete: { default: "value-that-chrome-doesnt-recognize" },
    modelValue: { default: "" },
    success: { type: Boolean, default: !1 },
    helpMessage: { default: "" },
    errorMessage: { default: "" },
    error: { type: Boolean, default: !1 },
    suffix: { default: "" },
    prefix: { default: "" },
    disabled: { type: Boolean, default: !1 },
    delayedFocus: { type: Boolean, default: !1 },
    pattern: { default: void 0 },
    fixedLabel: { type: Boolean, default: !1 },
    type: { default: xn.Text },
    max: { default: void 0 },
    min: { default: void 0 },
    step: { default: void 0 },
    minLength: { default: void 0 },
    maxLength: { default: void 0 },
    placeholder: { default: "" },
    readonly: { type: Boolean },
    autofocus: { type: Boolean },
    dataExternal: { default: void 0 },
    placeholderAsDefault: { type: Boolean, default: !1 },
    showClear: { type: Boolean },
    ariaHaspopup: { default: void 0 },
    ariaExpanded: { type: Boolean, default: void 0 },
    ariaActivedescendant: { default: void 0 }
  },
  emits: ["focus", "blur", "update:modelValue", "input", "click", "change"],
  setup(t, { expose: e, emit: o }) {
    const n = t, { prefix: r, modelValue: s } = Ke(n), i = xe(5), a = o, c = I(!1), u = I(0), f = I(!1), p = I(null), v = I(null), m = (V) => {
      a("update:modelValue", V);
    }, g = () => Q(this, null, function* () {
      var V;
      if (yield En(), !n.prefix) {
        u.value = 0;
        return;
      }
      u.value = ((V = v.value) == null ? void 0 : V.offsetWidth) || 0;
    });
    Je(r, g);
    const w = z(
      () => c.value || !!s.value || f.value || n.fixedLabel || y.value
    ), y = z(() => s.value === 0), M = z(() => n.id || "input-" + i), B = (V) => {
      n.placeholderAsDefault && !n.modelValue && m(n.placeholder), c.value = !0, a("focus", V);
    }, k = (V) => {
      n.placeholderAsDefault && n.modelValue === n.placeholder && m(""), c.value = !1, a("blur", V);
    }, x = (V) => {
      var J;
      n.disabled || (a("click", V), (J = p.value) == null || J.focus());
    }, b = (V) => {
      if (!n.disabled) {
        if (a("input", V), f.value = !1, n.max && V.target.value > n.max && n.type === xn.Number) {
          m(n.max.toString());
          return;
        }
        m(V.target.value);
      }
    }, N = (V) => {
      V.animationName.includes("onAutoFillStart") && (f.value = !0);
    }, Z = () => {
      var V;
      (V = p.value) == null || V.focus();
    }, ne = () => {
      var V;
      (V = p.value) == null || V.blur();
    };
    return ht(() => {
      g(), n.autofocus && Z(), n.delayedFocus && setTimeout(() => {
        Z();
      }, 1500);
    }), e({
      focus: Z,
      blur: ne
    }), (V, J) => (d(), P(Uo, {
      class: "input-box",
      label: V.label,
      success: V.success,
      active: w.value,
      disabled: V.disabled,
      "help-message": V.helpMessage,
      "error-message": V.errorMessage,
      error: V.error,
      "prefix-width": u.value,
      for: M.value,
      onClick: x
    }, {
      default: O(() => [
        _(r) ? (d(), h("span", {
          key: 0,
          ref_key: "prefixElement",
          ref: v,
          class: "prefix"
        }, F(_(r)), 513)) : E("", !0),
        l("input", {
          id: M.value,
          ref_key: "inputElement",
          ref: p,
          class: "input",
          disabled: V.disabled,
          value: _(s),
          type: V.type,
          max: V.max,
          min: V.min,
          maxLength: V.maxLength,
          minLength: V.minLength,
          autocomplete: V.autocomplete,
          placeholder: V.placeholder,
          readonly: V.readonly,
          "data-external": V.dataExternal,
          "aria-haspopup": V.ariaHaspopup,
          "aria-expanded": V.ariaExpanded,
          "aria-activedescendant": V.ariaActivedescendant,
          "aria-invalid": !!V.errorMessage,
          "aria-errormessage": V.errorMessage,
          "aria-describedby": `${M.value}-hint`,
          pattern: V.pattern,
          onFocus: B,
          onBlur: k,
          onAnimationstart: N,
          onInput: b,
          onChange: J[0] || (J[0] = (le) => a("change", le))
        }, null, 40, Ay),
        V.showClear ? (d(), P(_(me), {
          key: 1,
          class: S(["clear-button", { hide: !_(s) }]),
          onClick: J[1] || (J[1] = (le) => m(""))
        }, {
          default: O(() => [
            $(_(U), {
              icon: "close",
              size: _(He).Small
            }, null, 8, ["size"])
          ]),
          _: 1
        }, 8, ["class"])) : E("", !0),
        V.suffix ? (d(), h("span", Ly, F(V.suffix), 1)) : E("", !0),
        V.$slots.append ? (d(), h("span", Hy, [
          C(V.$slots, "append", { class: "append" }, void 0, !0)
        ])) : E("", !0)
      ]),
      _: 3
    }, 8, ["label", "success", "active", "disabled", "help-message", "error-message", "error", "prefix-width", "for"]));
  }
}), Wn = /* @__PURE__ */ T(Vy, [["__scopeId", "data-v-2b76837d"]]);
function uo(t) {
  return t.split("-")[0];
}
function Un(t) {
  return t.split("-")[1];
}
function Zn(t) {
  return ["top", "bottom"].includes(uo(t)) ? "x" : "y";
}
function iu(t) {
  return t === "y" ? "height" : "width";
}
function Ds(t, e, o) {
  let { reference: n, floating: r } = t;
  const s = n.x + n.width / 2 - r.width / 2, i = n.y + n.height / 2 - r.height / 2, a = Zn(e), c = iu(a), u = n[c] / 2 - r[c] / 2, f = a === "x";
  let p;
  switch (uo(e)) {
    case "top":
      p = { x: s, y: n.y - r.height };
      break;
    case "bottom":
      p = { x: s, y: n.y + n.height };
      break;
    case "right":
      p = { x: n.x + n.width, y: i };
      break;
    case "left":
      p = { x: n.x - r.width, y: i };
      break;
    default:
      p = { x: n.x, y: n.y };
  }
  switch (Un(e)) {
    case "start":
      p[a] -= u * (o && f ? -1 : 1);
      break;
    case "end":
      p[a] += u * (o && f ? -1 : 1);
  }
  return p;
}
const Fy = (t, e, o) => Q(void 0, null, function* () {
  const { placement: n = "bottom", strategy: r = "absolute", middleware: s = [], platform: i } = o, a = yield i.isRTL == null ? void 0 : i.isRTL(e);
  let c = yield i.getElementRects({ reference: t, floating: e, strategy: r }), { x: u, y: f } = Ds(c, n, a), p = n, v = {}, m = 0;
  for (let g = 0; g < s.length; g++) {
    const { name: w, fn: y } = s[g], { x: M, y: B, data: k, reset: x } = yield y({ x: u, y: f, initialPlacement: n, placement: p, strategy: r, middlewareData: v, rects: c, platform: i, elements: { reference: t, floating: e } });
    u = M != null ? M : u, f = B != null ? B : f, v = R(j({}, v), { [w]: j(j({}, v[w]), k) }), x && m <= 50 && (m++, typeof x == "object" && (x.placement && (p = x.placement), x.rects && (c = x.rects === !0 ? yield i.getElementRects({ reference: t, floating: e, strategy: r }) : x.rects), { x: u, y: f } = Ds(c, p, a)), g = -1);
  }
  return { x: u, y: f, placement: p, strategy: r, middlewareData: v };
});
function Iy(t) {
  return typeof t != "number" ? function(e) {
    return j({ top: 0, right: 0, bottom: 0, left: 0 }, e);
  }(t) : { top: t, right: t, bottom: t, left: t };
}
function Cn(t) {
  return R(j({}, t), { top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height });
}
function Qr(t, e) {
  return Q(this, null, function* () {
    var o;
    e === void 0 && (e = {});
    const { x: n, y: r, platform: s, rects: i, elements: a, strategy: c } = t, { boundary: u = "clippingAncestors", rootBoundary: f = "viewport", elementContext: p = "floating", altBoundary: v = !1, padding: m = 0 } = e, g = Iy(m), w = a[v ? p === "floating" ? "reference" : "floating" : p], y = Cn(yield s.getClippingRect({ element: (o = yield s.isElement == null ? void 0 : s.isElement(w)) == null || o ? w : w.contextElement || (yield s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)), boundary: u, rootBoundary: f, strategy: c })), M = Cn(s.convertOffsetParentRelativeRectToViewportRelativeRect ? yield s.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: p === "floating" ? R(j({}, i.floating), { x: n, y: r }) : i.reference, offsetParent: yield s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating), strategy: c }) : i[p]);
    return { top: y.top - M.top + g.top, bottom: M.bottom - y.bottom + g.bottom, left: y.left - M.left + g.left, right: M.right - y.right + g.right };
  });
}
const Dy = Math.min, Ht = Math.max;
function Ns(t, e, o) {
  return Ht(t, Dy(e, o));
}
const Ny = { left: "right", right: "left", bottom: "top", top: "bottom" };
function Mn(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Ny[e]);
}
function Ry(t, e, o) {
  o === void 0 && (o = !1);
  const n = Un(t), r = Zn(t), s = iu(r);
  let i = r === "x" ? n === (o ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (i = Mn(i)), { main: i, cross: Mn(i) };
}
const qy = { start: "end", end: "start" };
function Rs(t) {
  return t.replace(/start|end/g, (e) => qy[e]);
}
const Wy = ["top", "right", "bottom", "left"];
Wy.reduce((t, e) => t.concat(e, e + "-start", e + "-end"), []);
const Uy = function(t) {
  return t === void 0 && (t = {}), { name: "flip", options: t, fn(o) {
    return Q(this, null, function* () {
      var n;
      const { placement: r, middlewareData: s, rects: i, initialPlacement: a, platform: c, elements: u } = o, V = t, { mainAxis: f = !0, crossAxis: p = !0, fallbackPlacements: v, fallbackStrategy: m = "bestFit", flipAlignment: g = !0 } = V, w = Be(V, ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "flipAlignment"]), y = uo(r), M = v || (y === a || !g ? [Mn(a)] : function(J) {
        const le = Mn(J);
        return [Rs(J), le, Rs(le)];
      }(a)), B = [a, ...M], k = yield Qr(o, w), x = [];
      let b = ((n = s.flip) == null ? void 0 : n.overflows) || [];
      if (f && x.push(k[y]), p) {
        const { main: J, cross: le } = Ry(r, i, yield c.isRTL == null ? void 0 : c.isRTL(u.floating));
        x.push(k[J], k[le]);
      }
      if (b = [...b, { placement: r, overflows: x }], !x.every((J) => J <= 0)) {
        var N, Z;
        const J = ((N = (Z = s.flip) == null ? void 0 : Z.index) != null ? N : 0) + 1, le = B[J];
        if (le) return { data: { index: J, overflows: b }, reset: { placement: le } };
        let te = "bottom";
        switch (m) {
          case "bestFit": {
            var ne;
            const ie = (ne = b.map((ve) => [ve, ve.overflows.filter((he) => he > 0).reduce((he, fe) => he + fe, 0)]).sort((ve, he) => ve[1] - he[1])[0]) == null ? void 0 : ne[0].placement;
            ie && (te = ie);
            break;
          }
          case "initialPlacement":
            te = a;
        }
        if (r !== te) return { reset: { placement: te } };
      }
      return {};
    });
  } };
}, Zy = function(t) {
  return t === void 0 && (t = 0), { name: "offset", options: t, fn(o) {
    return Q(this, null, function* () {
      const { x: n, y: r } = o, s = yield function(i, a) {
        return Q(this, null, function* () {
          const { placement: c, platform: u, elements: f } = i, p = yield u.isRTL == null ? void 0 : u.isRTL(f.floating), v = uo(c), m = Un(c), g = Zn(c) === "x", w = ["left", "top"].includes(v) ? -1 : 1, y = p && g ? -1 : 1, M = typeof a == "function" ? a(i) : a;
          let { mainAxis: B, crossAxis: k, alignmentAxis: x } = typeof M == "number" ? { mainAxis: M, crossAxis: 0, alignmentAxis: null } : j({ mainAxis: 0, crossAxis: 0, alignmentAxis: null }, M);
          return m && typeof x == "number" && (k = m === "end" ? -1 * x : x), g ? { x: k * y, y: B * w } : { x: B * w, y: k * y };
        });
      }(o, t);
      return { x: n + s.x, y: r + s.y, data: s };
    });
  } };
};
function Gy(t) {
  return t === "x" ? "y" : "x";
}
const Yy = function(t) {
  return t === void 0 && (t = {}), { name: "shift", options: t, fn(o) {
    return Q(this, null, function* () {
      const { x: n, y: r, placement: s } = o, M = t, { mainAxis: i = !0, crossAxis: a = !1, limiter: c = { fn: (B) => {
        let { x: k, y: x } = B;
        return { x: k, y: x };
      } } } = M, u = Be(M, ["mainAxis", "crossAxis", "limiter"]), f = { x: n, y: r }, p = yield Qr(o, u), v = Zn(uo(s)), m = Gy(v);
      let g = f[v], w = f[m];
      if (i) {
        const B = v === "y" ? "bottom" : "right";
        g = Ns(g + p[v === "y" ? "top" : "left"], g, g - p[B]);
      }
      if (a) {
        const B = m === "y" ? "bottom" : "right";
        w = Ns(w + p[m === "y" ? "top" : "left"], w, w - p[B]);
      }
      const y = c.fn(R(j({}, o), { [v]: g, [m]: w }));
      return R(j({}, y), { data: { x: y.x - n, y: y.y - r } });
    });
  } };
}, Xy = function(t) {
  return t === void 0 && (t = {}), { name: "size", options: t, fn(o) {
    return Q(this, null, function* () {
      const { placement: n, rects: r, platform: s, elements: i } = o, x = t, { apply: a = () => {
      } } = x, c = Be(x, ["apply"]), u = yield Qr(o, c), f = uo(n), p = Un(n);
      let v, m;
      f === "top" || f === "bottom" ? (v = f, m = p === ((yield s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (m = f, v = p === "end" ? "top" : "bottom");
      const g = Ht(u.left, 0), w = Ht(u.right, 0), y = Ht(u.top, 0), M = Ht(u.bottom, 0), B = { availableHeight: r.floating.height - (["left", "right"].includes(n) ? 2 * (y !== 0 || M !== 0 ? y + M : Ht(u.top, u.bottom)) : u[v]), availableWidth: r.floating.width - (["top", "bottom"].includes(n) ? 2 * (g !== 0 || w !== 0 ? g + w : Ht(u.left, u.right)) : u[m]) };
      yield a(j(j({}, o), B));
      const k = yield s.getDimensions(i.floating);
      return r.floating.width !== k.width || r.floating.height !== k.height ? { reset: { rects: !0 } } : {};
    });
  } };
};
function au(t) {
  return t && t.document && t.location && t.alert && t.setInterval;
}
function ft(t) {
  if (t == null) return window;
  if (!au(t)) {
    const e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function tt(t) {
  return ft(t).getComputedStyle(t);
}
function lt(t) {
  return au(t) ? "" : t ? (t.nodeName || "").toLowerCase() : "";
}
function lu() {
  const t = navigator.userAgentData;
  return t != null && t.brands ? t.brands.map((e) => e.brand + "/" + e.version).join(" ") : navigator.userAgent;
}
function nt(t) {
  return t instanceof ft(t).HTMLElement;
}
function zt(t) {
  return t instanceof ft(t).Element;
}
function to(t) {
  return typeof ShadowRoot == "undefined" ? !1 : t instanceof ft(t).ShadowRoot || t instanceof ShadowRoot;
}
function Gn(t) {
  const { overflow: e, overflowX: o, overflowY: n } = tt(t);
  return /auto|scroll|overlay|hidden/.test(e + n + o);
}
function Ky(t) {
  return ["table", "td", "th"].includes(lt(t));
}
function qs(t) {
  const e = /firefox/i.test(lu()), o = tt(t);
  return o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].includes(o.willChange) || e && o.willChange === "filter" || e && !!o.filter && o.filter !== "none";
}
function du() {
  return !/^((?!chrome|android).)*safari/i.test(lu());
}
const Ws = Math.min, zo = Math.max, $n = Math.round;
function dt(t, e, o) {
  var n, r, s, i;
  e === void 0 && (e = !1), o === void 0 && (o = !1);
  const a = t.getBoundingClientRect();
  let c = 1, u = 1;
  e && nt(t) && (c = t.offsetWidth > 0 && $n(a.width) / t.offsetWidth || 1, u = t.offsetHeight > 0 && $n(a.height) / t.offsetHeight || 1);
  const f = zt(t) ? ft(t) : window, p = !du() && o, v = (a.left + (p && (n = (r = f.visualViewport) == null ? void 0 : r.offsetLeft) != null ? n : 0)) / c, m = (a.top + (p && (s = (i = f.visualViewport) == null ? void 0 : i.offsetTop) != null ? s : 0)) / u, g = a.width / c, w = a.height / u;
  return { width: g, height: w, top: m, right: v + g, bottom: m + w, left: v, x: v, y: m };
}
function Ot(t) {
  return (e = t, (e instanceof ft(e).Node ? t.ownerDocument : t.document) || window.document).documentElement;
  var e;
}
function Yn(t) {
  return zt(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function uu(t) {
  return dt(Ot(t)).left + Yn(t).scrollLeft;
}
function Jy(t, e, o) {
  const n = nt(e), r = Ot(e), s = dt(t, n && function(c) {
    const u = dt(c);
    return $n(u.width) !== c.offsetWidth || $n(u.height) !== c.offsetHeight;
  }(e), o === "fixed");
  let i = { scrollLeft: 0, scrollTop: 0 };
  const a = { x: 0, y: 0 };
  if (n || !n && o !== "fixed") if ((lt(e) !== "body" || Gn(r)) && (i = Yn(e)), nt(e)) {
    const c = dt(e, !0);
    a.x = c.x + e.clientLeft, a.y = c.y + e.clientTop;
  } else r && (a.x = uu(r));
  return { x: s.left + i.scrollLeft - a.x, y: s.top + i.scrollTop - a.y, width: s.width, height: s.height };
}
function cu(t) {
  return lt(t) === "html" ? t : t.assignedSlot || t.parentNode || (to(t) ? t.host : null) || Ot(t);
}
function Us(t) {
  return nt(t) && tt(t).position !== "fixed" ? function(e) {
    let { offsetParent: o } = e, n = e, r = !1;
    for (; n && n !== o; ) {
      const { assignedSlot: s } = n;
      if (s) {
        let i = s.offsetParent;
        if (tt(s).display === "contents") {
          const a = s.hasAttribute("style"), c = s.style.display;
          s.style.display = tt(n).display, i = s.offsetParent, s.style.display = c, a || s.removeAttribute("style");
        }
        n = s, o !== i && (o = i, r = !0);
      } else if (to(n) && n.host && r) break;
      n = to(n) && n.host || n.parentNode;
    }
    return o;
  }(t) : null;
}
function Br(t) {
  const e = ft(t);
  let o = Us(t);
  for (; o && Ky(o) && tt(o).position === "static"; ) o = Us(o);
  return o && (lt(o) === "html" || lt(o) === "body" && tt(o).position === "static" && !qs(o)) ? e : o || function(n) {
    let r = cu(n);
    for (to(r) && (r = r.host); nt(r) && !["html", "body"].includes(lt(r)); ) {
      if (qs(r)) return r;
      {
        const s = r.parentNode;
        r = to(s) ? s.host : s;
      }
    }
    return null;
  }(t) || e;
}
function Zs(t) {
  if (nt(t)) return { width: t.offsetWidth, height: t.offsetHeight };
  const e = dt(t);
  return { width: e.width, height: e.height };
}
function hu(t) {
  const e = cu(t);
  return ["html", "body", "#document"].includes(lt(e)) ? t.ownerDocument.body : nt(e) && Gn(e) ? e : hu(e);
}
function Sn(t, e) {
  var o;
  e === void 0 && (e = []);
  const n = hu(t), r = n === ((o = t.ownerDocument) == null ? void 0 : o.body), s = ft(n), i = r ? [s].concat(s.visualViewport || [], Gn(n) ? n : []) : n, a = e.concat(i);
  return r ? a : a.concat(Sn(i));
}
function Gs(t, e, o) {
  return e === "viewport" ? Cn(function(n, r) {
    const s = ft(n), i = Ot(n), a = s.visualViewport;
    let c = i.clientWidth, u = i.clientHeight, f = 0, p = 0;
    if (a) {
      c = a.width, u = a.height;
      const v = du();
      (v || !v && r === "fixed") && (f = a.offsetLeft, p = a.offsetTop);
    }
    return { width: c, height: u, x: f, y: p };
  }(t, o)) : zt(e) ? function(n, r) {
    const s = dt(n, !1, r === "fixed"), i = s.top + n.clientTop, a = s.left + n.clientLeft;
    return { top: i, left: a, x: a, y: i, right: a + n.clientWidth, bottom: i + n.clientHeight, width: n.clientWidth, height: n.clientHeight };
  }(e, o) : Cn(function(n) {
    var r;
    const s = Ot(n), i = Yn(n), a = (r = n.ownerDocument) == null ? void 0 : r.body, c = zo(s.scrollWidth, s.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), u = zo(s.scrollHeight, s.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0);
    let f = -i.scrollLeft + uu(n);
    const p = -i.scrollTop;
    return tt(a || s).direction === "rtl" && (f += zo(s.clientWidth, a ? a.clientWidth : 0) - c), { width: c, height: u, x: f, y: p };
  }(Ot(t)));
}
function Qy(t) {
  const e = Sn(t), o = ["absolute", "fixed"].includes(tt(t).position) && nt(t) ? Br(t) : t;
  return zt(o) ? e.filter((n) => zt(n) && function(r, s) {
    const i = s.getRootNode == null ? void 0 : s.getRootNode();
    if (r.contains(s)) return !0;
    if (i && to(i)) {
      let a = s;
      do {
        if (a && r === a) return !0;
        a = a.parentNode || a.host;
      } while (a);
    }
    return !1;
  }(n, o) && lt(n) !== "body") : [];
}
const ex = { getClippingRect: function(t) {
  let { element: e, boundary: o, rootBoundary: n, strategy: r } = t;
  const s = [...o === "clippingAncestors" ? Qy(e) : [].concat(o), n], i = s[0], a = s.reduce((c, u) => {
    const f = Gs(e, u, r);
    return c.top = zo(f.top, c.top), c.right = Ws(f.right, c.right), c.bottom = Ws(f.bottom, c.bottom), c.left = zo(f.left, c.left), c;
  }, Gs(e, i, r));
  return { width: a.right - a.left, height: a.bottom - a.top, x: a.left, y: a.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  let { rect: e, offsetParent: o, strategy: n } = t;
  const r = nt(o), s = Ot(o);
  if (o === s) return e;
  let i = { scrollLeft: 0, scrollTop: 0 };
  const a = { x: 0, y: 0 };
  if ((r || !r && n !== "fixed") && ((lt(o) !== "body" || Gn(s)) && (i = Yn(o)), nt(o))) {
    const c = dt(o, !0);
    a.x = c.x + o.clientLeft, a.y = c.y + o.clientTop;
  }
  return R(j({}, e), { x: e.x - i.scrollLeft + a.x, y: e.y - i.scrollTop + a.y });
}, isElement: zt, getDimensions: Zs, getOffsetParent: Br, getDocumentElement: Ot, getElementRects: (t) => {
  let { reference: e, floating: o, strategy: n } = t;
  return { reference: Jy(e, Br(o), n), floating: R(j({}, Zs(o)), { x: 0, y: 0 }) };
}, getClientRects: (t) => Array.from(t.getClientRects()), isRTL: (t) => tt(t).direction === "rtl" };
function tx(t, e, o, n) {
  n === void 0 && (n = {});
  const { ancestorScroll: r = !0, ancestorResize: s = !0, elementResize: i = !0, animationFrame: a = !1 } = n, c = r && !a, u = s && !a, f = c || u ? [...zt(t) ? Sn(t) : [], ...Sn(e)] : [];
  f.forEach((g) => {
    c && g.addEventListener("scroll", o, { passive: !0 }), u && g.addEventListener("resize", o);
  });
  let p, v = null;
  if (i) {
    let g = !0;
    v = new ResizeObserver(() => {
      g || o(), g = !1;
    }), zt(t) && !a && v.observe(t), v.observe(e);
  }
  let m = a ? dt(t) : null;
  return a && function g() {
    const w = dt(t);
    !m || w.x === m.x && w.y === m.y && w.width === m.width && w.height === m.height || o(), m = w, p = requestAnimationFrame(g);
  }(), o(), () => {
    var g;
    f.forEach((w) => {
      c && w.removeEventListener("scroll", o), u && w.removeEventListener("resize", o);
    }), (g = v) == null || g.disconnect(), v = null, a && cancelAnimationFrame(p);
  };
}
const ox = (t, e, o) => Fy(t, e, j({ platform: ex }, o));
var co = /* @__PURE__ */ ((t) => (t.Top = "top", t.TopStart = "top-start", t.TopEnd = "top-end", t.Bottom = "bottom", t.BottomStart = "bottom-start", t.BottomEnd = "bottom-end", t.Left = "left", t.LeftStart = "left-start", t.LeftEnd = "left-end", t.Right = "right", t.RightStart = "right-start", t.RightEnd = "right-end", t))(co || {});
const nx = /* @__PURE__ */ A({
  __name: "FriedFloater",
  props: {
    show: { type: Boolean },
    placement: { default: co.Bottom },
    mainAxisOffset: { default: 0 },
    crossAxisOffset: { default: 0 },
    sameWidthAsRef: { type: Boolean, default: !1 },
    appendToBody: { type: Boolean, default: !1 },
    noShift: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, o = I(null), n = I(null), r = I(null), s = z(() => !!o.value && !!n.value), i = () => {
      s.value && (r.value = tx(
        o.value,
        n.value,
        () => Q(this, null, function* () {
          const { x: c, y: u } = yield ox(
            o.value,
            n.value,
            {
              placement: e.placement,
              middleware: [
                Xy({
                  apply({ elements: f }) {
                    var v;
                    const p = (v = o.value) == null ? void 0 : v.getBoundingClientRect().width;
                    Object.assign(f.floating.style, {
                      width: e.sameWidthAsRef ? `${p}px` : "initial"
                    });
                  }
                }),
                Zy({ mainAxis: e.mainAxisOffset, crossAxis: e.crossAxisOffset }),
                Uy(),
                Yy({ mainAxis: !e.noShift })
              ]
            }
          );
          n.value && Object.assign(n.value.style, {
            transform: `translate3d(${c}px, ${u}px, 0)`
          });
        })
      ));
    }, a = () => r.value && r.value();
    return Je([e], () => {
      e.show && (a(), i());
    }), ht(() => i()), xi(() => a()), (c, u) => (d(), h("div", {
      ref_key: "referenceRef",
      ref: o,
      class: "floater-reference-container"
    }, [
      C(c.$slots, "reference", {}, void 0, !0),
      (d(), P(Ur, {
        to: "body",
        disabled: !c.appendToBody
      }, [
        se(l("span", {
          ref_key: "floaterRef",
          ref: n,
          class: "floater-container"
        }, [
          c.show ? C(c.$slots, "default", { key: 0 }, void 0, !0) : E("", !0)
        ], 512), [
          [yt, c.show]
        ])
      ], 8, ["disabled"]))
    ], 512));
  }
}), Zo = /* @__PURE__ */ T(nx, [["__scopeId", "data-v-a86b194b"]]), rx = {}, sx = { class: "heading-1" };
function ix(t, e) {
  return d(), h("h1", sx, [
    C(t.$slots, "default", {}, void 0, !0)
  ]);
}
const ax = /* @__PURE__ */ T(rx, [["render", ix], ["__scopeId", "data-v-45c1da9a"]]), lx = {}, dx = { class: "heading-2" };
function ux(t, e) {
  return d(), h("h2", dx, [
    C(t.$slots, "default", {}, void 0, !0)
  ]);
}
const fu = /* @__PURE__ */ T(lx, [["render", ux], ["__scopeId", "data-v-f12746b5"]]), cx = {}, hx = { class: "heading-3" };
function fx(t, e) {
  return d(), h("h3", hx, [
    C(t.$slots, "default", {}, void 0, !0)
  ]);
}
const Go = /* @__PURE__ */ T(cx, [["render", fx], ["__scopeId", "data-v-95027e39"]]), px = {}, mx = { class: "heading-4" };
function vx(t, e) {
  return d(), h("h4", mx, [
    C(t.$slots, "default", {}, void 0, !0)
  ]);
}
const ho = /* @__PURE__ */ T(px, [["render", vx], ["__scopeId", "data-v-c64be7f5"]]), gx = {}, _x = { class: "heading-5" };
function wx(t, e) {
  return d(), h("h5", _x, [
    C(t.$slots, "default", {}, void 0, !0)
  ]);
}
const es = /* @__PURE__ */ T(gx, [["render", wx], ["__scopeId", "data-v-2c72a4ad"]]);
var Yo = /* @__PURE__ */ ((t) => (t.Top = "top", t.Bottom = "bottom", t.Right = "right", t.Left = "left", t))(Yo || {});
const bx = /* @__PURE__ */ A({
  __name: "TransitionSlideInOut",
  props: {
    origin: { default: Yo.Bottom }
  },
  setup(t) {
    return (e, o) => (d(), P(Ro, Oe(e.$attrs, {
      name: `slide-in-out-${e.origin}`
    }), {
      default: O(() => [
        C(e.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["name"]));
  }
}), ts = /* @__PURE__ */ T(bx, [["__scopeId", "data-v-37b24dfa"]]), kx = /* @__PURE__ */ A({
  __name: "TransitionSlideAndFadeInOut",
  props: {
    origin: { default: Yo.Bottom }
  },
  setup(t) {
    return (e, o) => (d(), P(Ro, Oe(e.$attrs, {
      name: `slide-and-fade-in-out-${e.origin}`
    }), {
      default: O(() => [
        C(e.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["name"]));
  }
}), yx = /* @__PURE__ */ T(kx, [["__scopeId", "data-v-ef505eb6"]]), xx = {};
function Cx(t, e) {
  return d(), P(yo, Oe(t.$attrs, { name: "appear-list" }), {
    default: O(() => [
      C(t.$slots, "default")
    ]),
    _: 3
  }, 16);
}
const Mx = /* @__PURE__ */ T(xx, [["render", Cx]]), $x = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SlideOrigin: Yo,
  TransitionAppearList: Mx,
  TransitionExpand: $d,
  TransitionFadeInOut: nu,
  TransitionSlideAndFadeInOut: yx,
  TransitionSlideInOut: ts
}, Symbol.toStringTag, { value: "Module" })), Sx = { class: "header" }, jx = { class: "content-container" }, Ox = /* @__PURE__ */ A({
  __name: "FriedMobileContainer",
  props: {
    modelValue: { type: Boolean, default: !0 },
    title: { default: "" },
    closable: { type: Boolean, default: !0 },
    closeButtonDataExternal: { default: "close-button" },
    setMinHeight: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = () => {
      o.closable && n("update:modelValue", !1);
    };
    return (s, i) => (d(), h(oe, null, [
      $(_(Jr), {
        show: s.modelValue,
        appear: "",
        opacity: 0.55,
        class: "modal-backdrop",
        onClose: r
      }, null, 8, ["show"]),
      $(_(ts), { appear: "" }, {
        default: O(() => [
          s.modelValue ? se((d(), h("div", {
            key: 0,
            class: S(["container", { "set-min-height": s.setMinHeight }])
          }, [
            l("div", Sx, [
              s.title ? (d(), P(_(Go), {
                key: 0,
                class: "title"
              }, {
                default: O(() => [
                  K(F(s.title), 1)
                ]),
                _: 1
              })) : E("", !0),
              s.closable ? (d(), P(_(me), {
                key: 1,
                class: "close-button",
                "data-external": s.closeButtonDataExternal,
                onClick: r
              }, {
                default: O(() => [
                  $(_(U), {
                    size: "small",
                    icon: "close"
                  })
                ]),
                _: 1
              }, 8, ["data-external"])) : E("", !0)
            ]),
            l("div", jx, [
              C(s.$slots, "default", {}, void 0, !0)
            ]),
            C(s.$slots, "footer", {}, void 0, !0)
          ], 2)), [
            [_(io), r]
          ]) : E("", !0)
        ]),
        _: 3
      })
    ], 64));
  }
}), pu = /* @__PURE__ */ T(Ox, [["__scopeId", "data-v-5915e23f"]]);
function mu(t) {
  return q2() ? (W2(t), !0) : !1;
}
function Bt(t) {
  return typeof t == "function" ? t() : _(t);
}
const Tx = typeof window != "undefined" && typeof document != "undefined";
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const zx = Object.prototype.toString, Bx = (t) => zx.call(t) === "[object Object]", jn = () => {
};
function Ex(t, e) {
  function o(...n) {
    return new Promise((r, s) => {
      Promise.resolve(t(() => e.apply(this, n), { fn: e, thisArg: this, args: n })).then(r).catch(s);
    });
  }
  return o;
}
const Px = (t) => t();
function Ax(t, e = {}) {
  let o, n, r = jn;
  const s = (a) => {
    clearTimeout(a), r(), r = jn;
  };
  return (a) => {
    const c = Bt(t), u = Bt(e.maxWait);
    return o && s(o), c <= 0 || u !== void 0 && u <= 0 ? (n && (s(n), n = null), Promise.resolve(a())) : new Promise((f, p) => {
      r = e.rejectOnCancel ? p : f, u && !n && (n = setTimeout(() => {
        o && s(o), n = null, f(a());
      }, u)), o = setTimeout(() => {
        n && s(n), n = null, f(a());
      }, c);
    });
  };
}
function Lx(t, e) {
  var o;
  if (typeof t == "number")
    return t + e;
  const n = ((o = t.match(/^-?\d+\.?\d*/)) == null ? void 0 : o[0]) || "", r = t.slice(n.length), s = Number.parseFloat(n) + e;
  return Number.isNaN(s) ? t : s + r;
}
function Hx(t, e, o = {}) {
  const s = o, {
    eventFilter: n = Px
  } = s, r = Be(s, [
    "eventFilter"
  ]);
  return Je(
    t,
    Ex(
      n,
      e
    ),
    r
  );
}
function Vx(t, e, o = {}) {
  const i = o, {
    debounce: n = 0,
    maxWait: r = void 0
  } = i, s = Be(i, [
    "debounce",
    "maxWait"
  ]);
  return Hx(
    t,
    e,
    R(j({}, s), {
      eventFilter: Ax(n, { maxWait: r })
    })
  );
}
function Fx(t, e, o) {
  let n;
  U2(o) ? n = {
    evaluating: o
  } : n = {};
  const {
    lazy: r = !1,
    evaluating: s = void 0,
    shallow: i = !0,
    onError: a = jn
  } = n, c = I(!r), u = i ? Z2(e) : I(e);
  let f = 0;
  return Ci((p) => Q(this, null, function* () {
    if (!c.value)
      return;
    f++;
    const v = f;
    let m = !1;
    s && Promise.resolve().then(() => {
      s.value = !0;
    });
    try {
      const g = yield t((w) => {
        p(() => {
          s && (s.value = !1), m || w();
        });
      });
      v === f && (u.value = g);
    } catch (g) {
      a(g);
    } finally {
      s && v === f && (s.value = !1), m = !0;
    }
  })), r ? z(() => (c.value = !0, u.value)) : u;
}
const Xn = Tx ? window : void 0;
function Ix(t) {
  var e;
  const o = Bt(t);
  return (e = o == null ? void 0 : o.$el) != null ? e : o;
}
function vu(...t) {
  let e, o, n, r;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([o, n, r] = t, e = Xn) : [e, o, n, r] = t, !e)
    return jn;
  Array.isArray(o) || (o = [o]), Array.isArray(n) || (n = [n]);
  const s = [], i = () => {
    s.forEach((f) => f()), s.length = 0;
  }, a = (f, p, v, m) => (f.addEventListener(p, v, m), () => f.removeEventListener(p, v, m)), c = Je(
    () => [Ix(e), Bt(r)],
    ([f, p]) => {
      if (i(), !f)
        return;
      const v = Bx(p) ? j({}, p) : p;
      s.push(
        ...o.flatMap((m) => n.map((g) => a(f, m, g, v)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    c(), i();
  };
  return mu(u), u;
}
function Dx(t) {
  return typeof t == "function" ? t : typeof t == "string" ? (e) => e.key === t : Array.isArray(t) ? (e) => t.includes(e.key) : () => !0;
}
function Nx(...t) {
  let e, o, n = {};
  t.length === 3 ? (e = t[0], o = t[1], n = t[2]) : t.length === 2 ? typeof t[1] == "object" ? (e = !0, o = t[0], n = t[1]) : (e = t[0], o = t[1]) : (e = !0, o = t[0]);
  const {
    target: r = Xn,
    eventName: s = "keydown",
    passive: i = !1,
    dedupe: a = !1
  } = n, c = Dx(e);
  return vu(r, s, (f) => {
    f.repeat && Bt(a) || c(f) && o(f);
  }, i);
}
function Rx() {
  const t = I(!1), e = G2();
  return e && ht(() => {
    t.value = !0;
  }, e), t;
}
function qx(t) {
  const e = Rx();
  return z(() => (e.value, !!t()));
}
function Yt(t, e = {}) {
  const { window: o = Xn } = e, n = qx(() => o && "matchMedia" in o && typeof o.matchMedia == "function");
  let r;
  const s = I(!1), i = (u) => {
    s.value = u.matches;
  }, a = () => {
    r && ("removeEventListener" in r ? r.removeEventListener("change", i) : r.removeListener(i));
  }, c = Ci(() => {
    n.value && (a(), r = o.matchMedia(Bt(t)), "addEventListener" in r ? r.addEventListener("change", i) : r.addListener(i), s.value = r.matches);
  });
  return mu(() => {
    c(), a(), r = void 0;
  }), s;
}
function Wx(t, e = {}) {
  function o(f, p) {
    let v = Bt(t[Bt(f)]);
    return p != null && (v = Lx(v, p)), typeof v == "number" && (v = `${v}px`), v;
  }
  const { window: n = Xn, strategy: r = "min-width" } = e;
  function s(f) {
    return n ? n.matchMedia(f).matches : !1;
  }
  const i = (f) => Yt(() => `(min-width: ${o(f)})`, e), a = (f) => Yt(() => `(max-width: ${o(f)})`, e), c = Object.keys(t).reduce((f, p) => (Object.defineProperty(f, p, {
    get: () => r === "min-width" ? i(p) : a(p),
    enumerable: !0,
    configurable: !0
  }), f), {});
  function u() {
    const f = Object.keys(t).map((p) => [p, i(p)]);
    return z(() => f.filter(([, p]) => p.value).map(([p]) => p));
  }
  return Object.assign(c, {
    greaterOrEqual: i,
    smallerOrEqual: a,
    greater(f) {
      return Yt(() => `(min-width: ${o(f, 0.1)})`, e);
    },
    smaller(f) {
      return Yt(() => `(max-width: ${o(f, -0.1)})`, e);
    },
    between(f, p) {
      return Yt(() => `(min-width: ${o(f)}) and (max-width: ${o(p, -0.1)})`, e);
    },
    isGreater(f) {
      return s(`(min-width: ${o(f, 0.1)})`);
    },
    isGreaterOrEqual(f) {
      return s(`(min-width: ${o(f)})`);
    },
    isSmaller(f) {
      return s(`(max-width: ${o(f, -0.1)})`);
    },
    isSmallerOrEqual(f) {
      return s(`(max-width: ${o(f)})`);
    },
    isInBetween(f, p) {
      return s(`(min-width: ${o(f)}) and (max-width: ${o(p, -0.1)})`);
    },
    current: u,
    active() {
      const f = u();
      return z(() => f.value.length === 0 ? "" : f.value.at(-1));
    }
  });
}
var qe = /* @__PURE__ */ ((t) => (t.XXSmall = "xxs", t.XSmall = "xs", t.Small = "sm", t.Medium = "md", t.Large = "lg", t))(qe || {});
const Ys = {
  xxs: 400,
  xs: 600,
  sm: 960,
  md: 1264,
  lg: 1500
}, gu = (t = Ys) => {
  const { greater: e, greaterOrEqual: o, smallerOrEqual: n, between: r } = Wx(t), s = (w) => {
    const y = Ys[w];
    return Yt(`(max-width: ${y - 1}px) and (orientation: landscape)`);
  }, i = n(qe.XXSmall) || s(qe.XXSmall), a = n(qe.XSmall) || s(qe.XSmall), c = e(qe.XSmall), u = n(qe.Small), f = e(qe.Small), p = n(qe.Medium), v = e(qe.Medium), m = o(qe.Large);
  return {
    isXXSmallScreenAndDown: i,
    isXSmallScreenAndDown: a,
    isXSmallScreenAndUp: c,
    isSmallScreenAndDown: u,
    isSmallScreenAndUp: f,
    isMediumScreenAndDown: p,
    isMediumScreenAndUp: v,
    isLargeScreenAndUp: m,
    isBetweenBreakpoints: (w, y) => r(w, y)
  };
}, Ux = /* @__PURE__ */ A({
  __name: "FriedDropdown",
  props: {
    mainAxisOffset: { default: 0 },
    crossAxisOffset: { default: 0 },
    sameWidthAsRef: { type: Boolean, default: !1 },
    width: { default: 0 },
    placement: { default: co.BottomStart },
    closable: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    closeOnOutsideClick: { type: Boolean, default: !0 },
    appendToBody: { type: Boolean, default: !1 },
    closeOnAction: { type: Boolean, default: !0 },
    disableToggle: { type: Boolean, default: !1 },
    displayMobile: { type: Boolean, default: !0 },
    mobileFullScreen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: !1 },
    noShift: { type: Boolean, default: !1 },
    header: { default: "" }
  },
  emits: ["click", "update:open", "select", "hide", "scroll-start", "scroll-end", "key-enter", "key-down", "key-up", "key-esc"],
  setup(t, { emit: e }) {
    const o = t, n = e, { isXSmallScreenAndDown: r } = gu(), s = I(!1), i = I(), a = I(o.open), { open: c } = Ke(o), u = z(() => o.width ? { width: `${o.width}px` } : void 0), f = z(() => o.displayMobile && r.value);
    Je(c, (x) => {
      a.value = x;
    });
    const p = () => {
      if (!o.disabled) {
        if (o.disableToggle) {
          B(!0);
          return;
        }
        B(!a.value);
      }
    }, v = (x) => {
      o.disableToggle || o.disabled || (a.value ? n("select", x) : n("key-enter", x));
    }, m = (x) => {
      o.disabled || (a.value && n("key-down", x), B(a.value));
    }, g = (x) => {
      o.disabled || (a.value && n("key-up", x), B(!0));
    }, w = (x) => {
      o.disabled || (B(!1), n("key-esc", x));
    }, y = () => {
      o.disabled || (o.closeOnAction && B(!1), n("select"));
    }, M = () => {
      o.closeOnOutsideClick && (B(!1), n("hide"));
    }, B = (x) => {
      o.disabled || (a.value = x, n("update:open", x));
    }, k = () => {
      s.value || n("scroll-start"), clearTimeout(i.value), s.value = !0, i.value = setTimeout(() => {
        n("scroll-end"), s.value = !1;
      }, 100);
    };
    return (x, b) => se((d(), h("div", {
      class: S([{ open: a.value }])
    }, [
      $(Zo, {
        show: a.value,
        placement: x.placement,
        "main-axis-offset": x.mainAxisOffset,
        "cross-axis-offset": x.crossAxisOffset,
        "same-width-as-ref": x.sameWidthAsRef,
        "append-to-body": x.appendToBody,
        "no-shift": x.noShift
      }, {
        reference: O(() => [
          l("div", {
            class: "dropdown-button",
            onClick: _e(p, ["stop", "prevent"]),
            onKeyup: [
              q(m, ["down"]),
              q(v, ["enter", "space"]),
              q(g, ["up"]),
              q(w, ["esc"])
            ]
          }, [
            C(x.$slots, "trigger", { open: a.value }, void 0, !0)
          ], 32)
        ]),
        default: O(() => [
          f.value ? E("", !0) : (d(), h("div", {
            key: 0,
            class: S(["dropdown-content"]),
            style: re(u.value),
            onClick: _e(y, ["stop"]),
            onScroll: k,
            onKeyup: [
              q(y, ["enter", "space"]),
              q(w, ["esc"])
            ]
          }, [
            C(x.$slots, "content", {}, void 0, !0)
          ], 36))
        ]),
        _: 3
      }, 8, ["show", "placement", "main-axis-offset", "cross-axis-offset", "same-width-as-ref", "append-to-body", "no-shift"]),
      f.value ? (d(), P(_(pu), {
        key: 0,
        modelValue: a.value,
        "onUpdate:modelValue": [
          b[0] || (b[0] = (N) => a.value = N),
          y
        ],
        "set-min-height": x.mobileFullScreen
      }, {
        default: O(() => [
          l("div", {
            class: "dropdown-content-container",
            onClick: _e(y, ["stop"]),
            onKeyup: [
              q(y, ["enter", "space"]),
              q(w, ["esc"])
            ]
          }, [
            C(x.$slots, "content", {}, void 0, !0)
          ], 32)
        ]),
        _: 3
      }, 8, ["modelValue", "set-min-height"])) : E("", !0)
    ], 2)), [
      [_(io), M]
    ]);
  }
}), os = /* @__PURE__ */ T(Ux, [["__scopeId", "data-v-f3eeac59"]]), Zx = ["disabled"], Gx = /* @__PURE__ */ A({
  __name: "FriedColorPickerInput",
  props: {
    modelValue: { default: "#FFFFFF" },
    errorMessage: { default: "" },
    label: { default: "" },
    disableAlpha: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    Mi((u) => ({
      "3aeb87b9": u.modelValue
    }));
    const o = t, n = e, r = /^#[0-9A-Fa-f]{6}$/, s = /^#[0-9A-Fa-f]{8}$/, i = (u) => (o.disableAlpha ? r : s).test(u), a = I(!1), c = (u) => {
      a.value = !i(u), !a.value && n("update:modelValue", u);
    };
    return (u, f) => (d(), P(os, {
      "close-on-action": !1,
      "main-axis-offset": 8,
      "mobile-full-screen": !0,
      disabled: u.disabled,
      placement: "bottom-end"
    }, {
      trigger: O(() => [
        $(_(Wn), {
          "model-value": u.modelValue,
          active: !0,
          label: u.label,
          error: a.value,
          "error-message": a.value && u.errorMessage ? u.errorMessage : "",
          "max-length": u.disableAlpha ? 7 : 9,
          pattern: u.disableAlpha ? `${r}` : `${s}`,
          disabled: u.disabled,
          "onUpdate:modelValue": f[0] || (f[0] = (p) => c(p))
        }, {
          append: O(() => [
            l("button", {
              class: S(["color-button", { disabled: u.disabled }]),
              disabled: u.disabled
            }, null, 10, Zx)
          ]),
          _: 1
        }, 8, ["model-value", "label", "error", "error-message", "max-length", "pattern", "disabled"])
      ]),
      content: O(() => [
        $(su, {
          class: "color-picker",
          "model-value": u.modelValue,
          "disable-alpha": u.disableAlpha,
          "onUpdate:modelValue": f[1] || (f[1] = (p) => c(p))
        }, null, 8, ["model-value", "disable-alpha"])
      ]),
      _: 1
    }, 8, ["disabled"]));
  }
}), Yx = /* @__PURE__ */ T(Gx, [["__scopeId", "data-v-f88b3079"]]), No = Y2({
  locale: "",
  zone: void 0,
  modalTeleportTo: void 0
});
class Wt extends Error {
}
class Xx extends Wt {
  constructor(e) {
    super(`Invalid DateTime: ${e.toMessage()}`);
  }
}
class Kx extends Wt {
  constructor(e) {
    super(`Invalid Interval: ${e.toMessage()}`);
  }
}
class Jx extends Wt {
  constructor(e) {
    super(`Invalid Duration: ${e.toMessage()}`);
  }
}
class xo extends Wt {
}
class _u extends Wt {
  constructor(e) {
    super(`Invalid unit ${e}`);
  }
}
class Pe extends Wt {
}
class pt extends Wt {
  constructor() {
    super("Zone is an abstract class");
  }
}
const H = "numeric", Xe = "short", je = "long", Er = {
  year: H,
  month: H,
  day: H
}, wu = {
  year: H,
  month: Xe,
  day: H
}, Qx = {
  year: H,
  month: Xe,
  day: H,
  weekday: Xe
}, bu = {
  year: H,
  month: je,
  day: H
}, ku = {
  year: H,
  month: je,
  day: H,
  weekday: je
}, yu = {
  hour: H,
  minute: H
}, xu = {
  hour: H,
  minute: H,
  second: H
}, Cu = {
  hour: H,
  minute: H,
  second: H,
  timeZoneName: Xe
}, Mu = {
  hour: H,
  minute: H,
  second: H,
  timeZoneName: je
}, $u = {
  hour: H,
  minute: H,
  hourCycle: "h23"
}, Su = {
  hour: H,
  minute: H,
  second: H,
  hourCycle: "h23"
}, ju = {
  hour: H,
  minute: H,
  second: H,
  hourCycle: "h23",
  timeZoneName: Xe
}, Ou = {
  hour: H,
  minute: H,
  second: H,
  hourCycle: "h23",
  timeZoneName: je
}, Tu = {
  year: H,
  month: H,
  day: H,
  hour: H,
  minute: H
}, zu = {
  year: H,
  month: H,
  day: H,
  hour: H,
  minute: H,
  second: H
}, Bu = {
  year: H,
  month: Xe,
  day: H,
  hour: H,
  minute: H
}, Eu = {
  year: H,
  month: Xe,
  day: H,
  hour: H,
  minute: H,
  second: H
}, eC = {
  year: H,
  month: Xe,
  day: H,
  weekday: Xe,
  hour: H,
  minute: H
}, Pu = {
  year: H,
  month: je,
  day: H,
  hour: H,
  minute: H,
  timeZoneName: Xe
}, Au = {
  year: H,
  month: je,
  day: H,
  hour: H,
  minute: H,
  second: H,
  timeZoneName: Xe
}, Lu = {
  year: H,
  month: je,
  day: H,
  weekday: je,
  hour: H,
  minute: H,
  timeZoneName: je
}, Hu = {
  year: H,
  month: je,
  day: H,
  weekday: je,
  hour: H,
  minute: H,
  second: H,
  timeZoneName: je
};
function Y(t) {
  return typeof t == "undefined";
}
function Nt(t) {
  return typeof t == "number";
}
function Kn(t) {
  return typeof t == "number" && t % 1 === 0;
}
function tC(t) {
  return typeof t == "string";
}
function oC(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function Vu() {
  try {
    return typeof Intl != "undefined" && !!Intl.RelativeTimeFormat;
  } catch (t) {
    return !1;
  }
}
function nC(t) {
  return Array.isArray(t) ? t : [t];
}
function Xs(t, e, o) {
  if (t.length !== 0)
    return t.reduce((n, r) => {
      const s = [e(r), r];
      return n && o(n[0], s[0]) === n[0] ? n : s;
    }, null)[1];
}
function rC(t, e) {
  return e.reduce((o, n) => (o[n] = t[n], o), {});
}
function oo(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function at(t, e, o) {
  return Kn(t) && t >= e && t <= o;
}
function sC(t, e) {
  return t - e * Math.floor(t / e);
}
function pe(t, e = 2) {
  const o = t < 0;
  let n;
  return o ? n = "-" + ("" + -t).padStart(e, "0") : n = ("" + t).padStart(e, "0"), n;
}
function wt(t) {
  if (!(Y(t) || t === null || t === ""))
    return parseInt(t, 10);
}
function Pt(t) {
  if (!(Y(t) || t === null || t === ""))
    return parseFloat(t);
}
function ns(t) {
  if (!(Y(t) || t === null || t === "")) {
    const e = parseFloat("0." + t) * 1e3;
    return Math.floor(e);
  }
}
function rs(t, e, o = !1) {
  const n = Ut(10, e);
  return (o ? Math.trunc : Math.round)(t * n) / n;
}
function Xo(t) {
  return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
}
function Bo(t) {
  return Xo(t) ? 366 : 365;
}
function On(t, e) {
  const o = sC(e - 1, 12) + 1, n = t + (e - o) / 12;
  return o === 2 ? Xo(n) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][o - 1];
}
function ss(t) {
  let e = Date.UTC(
    t.year,
    t.month - 1,
    t.day,
    t.hour,
    t.minute,
    t.second,
    t.millisecond
  );
  return t.year < 100 && t.year >= 0 && (e = new Date(e), e.setUTCFullYear(e.getUTCFullYear() - 1900)), +e;
}
function Tn(t) {
  const e = (t + Math.floor(t / 4) - Math.floor(t / 100) + Math.floor(t / 400)) % 7, o = t - 1, n = (o + Math.floor(o / 4) - Math.floor(o / 100) + Math.floor(o / 400)) % 7;
  return e === 4 || n === 3 ? 53 : 52;
}
function Pr(t) {
  return t > 99 ? t : t > 60 ? 1900 + t : 2e3 + t;
}
function Fu(t, e, o, n = null) {
  const r = new Date(t), s = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  n && (s.timeZone = n);
  const i = j({ timeZoneName: e }, s), a = new Intl.DateTimeFormat(o, i).formatToParts(r).find((c) => c.type.toLowerCase() === "timezonename");
  return a ? a.value : null;
}
function Jn(t, e) {
  let o = parseInt(t, 10);
  Number.isNaN(o) && (o = 0);
  const n = parseInt(e, 10) || 0, r = o < 0 || Object.is(o, -0) ? -n : n;
  return o * 60 + r;
}
function Iu(t) {
  const e = Number(t);
  if (typeof t == "boolean" || t === "" || Number.isNaN(e))
    throw new Pe(`Invalid unit value ${t}`);
  return e;
}
function zn(t, e) {
  const o = {};
  for (const n in t)
    if (oo(t, n)) {
      const r = t[n];
      if (r == null) continue;
      o[e(n)] = Iu(r);
    }
  return o;
}
function Eo(t, e) {
  const o = Math.trunc(Math.abs(t / 60)), n = Math.trunc(Math.abs(t % 60)), r = t >= 0 ? "+" : "-";
  switch (e) {
    case "short":
      return `${r}${pe(o, 2)}:${pe(n, 2)}`;
    case "narrow":
      return `${r}${o}${n > 0 ? `:${n}` : ""}`;
    case "techie":
      return `${r}${pe(o, 2)}${pe(n, 2)}`;
    default:
      throw new RangeError(`Value format ${e} is out of range for property format`);
  }
}
function Qn(t) {
  return rC(t, ["hour", "minute", "second", "millisecond"]);
}
const Du = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/, iC = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Nu = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], aC = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Ru(t) {
  switch (t) {
    case "narrow":
      return [...aC];
    case "short":
      return [...Nu];
    case "long":
      return [...iC];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const qu = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], Wu = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], lC = ["M", "T", "W", "T", "F", "S", "S"];
function Uu(t) {
  switch (t) {
    case "narrow":
      return [...lC];
    case "short":
      return [...Wu];
    case "long":
      return [...qu];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const Zu = ["AM", "PM"], dC = ["Before Christ", "Anno Domini"], uC = ["BC", "AD"], cC = ["B", "A"];
function Gu(t) {
  switch (t) {
    case "narrow":
      return [...cC];
    case "short":
      return [...uC];
    case "long":
      return [...dC];
    default:
      return null;
  }
}
function hC(t) {
  return Zu[t.hour < 12 ? 0 : 1];
}
function fC(t, e) {
  return Uu(e)[t.weekday - 1];
}
function pC(t, e) {
  return Ru(e)[t.month - 1];
}
function mC(t, e) {
  return Gu(e)[t.year < 0 ? 0 : 1];
}
function vC(t, e, o = "always", n = !1) {
  const r = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, s = ["hours", "minutes", "seconds"].indexOf(t) === -1;
  if (o === "auto" && s) {
    const p = t === "days";
    switch (e) {
      case 1:
        return p ? "tomorrow" : `next ${r[t][0]}`;
      case -1:
        return p ? "yesterday" : `last ${r[t][0]}`;
      case 0:
        return p ? "today" : `this ${r[t][0]}`;
    }
  }
  const i = Object.is(e, -0) || e < 0, a = Math.abs(e), c = a === 1, u = r[t], f = n ? c ? u[1] : u[2] || u[1] : c ? r[t][0] : t;
  return i ? `${a} ${f} ago` : `in ${a} ${f}`;
}
function Ks(t, e) {
  let o = "";
  for (const n of t)
    n.literal ? o += n.val : o += e(n.val);
  return o;
}
const gC = {
  D: Er,
  DD: wu,
  DDD: bu,
  DDDD: ku,
  t: yu,
  tt: xu,
  ttt: Cu,
  tttt: Mu,
  T: $u,
  TT: Su,
  TTT: ju,
  TTTT: Ou,
  f: Tu,
  ff: Bu,
  fff: Pu,
  ffff: Lu,
  F: zu,
  FF: Eu,
  FFF: Au,
  FFFF: Hu
};
class Ce {
  static create(e, o = {}) {
    return new Ce(e, o);
  }
  static parseFormat(e) {
    let o = null, n = "", r = !1;
    const s = [];
    for (let i = 0; i < e.length; i++) {
      const a = e.charAt(i);
      a === "'" ? (n.length > 0 && s.push({ literal: r, val: n }), o = null, n = "", r = !r) : r || a === o ? n += a : (n.length > 0 && s.push({ literal: !1, val: n }), n = a, o = a);
    }
    return n.length > 0 && s.push({ literal: r, val: n }), s;
  }
  static macroTokenToFormatOpts(e) {
    return gC[e];
  }
  constructor(e, o) {
    this.opts = o, this.loc = e, this.systemLoc = null;
  }
  formatWithSystemDefault(e, o) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(e, j(j({}, this.opts), o)).format();
  }
  formatDateTime(e, o = {}) {
    return this.loc.dtFormatter(e, j(j({}, this.opts), o)).format();
  }
  formatDateTimeParts(e, o = {}) {
    return this.loc.dtFormatter(e, j(j({}, this.opts), o)).formatToParts();
  }
  resolvedOptions(e, o = {}) {
    return this.loc.dtFormatter(e, j(j({}, this.opts), o)).resolvedOptions();
  }
  num(e, o = 0) {
    if (this.opts.forceSimple)
      return pe(e, o);
    const n = j({}, this.opts);
    return o > 0 && (n.padTo = o), this.loc.numberFormatter(n).format(e);
  }
  formatDateTimeFromString(e, o) {
    const n = this.loc.listingMode() === "en", r = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", s = (m, g) => this.loc.extract(e, m, g), i = (m) => e.isOffsetFixed && e.offset === 0 && m.allowZ ? "Z" : e.isValid ? e.zone.formatOffset(e.ts, m.format) : "", a = () => n ? hC(e) : s({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), c = (m, g) => n ? pC(e, m) : s(g ? { month: m } : { month: m, day: "numeric" }, "month"), u = (m, g) => n ? fC(e, m) : s(
      g ? { weekday: m } : { weekday: m, month: "long", day: "numeric" },
      "weekday"
    ), f = (m) => {
      const g = Ce.macroTokenToFormatOpts(m);
      return g ? this.formatWithSystemDefault(e, g) : m;
    }, p = (m) => n ? mC(e, m) : s({ era: m }, "era"), v = (m) => {
      switch (m) {
        case "S":
          return this.num(e.millisecond);
        case "u":
        case "SSS":
          return this.num(e.millisecond, 3);
        case "s":
          return this.num(e.second);
        case "ss":
          return this.num(e.second, 2);
        case "uu":
          return this.num(Math.floor(e.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(e.millisecond / 100));
        case "m":
          return this.num(e.minute);
        case "mm":
          return this.num(e.minute, 2);
        case "h":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12);
        case "hh":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12, 2);
        case "H":
          return this.num(e.hour);
        case "HH":
          return this.num(e.hour, 2);
        case "Z":
          return i({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return i({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return i({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return e.zone.offsetName(e.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return e.zone.offsetName(e.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return e.zoneName;
        case "a":
          return a();
        case "d":
          return r ? s({ day: "numeric" }, "day") : this.num(e.day);
        case "dd":
          return r ? s({ day: "2-digit" }, "day") : this.num(e.day, 2);
        case "c":
          return this.num(e.weekday);
        case "ccc":
          return u("short", !0);
        case "cccc":
          return u("long", !0);
        case "ccccc":
          return u("narrow", !0);
        case "E":
          return this.num(e.weekday);
        case "EEE":
          return u("short", !1);
        case "EEEE":
          return u("long", !1);
        case "EEEEE":
          return u("narrow", !1);
        case "L":
          return r ? s({ month: "numeric", day: "numeric" }, "month") : this.num(e.month);
        case "LL":
          return r ? s({ month: "2-digit", day: "numeric" }, "month") : this.num(e.month, 2);
        case "LLL":
          return c("short", !0);
        case "LLLL":
          return c("long", !0);
        case "LLLLL":
          return c("narrow", !0);
        case "M":
          return r ? s({ month: "numeric" }, "month") : this.num(e.month);
        case "MM":
          return r ? s({ month: "2-digit" }, "month") : this.num(e.month, 2);
        case "MMM":
          return c("short", !1);
        case "MMMM":
          return c("long", !1);
        case "MMMMM":
          return c("narrow", !1);
        case "y":
          return r ? s({ year: "numeric" }, "year") : this.num(e.year);
        case "yy":
          return r ? s({ year: "2-digit" }, "year") : this.num(e.year.toString().slice(-2), 2);
        case "yyyy":
          return r ? s({ year: "numeric" }, "year") : this.num(e.year, 4);
        case "yyyyyy":
          return r ? s({ year: "numeric" }, "year") : this.num(e.year, 6);
        case "G":
          return p("short");
        case "GG":
          return p("long");
        case "GGGGG":
          return p("narrow");
        case "kk":
          return this.num(e.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(e.weekYear, 4);
        case "W":
          return this.num(e.weekNumber);
        case "WW":
          return this.num(e.weekNumber, 2);
        case "o":
          return this.num(e.ordinal);
        case "ooo":
          return this.num(e.ordinal, 3);
        case "q":
          return this.num(e.quarter);
        case "qq":
          return this.num(e.quarter, 2);
        case "X":
          return this.num(Math.floor(e.ts / 1e3));
        case "x":
          return this.num(e.ts);
        default:
          return f(m);
      }
    };
    return Ks(Ce.parseFormat(o), v);
  }
  formatDurationFromString(e, o) {
    const n = (c) => {
      switch (c[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, r = (c) => (u) => {
      const f = n(u);
      return f ? this.num(c.get(f), u.length) : u;
    }, s = Ce.parseFormat(o), i = s.reduce(
      (c, { literal: u, val: f }) => u ? c : c.concat(f),
      []
    ), a = e.shiftTo(...i.map(n).filter((c) => c));
    return Ks(s, r(a));
  }
}
class Ze {
  constructor(e, o) {
    this.reason = e, this.explanation = o;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
class Ko {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new pt();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new pt();
  }
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new pt();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, o) {
    throw new pt();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, o) {
    throw new pt();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    throw new pt();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    throw new pt();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new pt();
  }
}
let fr = null;
class er extends Ko {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return fr === null && (fr = new er()), fr;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: o, locale: n }) {
    return Fu(e, o, n);
  }
  /** @override **/
  formatOffset(e, o) {
    return Eo(this.offset(e), o);
  }
  /** @override **/
  offset(e) {
    return -new Date(e).getTimezoneOffset();
  }
  /** @override **/
  equals(e) {
    return e.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let mn = {};
function _C(t) {
  return mn[t] || (mn[t] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), mn[t];
}
const wC = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function bC(t, e) {
  const o = t.format(e).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(o), [, r, s, i, a, c, u, f] = n;
  return [i, r, s, a, c, u, f];
}
function kC(t, e) {
  const o = t.formatToParts(e), n = [];
  for (let r = 0; r < o.length; r++) {
    const { type: s, value: i } = o[r], a = wC[s];
    s === "era" ? n[a] = i : Y(a) || (n[a] = parseInt(i, 10));
  }
  return n;
}
let dn = {};
class ct extends Ko {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(e) {
    return dn[e] || (dn[e] = new ct(e)), dn[e];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    dn = {}, mn = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(e) {
    return this.isValidZone(e);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(e) {
    if (!e)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: e }).format(), !0;
    } catch (o) {
      return !1;
    }
  }
  constructor(e) {
    super(), this.zoneName = e, this.valid = ct.isValidZone(e);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: o, locale: n }) {
    return Fu(e, o, n, this.name);
  }
  /** @override **/
  formatOffset(e, o) {
    return Eo(this.offset(e), o);
  }
  /** @override **/
  offset(e) {
    const o = new Date(e);
    if (isNaN(o)) return NaN;
    const n = _C(this.name);
    let [r, s, i, a, c, u, f] = n.formatToParts ? kC(n, o) : bC(n, o);
    a === "BC" && (r = -Math.abs(r) + 1);
    const v = ss({
      year: r,
      month: s,
      day: i,
      hour: c === 24 ? 0 : c,
      minute: u,
      second: f,
      millisecond: 0
    });
    let m = +o;
    const g = m % 1e3;
    return m -= g >= 0 ? g : 1e3 + g, (v - m) / (60 * 1e3);
  }
  /** @override **/
  equals(e) {
    return e.type === "iana" && e.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let pr = null;
class Me extends Ko {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return pr === null && (pr = new Me(0)), pr;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(e) {
    return e === 0 ? Me.utcInstance : new Me(e);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(e) {
    if (e) {
      const o = e.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (o)
        return new Me(Jn(o[1], o[2]));
    }
    return null;
  }
  constructor(e) {
    super(), this.fixed = e;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Eo(this.fixed, "narrow")}`;
  }
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Eo(-this.fixed, "narrow")}`;
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(e, o) {
    return Eo(this.fixed, o);
  }
  /** @override **/
  get isUniversal() {
    return !0;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(e) {
    return e.type === "fixed" && e.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
class yC extends Ko {
  constructor(e) {
    super(), this.zoneName = e;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function bt(t, e) {
  if (Y(t) || t === null)
    return e;
  if (t instanceof Ko)
    return t;
  if (tC(t)) {
    const o = t.toLowerCase();
    return o === "default" ? e : o === "local" || o === "system" ? er.instance : o === "utc" || o === "gmt" ? Me.utcInstance : Me.parseSpecifier(o) || ct.create(t);
  } else return Nt(t) ? Me.instance(t) : typeof t == "object" && t.offset && typeof t.offset == "number" ? t : new yC(t);
}
let Js = () => Date.now(), Qs = "system", ei = null, ti = null, oi = null, ni;
class ge {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return Js;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(e) {
    Js = e;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(e) {
    Qs = e;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return bt(Qs, er.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return ei;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(e) {
    ei = e;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return ti;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(e) {
    ti = e;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return oi;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(e) {
    oi = e;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return ni;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(e) {
    ni = e;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    ae.resetCache(), ct.resetCache();
  }
}
let ri = {};
function xC(t, e = {}) {
  const o = JSON.stringify([t, e]);
  let n = ri[o];
  return n || (n = new Intl.ListFormat(t, e), ri[o] = n), n;
}
let Ar = {};
function Lr(t, e = {}) {
  const o = JSON.stringify([t, e]);
  let n = Ar[o];
  return n || (n = new Intl.DateTimeFormat(t, e), Ar[o] = n), n;
}
let Hr = {};
function CC(t, e = {}) {
  const o = JSON.stringify([t, e]);
  let n = Hr[o];
  return n || (n = new Intl.NumberFormat(t, e), Hr[o] = n), n;
}
let Vr = {};
function MC(t, e = {}) {
  const i = e, { base: o } = i, n = Be(i, ["base"]), r = JSON.stringify([t, n]);
  let s = Vr[r];
  return s || (s = new Intl.RelativeTimeFormat(t, e), Vr[r] = s), s;
}
let Co = null;
function $C() {
  return Co || (Co = new Intl.DateTimeFormat().resolvedOptions().locale, Co);
}
function SC(t) {
  const e = t.indexOf("-u-");
  if (e === -1)
    return [t];
  {
    let o;
    const n = t.substring(0, e);
    try {
      o = Lr(t).resolvedOptions();
    } catch (i) {
      o = Lr(n).resolvedOptions();
    }
    const { numberingSystem: r, calendar: s } = o;
    return [n, r, s];
  }
}
function jC(t, e, o) {
  return (o || e) && (t += "-u", o && (t += `-ca-${o}`), e && (t += `-nu-${e}`)), t;
}
function OC(t) {
  const e = [];
  for (let o = 1; o <= 12; o++) {
    const n = D.utc(2016, o, 1);
    e.push(t(n));
  }
  return e;
}
function TC(t) {
  const e = [];
  for (let o = 1; o <= 7; o++) {
    const n = D.utc(2016, 11, 13 + o);
    e.push(t(n));
  }
  return e;
}
function un(t, e, o, n, r) {
  const s = t.listingMode(o);
  return s === "error" ? null : s === "en" ? n(e) : r(e);
}
function zC(t) {
  return t.numberingSystem && t.numberingSystem !== "latn" ? !1 : t.numberingSystem === "latn" || !t.locale || t.locale.startsWith("en") || new Intl.DateTimeFormat(t.intl).resolvedOptions().numberingSystem === "latn";
}
class BC {
  constructor(e, o, n) {
    this.padTo = n.padTo || 0, this.floor = n.floor || !1;
    const a = n, { padTo: r, floor: s } = a, i = Be(a, ["padTo", "floor"]);
    if (!o || Object.keys(i).length > 0) {
      const c = j({ useGrouping: !1 }, n);
      n.padTo > 0 && (c.minimumIntegerDigits = n.padTo), this.inf = CC(e, c);
    }
  }
  format(e) {
    if (this.inf) {
      const o = this.floor ? Math.floor(e) : e;
      return this.inf.format(o);
    } else {
      const o = this.floor ? Math.floor(e) : rs(e, 3);
      return pe(o, this.padTo);
    }
  }
}
class EC {
  constructor(e, o, n) {
    this.opts = n;
    let r;
    if (e.zone.isUniversal) {
      const i = -1 * (e.offset / 60), a = i >= 0 ? `Etc/GMT+${i}` : `Etc/GMT${i}`;
      e.offset !== 0 && ct.create(a).valid ? (r = a, this.dt = e) : (r = "UTC", n.timeZoneName ? this.dt = e : this.dt = e.offset === 0 ? e : D.fromMillis(e.ts + e.offset * 60 * 1e3));
    } else e.zone.type === "system" ? this.dt = e : (this.dt = e, r = e.zone.name);
    const s = j({}, this.opts);
    r && (s.timeZone = r), this.dtf = Lr(o, s);
  }
  format() {
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    return this.dtf.formatToParts(this.dt.toJSDate());
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class PC {
  constructor(e, o, n) {
    this.opts = j({ style: "long" }, n), !o && Vu() && (this.rtf = MC(e, n));
  }
  format(e, o) {
    return this.rtf ? this.rtf.format(e, o) : vC(o, e, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(e, o) {
    return this.rtf ? this.rtf.formatToParts(e, o) : [];
  }
}
class ae {
  static fromOpts(e) {
    return ae.create(e.locale, e.numberingSystem, e.outputCalendar, e.defaultToEN);
  }
  static create(e, o, n, r = !1) {
    const s = e || ge.defaultLocale, i = s || (r ? "en-US" : $C()), a = o || ge.defaultNumberingSystem, c = n || ge.defaultOutputCalendar;
    return new ae(i, a, c, s);
  }
  static resetCache() {
    Co = null, Ar = {}, Hr = {}, Vr = {};
  }
  static fromObject({ locale: e, numberingSystem: o, outputCalendar: n } = {}) {
    return ae.create(e, o, n);
  }
  constructor(e, o, n, r) {
    const [s, i, a] = SC(e);
    this.locale = s, this.numberingSystem = o || i || null, this.outputCalendar = n || a || null, this.intl = jC(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = r, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = zC(this)), this.fastNumbersCached;
  }
  listingMode() {
    const e = this.isEnglish(), o = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return e && o ? "en" : "intl";
  }
  clone(e) {
    return !e || Object.getOwnPropertyNames(e).length === 0 ? this : ae.create(
      e.locale || this.specifiedLocale,
      e.numberingSystem || this.numberingSystem,
      e.outputCalendar || this.outputCalendar,
      e.defaultToEN || !1
    );
  }
  redefaultToEN(e = {}) {
    return this.clone(R(j({}, e), { defaultToEN: !0 }));
  }
  redefaultToSystem(e = {}) {
    return this.clone(R(j({}, e), { defaultToEN: !1 }));
  }
  months(e, o = !1, n = !0) {
    return un(this, e, n, Ru, () => {
      const r = o ? { month: e, day: "numeric" } : { month: e }, s = o ? "format" : "standalone";
      return this.monthsCache[s][e] || (this.monthsCache[s][e] = OC((i) => this.extract(i, r, "month"))), this.monthsCache[s][e];
    });
  }
  weekdays(e, o = !1, n = !0) {
    return un(this, e, n, Uu, () => {
      const r = o ? { weekday: e, year: "numeric", month: "long", day: "numeric" } : { weekday: e }, s = o ? "format" : "standalone";
      return this.weekdaysCache[s][e] || (this.weekdaysCache[s][e] = TC(
        (i) => this.extract(i, r, "weekday")
      )), this.weekdaysCache[s][e];
    });
  }
  meridiems(e = !0) {
    return un(
      this,
      void 0,
      e,
      () => Zu,
      () => {
        if (!this.meridiemCache) {
          const o = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [D.utc(2016, 11, 13, 9), D.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, o, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(e, o = !0) {
    return un(this, e, o, Gu, () => {
      const n = { era: e };
      return this.eraCache[e] || (this.eraCache[e] = [D.utc(-40, 1, 1), D.utc(2017, 1, 1)].map(
        (r) => this.extract(r, n, "era")
      )), this.eraCache[e];
    });
  }
  extract(e, o, n) {
    const r = this.dtFormatter(e, o), s = r.formatToParts(), i = s.find((a) => a.type.toLowerCase() === n);
    return i ? i.value : null;
  }
  numberFormatter(e = {}) {
    return new BC(this.intl, e.forceSimple || this.fastNumbers, e);
  }
  dtFormatter(e, o = {}) {
    return new EC(e, this.intl, o);
  }
  relFormatter(e = {}) {
    return new PC(this.intl, this.isEnglish(), e);
  }
  listFormatter(e = {}) {
    return xC(this.intl, e);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  equals(e) {
    return this.locale === e.locale && this.numberingSystem === e.numberingSystem && this.outputCalendar === e.outputCalendar;
  }
}
function fo(...t) {
  const e = t.reduce((o, n) => o + n.source, "");
  return RegExp(`^${e}$`);
}
function po(...t) {
  return (e) => t.reduce(
    ([o, n, r], s) => {
      const [i, a, c] = s(e, r);
      return [j(j({}, o), i), a || n, c];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function mo(t, ...e) {
  if (t == null)
    return [null, null];
  for (const [o, n] of e) {
    const r = o.exec(t);
    if (r)
      return n(r);
  }
  return [null, null];
}
function Yu(...t) {
  return (e, o) => {
    const n = {};
    let r;
    for (r = 0; r < t.length; r++)
      n[t[r]] = wt(e[o + r]);
    return [n, null, o + r];
  };
}
const Xu = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, AC = `(?:${Xu.source}?(?:\\[(${Du.source})\\])?)?`, is = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Ku = RegExp(`${is.source}${AC}`), as = RegExp(`(?:T${Ku.source})?`), LC = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, HC = /(\d{4})-?W(\d\d)(?:-?(\d))?/, VC = /(\d{4})-?(\d{3})/, FC = Yu("weekYear", "weekNumber", "weekDay"), IC = Yu("year", "ordinal"), DC = /(\d{4})-(\d\d)-(\d\d)/, Ju = RegExp(
  `${is.source} ?(?:${Xu.source}|(${Du.source}))?`
), NC = RegExp(`(?: ${Ju.source})?`);
function Qt(t, e, o) {
  const n = t[e];
  return Y(n) ? o : wt(n);
}
function RC(t, e) {
  return [{
    year: Qt(t, e),
    month: Qt(t, e + 1, 1),
    day: Qt(t, e + 2, 1)
  }, null, e + 3];
}
function vo(t, e) {
  return [{
    hours: Qt(t, e, 0),
    minutes: Qt(t, e + 1, 0),
    seconds: Qt(t, e + 2, 0),
    milliseconds: ns(t[e + 3])
  }, null, e + 4];
}
function Jo(t, e) {
  const o = !t[e] && !t[e + 1], n = Jn(t[e + 1], t[e + 2]), r = o ? null : Me.instance(n);
  return [{}, r, e + 3];
}
function Qo(t, e) {
  const o = t[e] ? ct.create(t[e]) : null;
  return [{}, o, e + 1];
}
const qC = RegExp(`^T?${is.source}$`), WC = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function UC(t) {
  const [e, o, n, r, s, i, a, c, u] = t, f = e[0] === "-", p = c && c[0] === "-", v = (m, g = !1) => m !== void 0 && (g || m && f) ? -m : m;
  return [
    {
      years: v(Pt(o)),
      months: v(Pt(n)),
      weeks: v(Pt(r)),
      days: v(Pt(s)),
      hours: v(Pt(i)),
      minutes: v(Pt(a)),
      seconds: v(Pt(c), c === "-0"),
      milliseconds: v(ns(u), p)
    }
  ];
}
const ZC = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function ls(t, e, o, n, r, s, i) {
  const a = {
    year: e.length === 2 ? Pr(wt(e)) : wt(e),
    month: Nu.indexOf(o) + 1,
    day: wt(n),
    hour: wt(r),
    minute: wt(s)
  };
  return i && (a.second = wt(i)), t && (a.weekday = t.length > 3 ? qu.indexOf(t) + 1 : Wu.indexOf(t) + 1), a;
}
const GC = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function YC(t) {
  const [
    ,
    e,
    o,
    n,
    r,
    s,
    i,
    a,
    c,
    u,
    f,
    p
  ] = t, v = ls(e, r, n, o, s, i, a);
  let m;
  return c ? m = ZC[c] : u ? m = 0 : m = Jn(f, p), [v, new Me(m)];
}
function XC(t) {
  return t.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const KC = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, JC = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, QC = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function si(t) {
  const [, e, o, n, r, s, i, a] = t;
  return [ls(e, r, n, o, s, i, a), Me.utcInstance];
}
function eM(t) {
  const [, e, o, n, r, s, i, a] = t;
  return [ls(e, a, o, n, r, s, i), Me.utcInstance];
}
const tM = fo(LC, as), oM = fo(HC, as), nM = fo(VC, as), rM = fo(Ku), Qu = po(
  RC,
  vo,
  Jo,
  Qo
), sM = po(
  FC,
  vo,
  Jo,
  Qo
), iM = po(
  IC,
  vo,
  Jo,
  Qo
), aM = po(
  vo,
  Jo,
  Qo
);
function lM(t) {
  return mo(
    t,
    [tM, Qu],
    [oM, sM],
    [nM, iM],
    [rM, aM]
  );
}
function dM(t) {
  return mo(XC(t), [GC, YC]);
}
function uM(t) {
  return mo(
    t,
    [KC, si],
    [JC, si],
    [QC, eM]
  );
}
function cM(t) {
  return mo(t, [WC, UC]);
}
const hM = po(vo);
function fM(t) {
  return mo(t, [qC, hM]);
}
const pM = fo(DC, NC), mM = fo(Ju), vM = po(
  vo,
  Jo,
  Qo
);
function gM(t) {
  return mo(
    t,
    [pM, Qu],
    [mM, vM]
  );
}
const _M = "Invalid Duration", e2 = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, wM = j({
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  }
}, e2), Ee = 146097 / 400, Zt = 146097 / 4800, bM = j({
  years: {
    quarters: 4,
    months: 12,
    weeks: Ee / 7,
    days: Ee,
    hours: Ee * 24,
    minutes: Ee * 24 * 60,
    seconds: Ee * 24 * 60 * 60,
    milliseconds: Ee * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: Ee / 28,
    days: Ee / 4,
    hours: Ee * 24 / 4,
    minutes: Ee * 24 * 60 / 4,
    seconds: Ee * 24 * 60 * 60 / 4,
    milliseconds: Ee * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: Zt / 7,
    days: Zt,
    hours: Zt * 24,
    minutes: Zt * 24 * 60,
    seconds: Zt * 24 * 60 * 60,
    milliseconds: Zt * 24 * 60 * 60 * 1e3
  }
}, e2), Vt = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], kM = Vt.slice(0).reverse();
function At(t, e, o = !1) {
  const n = {
    values: o ? e.values : j(j({}, t.values), e.values || {}),
    loc: t.loc.clone(e.loc),
    conversionAccuracy: e.conversionAccuracy || t.conversionAccuracy,
    matrix: e.matrix || t.matrix
  };
  return new X(n);
}
function yM(t) {
  return t < 0 ? Math.floor(t) : Math.ceil(t);
}
function t2(t, e, o, n, r) {
  const s = t[r][o], i = e[o] / s, a = Math.sign(i) === Math.sign(n[r]), c = !a && n[r] !== 0 && Math.abs(i) <= 1 ? yM(i) : Math.trunc(i);
  n[r] += c, e[o] -= c * s;
}
function xM(t, e) {
  kM.reduce((o, n) => Y(e[n]) ? o : (o && t2(t, e, o, e, n), n), null);
}
class X {
  /**
   * @private
   */
  constructor(e) {
    const o = e.conversionAccuracy === "longterm" || !1;
    let n = o ? bM : wM;
    e.matrix && (n = e.matrix), this.values = e.values, this.loc = e.loc || ae.create(), this.conversionAccuracy = o ? "longterm" : "casual", this.invalid = e.invalid || null, this.matrix = n, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(e, o) {
    return X.fromObject({ milliseconds: e }, o);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(e, o = {}) {
    if (e == null || typeof e != "object")
      throw new Pe(
        `Duration.fromObject: argument expected to be an object, got ${e === null ? "null" : typeof e}`
      );
    return new X({
      values: zn(e, X.normalizeUnit),
      loc: ae.fromObject(o),
      conversionAccuracy: o.conversionAccuracy,
      matrix: o.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(e) {
    if (Nt(e))
      return X.fromMillis(e);
    if (X.isDuration(e))
      return e;
    if (typeof e == "object")
      return X.fromObject(e);
    throw new Pe(
      `Unknown duration argument ${e} of type ${typeof e}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(e, o) {
    const [n] = cM(e);
    return n ? X.fromObject(n, o) : X.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(e, o) {
    const [n] = fM(e);
    return n ? X.fromObject(n, o) : X.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(e, o = null) {
    if (!e)
      throw new Pe("need to specify a reason the Duration is invalid");
    const n = e instanceof Ze ? e : new Ze(e, o);
    if (ge.throwOnInvalid)
      throw new Jx(n);
    return new X({ invalid: n });
  }
  /**
   * @private
   */
  static normalizeUnit(e) {
    const o = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[e && e.toLowerCase()];
    if (!o) throw new _u(e);
    return o;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(e) {
    return e && e.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(e, o = {}) {
    const n = R(j({}, o), {
      floor: o.round !== !1 && o.floor !== !1
    });
    return this.isValid ? Ce.create(this.loc, n).formatDurationFromString(this, e) : _M;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(e = {}) {
    const o = Vt.map((n) => {
      const r = this.values[n];
      return Y(r) ? null : this.loc.numberFormatter(R(j({ style: "unit", unitDisplay: "long" }, e), { unit: n.slice(0, -1) })).format(r);
    }).filter((n) => n);
    return this.loc.listFormatter(j({ type: "conjunction", style: e.listStyle || "narrow" }, e)).format(o);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? j({}, this.values) : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let e = "P";
    return this.years !== 0 && (e += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (e += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (e += this.weeks + "W"), this.days !== 0 && (e += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (e += "T"), this.hours !== 0 && (e += this.hours + "H"), this.minutes !== 0 && (e += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (e += rs(this.seconds + this.milliseconds / 1e3, 3) + "S"), e === "P" && (e += "T0S"), e;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(e = {}) {
    if (!this.isValid) return null;
    const o = this.toMillis();
    if (o < 0 || o >= 864e5) return null;
    e = j({
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended"
    }, e);
    const n = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
    let r = e.format === "basic" ? "hhmm" : "hh:mm";
    (!e.suppressSeconds || n.seconds !== 0 || n.milliseconds !== 0) && (r += e.format === "basic" ? "ss" : ":ss", (!e.suppressMilliseconds || n.milliseconds !== 0) && (r += ".SSS"));
    let s = n.toFormat(r);
    return e.includePrefix && (s = "T" + s), s;
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.as("milliseconds");
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(e) {
    if (!this.isValid) return this;
    const o = X.fromDurationLike(e), n = {};
    for (const r of Vt)
      (oo(o.values, r) || oo(this.values, r)) && (n[r] = o.get(r) + this.get(r));
    return At(this, { values: n }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(e) {
    if (!this.isValid) return this;
    const o = X.fromDurationLike(e);
    return this.plus(o.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(e) {
    if (!this.isValid) return this;
    const o = {};
    for (const n of Object.keys(this.values))
      o[n] = Iu(e(this.values[n], n));
    return At(this, { values: o }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(e) {
    return this[X.normalizeUnit(e)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(e) {
    if (!this.isValid) return this;
    const o = j(j({}, this.values), zn(e, X.normalizeUnit));
    return At(this, { values: o });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: e, numberingSystem: o, conversionAccuracy: n, matrix: r } = {}) {
    const i = { loc: this.loc.clone({ locale: e, numberingSystem: o }), matrix: r, conversionAccuracy: n };
    return At(this, i);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(e) {
    return this.isValid ? this.shiftTo(e).get(e) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const e = this.toObject();
    return xM(this.matrix, e), At(this, { values: e }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...e) {
    if (!this.isValid) return this;
    if (e.length === 0)
      return this;
    e = e.map((i) => X.normalizeUnit(i));
    const o = {}, n = {}, r = this.toObject();
    let s;
    for (const i of Vt)
      if (e.indexOf(i) >= 0) {
        s = i;
        let a = 0;
        for (const u in n)
          a += this.matrix[u][i] * n[u], n[u] = 0;
        Nt(r[i]) && (a += r[i]);
        const c = Math.trunc(a);
        o[i] = c, n[i] = (a * 1e3 - c * 1e3) / 1e3;
        for (const u in r)
          Vt.indexOf(u) > Vt.indexOf(i) && t2(this.matrix, r, u, o, i);
      } else Nt(r[i]) && (n[i] = r[i]);
    for (const i in n)
      n[i] !== 0 && (o[s] += i === s ? n[i] : n[i] / this.matrix[s][i]);
    return At(this, { values: o }, !0).normalize();
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const e = {};
    for (const o of Object.keys(this.values))
      e[o] = this.values[o] === 0 ? 0 : -this.values[o];
    return At(this, { values: e }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(e) {
    if (!this.isValid || !e.isValid || !this.loc.equals(e.loc))
      return !1;
    function o(n, r) {
      return n === void 0 || n === 0 ? r === void 0 || r === 0 : n === r;
    }
    for (const n of Vt)
      if (!o(this.values[n], e.values[n]))
        return !1;
    return !0;
  }
}
const go = "Invalid Interval";
function CM(t, e) {
  return !t || !t.isValid ? ue.invalid("missing or invalid start") : !e || !e.isValid ? ue.invalid("missing or invalid end") : e < t ? ue.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${t.toISO()} and end=${e.toISO()}`
  ) : null;
}
class ue {
  /**
   * @private
   */
  constructor(e) {
    this.s = e.start, this.e = e.end, this.invalid = e.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(e, o = null) {
    if (!e)
      throw new Pe("need to specify a reason the Interval is invalid");
    const n = e instanceof Ze ? e : new Ze(e, o);
    if (ge.throwOnInvalid)
      throw new Kx(n);
    return new ue({ invalid: n });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(e, o) {
    const n = bo(e), r = bo(o), s = CM(n, r);
    return s == null ? new ue({
      start: n,
      end: r
    }) : s;
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(e, o) {
    const n = X.fromDurationLike(o), r = bo(e);
    return ue.fromDateTimes(r, r.plus(n));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(e, o) {
    const n = X.fromDurationLike(o), r = bo(e);
    return ue.fromDateTimes(r.minus(n), r);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(e, o) {
    const [n, r] = (e || "").split("/", 2);
    if (n && r) {
      let s, i;
      try {
        s = D.fromISO(n, o), i = s.isValid;
      } catch (u) {
        i = !1;
      }
      let a, c;
      try {
        a = D.fromISO(r, o), c = a.isValid;
      } catch (u) {
        c = !1;
      }
      if (i && c)
        return ue.fromDateTimes(s, a);
      if (i) {
        const u = X.fromISO(r, o);
        if (u.isValid)
          return ue.after(s, u);
      } else if (c) {
        const u = X.fromISO(n, o);
        if (u.isValid)
          return ue.before(a, u);
      }
    }
    return ue.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(e) {
    return e && e.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(e = "milliseconds") {
    return this.isValid ? this.toDuration(e).get(e) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  count(e = "milliseconds") {
    if (!this.isValid) return NaN;
    const o = this.start.startOf(e), n = this.end.startOf(e);
    return Math.floor(n.diff(o, e).get(e)) + 1;
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(e) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, e) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(e) {
    return this.isValid ? this.s > e : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(e) {
    return this.isValid ? this.e <= e : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(e) {
    return this.isValid ? this.s <= e && this.e > e : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: e, end: o } = {}) {
    return this.isValid ? ue.fromDateTimes(e || this.s, o || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...e) {
    if (!this.isValid) return [];
    const o = e.map(bo).filter((i) => this.contains(i)).sort(), n = [];
    let { s: r } = this, s = 0;
    for (; r < this.e; ) {
      const i = o[s] || this.e, a = +i > +this.e ? this.e : i;
      n.push(ue.fromDateTimes(r, a)), r = a, s += 1;
    }
    return n;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(e) {
    const o = X.fromDurationLike(e);
    if (!this.isValid || !o.isValid || o.as("milliseconds") === 0)
      return [];
    let { s: n } = this, r = 1, s;
    const i = [];
    for (; n < this.e; ) {
      const a = this.start.plus(o.mapUnits((c) => c * r));
      s = +a > +this.e ? this.e : a, i.push(ue.fromDateTimes(n, s)), n = s, r += 1;
    }
    return i;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(e) {
    return this.isValid ? this.splitBy(this.length() / e).slice(0, e) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(e) {
    return this.e > e.s && this.s < e.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(e) {
    return this.isValid ? +this.e == +e.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(e) {
    return this.isValid ? +e.e == +this.s : !1;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(e) {
    return this.isValid ? this.s <= e.s && this.e >= e.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(e) {
    return !this.isValid || !e.isValid ? !1 : this.s.equals(e.s) && this.e.equals(e.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(e) {
    if (!this.isValid) return this;
    const o = this.s > e.s ? this.s : e.s, n = this.e < e.e ? this.e : e.e;
    return o >= n ? null : ue.fromDateTimes(o, n);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(e) {
    if (!this.isValid) return this;
    const o = this.s < e.s ? this.s : e.s, n = this.e > e.e ? this.e : e.e;
    return ue.fromDateTimes(o, n);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(e) {
    const [o, n] = e.sort((r, s) => r.s - s.s).reduce(
      ([r, s], i) => s ? s.overlaps(i) || s.abutsStart(i) ? [r, s.union(i)] : [r.concat([s]), i] : [r, i],
      [[], null]
    );
    return n && o.push(n), o;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(e) {
    let o = null, n = 0;
    const r = [], s = e.map((c) => [
      { time: c.s, type: "s" },
      { time: c.e, type: "e" }
    ]), i = Array.prototype.concat(...s), a = i.sort((c, u) => c.time - u.time);
    for (const c of a)
      n += c.type === "s" ? 1 : -1, n === 1 ? o = c.time : (o && +o != +c.time && r.push(ue.fromDateTimes(o, c.time)), o = null);
    return ue.merge(r);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...e) {
    return ue.xor([this].concat(e)).map((o) => this.intersection(o)).filter((o) => o && !o.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : go;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(e) {
    return this.isValid ? `${this.s.toISO(e)}/${this.e.toISO(e)}` : go;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : go;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(e) {
    return this.isValid ? `${this.s.toISOTime(e)}/${this.e.toISOTime(e)}` : go;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format string.
   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime#toFormat} for details.
   * @param {Object} opts - options
   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
   * @return {string}
   */
  toFormat(e, { separator: o = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(e)}${o}${this.e.toFormat(e)}` : go;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(e, o) {
    return this.isValid ? this.e.diff(this.s, e, o) : X.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(e) {
    return ue.fromDateTimes(e(this.s), e(this.e));
  }
}
class Ct {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(e = ge.defaultZone) {
    const o = D.now().setZone(e).set({ month: 12 });
    return !e.isUniversal && o.offset !== o.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(e) {
    return ct.isValidZone(e);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(e) {
    return bt(e, ge.defaultZone);
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(e = "long", { locale: o = null, numberingSystem: n = null, locObj: r = null, outputCalendar: s = "gregory" } = {}) {
    return (r || ae.create(o, n, s)).months(e);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(e = "long", { locale: o = null, numberingSystem: n = null, locObj: r = null, outputCalendar: s = "gregory" } = {}) {
    return (r || ae.create(o, n, s)).months(e, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(e = "long", { locale: o = null, numberingSystem: n = null, locObj: r = null } = {}) {
    return (r || ae.create(o, n, null)).weekdays(e);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(e = "long", { locale: o = null, numberingSystem: n = null, locObj: r = null } = {}) {
    return (r || ae.create(o, n, null)).weekdays(e, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: e = null } = {}) {
    return ae.create(e).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(e = "short", { locale: o = null } = {}) {
    return ae.create(o, null, "gregory").eras(e);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */
  static features() {
    return { relative: Vu() };
  }
}
function ii(t, e) {
  const o = (r) => r.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), n = o(e) - o(t);
  return Math.floor(X.fromMillis(n).as("days"));
}
function MM(t, e, o) {
  const n = [
    ["years", (a, c) => c.year - a.year],
    ["quarters", (a, c) => c.quarter - a.quarter + (c.year - a.year) * 4],
    ["months", (a, c) => c.month - a.month + (c.year - a.year) * 12],
    [
      "weeks",
      (a, c) => {
        const u = ii(a, c);
        return (u - u % 7) / 7;
      }
    ],
    ["days", ii]
  ], r = {};
  let s, i;
  for (const [a, c] of n)
    if (o.indexOf(a) >= 0) {
      s = a;
      let u = c(t, e);
      i = t.plus({ [a]: u }), i > e ? (t = t.plus({ [a]: u - 1 }), u -= 1) : t = i, r[a] = u;
    }
  return [t, r, i, s];
}
function $M(t, e, o, n) {
  let [r, s, i, a] = MM(t, e, o);
  const c = e - r, u = o.filter(
    (p) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(p) >= 0
  );
  u.length === 0 && (i < e && (i = r.plus({ [a]: 1 })), i !== r && (s[a] = (s[a] || 0) + c / (i - r)));
  const f = X.fromObject(s, n);
  return u.length > 0 ? X.fromMillis(c, n).shiftTo(...u).plus(f) : f;
}
const ds = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, ai = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, SM = ds.hanidec.replace(/[\[|\]]/g, "").split("");
function jM(t) {
  let e = parseInt(t, 10);
  if (isNaN(e)) {
    e = "";
    for (let o = 0; o < t.length; o++) {
      const n = t.charCodeAt(o);
      if (t[o].search(ds.hanidec) !== -1)
        e += SM.indexOf(t[o]);
      else
        for (const r in ai) {
          const [s, i] = ai[r];
          n >= s && n <= i && (e += n - s);
        }
    }
    return parseInt(e, 10);
  } else
    return e;
}
function De({ numberingSystem: t }, e = "") {
  return new RegExp(`${ds[t || "latn"]}${e}`);
}
const OM = "missing Intl.DateTimeFormat.formatToParts support";
function ee(t, e = (o) => o) {
  return { regex: t, deser: ([o]) => e(jM(o)) };
}
const TM = " ", o2 = `[ ${TM}]`, n2 = new RegExp(o2, "g");
function zM(t) {
  return t.replace(/\./g, "\\.?").replace(n2, o2);
}
function li(t) {
  return t.replace(/\./g, "").replace(n2, " ").toLowerCase();
}
function Ne(t, e) {
  return t === null ? null : {
    regex: RegExp(t.map(zM).join("|")),
    deser: ([o]) => t.findIndex((n) => li(o) === li(n)) + e
  };
}
function di(t, e) {
  return { regex: t, deser: ([, o, n]) => Jn(o, n), groups: e };
}
function mr(t) {
  return { regex: t, deser: ([e]) => e };
}
function BM(t) {
  return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function EM(t, e) {
  const o = De(e), n = De(e, "{2}"), r = De(e, "{3}"), s = De(e, "{4}"), i = De(e, "{6}"), a = De(e, "{1,2}"), c = De(e, "{1,3}"), u = De(e, "{1,6}"), f = De(e, "{1,9}"), p = De(e, "{2,4}"), v = De(e, "{4,6}"), m = (y) => ({ regex: RegExp(BM(y.val)), deser: ([M]) => M, literal: !0 }), w = ((y) => {
    if (t.literal)
      return m(y);
    switch (y.val) {
      case "G":
        return Ne(e.eras("short", !1), 0);
      case "GG":
        return Ne(e.eras("long", !1), 0);
      case "y":
        return ee(u);
      case "yy":
        return ee(p, Pr);
      case "yyyy":
        return ee(s);
      case "yyyyy":
        return ee(v);
      case "yyyyyy":
        return ee(i);
      case "M":
        return ee(a);
      case "MM":
        return ee(n);
      case "MMM":
        return Ne(e.months("short", !0, !1), 1);
      case "MMMM":
        return Ne(e.months("long", !0, !1), 1);
      case "L":
        return ee(a);
      case "LL":
        return ee(n);
      case "LLL":
        return Ne(e.months("short", !1, !1), 1);
      case "LLLL":
        return Ne(e.months("long", !1, !1), 1);
      case "d":
        return ee(a);
      case "dd":
        return ee(n);
      case "o":
        return ee(c);
      case "ooo":
        return ee(r);
      case "HH":
        return ee(n);
      case "H":
        return ee(a);
      case "hh":
        return ee(n);
      case "h":
        return ee(a);
      case "mm":
        return ee(n);
      case "m":
        return ee(a);
      case "q":
        return ee(a);
      case "qq":
        return ee(n);
      case "s":
        return ee(a);
      case "ss":
        return ee(n);
      case "S":
        return ee(c);
      case "SSS":
        return ee(r);
      case "u":
        return mr(f);
      case "uu":
        return mr(a);
      case "uuu":
        return ee(o);
      case "a":
        return Ne(e.meridiems(), 0);
      case "kkkk":
        return ee(s);
      case "kk":
        return ee(p, Pr);
      case "W":
        return ee(a);
      case "WW":
        return ee(n);
      case "E":
      case "c":
        return ee(o);
      case "EEE":
        return Ne(e.weekdays("short", !1, !1), 1);
      case "EEEE":
        return Ne(e.weekdays("long", !1, !1), 1);
      case "ccc":
        return Ne(e.weekdays("short", !0, !1), 1);
      case "cccc":
        return Ne(e.weekdays("long", !0, !1), 1);
      case "Z":
      case "ZZ":
        return di(new RegExp(`([+-]${a.source})(?::(${n.source}))?`), 2);
      case "ZZZ":
        return di(new RegExp(`([+-]${a.source})(${n.source})?`), 2);
      case "z":
        return mr(/[a-z_+-/]{1,256}?/i);
      default:
        return m(y);
    }
  })(t) || {
    invalidReason: OM
  };
  return w.token = t, w;
}
const PM = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function AM(t, e, o) {
  const { type: n, value: r } = t;
  if (n === "literal")
    return {
      literal: !0,
      val: r
    };
  const s = o[n];
  let i = PM[n];
  if (typeof i == "object" && (i = i[s]), i)
    return {
      literal: !1,
      val: i
    };
}
function LM(t) {
  return [`^${t.map((o) => o.regex).reduce((o, n) => `${o}(${n.source})`, "")}$`, t];
}
function HM(t, e, o) {
  const n = t.match(e);
  if (n) {
    const r = {};
    let s = 1;
    for (const i in o)
      if (oo(o, i)) {
        const a = o[i], c = a.groups ? a.groups + 1 : 1;
        !a.literal && a.token && (r[a.token.val[0]] = a.deser(n.slice(s, s + c))), s += c;
      }
    return [n, r];
  } else
    return [n, {}];
}
function VM(t) {
  const e = (s) => {
    switch (s) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let o = null, n;
  return Y(t.z) || (o = ct.create(t.z)), Y(t.Z) || (o || (o = new Me(t.Z)), n = t.Z), Y(t.q) || (t.M = (t.q - 1) * 3 + 1), Y(t.h) || (t.h < 12 && t.a === 1 ? t.h += 12 : t.h === 12 && t.a === 0 && (t.h = 0)), t.G === 0 && t.y && (t.y = -t.y), Y(t.u) || (t.S = ns(t.u)), [Object.keys(t).reduce((s, i) => {
    const a = e(i);
    return a && (s[a] = t[i]), s;
  }, {}), o, n];
}
let vr = null;
function FM() {
  return vr || (vr = D.fromMillis(1555555555555)), vr;
}
function IM(t, e) {
  if (t.literal)
    return t;
  const o = Ce.macroTokenToFormatOpts(t.val), n = i2(o, e);
  return n == null || n.includes(void 0) ? t : n;
}
function r2(t, e) {
  return Array.prototype.concat(...t.map((o) => IM(o, e)));
}
function s2(t, e, o) {
  const n = r2(Ce.parseFormat(o), t), r = n.map((i) => EM(i, t)), s = r.find((i) => i.invalidReason);
  if (s)
    return { input: e, tokens: n, invalidReason: s.invalidReason };
  {
    const [i, a] = LM(r), c = RegExp(i, "i"), [u, f] = HM(e, c, a), [p, v, m] = f ? VM(f) : [null, null, void 0];
    if (oo(f, "a") && oo(f, "H"))
      throw new xo(
        "Can't include meridiem when specifying 24-hour format"
      );
    return { input: e, tokens: n, regex: c, rawMatches: u, matches: f, result: p, zone: v, specificOffset: m };
  }
}
function DM(t, e, o) {
  const { result: n, zone: r, specificOffset: s, invalidReason: i } = s2(t, e, o);
  return [n, r, s, i];
}
function i2(t, e) {
  return t ? Ce.create(e, t).formatDateTimeParts(FM()).map((r) => AM(r, e, t)) : null;
}
const a2 = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], l2 = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function Fe(t, e) {
  return new Ze(
    "unit out of range",
    `you specified ${e} (of type ${typeof e}) as a ${t}, which is invalid`
  );
}
function d2(t, e, o) {
  const n = new Date(Date.UTC(t, e - 1, o));
  t < 100 && t >= 0 && n.setUTCFullYear(n.getUTCFullYear() - 1900);
  const r = n.getUTCDay();
  return r === 0 ? 7 : r;
}
function u2(t, e, o) {
  return o + (Xo(t) ? l2 : a2)[e - 1];
}
function c2(t, e) {
  const o = Xo(t) ? l2 : a2, n = o.findIndex((s) => s < e), r = e - o[n];
  return { month: n + 1, day: r };
}
function Fr(t) {
  const { year: e, month: o, day: n } = t, r = u2(e, o, n), s = d2(e, o, n);
  let i = Math.floor((r - s + 10) / 7), a;
  return i < 1 ? (a = e - 1, i = Tn(a)) : i > Tn(e) ? (a = e + 1, i = 1) : a = e, j({ weekYear: a, weekNumber: i, weekday: s }, Qn(t));
}
function ui(t) {
  const { weekYear: e, weekNumber: o, weekday: n } = t, r = d2(e, 1, 4), s = Bo(e);
  let i = o * 7 + n - r - 3, a;
  i < 1 ? (a = e - 1, i += Bo(a)) : i > s ? (a = e + 1, i -= Bo(e)) : a = e;
  const { month: c, day: u } = c2(a, i);
  return j({ year: a, month: c, day: u }, Qn(t));
}
function gr(t) {
  const { year: e, month: o, day: n } = t, r = u2(e, o, n);
  return j({ year: e, ordinal: r }, Qn(t));
}
function ci(t) {
  const { year: e, ordinal: o } = t, { month: n, day: r } = c2(e, o);
  return j({ year: e, month: n, day: r }, Qn(t));
}
function NM(t) {
  const e = Kn(t.weekYear), o = at(t.weekNumber, 1, Tn(t.weekYear)), n = at(t.weekday, 1, 7);
  return e ? o ? n ? !1 : Fe("weekday", t.weekday) : Fe("week", t.week) : Fe("weekYear", t.weekYear);
}
function RM(t) {
  const e = Kn(t.year), o = at(t.ordinal, 1, Bo(t.year));
  return e ? o ? !1 : Fe("ordinal", t.ordinal) : Fe("year", t.year);
}
function h2(t) {
  const e = Kn(t.year), o = at(t.month, 1, 12), n = at(t.day, 1, On(t.year, t.month));
  return e ? o ? n ? !1 : Fe("day", t.day) : Fe("month", t.month) : Fe("year", t.year);
}
function f2(t) {
  const { hour: e, minute: o, second: n, millisecond: r } = t, s = at(e, 0, 23) || e === 24 && o === 0 && n === 0 && r === 0, i = at(o, 0, 59), a = at(n, 0, 59), c = at(r, 0, 999);
  return s ? i ? a ? c ? !1 : Fe("millisecond", r) : Fe("second", n) : Fe("minute", o) : Fe("hour", e);
}
const _r = "Invalid DateTime", hi = 864e13;
function cn(t) {
  return new Ze("unsupported zone", `the zone "${t.name}" is not supported`);
}
function wr(t) {
  return t.weekData === null && (t.weekData = Fr(t.c)), t.weekData;
}
function _o(t, e) {
  const o = {
    ts: t.ts,
    zone: t.zone,
    c: t.c,
    o: t.o,
    loc: t.loc,
    invalid: t.invalid
  };
  return new D(R(j(j({}, o), e), { old: o }));
}
function p2(t, e, o) {
  let n = t - e * 60 * 1e3;
  const r = o.offset(n);
  if (e === r)
    return [n, e];
  n -= (r - e) * 60 * 1e3;
  const s = o.offset(n);
  return r === s ? [n, r] : [t - Math.min(r, s) * 60 * 1e3, Math.max(r, s)];
}
function fi(t, e) {
  t += e * 60 * 1e3;
  const o = new Date(t);
  return {
    year: o.getUTCFullYear(),
    month: o.getUTCMonth() + 1,
    day: o.getUTCDate(),
    hour: o.getUTCHours(),
    minute: o.getUTCMinutes(),
    second: o.getUTCSeconds(),
    millisecond: o.getUTCMilliseconds()
  };
}
function vn(t, e, o) {
  return p2(ss(t), e, o);
}
function pi(t, e) {
  const o = t.o, n = t.c.year + Math.trunc(e.years), r = t.c.month + Math.trunc(e.months) + Math.trunc(e.quarters) * 3, s = R(j({}, t.c), {
    year: n,
    month: r,
    day: Math.min(t.c.day, On(n, r)) + Math.trunc(e.days) + Math.trunc(e.weeks) * 7
  }), i = X.fromObject({
    years: e.years - Math.trunc(e.years),
    quarters: e.quarters - Math.trunc(e.quarters),
    months: e.months - Math.trunc(e.months),
    weeks: e.weeks - Math.trunc(e.weeks),
    days: e.days - Math.trunc(e.days),
    hours: e.hours,
    minutes: e.minutes,
    seconds: e.seconds,
    milliseconds: e.milliseconds
  }).as("milliseconds"), a = ss(s);
  let [c, u] = p2(a, o, t.zone);
  return i !== 0 && (c += i, u = t.zone.offset(c)), { ts: c, o: u };
}
function wo(t, e, o, n, r, s) {
  const { setZone: i, zone: a } = o;
  if (t && Object.keys(t).length !== 0) {
    const c = e || a, u = D.fromObject(t, R(j({}, o), {
      zone: c,
      specificOffset: s
    }));
    return i ? u : u.setZone(a);
  } else
    return D.invalid(
      new Ze("unparsable", `the input "${r}" can't be parsed as ${n}`)
    );
}
function hn(t, e, o = !0) {
  return t.isValid ? Ce.create(ae.create("en-US"), {
    allowZ: o,
    forceSimple: !0
  }).formatDateTimeFromString(t, e) : null;
}
function br(t, e) {
  const o = t.c.year > 9999 || t.c.year < 0;
  let n = "";
  return o && t.c.year >= 0 && (n += "+"), n += pe(t.c.year, o ? 6 : 4), e ? (n += "-", n += pe(t.c.month), n += "-", n += pe(t.c.day)) : (n += pe(t.c.month), n += pe(t.c.day)), n;
}
function mi(t, e, o, n, r, s) {
  let i = pe(t.c.hour);
  return e ? (i += ":", i += pe(t.c.minute), (t.c.second !== 0 || !o) && (i += ":")) : i += pe(t.c.minute), (t.c.second !== 0 || !o) && (i += pe(t.c.second), (t.c.millisecond !== 0 || !n) && (i += ".", i += pe(t.c.millisecond, 3))), r && (t.isOffsetFixed && t.offset === 0 && !s ? i += "Z" : t.o < 0 ? (i += "-", i += pe(Math.trunc(-t.o / 60)), i += ":", i += pe(Math.trunc(-t.o % 60))) : (i += "+", i += pe(Math.trunc(t.o / 60)), i += ":", i += pe(Math.trunc(t.o % 60)))), s && (i += "[" + t.zone.ianaName + "]"), i;
}
const m2 = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, qM = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, WM = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, v2 = ["year", "month", "day", "hour", "minute", "second", "millisecond"], UM = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], ZM = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function vi(t) {
  const e = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[t.toLowerCase()];
  if (!e) throw new _u(t);
  return e;
}
function gi(t, e) {
  const o = bt(e.zone, ge.defaultZone), n = ae.fromObject(e), r = ge.now();
  let s, i;
  if (Y(t.year))
    s = r;
  else {
    for (const u of v2)
      Y(t[u]) && (t[u] = m2[u]);
    const a = h2(t) || f2(t);
    if (a)
      return D.invalid(a);
    const c = o.offset(r);
    [s, i] = vn(t, c, o);
  }
  return new D({ ts: s, zone: o, loc: n, o: i });
}
function _i(t, e, o) {
  const n = Y(o.round) ? !0 : o.round, r = (i, a) => (i = rs(i, n || o.calendary ? 0 : 2, !0), e.loc.clone(o).relFormatter(o).format(i, a)), s = (i) => o.calendary ? e.hasSame(t, i) ? 0 : e.startOf(i).diff(t.startOf(i), i).get(i) : e.diff(t, i).get(i);
  if (o.unit)
    return r(s(o.unit), o.unit);
  for (const i of o.units) {
    const a = s(i);
    if (Math.abs(a) >= 1)
      return r(a, i);
  }
  return r(t > e ? -0 : 0, o.units[o.units.length - 1]);
}
function wi(t) {
  let e = {}, o;
  return t.length > 0 && typeof t[t.length - 1] == "object" ? (e = t[t.length - 1], o = Array.from(t).slice(0, t.length - 1)) : o = Array.from(t), [e, o];
}
class D {
  /**
   * @access private
   */
  constructor(e) {
    const o = e.zone || ge.defaultZone;
    let n = e.invalid || (Number.isNaN(e.ts) ? new Ze("invalid input") : null) || (o.isValid ? null : cn(o));
    this.ts = Y(e.ts) ? ge.now() : e.ts;
    let r = null, s = null;
    if (!n)
      if (e.old && e.old.ts === this.ts && e.old.zone.equals(o))
        [r, s] = [e.old.c, e.old.o];
      else {
        const a = o.offset(this.ts);
        r = fi(this.ts, a), n = Number.isNaN(r.year) ? new Ze("invalid input") : null, r = n ? null : r, s = n ? null : a;
      }
    this._zone = o, this.loc = e.loc || ae.create(), this.invalid = n, this.weekData = null, this.c = r, this.o = s, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new D({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [e, o] = wi(arguments), [n, r, s, i, a, c, u] = o;
    return gi({ year: n, month: r, day: s, hour: i, minute: a, second: c, millisecond: u }, e);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [e, o] = wi(arguments), [n, r, s, i, a, c, u] = o;
    return e.zone = Me.utcInstance, gi({ year: n, month: r, day: s, hour: i, minute: a, second: c, millisecond: u }, e);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(e, o = {}) {
    const n = oC(e) ? e.valueOf() : NaN;
    if (Number.isNaN(n))
      return D.invalid("invalid input");
    const r = bt(o.zone, ge.defaultZone);
    return r.isValid ? new D({
      ts: n,
      zone: r,
      loc: ae.fromObject(o)
    }) : D.invalid(cn(r));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(e, o = {}) {
    if (Nt(e))
      return e < -hi || e > hi ? D.invalid("Timestamp out of range") : new D({
        ts: e,
        zone: bt(o.zone, ge.defaultZone),
        loc: ae.fromObject(o)
      });
    throw new Pe(
      `fromMillis requires a numerical input, but received a ${typeof e} with value ${e}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(e, o = {}) {
    if (Nt(e))
      return new D({
        ts: e * 1e3,
        zone: bt(o.zone, ge.defaultZone),
        loc: ae.fromObject(o)
      });
    throw new Pe("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  static fromObject(e, o = {}) {
    e = e || {};
    const n = bt(o.zone, ge.defaultZone);
    if (!n.isValid)
      return D.invalid(cn(n));
    const r = ge.now(), s = Y(o.specificOffset) ? n.offset(r) : o.specificOffset, i = zn(e, vi), a = !Y(i.ordinal), c = !Y(i.year), u = !Y(i.month) || !Y(i.day), f = c || u, p = i.weekYear || i.weekNumber, v = ae.fromObject(o);
    if ((f || a) && p)
      throw new xo(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (u && a)
      throw new xo("Can't mix ordinal dates with month/day");
    const m = p || i.weekday && !f;
    let g, w, y = fi(r, s);
    m ? (g = UM, w = qM, y = Fr(y)) : a ? (g = ZM, w = WM, y = gr(y)) : (g = v2, w = m2);
    let M = !1;
    for (const ne of g) {
      const V = i[ne];
      Y(V) ? M ? i[ne] = w[ne] : i[ne] = y[ne] : M = !0;
    }
    const B = m ? NM(i) : a ? RM(i) : h2(i), k = B || f2(i);
    if (k)
      return D.invalid(k);
    const x = m ? ui(i) : a ? ci(i) : i, [b, N] = vn(x, s, n), Z = new D({
      ts: b,
      zone: n,
      o: N,
      loc: v
    });
    return i.weekday && f && e.weekday !== Z.weekday ? D.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${i.weekday} and a date of ${Z.toISO()}`
    ) : Z;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(e, o = {}) {
    const [n, r] = lM(e);
    return wo(n, r, o, "ISO 8601", e);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(e, o = {}) {
    const [n, r] = dM(e);
    return wo(n, r, o, "RFC 2822", e);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(e, o = {}) {
    const [n, r] = uM(e);
    return wo(n, r, o, "HTTP", o);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(e, o, n = {}) {
    if (Y(e) || Y(o))
      throw new Pe("fromFormat requires an input string and a format");
    const { locale: r = null, numberingSystem: s = null } = n, i = ae.fromOpts({
      locale: r,
      numberingSystem: s,
      defaultToEN: !0
    }), [a, c, u, f] = DM(i, e, o);
    return f ? D.invalid(f) : wo(a, c, n, `format ${o}`, e, u);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(e, o, n = {}) {
    return D.fromFormat(e, o, n);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(e, o = {}) {
    const [n, r] = gM(e);
    return wo(n, r, o, "SQL", e);
  }
  /**
   * Create an invalid DateTime.
   * @param {DateTime} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(e, o = null) {
    if (!e)
      throw new Pe("need to specify a reason the DateTime is invalid");
    const n = e instanceof Ze ? e : new Ze(e, o);
    if (ge.throwOnInvalid)
      throw new Xx(n);
    return new D({ invalid: n });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(e) {
    return e && e.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(e, o = {}) {
    const n = i2(e, ae.fromObject(o));
    return n ? n.map((r) => r ? r.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(e, o = {}) {
    return r2(Ce.parseFormat(e), ae.fromObject(o)).map((r) => r.val).join("");
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(e) {
    return this[e];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? wr(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? wr(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? wr(this).weekday : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gr(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Ct.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Ct.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Ct.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Ct.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Xo(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return On(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Bo(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? Tn(this.weekYear) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(e = {}) {
    const { locale: o, numberingSystem: n, calendar: r } = Ce.create(
      this.loc.clone(e),
      e
    ).resolvedOptions(this);
    return { locale: o, numberingSystem: n, outputCalendar: r };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(e = 0, o = {}) {
    return this.setZone(Me.instance(e), o);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(ge.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(e, { keepLocalTime: o = !1, keepCalendarTime: n = !1 } = {}) {
    if (e = bt(e, ge.defaultZone), e.equals(this.zone))
      return this;
    if (e.isValid) {
      let r = this.ts;
      if (o || n) {
        const s = e.offset(this.ts), i = this.toObject();
        [r] = vn(i, s, e);
      }
      return _o(this, { ts: r, zone: e });
    } else
      return D.invalid(cn(e));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: e, numberingSystem: o, outputCalendar: n } = {}) {
    const r = this.loc.clone({ locale: e, numberingSystem: o, outputCalendar: n });
    return _o(this, { loc: r });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(e) {
    return this.reconfigure({ locale: e });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(e) {
    if (!this.isValid) return this;
    const o = zn(e, vi), n = !Y(o.weekYear) || !Y(o.weekNumber) || !Y(o.weekday), r = !Y(o.ordinal), s = !Y(o.year), i = !Y(o.month) || !Y(o.day), a = s || i, c = o.weekYear || o.weekNumber;
    if ((a || r) && c)
      throw new xo(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (i && r)
      throw new xo("Can't mix ordinal dates with month/day");
    let u;
    n ? u = ui(j(j({}, Fr(this.c)), o)) : Y(o.ordinal) ? (u = j(j({}, this.toObject()), o), Y(o.day) && (u.day = Math.min(On(u.year, u.month), u.day))) : u = ci(j(j({}, gr(this.c)), o));
    const [f, p] = vn(u, this.o, this.zone);
    return _o(this, { ts: f, o: p });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(e) {
    if (!this.isValid) return this;
    const o = X.fromDurationLike(e);
    return _o(this, pi(this, o));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(e) {
    if (!this.isValid) return this;
    const o = X.fromDurationLike(e).negate();
    return _o(this, pi(this, o));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(e) {
    if (!this.isValid) return this;
    const o = {}, n = X.normalizeUnit(e);
    switch (n) {
      case "years":
        o.month = 1;
      case "quarters":
      case "months":
        o.day = 1;
      case "weeks":
      case "days":
        o.hour = 0;
      case "hours":
        o.minute = 0;
      case "minutes":
        o.second = 0;
      case "seconds":
        o.millisecond = 0;
        break;
    }
    if (n === "weeks" && (o.weekday = 1), n === "quarters") {
      const r = Math.ceil(this.month / 3);
      o.month = (r - 1) * 3 + 1;
    }
    return this.set(o);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(e) {
    return this.isValid ? this.plus({ [e]: 1 }).startOf(e).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(e, o = {}) {
    return this.isValid ? Ce.create(this.loc.redefaultToEN(o)).formatDateTimeFromString(this, e) : _r;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(e = Er, o = {}) {
    return this.isValid ? Ce.create(this.loc.clone(o), e).formatDateTime(this) : _r;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(e = {}) {
    return this.isValid ? Ce.create(this.loc.clone(e), e).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: e = "extended",
    suppressSeconds: o = !1,
    suppressMilliseconds: n = !1,
    includeOffset: r = !0,
    extendedZone: s = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const i = e === "extended";
    let a = br(this, i);
    return a += "T", a += mi(this, i, o, n, r, s), a;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: e = "extended" } = {}) {
    return this.isValid ? br(this, e === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return hn(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: e = !1,
    suppressSeconds: o = !1,
    includeOffset: n = !0,
    includePrefix: r = !1,
    extendedZone: s = !1,
    format: i = "extended"
  } = {}) {
    return this.isValid ? (r ? "T" : "") + mi(
      this,
      i === "extended",
      o,
      e,
      n,
      s
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return hn(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return hn(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? br(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: e = !0, includeZone: o = !1, includeOffsetSpace: n = !0 } = {}) {
    let r = "HH:mm:ss.SSS";
    return (o || e) && (n && (r += " "), o ? r += "z" : e && (r += "ZZ")), hn(this, r, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(e = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(e)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : _r;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(e = {}) {
    if (!this.isValid) return {};
    const o = j({}, this.c);
    return e.includeConfig && (o.outputCalendar = this.outputCalendar, o.numberingSystem = this.loc.numberingSystem, o.locale = this.loc.locale), o;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(e, o = "milliseconds", n = {}) {
    if (!this.isValid || !e.isValid)
      return X.invalid("created by diffing an invalid DateTime");
    const r = j({ locale: this.locale, numberingSystem: this.numberingSystem }, n), s = nC(o).map(X.normalizeUnit), i = e.valueOf() > this.valueOf(), a = i ? this : e, c = i ? e : this, u = $M(a, c, s, r);
    return i ? u.negate() : u;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(e = "milliseconds", o = {}) {
    return this.diff(D.now(), e, o);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(e) {
    return this.isValid ? ue.fromDateTimes(this, e) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(e, o) {
    if (!this.isValid) return !1;
    const n = e.valueOf(), r = this.setZone(e.zone, { keepLocalTime: !0 });
    return r.startOf(o) <= n && n <= r.endOf(o);
  }
  /**
   * Equality check
   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(e) {
    return this.isValid && e.isValid && this.valueOf() === e.valueOf() && this.zone.equals(e.zone) && this.loc.equals(e.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(e = {}) {
    if (!this.isValid) return null;
    const o = e.base || D.fromObject({}, { zone: this.zone }), n = e.padding ? this < o ? -e.padding : e.padding : 0;
    let r = ["years", "months", "days", "hours", "minutes", "seconds"], s = e.unit;
    return Array.isArray(e.unit) && (r = e.unit, s = void 0), _i(o, this.plus(n), R(j({}, e), {
      numeric: "always",
      units: r,
      unit: s
    }));
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(e = {}) {
    return this.isValid ? _i(e.base || D.fromObject({}, { zone: this.zone }), this, R(j({}, e), {
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    })) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...e) {
    if (!e.every(D.isDateTime))
      throw new Pe("min requires all arguments be DateTimes");
    return Xs(e, (o) => o.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...e) {
    if (!e.every(D.isDateTime))
      throw new Pe("max requires all arguments be DateTimes");
    return Xs(e, (o) => o.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(e, o, n = {}) {
    const { locale: r = null, numberingSystem: s = null } = n, i = ae.fromOpts({
      locale: r,
      numberingSystem: s,
      defaultToEN: !0
    });
    return s2(i, e, o);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(e, o, n = {}) {
    return D.fromFormatExplain(e, o, n);
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return Er;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return wu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return Qx;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return bu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return ku;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return yu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return xu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return Cu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return Mu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return $u;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return Su;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return ju;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return Ou;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return Tu;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return zu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return Bu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return Eu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return eC;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return Pu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return Au;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return Lu;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return Hu;
  }
}
function bo(t) {
  if (D.isDateTime(t))
    return t;
  if (t && t.valueOf && Nt(t.valueOf()))
    return D.fromJSDate(t);
  if (t && typeof t == "object")
    return D.fromObject(t);
  throw new Pe(
    `Unknown datetime argument: ${t}, of type ${typeof t}`
  );
}
const kt = 7, en = (t) => Array.from(Array.from({ length: t }).keys()), GM = (t) => {
  const e = t.daysInMonth;
  return en(e).map((o, n) => n + 1);
}, YM = (t) => en(t.length / kt).map((e) => {
  const o = e * kt;
  return t.slice(o, o + kt);
}), XM = (t, e) => {
  const o = t.minus({ month: 1 }).endOf("month").day;
  return en(e).map((n, r) => o - (e - r - 1));
}, KM = (t) => t.startOf("month").weekday - 1, JM = (t) => {
  try {
    return Ct.weekdays("short", { locale: t });
  } catch (e) {
    return Ct.weekdays("short");
  }
}, QM = (t) => {
  try {
    return Ct.months("long", { locale: t }).map((e, o) => ({ name: e, key: o + 1 }));
  } catch (e) {
    return Ct.months("long").map((o, n) => ({ name: o, key: n + 1 }));
  }
}, e$ = (t) => {
  const e = KM(t), o = XM(t, (e + kt) % kt).map(
    (a) => ({
      text: a,
      type: "prev"
    })
  ), n = GM(t).map((a) => ({
    text: a,
    type: "current"
  })), r = [...o, ...n], s = kt - (r.length % kt || kt), i = en(s).map((a, c) => ({
    text: c + 1,
    type: "next"
  }));
  return YM(r.concat(i));
}, t$ = ["onClick", "onKeyup"], o$ = /* @__PURE__ */ A({
  __name: "_DateTable",
  props: {
    locale: {},
    zone: {},
    defaultTime: {},
    disabledDates: {},
    highlightToday: { type: Boolean },
    date: {},
    selectedDate: {},
    useIsoValue: { type: Boolean }
  },
  emits: ["update:modelValue", "next-month", "prev-month"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = JM(o.locale), s = z(() => e$(o.date)), i = ({ text: m, type: g }) => !o.selectedDate || g !== "current" ? !1 : u({ text: m, type: g }).hasSame(o.selectedDate, "day"), a = ({ text: m, type: g }) => u({ text: m, type: g }).hasSame(D.local({ zone: o.zone }), "day"), c = ({ text: m, type: g }) => o.highlightToday ? a({ text: m, type: g }) : !1, u = ({ text: m, type: g }) => {
      switch (g) {
        case "prev":
          return o.date.startOf("month").minus({ month: 1 }).set({ day: m });
        case "next":
          return o.date.startOf("month").plus({ month: 1 }).set({ day: m });
        default:
          return o.date.set({ day: m });
      }
    }, f = ({ text: m, type: g }) => {
      var k;
      const w = u({ text: m, type: g });
      let y = !1, M = !1, B = !1;
      return o.disabledDates.to && (y = w.valueOf() < new Date(o.disabledDates.to).valueOf()), o.disabledDates.from && (M = w.valueOf() > new Date(o.disabledDates.from).valueOf()), (k = o.disabledDates.dates) != null && k.length && (B = o.disabledDates.dates.some((x) => D.fromJSDate(new Date(x)).toFormat("yyyy-MM-dd") === w.toFormat("yyyy-MM-dd"))), y || M || B;
    }, p = ({ text: m, type: g }) => {
      if (f({ text: m, type: g }))
        return;
      const w = u({ text: m, type: g });
      o.defaultTime ? v(w.setZone(o.zone).set(o.defaultTime)) : v(w.setZone(o.zone)), g === "prev" && n("prev-month"), g === "next" && n("next-month");
    }, v = (m) => {
      if (o.useIsoValue) {
        n("update:modelValue", m.toISO());
        return;
      }
      n("update:modelValue", m.toJSDate());
    };
    return (m, g) => (d(), h("table", null, [
      l("tbody", null, [
        l("tr", null, [
          (d(!0), h(oe, null, ce(_(r), (w) => (d(), h("th", { key: w }, [
            $(_(ho), null, {
              default: O(() => [
                K(F(w), 1)
              ]),
              _: 2
            }, 1024)
          ]))), 128))
        ]),
        (d(!0), h(oe, null, ce(s.value, (w, y) => (d(), h("tr", { key: y }, [
          (d(!0), h(oe, null, ce(w, (M) => (d(), h("td", {
            key: M.text,
            tabindex: "0",
            role: "button",
            class: S([
              {
                selected: i(M),
                highlight: c(M),
                disabled: f(M),
                today: a(M)
              },
              `${M.type}-month`,
              "day",
              "cell"
            ]),
            onClick: (B) => p(M),
            onKeyup: [
              q((B) => p(M), ["enter"]),
              q((B) => p(M), ["space"])
            ]
          }, F(M.text), 43, t$))), 128))
        ]))), 128))
      ])
    ]));
  }
}), n$ = /* @__PURE__ */ T(o$, [["__scopeId", "data-v-961d7678"]]), r$ = {}, s$ = { class: "date-button" };
function i$(t, e) {
  return d(), h("button", s$, [
    C(t.$slots, "default", {}, void 0, !0)
  ]);
}
const g2 = /* @__PURE__ */ T(r$, [["render", i$], ["__scopeId", "data-v-5c54eeaf"]]), a$ = { class: "months" }, l$ = /* @__PURE__ */ A({
  __name: "_Months",
  props: {
    locale: {},
    modelValue: {},
    value: {}
  },
  emits: ["update:modelValue", "close"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = QM(o.locale), s = (a) => {
      n("update:modelValue", o.modelValue.set({ month: a })), n("close");
    }, i = (a) => {
      var c;
      return o.modelValue.month === a && ((c = o.value) == null ? void 0 : c.year) === o.modelValue.year;
    };
    return (a, c) => (d(), h("div", a$, [
      (d(!0), h(oe, null, ce(_(r), ({ key: u, name: f }) => (d(), P(g2, {
        key: u,
        class: S([{ selected: i(u) }, "month"]),
        onClick: (p) => s(u)
      }, {
        default: O(() => [
          K(F(f), 1)
        ]),
        _: 2
      }, 1032, ["class", "onClick"]))), 128))
    ]));
  }
}), d$ = /* @__PURE__ */ T(l$, [["__scopeId", "data-v-92978f48"]]), u$ = { class: "years" }, c$ = /* @__PURE__ */ A({
  __name: "_Years",
  props: {
    locale: {},
    modelValue: {},
    page: {}
  },
  emits: ["update:modelValue", "close"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = z(() => en(10).map((a) => `${o.page}${a}`)), s = (a) => {
      n("update:modelValue", o.modelValue.set({ year: a })), n("close");
    }, i = (a) => o.modelValue.year === Number(a);
    return (a, c) => (d(), h("div", u$, [
      (d(!0), h(oe, null, ce(r.value, (u) => (d(), P(g2, {
        key: u,
        class: S([{ selected: i(u) }, "year"]),
        onClick: (f) => s(u)
      }, {
        default: O(() => [
          K(F(u), 1)
        ]),
        _: 2
      }, 1032, ["class", "onClick"]))), 128))
    ]));
  }
}), h$ = /* @__PURE__ */ T(c$, [["__scopeId", "data-v-6812015a"]]), f$ = { class: "datepicker-container" }, p$ = {
  key: 0,
  class: "header"
}, m$ = {
  key: 1,
  class: "header"
}, v$ = {
  key: 2,
  class: "header"
}, g$ = { class: "datepicker-content" }, _$ = /* @__PURE__ */ A({
  __name: "FriedDatePicker",
  props: {
    modelValue: { default: "" },
    locale: { default: "" },
    zone: { default: void 0 },
    defaultTime: { default: void 0 },
    disabledDates: { default: () => ({}) },
    highlightToday: { type: Boolean, default: !1 },
    useIsoValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = z(() => o.locale || No.locale || void 0), s = z(() => o.zone || No.zone || void 0), i = z(
      () => o.modelValue ? D.fromJSDate(new Date(o.modelValue), { zone: s.value }) : void 0
    ), a = I(i.value || D.local({ zone: s.value })), c = I(!1), u = I(!1), f = I(Math.floor(a.value.year / 10)), p = z(() => `${f.value}0 - ${f.value}9`), v = z(() => {
      try {
        return a.value.toFormat("MMM", { locale: r.value });
      } catch (x) {
        return a.value.toFormat("MMM");
      }
    }), m = z(() => a.value.toFormat("yyyy"));
    Je(
      () => o.modelValue,
      () => {
        a.value = i.value || D.local({ zone: s.value });
      }
    );
    const g = () => a.value = a.value.minus({ month: 1 }), w = () => a.value = a.value.plus({ month: 1 }), y = () => a.value = a.value.minus({ year: 1 }), M = () => a.value = a.value.plus({ year: 1 }), B = () => f.value--, k = () => f.value++;
    return (x, b) => (d(), h("div", f$, [
      u.value ? (d(), h("div", p$, [
        $(_(me), {
          class: "prev",
          onClick: B
        }, {
          default: O(() => [
            $(_(U), { icon: "chevron-left" })
          ]),
          _: 1
        }),
        $(_(pn), {
          "button-type": _(jt).Tertiary,
          onFocusout: b[0] || (b[0] = _e(() => {
          }, ["stop"]))
        }, {
          default: O(() => [
            K(F(p.value), 1)
          ]),
          _: 1
        }, 8, ["button-type"]),
        $(_(me), {
          class: "next",
          onClick: k
        }, {
          default: O(() => [
            $(_(U), { icon: "chevron-right" })
          ]),
          _: 1
        })
      ])) : c.value ? (d(), h("div", m$, [
        $(_(me), {
          class: "prev",
          onClick: y
        }, {
          default: O(() => [
            $(_(U), { icon: "chevron-left" })
          ]),
          _: 1
        }),
        $(_(pn), {
          "button-type": _(jt).Tertiary,
          class: "month__year_btn up",
          onFocusout: b[1] || (b[1] = _e(() => {
          }, ["stop"])),
          onClick: b[2] || (b[2] = (N) => u.value = !0)
        }, {
          default: O(() => [
            K(F(m.value), 1)
          ]),
          _: 1
        }, 8, ["button-type"]),
        $(_(me), {
          class: "next",
          onClick: M
        }, {
          default: O(() => [
            $(_(U), { icon: "chevron-right" })
          ]),
          _: 1
        })
      ])) : (d(), h("div", v$, [
        $(_(me), {
          class: "prev",
          onClick: g
        }, {
          default: O(() => [
            $(_(U), { icon: "chevron-left" })
          ]),
          _: 1
        }),
        $(_(pn), {
          "button-type": _(jt).Tertiary,
          class: "day__month_btn up",
          onFocusout: b[3] || (b[3] = _e(() => {
          }, ["stop"])),
          onClick: b[4] || (b[4] = (N) => c.value = !0)
        }, {
          default: O(() => [
            K(F(v.value) + " " + F(m.value), 1)
          ]),
          _: 1
        }, 8, ["button-type"]),
        $(_(me), {
          class: "next",
          onClick: w
        }, {
          default: O(() => [
            $(_(U), { icon: "chevron-right" })
          ]),
          _: 1
        })
      ])),
      l("div", g$, [
        u.value ? (d(), P(h$, {
          key: 0,
          modelValue: a.value,
          "onUpdate:modelValue": b[5] || (b[5] = (N) => a.value = N),
          class: "months",
          locale: r.value,
          page: f.value,
          onFocusout: b[6] || (b[6] = _e(() => {
          }, ["stop"])),
          onClose: b[7] || (b[7] = (N) => u.value = !1)
        }, null, 8, ["modelValue", "locale", "page"])) : c.value ? (d(), P(d$, {
          key: 1,
          modelValue: a.value,
          "onUpdate:modelValue": b[8] || (b[8] = (N) => a.value = N),
          value: i.value,
          class: "months",
          locale: r.value,
          onFocusout: b[9] || (b[9] = _e(() => {
          }, ["stop"])),
          onClose: b[10] || (b[10] = (N) => c.value = !1)
        }, null, 8, ["modelValue", "value", "locale"])) : E("", !0),
        $(n$, {
          locale: r.value,
          zone: s.value,
          "default-time": x.defaultTime,
          "disabled-dates": x.disabledDates,
          "highlight-today": x.highlightToday,
          date: a.value,
          "selected-date": i.value,
          "use-iso-value": x.useIsoValue,
          "onUpdate:modelValue": b[11] || (b[11] = (N) => n("update:modelValue", N)),
          onPrevMonth: g,
          onNextMonth: w
        }, null, 8, ["locale", "zone", "default-time", "disabled-dates", "highlight-today", "date", "selected-date", "use-iso-value"])
      ])
    ]));
  }
}), _2 = /* @__PURE__ */ T(_$, [["__scopeId", "data-v-b78b1886"]]), w$ = ["id"], b$ = ["id", "aria-checked", "aria-disabled", "aria-labelledby", "onKeydown"], k$ = {
  key: 0,
  class: "inner-circle"
}, y$ = /* @__PURE__ */ A({
  __name: "FriedRadioButton",
  props: {
    value: { default: void 0 },
    label: { default: "" },
    id: { default: "" },
    disabled: { type: Boolean, default: !1 },
    modelValue: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = xe(5), { value: s, modelValue: i } = Ke(o), a = z(() => s.value === (i == null ? void 0 : i.value)), c = () => {
      o.disabled || n("update:modelValue", s.value);
    }, u = z(() => o.id || "input-radio-" + r), f = z(() => o.id || "input-radio-button-" + r), p = z(() => "input-radio-button-label-" + r);
    return (v, m) => (d(), h("div", {
      id: f.value,
      class: S(["radio-outer-container", { disabled: v.disabled }]),
      onClick: c,
      onKeyup: [
        q(c, ["enter"]),
        q(c, ["space"])
      ]
    }, [
      l("div", {
        id: u.value,
        tabindex: "0",
        role: "radio",
        "aria-checked": a.value,
        "aria-disabled": v.disabled,
        "aria-labelledby": p.value,
        class: S(["outer-circle", { checked: a.value }]),
        onKeydown: [
          q(c, ["enter"]),
          q(_e(c, ["prevent"]), ["space"])
        ]
      }, [
        a.value ? (d(), h("div", k$)) : E("", !0)
      ], 42, b$),
      v.label ? (d(), P(_(Fn), {
        key: 0,
        id: p.value,
        class: S(["label", { disabled: v.disabled }]),
        size: _(qt).Medium,
        for: u.value
      }, {
        default: O(() => [
          K(F(v.label), 1)
        ]),
        _: 1
      }, 8, ["id", "class", "size", "for"])) : E("", !0)
    ], 42, w$));
  }
}), Ir = /* @__PURE__ */ T(y$, [["__scopeId", "data-v-950ad3b6"]]), x$ = /* @__PURE__ */ A({
  __name: "FriedSelectInput",
  props: {
    label: { default: "" },
    placeholder: { default: "" },
    open: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    errorMessage: { default: "" },
    helpMessage: { default: "" },
    success: { type: Boolean, default: !1 },
    value: { default: "" },
    fixedLabel: { type: Boolean, default: !1 }
  },
  emits: ["update", "arrowDown", "arrowUp", "enter", "blur", "focus", "close"],
  setup(t, { emit: e }) {
    const o = t, n = z(() => !o.searchable || !o.open), r = e, s = (a) => {
      o.disabled || r("update", a);
    }, i = ({ key: a }) => {
      switch (a) {
        case "ArrowUp":
          r("arrowUp");
          break;
        case "ArrowDown":
          r("arrowDown");
          break;
        case "Enter":
          r("enter");
          break;
        case "Escape":
          r("close");
          break;
      }
    };
    return (a, c) => (d(), P(Wn, {
      "aria-haspopup": "listbox",
      "aria-expanded": !!a.open,
      disabled: a.disabled,
      readonly: n.value,
      label: a.label,
      autocomplete: "off",
      placeholder: a.placeholder,
      "fixed-label": a.fixedLabel,
      "help-message": a.helpMessage,
      "error-message": a.errorMessage,
      error: a.error,
      success: a.success,
      class: S(["select-container", { readonly: n.value, disabled: a.disabled }]),
      "model-value": a.value,
      "onUpdate:modelValue": s,
      onBlur: c[1] || (c[1] = (u) => r("blur")),
      onFocus: c[2] || (c[2] = (u) => r("focus")),
      onKeydown: i
    }, {
      append: O(() => [
        l("div", {
          class: S([{ disabled: a.disabled }, "icon-container"]),
          onMousedown: c[0] || (c[0] = _e(() => {
          }, ["prevent"]))
        }, [
          $(U, {
            class: S(["chevron-icon", { expanded: a.open }]),
            icon: "chevron-down"
          }, null, 8, ["class"])
        ], 34)
      ]),
      _: 1
    }, 8, ["aria-expanded", "disabled", "readonly", "label", "placeholder", "fixed-label", "help-message", "error-message", "error", "success", "class", "model-value"]));
  }
}), w2 = /* @__PURE__ */ T(x$, [["__scopeId", "data-v-6f5af870"]]), C$ = ["disabled"], M$ = /* @__PURE__ */ A({
  __name: "FriedSelectOption",
  props: {
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, o) => (d(), h("button", {
      class: S(["select-option", { active: e.active, disabled: e.disabled }]),
      disabled: e.disabled,
      type: "button"
    }, [
      C(e.$slots, "default", {}, void 0, !0)
    ], 10, C$));
  }
}), Dr = /* @__PURE__ */ T(M$, [["__scopeId", "data-v-f622c93a"]]), $$ = {
  key: 0,
  class: "help-text-container"
}, S$ = {
  key: 0,
  class: "option-group"
}, j$ = /* @__PURE__ */ A({
  __name: "FriedSelect",
  props: {
    label: { default: "" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    errorMessage: { default: "" },
    helpMessage: { default: "" },
    helpText: { default: "" },
    success: { type: Boolean, default: !1 },
    optionLabel: { default: "" },
    optionKey: { default: "" },
    optionGroupKey: { default: "" },
    optionGroupLabel: { default: "" },
    options: { default: () => [] },
    emptyStateText: { default: "" },
    modelValue: { default: void 0 },
    stayOpenOnSelect: { type: Boolean, default: !1 },
    appendToBody: { type: Boolean, default: !1 },
    fixedLabel: { type: Boolean, default: !1 },
    noShift: { type: Boolean, default: !1 },
    dataExternal: { default: "" },
    optionsSelectedLabel: { default: "" },
    sameWidthAsRef: { type: Boolean, default: !0 },
    placement: { default: "bottom-start" },
    searchInput: { default: "" }
  },
  emits: ["update:modelValue", "focus", "blur", "search"],
  setup(t, { expose: e, emit: o }) {
    const n = t, r = o, s = I(""), i = I(""), a = (L) => {
      L.key !== "Enter" && (i.value = `${i.value}${L.key}`);
    };
    Vx(
      i,
      () => {
        i.value = "";
      },
      {
        debounce: 2e3
      }
    ), Je(i, () => {
      if (!i.value || n.searchable)
        return;
      const L = new RegExp(`(^|\\s)${i.value}`, "gi"), $e = B.value.findIndex(
        (de) => fe(de).toLowerCase().search(L) !== -1
      );
      $e !== -1 && (u.value = $e, V(w.value));
    }), Je(
      () => n.searchInput,
      () => {
        s.value = n.searchInput;
      },
      { immediate: !0 }
    );
    const c = I(!1), u = I(-1);
    Je(c, () => {
      c.value || (u.value = 0, i.value = "");
    });
    const f = (L) => typeof ke(L) == "string" || typeof ke(L) == "number" ? `${n.dataExternal}:${ke(L)}-btn` : `${n.dataExternal}:${fe(L)}-btn`, p = z(() => {
      var L;
      return !!((L = n.options[0]) != null && L[n.optionGroupKey]);
    }), v = z(
      () => p.value ? n.options.map((L) => L[n.optionGroupKey]).flat() : n.options
    ), m = z(
      () => p.value ? B.value.map((L) => L[n.optionGroupKey]).flat() : B.value
    ), g = z(() => p.value && n.optionKey ? v.value.find((L) => L[n.optionKey] === n.modelValue) : n.optionKey ? n.options.find((L) => L[n.optionKey] === n.modelValue) : n.modelValue), w = z(
      () => p.value ? m.value[u.value] : B.value[u.value]
    ), y = z(() => fe(g.value) || n.placeholder), M = z(
      () => c.value && n.searchable ? s.value : ze(g.value)
    ), B = z(() => {
      if (!n.options)
        return [];
      if (!s.value || n.searchInput)
        return n.options;
      if (p.value) {
        const $e = new RegExp(`(\\W|^)${s.value}`, "i");
        return n.options.map((de) => R(j({}, de), {
          [n.optionGroupKey]: de[n.optionGroupKey].filter(
            (tr) => fe(tr).search($e) !== -1
          )
        }));
      }
      const L = new RegExp(`(\\W|^)${s.value}`, "i");
      return n.options.filter(($e) => fe($e).search(L) !== -1);
    }), k = () => {
      s.value && (r("search", ""), s.value = "");
    }, x = (L) => {
      n.disabled || (r("update:modelValue", ke(L)), k(), u.value = m.value.findIndex(($e) => $e === L), n.stayOpenOnSelect || ie());
    }, b = () => {
      if (!n.disabled) {
        if (c.value) {
          ie();
          return;
        }
        te();
      }
    }, N = (L) => {
      n.disabled || (r("search", L), s.value = `${L}`, u.value = 0);
    }, Z = () => {
      if (!n.disabled) {
        if (!c.value) {
          te();
          return;
        }
        u.value !== m.value.length - 1 && (u.value++, V(w.value));
      }
    }, ne = () => {
      if (!n.disabled) {
        if (!c.value) {
          te();
          return;
        }
        u.value !== 0 && (u.value !== null && u.value--, V(w.value));
      }
    }, V = (L) => Q(this, null, function* () {
      var de;
      if (!((de = n.options) != null && de.length))
        return;
      yield En();
      const $e = document.getElementById(f(L));
      $e && $e.scrollIntoView({ block: "nearest" });
    }), J = () => {
      if (!n.disabled) {
        if (!c.value) {
          te();
          return;
        }
        x(w.value);
      }
    }, le = () => {
      n.disabled || n.searchable || J();
    }, te = () => {
      n.disabled || (c.value = !0, g.value && (u.value = g.value ? v.value.findIndex((L) => ke(L) === n.modelValue) : -1, V(g.value)));
    }, ie = () => {
      k(), c.value = !1;
    }, ve = () => {
      r("blur"), ie();
    }, he = () => {
      r("focus");
    }, fe = (L) => L ? (L == null ? void 0 : L[n.optionLabel]) || `${L}` : "", ze = (L) => (L == null ? void 0 : L[n.optionsSelectedLabel]) || fe(L), ke = (L) => n.optionKey ? L == null ? void 0 : L[n.optionKey] : L, rt = (L) => n.modelValue == ke(L), on = (L) => L === w.value;
    return e({
      open: te,
      close: ie
    }), (L, $e) => (d(), h("div", {
      class: "select-container",
      onKeypress: a
    }, [
      $(Zo, {
        show: c.value,
        "same-width-as-ref": L.sameWidthAsRef,
        "append-to-body": L.appendToBody,
        "no-shift": L.noShift,
        placement: L.placement,
        class: "select-floater-container"
      }, {
        reference: O(() => [
          $(w2, {
            disabled: L.disabled,
            open: c.value,
            placeholder: y.value,
            searchable: L.searchable,
            label: L.label,
            error: L.error,
            "error-message": L.errorMessage,
            "help-message": L.helpMessage,
            "aria-activedescendant": c.value && f(w.value) || null,
            value: M.value,
            "fixed-label": L.fixedLabel,
            "data-external": L.dataExternal,
            onUpdate: N,
            onArrowDown: Z,
            onArrowUp: ne,
            onEnter: J,
            onSpace: le,
            onBlur: ve,
            onFocus: he,
            onClose: ie,
            onClick: b
          }, null, 8, ["disabled", "open", "placeholder", "searchable", "label", "error", "error-message", "help-message", "aria-activedescendant", "value", "fixed-label", "data-external"])
        ]),
        default: O(() => [
          l("div", {
            class: "list",
            role: "listbox",
            onMousedown: $e[0] || ($e[0] = _e(() => {
            }, ["prevent"]))
          }, [
            C(L.$slots, "options", {}, () => [
              n.disabled ? E("", !0) : (d(), h(oe, { key: 0 }, [
                L.helpText ? (d(), h("div", $$, [
                  $(Te, {
                    size: _(Ye).Small
                  }, {
                    default: O(() => [
                      K(F(L.helpText), 1)
                    ]),
                    _: 1
                  }, 8, ["size"])
                ])) : E("", !0),
                C(L.$slots, "customTopOption", {}, void 0, !0),
                B.value.length ? (d(!0), h(oe, { key: 2 }, ce(B.value, (de, tr) => (d(), h(oe, { key: tr }, [
                  de[L.optionGroupKey] ? (d(), h("div", S$, [
                    de[L.optionGroupKey].length ? (d(), P(_(es), {
                      key: 0,
                      class: "group-heading"
                    }, {
                      default: O(() => [
                        K(F(de[L.optionGroupLabel]), 1)
                      ]),
                      _: 2
                    }, 1024)) : E("", !0),
                    (d(!0), h(oe, null, ce(de[L.optionGroupKey], (Ie, B2) => se((d(), P(Dr, {
                      id: f(Ie),
                      key: B2,
                      "data-external": f(Ie),
                      tabindex: "-1",
                      active: rt(Ie),
                      class: S({ focused: on(Ie) }),
                      disabled: Ie.disabled,
                      onClick: (nz) => x(Ie)
                    }, {
                      default: O(() => [
                        Ie.icon ? (d(), P(U, {
                          key: 0,
                          icon: Ie.icon
                        }, null, 8, ["icon"])) : E("", !0),
                        K(" " + F(fe(Ie)), 1)
                      ]),
                      _: 2
                    }, 1032, ["id", "data-external", "active", "class", "disabled", "onClick"])), [
                      [_(yn), {
                        content: Ie.tooltip || null,
                        delay: { show: 300, hide: 100 }
                      }]
                    ])), 128))
                  ])) : se((d(), P(Dr, {
                    key: 1,
                    id: f(de),
                    tabindex: "-1",
                    "data-external": f(de),
                    active: rt(de),
                    role: "option",
                    disabled: de.disabled,
                    "aria-selected": rt(de),
                    class: S({ focused: on(de) }),
                    onClick: (Ie) => x(de)
                  }, {
                    default: O(() => [
                      de.icon ? (d(), P(U, {
                        key: 0,
                        icon: de.icon
                      }, null, 8, ["icon"])) : E("", !0),
                      K(" " + F(fe(de)), 1)
                    ]),
                    _: 2
                  }, 1032, ["id", "data-external", "active", "disabled", "aria-selected", "class", "onClick"])), [
                    [_(yn), { content: de.tooltip || null, delay: { show: 300, hide: 100 } }]
                  ])
                ], 64))), 128)) : C(L.$slots, "emptyState", { key: 1 }, () => [
                  $(Te, { class: "empty-state" }, {
                    default: O(() => [
                      K(F(L.emptyStateText), 1)
                    ]),
                    _: 1
                  })
                ], !0),
                C(L.$slots, "customBottomOption", {}, void 0, !0),
                C(L.$slots, "loader", {}, void 0, !0)
              ], 64))
            ], !0)
          ], 32)
        ]),
        _: 3
      }, 8, ["show", "same-width-as-ref", "append-to-body", "no-shift", "placement"])
    ], 32));
  }
}), Nr = /* @__PURE__ */ T(j$, [["__scopeId", "data-v-ea887ac3"]]), O$ = { class: "timepicker-container" }, T$ = { class: "time-container" }, z$ = {
  key: 0,
  class: "am-pm-container"
}, B$ = { class: "am-pm-background" }, E$ = { class: "am-pm-background" }, P$ = /* @__PURE__ */ A({
  __name: "_TimePicker",
  props: {
    is24: { type: Boolean },
    time: {},
    appendToBody: { type: Boolean }
  },
  emits: ["update:time"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = (p) => {
      n("update:time", R(j({}, o.time), { hour: p }));
    }, s = z(() => {
      var p;
      return ((p = o.time) == null ? void 0 : p.hour) >= 12 ? "pm" : "am";
    }), i = (p) => {
      if (p !== s.value) {
        if (p === "am" && o.time.hour === 12) {
          r(0);
          return;
        }
        if (p === "am") {
          r(o.time.hour - 12);
          return;
        }
        if (p === "pm") {
          r(o.time.hour + 12);
          return;
        }
        r(o.time.hour);
      }
    }, a = z(() => {
      var p, v;
      return o.is24 ? (p = o.time) == null ? void 0 : p.hour : ((v = o.time) == null ? void 0 : v.hour) % 12 || 12;
    }), c = (p) => {
      if (s.value === "pm" && !o.is24 && p !== 12) {
        r(parseInt(p) + 12);
        return;
      }
      if (s.value === "am" && !o.is24 && p === 12) {
        r(0);
        return;
      }
      r(+p);
    }, u = (p) => {
      let v = p === 13 ? 1 : 0;
      const m = [];
      for (v; v < p; v++)
        m.push({ text: v < 10 ? `0${v}` : v.toString(), value: v });
      return m;
    }, f = (p) => {
      n("update:time", R(j({}, o.time), { minute: +p }));
    };
    return (p, v) => {
      var m;
      return d(), h("div", O$, [
        l("div", T$, [
          $(_(Nr), {
            options: u(p.is24 ? 24 : 13),
            "option-key": "value",
            "option-label": "text",
            "model-value": a.value,
            "onUpdate:modelValue": c
          }, null, 8, ["options", "model-value"]),
          $(_(Nr), {
            options: u(60),
            "option-key": "value",
            "option-label": "text",
            "model-value": (m = p.time) == null ? void 0 : m.minute,
            "onUpdate:modelValue": f
          }, null, 8, ["options", "model-value"])
        ]),
        p.is24 ? E("", !0) : (d(), h("div", z$, [
          l("div", B$, [
            $(_(Ir), {
              modelValue: s.value,
              "onUpdate:modelValue": [
                v[0] || (v[0] = (g) => s.value = g),
                i
              ],
              class: "am-pm-radio-btn",
              label: "AM",
              value: "am"
            }, null, 8, ["modelValue"])
          ]),
          l("div", E$, [
            $(_(Ir), {
              modelValue: s.value,
              "onUpdate:modelValue": [
                v[1] || (v[1] = (g) => s.value = g),
                i
              ],
              class: "am-pm-radio-btn",
              label: "PM",
              value: "pm"
            }, null, 8, ["modelValue"])
          ])
        ]))
      ]);
    };
  }
}), A$ = /* @__PURE__ */ T(P$, [["__scopeId", "data-v-b11d8b2f"]]), L$ = { class: "date-picker" }, H$ = ["id", "disabled", "value", "placeholder", "data-external"], V$ = /* @__PURE__ */ A({
  __name: "FriedDateTimeInput",
  props: {
    modelValue: {},
    locale: { default: "" },
    zone: { default: void 0 },
    defaultTime: { default: void 0 },
    disabledDates: { default: void 0 },
    highlightToday: { type: Boolean },
    placeholder: { default: "" },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    errorMessage: { default: "" },
    enableTime: { type: Boolean, default: !1 },
    error: { type: Boolean },
    id: { default: "" },
    appendToBody: { type: Boolean, default: !0 },
    useIsoValue: { type: Boolean },
    dataExternal: { default: void 0 },
    closeAfterSelect: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const o = t, n = xe(5), r = z(
      () => D.fromJSDate(new Date(o.modelValue)).setZone(a.value)
    ), s = z(() => o.id || "input-datepicker-" + n), i = z(() => o.locale || No.locale || void 0), a = z(() => o.zone || No.zone || void 0), c = z(() => o.modelValue ? {
      hour: r.value.hour,
      minute: r.value.minute
    } : o.defaultTime ? o.defaultTime : {
      hour: D.now().setZone(a.value).hour,
      minute: D.now().setZone(a.value).minute
    }), u = z(() => {
      try {
        return !D.local().toLocaleString(
          {
            hour: "numeric"
          },
          { locale: i.value }
        ).includes("M");
      } catch (b) {
        return !D.local().toLocaleString({
          hour: "numeric"
        }).includes("M");
      }
    }), f = (b) => {
      if (o.useIsoValue) {
        const Z = r.value.set(b).toISO();
        p(Z);
        return;
      }
      const N = r.value.set(b).toJSDate();
      p(N);
    }, p = (b) => {
      m("update:modelValue", b), o.closeAfterSelect && (y.value = !1);
    }, v = z(() => {
      if (!o.modelValue) return "";
      if (o.enableTime)
        try {
          return r.value.toLocaleString(
            {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "numeric",
              minute: "numeric"
            },
            { locale: i.value }
          );
        } catch (b) {
          return r.value.toLocaleString({
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric"
          });
        }
      try {
        return r.value.toLocaleString(
          {
            year: "numeric",
            month: "short",
            day: "numeric"
          },
          { locale: i.value }
        );
      } catch (b) {
        return r.value.toLocaleString({
          year: "numeric",
          month: "short",
          day: "numeric"
        });
      }
    }), m = e, g = I(), w = I(), y = I(!1);
    Nx("Escape", () => {
      var b;
      y.value && (y.value = !1, (b = w.value) == null || b.focus());
    });
    const M = (b) => {
      var N;
      b.relatedTarget, !((N = g.value) != null && N.contains(b.relatedTarget)) && (y.value = !1);
    }, B = () => {
      o.disabled || (y.value = !0);
    }, k = () => {
      o.disabled || (y.value = !y.value);
    }, x = () => {
      y.value = !1;
    };
    return (b, N) => (d(), h("div", L$, [
      $(_(Zo), {
        show: y.value,
        placement: _(co).BottomEnd,
        "append-to-body": b.appendToBody
      }, {
        reference: O(() => [
          se((d(), P(_(Uo), {
            class: "input-calendar",
            label: b.label,
            active: "",
            "error-message": b.errorMessage,
            error: b.error,
            disabled: b.disabled,
            focused: y.value,
            for: s.value,
            onClick: k
          }, {
            default: O(() => [
              $(_(U), {
                class: "date-icon",
                icon: "calendar-edit",
                size: _(He).Small
              }, null, 8, ["size"]),
              l("input", {
                id: s.value,
                ref_key: "inputElement",
                ref: w,
                class: "input",
                readonly: "",
                disabled: b.disabled,
                value: v.value,
                type: "text",
                placeholder: b.placeholder,
                "data-external": b.dataExternal,
                onKeyup: [
                  q(B, ["enter"]),
                  q(B, ["space"]),
                  q(B, ["arrow-up"]),
                  q(B, ["arrow-down"]),
                  q(B, ["arrow-left"]),
                  q(B, ["arrow-right"])
                ]
              }, null, 40, H$),
              $(_(U), {
                class: S(["chevron-icon icon", { expanded: y.value }]),
                icon: "chevron-down"
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 8, ["label", "error-message", "error", "disabled", "focused", "for"])), [
            [_(io), x]
          ])
        ]),
        default: O(() => [
          l("div", {
            ref_key: "dateCard",
            ref: g,
            class: S(["date-card", { "enable-time": b.enableTime }]),
            onFocusout: M,
            onMousedown: N[1] || (N[1] = _e(() => {
            }, ["stop", "prevent"]))
          }, [
            $(_2, {
              class: "datepicker",
              "model-value": b.modelValue,
              locale: b.locale,
              zone: b.zone,
              "default-time": c.value,
              "disabled-dates": b.disabledDates,
              "highlight-today": b.highlightToday,
              "use-iso-value": b.useIsoValue,
              "onUpdate:modelValue": N[0] || (N[0] = (Z) => p(Z))
            }, null, 8, ["model-value", "locale", "zone", "default-time", "disabled-dates", "highlight-today", "use-iso-value"]),
            b.enableTime ? (d(), P(A$, {
              key: 0,
              class: "time-picker",
              is24: u.value,
              time: c.value,
              "onUpdate:time": f
            }, null, 8, ["is24", "time"])) : E("", !0)
          ], 34)
        ]),
        _: 1
      }, 8, ["show", "placement", "append-to-body"])
    ]));
  }
}), F$ = /* @__PURE__ */ T(V$, [["__scopeId", "data-v-85c4ff75"]]), I$ = {
  key: 0,
  class: "button-icon left"
}, D$ = { class: "dropdown-item-content" }, N$ = { class: "title" }, R$ = {
  key: 0,
  class: "description"
}, q$ = {
  key: 1,
  class: "button-icon right"
}, W$ = /* @__PURE__ */ A({
  __name: "FriedDropdownItem",
  props: {
    to: { default: null },
    disabled: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const o = t, n = e, { to: r, disabled: s, active: i } = Ke(o), a = (u) => {
      s.value || n("click", u);
    }, c = z(() => r.value ? "router-link" : "button");
    return (u, f) => (d(), P(ro(c.value), {
      to: _(r),
      class: S(["dropdown-item-container", { disabled: _(s), active: _(i) }]),
      onClick: a,
      onKeyup: q(a, ["enter", "space"]),
      onMousedown: f[0] || (f[0] = _e(() => {
      }, ["stop", "prevent"]))
    }, {
      default: O(() => [
        u.$slots.leftIcon ? (d(), h("span", I$, [
          C(u.$slots, "leftIcon", {}, void 0, !0)
        ])) : E("", !0),
        l("div", D$, [
          l("span", N$, [
            C(u.$slots, "default", {}, void 0, !0)
          ]),
          u.$slots.description ? (d(), h("span", R$, [
            C(u.$slots, "description", {}, void 0, !0)
          ])) : E("", !0)
        ]),
        u.$slots.rightIcon ? (d(), h("span", q$, [
          C(u.$slots, "rightIcon", {}, void 0, !0)
        ])) : E("", !0)
      ]),
      _: 3
    }, 40, ["to", "class"]));
  }
}), U$ = /* @__PURE__ */ T(W$, [["__scopeId", "data-v-3f499988"]]), Z$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 52 52"
};
function G$(t, e) {
  return d(), h("svg", Z$, e[0] || (e[0] = [
    l("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M48.701 47.125a3.25 3.25 0 0 1-3.25 3.25h-38.9a3.25 3.25 0 0 1-3.25-3.25V4.875a3.25 3.25 0 0 1 3.25-3.25h32.5a3.25 3.25 0 0 1 2.268.923l6.403 6.246a3.25 3.25 0 0 1 .98 2.327z",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.926 21.125a4.875 4.875 0 1 0 0-9.75 4.875 4.875 0 0 0 0 9.75",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "m40.762 39.435-8.504-12.758a2.19 2.19 0 0 0-3.62-.041l-5.83 8.33-3.615-2.898a2.19 2.19 0 0 0-3.193.496l-4.574 6.87",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m40.762 39.435-8.504-12.758a2.19 2.19 0 0 0-3.62-.041l-5.83 8.33-3.615-2.898a2.19 2.19 0 0 0-3.193.496l-4.574 6.87"
    }, null, -1)
  ]));
}
const Y$ = { render: G$ }, X$ = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 58"
};
function K$(t, e) {
  return d(), h("svg", X$, e[0] || (e[0] = [
    W('<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M48.4 47.5a3.25 3.25 0 0 1-3.25 3.25H6.25A3.25 3.25 0 0 1 3 47.5V5.25A3.25 3.25 0 0 1 6.25 2h32.5a3.25 3.25 0 0 1 2.269.923l6.402 6.246a3.25 3.25 0 0 1 .98 2.327z" clip-rule="evenodd"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 33s1.333-2.5 5-2.5 5 2.5 5 2.5"></path><circle cx="20" cy="24" r="2" fill="currentColor"></circle><circle cx="32" cy="24" r="2" fill="currentColor"></circle><path fill="currentColor" d="M44 17.395C44 18.834 42.88 20 41.5 20S39 18.834 39 17.395C39 15.957 41.5 12 41.5 12s2.5 3.957 2.5 5.395M39 11.047C39 12.125 38.105 13 37 13s-2-.875-2-1.953C35 9.967 37 7 37 7s2 2.968 2 4.047"></path><circle cx="48" cy="50" r="8" fill="currentColor" stroke="currentColor"></circle><path fill="currentColor" d="M45 47h6v6h-6z"></path><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" d="m45 53 6-6M51 53l-6-6"></path>', 8)
  ]));
}
const J$ = { render: K$ }, Q$ = ["for"], eS = ["id", "multiple", "accept", "disabled", "value"], tS = /* @__PURE__ */ A({
  __name: "FriedDropzone",
  props: {
    acceptedFileTypes: { default: "" },
    disabled: { type: Boolean, default: !1 },
    id: { default: "" },
    multiple: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "error"],
  setup(t, { emit: e }) {
    const o = t, n = I(""), r = e, s = (m) => {
      r("update:modelValue", m);
    }, i = xe(5), a = z(() => o.id || `dropzone-${i}`), c = I(!0), u = (m) => {
      if (o.disabled)
        return;
      const { files: g } = m.target;
      if (g != null && g.length) {
        if (o.multiple) {
          p(g);
          return;
        }
        if (c.value = v(g[0]), !c.value) {
          r("error", [g[0].name]);
          return;
        }
        s([g[0]]), n.value = "";
      }
    }, f = (m) => {
      var g;
      if (!o.disabled && (g = m.dataTransfer) != null && g.files.length) {
        if (o.multiple) {
          p(m.dataTransfer.files);
          return;
        }
        if (c.value = v(m.dataTransfer.files[0]), !c.value) {
          r("error", [m.dataTransfer.files[0].name]);
          return;
        }
        s([m.dataTransfer.files[0]]);
      }
    }, p = (m) => {
      const g = [], w = [];
      for (let y = 0; y < m.length; y++)
        v(m[y]) ? g.push(m[y]) : w.push(m[y].name);
      s(g), w.length ? (r("error", w), c.value = !1) : c.value = !0;
    }, v = (m) => {
      const g = (m == null ? void 0 : m.name) || "", w = g.lastIndexOf(".");
      if (w < 0)
        return !1;
      const y = g.substr(w).toLowerCase();
      return o.acceptedFileTypes ? o.acceptedFileTypes.includes(y) : !0;
    };
    return (m, g) => (d(), h("div", {
      class: S(["dropzone-container", { disabled: m.disabled }])
    }, [
      l("label", {
        for: a.value,
        onDrop: _e(f, ["prevent"]),
        onDragover: g[1] || (g[1] = _e(() => {
        }, ["prevent"]))
      }, [
        l("input", {
          id: a.value,
          type: "file",
          multiple: m.multiple,
          accept: m.acceptedFileTypes,
          disabled: m.disabled,
          value: n.value,
          onChange: g[0] || (g[0] = (w) => u(w))
        }, null, 40, eS),
        C(m.$slots, "illustration", {}, () => [
          c.value ? (d(), P(_(Y$), {
            key: 0,
            class: "svg-icon"
          })) : (d(), P(_(J$), {
            key: 1,
            class: "svg-icon"
          })),
          $(Te, null, {
            default: O(() => [
              C(m.$slots, "illustrationText", {}, void 0, !0)
            ]),
            _: 3
          })
        ], !0),
        C(m.$slots, "content", {}, () => [
          $(_(Go), {
            class: S(["title", { disabled: m.disabled }])
          }, {
            default: O(() => [
              C(m.$slots, "title", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["class"]),
          $(Te, {
            class: S(["description", { disabled: m.disabled }])
          }, {
            default: O(() => [
              C(m.$slots, "description", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["class"])
        ], !0)
      ], 40, Q$)
    ], 2));
  }
}), oS = /* @__PURE__ */ T(tS, [["__scopeId", "data-v-faa67239"]]);
var us = "emoji-mart";
const nS = JSON;
var b2 = typeof window != "undefined" && "localStorage" in window;
let Rr, qr;
function rS(t) {
  t || (t = {}), Rr = t.getter, qr = t.setter;
}
function sS(t) {
  us = t;
}
function iS(t) {
  for (let e in t) {
    let o = t[e];
    k2(e, o);
  }
}
function k2(t, e) {
  if (qr)
    qr(t, e);
  else {
    if (!b2) return;
    try {
      window.localStorage[`${us}.${t}`] = nS.stringify(e);
    } catch (o) {
    }
  }
}
function aS(t) {
  if (Rr)
    return Rr(t);
  if (!b2) return;
  try {
    var e = window.localStorage[`${us}.${t}`];
  } catch (o) {
    return;
  }
  if (e)
    return JSON.parse(e);
}
const no = { update: iS, set: k2, get: aS, setNamespace: sS, setHandlers: rS }, kr = [
  "+1",
  "grinning",
  "kissing_heart",
  "heart_eyes",
  "laughing",
  "stuck_out_tongue_winking_eye",
  "sweat_smile",
  "joy",
  "scream",
  "disappointed",
  "unamused",
  "weary",
  "sob",
  "sunglasses",
  "heart",
  "hankey"
];
let Ae, cs, Wr = {};
function y2() {
  cs = !0, Ae = no.get("frequently");
}
function lS(t) {
  cs || y2();
  var { id: e } = t;
  Ae || (Ae = Wr), Ae[e] || (Ae[e] = 0), Ae[e] += 1, no.set("last", e), no.set("frequently", Ae);
}
function dS(t) {
  if (cs || y2(), !Ae) {
    Wr = {};
    const i = [];
    let a = Math.min(t, kr.length);
    for (let c = 0; c < a; c++)
      Wr[kr[c]] = parseInt((a - c) / 4, 10) + 1, i.push(kr[c]);
    return i;
  }
  const e = t, o = [];
  for (let i in Ae)
    Ae.hasOwnProperty(i) && o.push(i);
  const r = o.sort((i, a) => Ae[i] - Ae[a]).reverse().slice(0, e), s = no.get("last");
  return s && r.indexOf(s) == -1 && (r.pop(), r.push(s)), r;
}
const bi = { add: lS, get: dS }, uS = {
  activity: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"/></svg>',
  custom: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g transform="translate(2.000000, 1.000000)"><rect id="Rectangle" x="8" y="0" width="3" height="21" rx="1.5"></rect><rect id="Rectangle" transform="translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) " x="8.343" y="0.049" width="3" height="21" rx="1.5"></rect><rect id="Rectangle" transform="translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) " x="8.343" y="0.049" width="3" height="21" rx="1.5"></rect></g></svg>',
  flags: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"/></svg>',
  foods: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"/></svg>',
  nature: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"/><path d="M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"/></svg>',
  objects: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"/><path d="M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"/></svg>',
  smileys: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"/><path d="M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"/></svg>',
  people: '<svg xmlns:svg="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24"> <path id="path3814" d="m 3.3591089,21.17726 c 0.172036,0.09385 4.265994,2.29837 8.8144451,2.29837 4.927767,0 8.670894,-2.211883 8.82782,-2.306019 0.113079,-0.06785 0.182268,-0.190051 0.182267,-0.321923 0,-3.03119 -0.929494,-5.804936 -2.617196,-7.810712 -1.180603,-1.403134 -2.661918,-2.359516 -4.295699,-2.799791 4.699118,-2.236258 3.102306,-9.28617162 -2.097191,-9.28617162 -5.1994978,0 -6.7963103,7.04991362 -2.097192,9.28617162 -1.6337821,0.440275 -3.1150971,1.396798 -4.2956991,2.799791 -1.687703,2.005776 -2.617196,4.779522 -2.617196,7.810712 1.2e-6,0.137378 0.075039,0.263785 0.195641,0.329572 z M 8.0439319,5.8308783 C 8.0439309,2.151521 12.492107,0.30955811 15.093491,2.9109411 17.694874,5.5123241 15.852911,9.9605006 12.173554,9.9605 9.8938991,9.9579135 8.0465186,8.1105332 8.0439319,5.8308783 Z m -1.688782,7.6894977 c 1.524535,-1.811449 3.5906601,-2.809035 5.8184041,-2.809035 2.227744,0 4.293869,0.997586 5.818404,2.809035 1.533639,1.822571 2.395932,4.339858 2.439152,7.108301 -0.803352,0.434877 -4.141636,2.096112 -8.257556,2.096112 -3.8062921,0 -7.3910861,-1.671043 -8.2573681,-2.104981 0.04505,-2.765017 0.906968,-5.278785 2.438964,-7.099432 z" /> <path id="path3816" d="M 12.173828 0.38867188 C 9.3198513 0.38867187 7.3770988 2.3672285 6.8652344 4.6308594 C 6.4218608 6.5916015 7.1153562 8.7676117 8.9648438 10.126953 C 7.6141249 10.677376 6.3550511 11.480944 5.3496094 12.675781 C 3.5629317 14.799185 2.6015625 17.701475 2.6015625 20.847656 C 2.6015654 21.189861 2.7894276 21.508002 3.0898438 21.671875 C 3.3044068 21.788925 7.4436239 24.039062 12.173828 24.039062 C 17.269918 24.039062 21.083568 21.776786 21.291016 21.652344 C 21.57281 21.483266 21.746097 21.176282 21.746094 20.847656 C 21.746094 17.701475 20.78277 14.799185 18.996094 12.675781 C 17.990455 11.480591 16.733818 10.675362 15.382812 10.125 C 17.231132 8.7655552 17.925675 6.5910701 17.482422 4.6308594 C 16.970557 2.3672285 15.027805 0.38867188 12.173828 0.38867188 z M 12.792969 2.3007812 C 13.466253 2.4161792 14.125113 2.7383941 14.695312 3.3085938 C 15.835712 4.4489931 15.985604 5.9473549 15.46875 7.1953125 C 14.951896 8.4432701 13.786828 9.3984378 12.173828 9.3984375 C 10.197719 9.3961954 8.607711 7.806187 8.6054688 5.8300781 C 8.6054683 4.2170785 9.5606362 3.0520102 10.808594 2.5351562 C 11.432573 2.2767293 12.119685 2.1853833 12.792969 2.3007812 z M 12.173828 11.273438 C 14.233647 11.273438 16.133674 12.185084 17.5625 13.882812 C 18.93069 15.508765 19.698347 17.776969 19.808594 20.283203 C 18.807395 20.800235 15.886157 22.162109 12.173828 22.162109 C 8.7614632 22.162109 5.6245754 20.787069 4.5390625 20.265625 C 4.6525896 17.766717 5.4203315 15.504791 6.7851562 13.882812 C 8.2139827 12.185084 10.11401 11.273438 12.173828 11.273438 z " /> </svg>',
  places: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"/><path d="M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"/></svg>',
  recent: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"/><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"/></svg>',
  symbols: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"/></svg>'
}, cS = {
  props: {
    i18n: {
      type: Object,
      required: !0
    },
    color: {
      type: String
    },
    categories: {
      type: Array,
      required: !0
    },
    activeCategory: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  created() {
    this.svgs = uS;
  }
}, hS = {
  role: "tablist",
  class: "emoji-mart-anchors"
}, fS = ["aria-label", "aria-selected", "data-title", "onClick"], pS = ["innerHTML"];
function mS(t, e, o, n, r, s) {
  return d(), h("div", hS, [
    (d(!0), h(oe, null, ce(o.categories, (i) => (d(), h("button", {
      role: "tab",
      type: "button",
      "aria-label": i.name,
      "aria-selected": i.id == o.activeCategory.id,
      key: i.id,
      class: S({
        "emoji-mart-anchor": !0,
        "emoji-mart-anchor-selected": i.id == o.activeCategory.id
      }),
      style: re({ color: i.id == o.activeCategory.id ? o.color : "" }),
      "data-title": o.i18n.categories[i.id],
      onClick: (a) => t.$emit("click", i)
    }, [
      l("div", {
        "aria-hidden": "true",
        innerHTML: t.svgs[i.id]
      }, null, 8, pS),
      l("span", {
        "aria-hidden": "true",
        class: "emoji-mart-anchor-bar",
        style: re({ backgroundColor: o.color })
      }, null, 4)
    ], 14, fS))), 128))
  ]);
}
const vS = /* @__PURE__ */ T(cS, [["render", mS]]);
function x2(t, e) {
  var o = {};
  for (let n in t) {
    let r = t[n], s = r;
    e.hasOwnProperty(n) && (s = e[n]), typeof s == "object" && (s = x2(r, s)), o[n] = s;
  }
  return o;
}
function gS() {
  if (typeof document == "undefined") return 0;
  const t = document.createElement("div");
  t.style.width = "100px", t.style.height = "100px", t.style.overflow = "scroll", t.style.position = "absolute", t.style.top = "-9999px", document.body.appendChild(t);
  const e = t.offsetWidth - t.clientWidth;
  return document.body.removeChild(t), e;
}
class C2 {
  /**
   * emoji - Emoji to display
   * set - string, emoji set name
   * native - boolean, whether to render native emoji
   * fallback - fallback function to render missing emoji, optional
   * emojiTooltip - wether we need to show the emoji tooltip, optional
   * emojiSize - emoji size in pixels, optional
   */
  constructor(e, o, n, r, s, i, a) {
    this._emoji = e, this._native = r, this._skin = o, this._set = n, this._fallback = s, this.canRender = this._canRender(), this.cssClass = this._cssClass(), this.cssStyle = this._cssStyle(a), this.content = this._content(), this.title = i === !0 ? e.short_name : null, this.ariaLabel = e.ariaLabel(), Object.freeze(this);
  }
  getEmoji() {
    return this._emoji.getSkin(this._skin);
  }
  _canRender() {
    return this._isCustom() || this._isNative() || this._hasEmoji() || this._fallback;
  }
  _cssClass() {
    return ["emoji-set-" + this._set, "emoji-type-" + this._emojiType()];
  }
  _cssStyle(e) {
    let o = {};
    return this._isCustom() ? o = {
      backgroundImage: "url(" + this.getEmoji()._data.imageUrl + ")",
      backgroundSize: "100%",
      width: e + "px",
      height: e + "px"
    } : this._hasEmoji() && !this._isNative() && (o = {
      backgroundPosition: this.getEmoji().getPosition()
    }), e && (this._isNative() ? o = Object.assign(o, {
      // font-size is used for native emoji which we need
      // to scale with 0.95 factor to have them look approximately
      // the same size as image-based emoji.
      fontSize: Math.round(e * 0.95 * 10) / 10 + "px"
    }) : o = Object.assign(o, {
      width: e + "px",
      height: e + "px"
    })), o;
  }
  _content() {
    return this._isCustom() ? "" : this._isNative() ? this.getEmoji().native : this._hasEmoji() ? "" : this._fallback ? this._fallback(this.getEmoji()) : null;
  }
  _isNative() {
    return this._native;
  }
  _isCustom() {
    return this.getEmoji().custom;
  }
  _hasEmoji() {
    if (!this.getEmoji()._data)
      return !1;
    const e = this.getEmoji()._data["has_img_" + this._set];
    return e === void 0 ? !0 : e;
  }
  _emojiType() {
    return this._isCustom() ? "custom" : this._isNative() ? "native" : this._hasEmoji() ? "image" : "fallback";
  }
}
const _S = {
  native: {
    type: Boolean,
    default: !1
  },
  tooltip: {
    type: Boolean,
    default: !1
  },
  fallback: {
    type: Function
  },
  skin: {
    type: Number,
    default: 1
  },
  set: {
    type: String,
    default: "apple"
  },
  emoji: {
    type: [String, Object],
    required: !0
  },
  size: {
    type: Number,
    default: null
  },
  tag: {
    type: String,
    default: "span"
  }
}, wS = {
  perLine: {
    type: Number,
    default: 9
  },
  maxSearchResults: {
    type: Number,
    default: 75
  },
  emojiSize: {
    type: Number,
    default: 24
  },
  title: {
    type: String,
    default: "Emoji Mart™"
  },
  emoji: {
    type: String,
    default: "department_store"
  },
  color: {
    type: String,
    default: "#ae65c5"
  },
  set: {
    type: String,
    default: "apple"
  },
  skin: {
    type: Number,
    default: null
  },
  defaultSkin: {
    type: Number,
    default: 1
  },
  native: {
    type: Boolean,
    default: !1
  },
  emojiTooltip: {
    type: Boolean,
    default: !1
  },
  autoFocus: {
    type: Boolean,
    default: !1
  },
  i18n: {
    type: Object,
    default() {
      return {};
    }
  },
  showPreview: {
    type: Boolean,
    default: !0
  },
  showSearch: {
    type: Boolean,
    default: !0
  },
  showCategories: {
    type: Boolean,
    default: !0
  },
  showSkinTones: {
    type: Boolean,
    default: !0
  },
  infiniteScroll: {
    type: Boolean,
    default: !0
  },
  pickerStyles: {
    type: Object,
    default() {
      return {};
    }
  }
}, bS = {
  props: R(j({}, _S), {
    data: {
      type: Object,
      required: !0
    }
  }),
  emits: ["click"],
  computed: {
    view() {
      return new C2(
        this.emojiObject,
        this.skin,
        this.set,
        this.native,
        this.fallback,
        this.tooltip,
        this.size
      );
    },
    sanitizedData() {
      return this.emojiObject._sanitized;
    },
    title() {
      return this.tooltip ? this.emojiObject.short_name : null;
    },
    emojiObject() {
      return typeof this.emoji == "string" ? this.data.findEmoji(this.emoji) : this.emoji;
    }
  },
  created() {
  },
  methods: {
    onClick() {
      this.$emit("click", this.emojiObject);
    },
    onMouseEnter() {
      this.$emit("mouseenter", this.emojiObject);
    },
    onMouseLeave() {
      this.$emit("mouseleave", this.emojiObject);
    }
  }
};
function kS(t, e, o, n, r, s) {
  return s.view.canRender ? (d(), P(ro(t.tag), {
    key: 0,
    title: s.view.title,
    "aria-label": s.view.ariaLabel,
    "data-title": s.title,
    class: "emoji-mart-emoji",
    onMouseenter: s.onMouseEnter,
    onMouseleave: s.onMouseLeave,
    onClick: s.onClick
  }, {
    default: O(() => [
      l("span", {
        class: S(s.view.cssClass),
        style: re(s.view.cssStyle)
      }, F(s.view.content), 7)
    ]),
    _: 1
  }, 40, ["title", "aria-label", "data-title", "onMouseenter", "onMouseleave", "onClick"])) : E("", !0);
}
const M2 = /* @__PURE__ */ T(bS, [["render", kS]]), yS = {
  props: {
    data: {
      type: Object,
      required: !0
    },
    i18n: {
      type: Object,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    emojis: {
      type: Array
    },
    emojiProps: {
      type: Object,
      required: !0
    }
  },
  methods: {
    activeClass: function(t) {
      return !this.emojiProps.selectedEmoji || !this.emojiProps.selectedEmojiCategory ? "" : this.emojiProps.selectedEmoji.id == t.id && this.emojiProps.selectedEmojiCategory.id == this.id ? "emoji-mart-emoji-selected" : "";
    }
  },
  computed: {
    isVisible() {
      return !!this.emojis;
    },
    isSearch() {
      return this.name == "Search";
    },
    hasResults() {
      return this.emojis.length > 0;
    },
    emojiObjects() {
      return this.emojis.map((t) => {
        let e = t, o = new C2(
          t,
          this.emojiProps.skin,
          this.emojiProps.set,
          this.emojiProps.native,
          this.emojiProps.fallback,
          this.emojiProps.emojiTooltip,
          this.emojiProps.emojiSize
        );
        return { emojiObject: e, emojiView: o };
      });
    }
  },
  components: {
    Emoji: M2
  }
}, xS = ["aria-label"], CS = { class: "emoji-mart-category-label" }, MS = { class: "emoji-mart-category-label" }, $S = ["aria-label", "data-title", "title", "onMouseenter", "onMouseleave", "onClick"], SS = { key: 0 }, jS = { class: "emoji-mart-no-results-label" };
function OS(t, e, o, n, r, s) {
  const i = be("emoji");
  return s.isVisible && (s.isSearch || s.hasResults) ? (d(), h("section", {
    key: 0,
    class: S({
      "emoji-mart-category": !0,
      "emoji-mart-no-results": !s.hasResults
    }),
    "aria-label": o.i18n.categories[o.id]
  }, [
    l("div", CS, [
      l("h3", MS, F(o.i18n.categories[o.id]), 1)
    ]),
    (d(!0), h(oe, null, ce(s.emojiObjects, ({ emojiObject: a, emojiView: c }) => (d(), h(oe, null, [
      c.canRender ? (d(), h("button", {
        "aria-label": c.ariaLabel,
        role: "option",
        "aria-selected": "false",
        "aria-posinset": "1",
        "aria-setsize": "1812",
        type: "button",
        "data-title": a.short_name,
        key: a.id,
        title: c.title,
        class: S(["emoji-mart-emoji", s.activeClass(a)]),
        onMouseenter: (u) => o.emojiProps.onEnter(c.getEmoji()),
        onMouseleave: (u) => o.emojiProps.onLeave(c.getEmoji()),
        onClick: (u) => o.emojiProps.onClick(c.getEmoji())
      }, [
        l("span", {
          class: S(c.cssClass),
          style: re(c.cssStyle)
        }, F(c.content), 7)
      ], 42, $S)) : E("", !0)
    ], 64))), 256)),
    s.hasResults ? E("", !0) : (d(), h("div", SS, [
      $(i, {
        data: o.data,
        emoji: "sleuth_or_spy",
        native: o.emojiProps.native,
        skin: o.emojiProps.skin,
        set: o.emojiProps.set
      }, null, 8, ["data", "native", "skin", "set"]),
      l("div", jS, F(o.i18n.notfound), 1)
    ]))
  ], 10, xS)) : E("", !0);
}
const TS = /* @__PURE__ */ T(yS, [["render", OS]]), zS = {
  props: {
    skin: {
      type: Number,
      required: !0
    }
  },
  data() {
    return {
      opened: !1
    };
  },
  methods: {
    onClick(t) {
      this.opened && t != this.skin && this.$emit("change", t), this.opened = !this.opened;
    }
  }
}, BS = ["onClick"];
function ES(t, e, o, n, r, s) {
  return d(), h("div", {
    class: S({ "emoji-mart-skin-swatches": !0, "emoji-mart-skin-swatches-opened": r.opened })
  }, [
    (d(), h(oe, null, ce(6, (i) => l("span", {
      key: i,
      class: S({ "emoji-mart-skin-swatch": !0, "emoji-mart-skin-swatch-selected": o.skin == i })
    }, [
      l("span", {
        class: S("emoji-mart-skin emoji-mart-skin-tone-" + i),
        onClick: (a) => s.onClick(i)
      }, null, 10, BS)
    ], 2)), 64))
  ], 2);
}
const PS = /* @__PURE__ */ T(zS, [["render", ES]]), AS = {
  props: {
    data: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    emoji: {
      type: [String, Object]
    },
    idleEmoji: {
      type: [String, Object],
      required: !0
    },
    showSkinTones: {
      type: Boolean,
      default: !0
    },
    emojiProps: {
      type: Object,
      required: !0
    },
    skinProps: {
      type: Object,
      required: !0
    },
    onSkinChange: {
      type: Function,
      required: !0
    }
  },
  computed: {
    emojiData() {
      return this.emoji ? this.emoji : {};
    },
    emojiShortNames() {
      return this.emojiData.short_names;
    },
    emojiEmoticons() {
      return this.emojiData.emoticons;
    }
  },
  components: {
    Emoji: M2,
    Skins: PS
  }
}, LS = { class: "emoji-mart-preview" }, HS = { class: "emoji-mart-preview-emoji" }, VS = { class: "emoji-mart-preview-data" }, FS = { class: "emoji-mart-preview-name" }, IS = { class: "emoji-mart-preview-shortnames" }, DS = { class: "emoji-mart-preview-emoticons" }, NS = { class: "emoji-mart-preview-emoji" }, RS = { class: "emoji-mart-preview-data" }, qS = { class: "emoji-mart-title-label" }, WS = {
  key: 0,
  class: "emoji-mart-preview-skins"
};
function US(t, e, o, n, r, s) {
  const i = be("emoji"), a = be("skins");
  return d(), h("div", LS, [
    o.emoji ? (d(), h(oe, { key: 0 }, [
      l("div", HS, [
        $(i, {
          data: o.data,
          emoji: o.emoji,
          native: o.emojiProps.native,
          skin: o.emojiProps.skin,
          set: o.emojiProps.set
        }, null, 8, ["data", "emoji", "native", "skin", "set"])
      ]),
      l("div", VS, [
        l("div", FS, F(o.emoji.name), 1),
        l("div", IS, [
          (d(!0), h(oe, null, ce(s.emojiShortNames, (c) => (d(), h("span", {
            key: c,
            class: "emoji-mart-preview-shortname"
          }, ":" + F(c) + ":", 1))), 128))
        ]),
        l("div", DS, [
          (d(!0), h(oe, null, ce(s.emojiEmoticons, (c) => (d(), h("span", {
            key: c,
            class: "emoji-mart-preview-emoticon"
          }, F(c), 1))), 128))
        ])
      ])
    ], 64)) : (d(), h(oe, { key: 1 }, [
      l("div", NS, [
        $(i, {
          data: o.data,
          emoji: o.idleEmoji,
          native: o.emojiProps.native,
          skin: o.emojiProps.skin,
          set: o.emojiProps.set
        }, null, 8, ["data", "emoji", "native", "skin", "set"])
      ]),
      l("div", RS, [
        l("span", qS, F(o.title), 1)
      ]),
      o.showSkinTones ? (d(), h("div", WS, [
        $(a, {
          skin: o.skinProps.skin,
          onChange: e[0] || (e[0] = (c) => o.onSkinChange(c))
        }, null, 8, ["skin"])
      ])) : E("", !0)
    ], 64))
  ]);
}
const ZS = /* @__PURE__ */ T(AS, [["render", US]]), GS = {
  props: {
    data: {
      type: Object,
      required: !0
    },
    i18n: {
      type: Object,
      required: !0
    },
    autoFocus: {
      type: Boolean,
      default: !1
    },
    onSearch: {
      type: Function,
      required: !0
    },
    onArrowLeft: {
      type: Function,
      required: !1
    },
    onArrowRight: {
      type: Function,
      required: !1
    },
    onArrowDown: {
      type: Function,
      required: !1
    },
    onArrowUp: {
      type: Function,
      required: !1
    },
    onEnter: {
      type: Function,
      required: !1
    }
  },
  data() {
    return {
      value: ""
    };
  },
  computed: {
    emojiIndex() {
      return this.data;
    }
  },
  watch: {
    value() {
      this.$emit("search", this.value);
    }
  },
  methods: {
    clear() {
      this.value = "";
    }
  },
  mounted() {
    let t = this.$el.querySelector("input");
    this.autoFocus && t.focus();
  }
}, YS = { class: "emoji-mart-search" }, XS = ["placeholder"];
function KS(t, e, o, n, r, s) {
  return d(), h("div", YS, [
    se(l("input", {
      type: "text",
      placeholder: o.i18n.search,
      role: "textbox",
      "aria-autocomplete": "list",
      "aria-owns": "emoji-mart-list",
      "aria-label": "Search for an emoji",
      "aria-describedby": "emoji-mart-search-description",
      onKeydown: [
        e[0] || (e[0] = q((i) => t.$emit("arrowLeft", i), ["left"])),
        e[1] || (e[1] = q(() => t.$emit("arrowRight"), ["right"])),
        e[2] || (e[2] = q(() => t.$emit("arrowDown"), ["down"])),
        e[3] || (e[3] = q((i) => t.$emit("arrowUp", i), ["up"])),
        e[4] || (e[4] = q(() => t.$emit("enter"), ["enter"]))
      ],
      "onUpdate:modelValue": e[5] || (e[5] = (i) => r.value = i)
    }, null, 40, XS), [
      [yi, r.value]
    ]),
    e[6] || (e[6] = l("span", {
      class: "hidden",
      id: "emoji-picker-search-description"
    }, "Use the left, right, up and down arrow keys to navigate the emoji search results.", -1))
  ]);
}
const JS = /* @__PURE__ */ T(GS, [["render", KS]]);
var QS = typeof window != "undefined";
QS && function() {
  for (var t = 0, e = ["ms", "moz", "webkit", "o"], o = 0; o < e.length && !window.requestAnimationFrame; ++o)
    window.requestAnimationFrame = window[e[o] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[e[o] + "CancelAnimationFrame"] || window[e[o] + "CancelRequestAnimationFrame"];
  window.requestAnimationFrame || (window.requestAnimationFrame = function(n, r) {
    var s = (/* @__PURE__ */ new Date()).getTime(), i = Math.max(0, 16 - (s - t)), a = window.setTimeout(function() {
      n(s + i);
    }, i);
    return t = s + i, a;
  }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(n) {
    clearTimeout(n);
  });
}();
class ej {
  constructor(e) {
    this._vm = e, this._data = e.data, this._perLine = e.perLine, this._categories = [], this._categories.push(...this._data.categories()), this._categories = this._categories.filter((o) => o.emojis.length > 0), this._categories[0].first = !0, Object.freeze(this._categories), this.activeCategory = this._categories[0], this.searchEmojis = null, this.previewEmoji = null, this.previewEmojiCategoryIdx = 0, this.previewEmojiIdx = -1;
  }
  onScroll() {
    const o = this._vm.$refs.scroll.scrollTop;
    let n = this.filteredCategories[0];
    for (let r = 0, s = this.filteredCategories.length; r < s; r++) {
      let i = this.filteredCategories[r], a = this._vm.getCategoryComponent(r);
      if (a && a.$el.offsetTop - 50 > o)
        break;
      n = i;
    }
    this.activeCategory = n;
  }
  get allCategories() {
    return this._categories;
  }
  get filteredCategories() {
    return this.searchEmojis ? [
      {
        id: "search",
        name: "Search",
        emojis: this.searchEmojis
      }
    ] : this._categories.filter((e) => e.emojis.length > 0);
  }
  get previewEmojiCategory() {
    return this.previewEmojiCategoryIdx >= 0 ? this.filteredCategories[this.previewEmojiCategoryIdx] : null;
  }
  onAnchorClick(e) {
    if (this.searchEmojis)
      return;
    let o = this.filteredCategories.indexOf(e), n = this._vm.getCategoryComponent(o), r = () => {
      if (n) {
        let s = n.$el.offsetTop;
        e.first && (s = 0), this._vm.$refs.scroll.scrollTop = s;
      }
    };
    this._vm.infiniteScroll ? r() : this.activeCategory = this.filteredCategories[o];
  }
  onSearch(e) {
    let o = this._data.search(e, this.maxSearchResults);
    this.searchEmojis = o, this.previewEmojiCategoryIdx = 0, this.previewEmojiIdx = 0, this.updatePreviewEmoji();
  }
  onEmojiEnter(e) {
    this.previewEmoji = e, this.previewEmojiIdx = -1, this.previewEmojiCategoryIdx = -1;
  }
  onEmojiLeave(e) {
    this.previewEmoji = null;
  }
  onArrowLeft() {
    this.previewEmojiIdx > 0 ? this.previewEmojiIdx -= 1 : (this.previewEmojiCategoryIdx -= 1, this.previewEmojiCategoryIdx < 0 ? this.previewEmojiCategoryIdx = 0 : this.previewEmojiIdx = this.filteredCategories[this.previewEmojiCategoryIdx].emojis.length - 1), this.updatePreviewEmoji();
  }
  onArrowRight() {
    this.previewEmojiIdx < this.emojisLength(this.previewEmojiCategoryIdx) - 1 ? this.previewEmojiIdx += 1 : (this.previewEmojiCategoryIdx += 1, this.previewEmojiCategoryIdx >= this.filteredCategories.length ? this.previewEmojiCategoryIdx = this.filteredCategories.length - 1 : this.previewEmojiIdx = 0), this.updatePreviewEmoji();
  }
  onArrowDown() {
    if (this.previewEmojiIdx == -1)
      return this.onArrowRight();
    const e = this.filteredCategories[this.previewEmojiCategoryIdx].emojis.length;
    let o = this._perLine;
    this.previewEmojiIdx + o > e && (o = e % this._perLine);
    for (let n = 0; n < o; n++)
      this.onArrowRight();
    this.updatePreviewEmoji();
  }
  onArrowUp() {
    let e = this._perLine;
    this.previewEmojiIdx - e < 0 && (this.previewEmojiCategoryIdx > 0 ? e = this.filteredCategories[this.previewEmojiCategoryIdx - 1].emojis.length % this._perLine : e = 0);
    for (let o = 0; o < e; o++)
      this.onArrowLeft();
    this.updatePreviewEmoji();
  }
  updatePreviewEmoji() {
    this.previewEmoji = this.filteredCategories[this.previewEmojiCategoryIdx].emojis[this.previewEmojiIdx], this._vm.$nextTick(() => {
      const e = this._vm.$refs.scroll, o = e.querySelector(".emoji-mart-emoji-selected"), n = e.offsetTop - e.offsetHeight;
      o && o.offsetTop + o.offsetHeight > n + e.scrollTop && (e.scrollTop += o.offsetHeight), o && o.offsetTop < e.scrollTop && (e.scrollTop -= o.offsetHeight);
    });
  }
  emojisLength(e) {
    return e == -1 ? 0 : this.filteredCategories[e].emojis.length;
  }
}
const tj = {
  search: "Search",
  notfound: "No Emoji Found",
  categories: {
    search: "Search Results",
    recent: "Frequently Used",
    smileys: "Smileys & Emotion",
    people: "People & Body",
    nature: "Animals & Nature",
    foods: "Food & Drink",
    activity: "Activity",
    places: "Travel & Places",
    objects: "Objects",
    symbols: "Symbols",
    flags: "Flags",
    custom: "Custom"
  }
}, oj = {
  props: R(j({}, wS), {
    data: {
      type: Object,
      required: !0
    }
  }),
  data() {
    return {
      activeSkin: this.skin || no.get("skin") || this.defaultSkin,
      view: new ej(this)
    };
  },
  computed: {
    customStyles() {
      return j({
        width: this.calculateWidth + "px"
      }, this.pickerStyles);
    },
    emojiProps() {
      return {
        native: this.native,
        skin: this.activeSkin,
        set: this.set,
        emojiTooltip: this.emojiTooltip,
        emojiSize: this.emojiSize,
        selectedEmoji: this.view.previewEmoji,
        selectedEmojiCategory: this.view.previewEmojiCategory,
        onEnter: this.onEmojiEnter.bind(this),
        onLeave: this.onEmojiLeave.bind(this),
        onClick: this.onEmojiClick.bind(this)
      };
    },
    skinProps() {
      return {
        skin: this.activeSkin
      };
    },
    calculateWidth() {
      return this.perLine * (this.emojiSize + 12) + 12 + 2 + gS();
    },
    // emojisPerRow() {
    //   const listEl = this.$refs.scrollContent
    //   const emojiEl = listEl.querySelector('.emoji-mart-emoji')
    //   return Math.floor(listEl.offsetWidth / emojiEl.offsetWidth)
    // },
    filteredCategories() {
      return this.view.filteredCategories;
    },
    mergedI18n() {
      return Object.freeze(x2(tj, this.i18n));
    },
    idleEmoji() {
      try {
        return this.data.emoji(this.emoji);
      } catch (t) {
        return console.error(
          "Default preview emoji `" + this.emoji + "` is not available, check the Picker `emoji` property"
        ), console.error(t), this.data.firstEmoji();
      }
    }
  },
  methods: {
    onScroll() {
      this.infiniteScroll && !this.waitingForPaint && (this.waitingForPaint = !0, window.requestAnimationFrame(this.onScrollPaint.bind(this)));
    },
    onScrollPaint() {
      this.waitingForPaint = !1, this.view.onScroll();
    },
    onAnchorClick(t) {
      this.view.onAnchorClick(t);
    },
    onSearch(t) {
      this.view.onSearch(t);
    },
    onEmojiEnter(t) {
      this.view.onEmojiEnter(t);
    },
    onEmojiLeave(t) {
      this.view.onEmojiLeave(t);
    },
    onArrowLeft(t) {
      const e = this.view.previewEmojiIdx;
      this.view.onArrowLeft(), t && this.view.previewEmojiIdx !== e && t.preventDefault();
    },
    onArrowRight() {
      this.view.onArrowRight();
    },
    onArrowDown() {
      this.view.onArrowDown();
    },
    onArrowUp(t) {
      this.view.onArrowUp(), t.preventDefault();
    },
    onEnter(t) {
      this.$emit("select", this.view.previewEmoji), bi.add(this.view.previewEmoji);
    },
    onEmojiClick(t) {
      this.$emit("select", t), bi.add(t);
    },
    onSkinChange(t) {
      this.activeSkin = t, no.update({ skin: t }), this.$emit("skin-change", t);
    },
    getCategoryComponent(t) {
      let e = this.$refs["categories_" + t];
      return e && "0" in e ? e[0] : e;
    }
  },
  components: {
    Anchors: vS,
    Category: TS,
    Preview: ZS,
    Search: JS
  }
}, nj = {
  key: 0,
  class: "emoji-mart-bar emoji-mart-bar-anchors"
}, rj = {
  id: "emoji-mart-list",
  ref: "scrollContent",
  role: "listbox",
  "aria-expanded": "true"
}, sj = {
  key: 0,
  class: "emoji-mart-bar emoji-mart-bar-preview"
};
function ij(t, e, o, n, r, s) {
  const i = be("anchors"), a = be("search"), c = be("category"), u = be("preview");
  return d(), h("section", {
    class: "emoji-mart emoji-mart-static",
    style: re(s.customStyles)
  }, [
    t.showCategories ? (d(), h("div", nj, [
      $(i, {
        data: o.data,
        i18n: s.mergedI18n,
        color: t.color,
        categories: r.view.allCategories,
        "active-category": r.view.activeCategory,
        onClick: s.onAnchorClick
      }, null, 8, ["data", "i18n", "color", "categories", "active-category", "onClick"])
    ])) : E("", !0),
    C(t.$slots, "searchTemplate", {
      data: o.data,
      i18n: t.i18n,
      autoFocus: t.autoFocus,
      onSearch: s.onSearch
    }, () => [
      t.showSearch ? (d(), P(a, {
        key: 0,
        ref: "search",
        data: o.data,
        i18n: s.mergedI18n,
        "auto-focus": t.autoFocus,
        "on-search": s.onSearch,
        onSearch: s.onSearch,
        onArrowLeft: s.onArrowLeft,
        onArrowRight: s.onArrowRight,
        onArrowDown: s.onArrowDown,
        onArrowUp: s.onArrowUp,
        onEnter: s.onEnter
      }, null, 8, ["data", "i18n", "auto-focus", "on-search", "onSearch", "onArrowLeft", "onArrowRight", "onArrowDown", "onArrowUp", "onEnter"])) : E("", !0)
    ]),
    l("div", {
      role: "tabpanel",
      class: "emoji-mart-scroll",
      ref: "scroll",
      onScroll: e[0] || (e[0] = (...f) => s.onScroll && s.onScroll(...f))
    }, [
      l("div", rj, [
        (d(!0), h(oe, null, ce(r.view.filteredCategories, (f, p) => se((d(), P(c, {
          ref_for: !0,
          ref: "categories_" + p,
          key: f.id,
          data: o.data,
          i18n: s.mergedI18n,
          id: f.id,
          name: f.name,
          emojis: f.emojis,
          "emoji-props": s.emojiProps
        }, null, 8, ["data", "i18n", "id", "name", "emojis", "emoji-props"])), [
          [yt, t.infiniteScroll || f == r.view.activeCategory]
        ])), 128))
      ], 512)
    ], 544),
    C(t.$slots, "previewTemplate", {
      data: o.data,
      title: t.title,
      emoji: r.view.previewEmoji,
      idleEmoji: s.idleEmoji,
      showSkinTones: t.showSkinTones,
      emojiProps: s.emojiProps,
      skinProps: s.skinProps,
      onSkinChange: s.onSkinChange
    }, () => [
      t.showPreview ? (d(), h("div", sj, [
        $(u, {
          data: o.data,
          title: t.title,
          emoji: r.view.previewEmoji,
          "idle-emoji": s.idleEmoji,
          "show-skin-tones": t.showSkinTones,
          "emoji-props": s.emojiProps,
          "skin-props": s.skinProps,
          "on-skin-change": s.onSkinChange
        }, null, 8, ["data", "title", "emoji", "idle-emoji", "show-skin-tones", "emoji-props", "skin-props", "on-skin-change"])
      ])) : E("", !0)
    ])
  ], 4);
}
const aj = /* @__PURE__ */ T(oj, [["render", ij]]), lj = { class: "emoji-container" }, dj = /* @__PURE__ */ A({
  __name: "FriedEmojiPicker",
  props: {
    localization: {},
    color: { default: "#FE9500" },
    emojiIndex: {}
  },
  emits: ["skin-change", "select"],
  setup(t, { emit: e }) {
    const o = e, n = (s) => {
      o("skin-change", s);
    }, r = (s) => {
      o("select", s);
    };
    return (s, i) => (d(), h("div", lj, [
      $(_(aj), {
        title: s.localization.choose,
        emoji: "point_up",
        color: s.color,
        data: s.emojiIndex,
        i18n: {
          search: s.localization.search,
          notfound: s.localization.notfound,
          categories: {
            search: s.localization.searchresult,
            recent: s.localization.recent,
            smileys: s.localization.smileys,
            people: s.localization.people,
            nature: s.localization.nature,
            foods: s.localization.foods,
            activity: s.localization.activity,
            places: s.localization.places,
            objects: s.localization.objects,
            symbols: s.localization.symbols,
            flags: s.localization.flags,
            custom: s.localization.custom
          }
        },
        onSelect: r,
        onSkinChange: n
      }, null, 8, ["title", "color", "data", "i18n"])
    ]));
  }
}), uj = /* @__PURE__ */ T(dj, [["__scopeId", "data-v-2292cec0"]]), cj = { class: "emoji-dropdown" }, hj = { class: "emoji-list" }, fj = ["id", "onClick", "onKeyup"], pj = ["src", "alt"], mj = {
  key: 1,
  class: "emoji"
}, vj = { class: "emoji-key" }, gj = /* @__PURE__ */ A({
  __name: "FriedInlineEmoji",
  props: {
    matchedEmojis: {},
    skinTone: {},
    selected: { default: void 0 }
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const o = t, n = e, { selected: r } = Ke(o);
    Je(r, () => {
      var c, u;
      if (!((c = o.matchedEmojis) != null && c.length) || !o.selected) return;
      const a = document.getElementById(
        (u = o.matchedEmojis[o.selected]) == null ? void 0 : u.id
      );
      a && a.scrollIntoView({ block: "nearest" });
    });
    const s = (a) => ((a == null ? void 0 : a._skins) && (a == null ? void 0 : a._skins[o.skinTone - 1]) || a).native, i = (a) => {
      n("select", a);
    };
    return (a, c) => (d(), h("div", cj, [
      l("div", hj, [
        (d(!0), h(oe, null, ce(a.matchedEmojis, (u, f) => se((d(), h("div", {
          id: u.id,
          key: u.id,
          class: S(["emoji-list-item", { selected: f === _(r) }]),
          onClick: (p) => i(u),
          onKeyup: q((p) => i(u), ["enter"])
        }, [
          u.custom ? (d(), h("img", {
            key: 0,
            class: "emoji",
            src: u.imageUrl,
            alt: u.name
          }, null, 8, pj)) : (d(), h("span", mj, F(s(u)), 1)),
          l("span", vj, F(u.colons), 1)
        ], 42, fj)), [
          [_(ut)]
        ])), 128))
      ])
    ]));
  }
}), _j = /* @__PURE__ */ T(gj, [["__scopeId", "data-v-1c763534"]]), wj = (t, e, o) => {
  const n = t[e];
  return n ? typeof n == "function" ? n() : Promise.resolve(n) : new Promise((r, s) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      s.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== o ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, bj = ["src", "alt"], kj = { class: "empty-state-text-container" }, yj = /* @__PURE__ */ A({
  __name: "FriedEmptyState",
  props: {
    title: { default: "" },
    icon: { default: "" },
    description: { default: "" },
    maxWidth: { default: 30 },
    iconSize: { default: "default" }
  },
  setup(t) {
    const e = t, o = Fx(() => Q(this, null, function* () {
      return e.icon, (yield wj(/* @__PURE__ */ Object.assign({ "../../assets/emojis/electric-plug.png": () => import("./electric-plug-Bg2sjJfY.mjs"), "../../assets/emojis/eyes.png": () => import("./eyes-DOr_Sr6J.mjs"), "../../assets/emojis/face-with-monocle.png": () => import("./face-with-monocle-BKRjzbYo.mjs"), "../../assets/emojis/link.png": () => import("./link-CS-HSoHr.mjs"), "../../assets/emojis/mailbox-open-lowered-flag.png": () => import("./mailbox-open-lowered-flag-B-YNJsSp.mjs"), "../../assets/emojis/money-with-wings.png": () => import("./money-with-wings-Ch-hLjm3.mjs"), "../../assets/emojis/raising-hands.png": () => import("./raising-hands-DyT4W0db.mjs"), "../../assets/emojis/rocket.png": () => import("./rocket-K9f9g8AI.mjs"), "../../assets/emojis/see-no-evil-monkey.png": () => import("./see-no-evil-monkey-B9RiQ356.mjs"), "../../assets/emojis/sleeping-face.png": () => import("./sleeping-face-CNdClGe-.mjs"), "../../assets/emojis/thought-ballon.png": () => import("./thought-ballon-DPom4HMW.mjs"), "../../assets/emojis/writing-hand.png": () => import("./writing-hand-BN0iQL9e.mjs") }), `../../assets/emojis/${e.icon}.png`, 5)).default;
    }));
    return (n, r) => (d(), h("div", {
      class: "empty-state-container",
      style: re({ "max-width": `${n.maxWidth}rem` })
    }, [
      C(n.$slots, "icon", {}, () => [
        n.icon ? (d(), h("img", {
          key: 0,
          class: S(["empty-state-icon", `icon-size-${n.iconSize}`]),
          src: _(o),
          alt: `${n.icon} icon`
        }, null, 10, bj)) : E("", !0)
      ], !0),
      l("div", kj, [
        $(_(Go), null, {
          default: O(() => [
            K(F(n.title), 1)
          ]),
          _: 1
        }),
        n.description ? (d(), P(Te, { key: 0 }, {
          default: O(() => [
            K(F(n.description), 1)
          ]),
          _: 1
        })) : E("", !0)
      ]),
      C(n.$slots, "cta", {}, void 0, !0)
    ], 4));
  }
}), xj = /* @__PURE__ */ T(yj, [["__scopeId", "data-v-7c76125d"]]), Cj = "data:image/svg+xml,%3csvg%20viewBox='0%200%20249%2048'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cmask%20id='mask0_9073_26197'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='249'%20height='48'%3e%3cpath%20d='M249%200H0V48H249V0Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_9073_26197)'%3e%3cpath%20d='M79.1541%2022.335H71.451C70.4038%2022.335%2069.5499%2023.1912%2069.5499%2024.2412C69.5499%2025.2913%2070.4038%2026.1474%2071.451%2026.1474H77.6305V32.7836C75.6351%2033.8478%2073.3756%2034.406%2071.0689%2034.406C69.1254%2034.4391%2067.2056%2033.9661%2065.5263%2033.0437C64.0167%2032.2065%2062.7715%2030.9246%2061.9318%2029.3401C61.0968%2027.6941%2060.6723%2025.8542%2060.7006%2024C60.6675%2022.0182%2061.1252%2020.0836%2062.0262%2018.4044C62.8374%2016.9097%2064.0923%2015.6846%2065.6536%2014.8711C67.2574%2014.0339%2069.0547%2013.6082%2070.8661%2013.6413C72.234%2013.6413%2073.5502%2013.821%2074.7718%2014.1758C75.9417%2014.5164%2077.1211%2015.0413%2078.39%2015.7887C78.6635%2015.9447%2079.0126%2016.0347%2079.3569%2016.0347H79.4607C79.9513%2016.0347%2080.4324%2015.8265%2080.7769%2015.467C81.126%2015.1029%2081.3099%2014.6252%2081.2909%2014.1285C81.2909%2013.7501%2081.2014%2013.4284%2081.0128%2013.1257C80.8476%2012.8419%2080.64%2012.6291%2080.3711%2012.4777C79.0645%2011.6263%2077.5597%2010.9121%2075.8993%2010.3587C74.1728%209.81472%2072.3472%209.55931%2070.4651%209.59242C68.0122%209.55931%2065.5546%2010.1837%2063.3987%2011.4087C61.3232%2012.5676%2059.5874%2014.3319%2058.375%2016.5172C57.1344%2018.7969%2056.4976%2021.4032%2056.5306%2024.0378C56.4976%2026.5683%2057.1109%2029.1368%2058.3042%2031.4591C59.408%2033.564%2061.1675%2035.3803%2063.262%2036.5724C65.3518%2037.75%2067.6772%2038.365%2070.0217%2038.365C70.201%2038.365%2070.3849%2038.365%2070.5641%2038.3556C73.7247%2038.3556%2076.871%2037.5892%2079.6541%2036.1419C80.1353%2035.9196%2080.5551%2035.5506%2080.8711%2035.0729C81.1683%2034.5904%2081.324%2034.0276%2081.324%2033.4458V24.5251C81.324%2023.3425%2080.3286%2022.3492%2079.1541%2022.3492V22.335Z'%20fill='%23273344'/%3e%3cpath%20d='M99.4569%2018.447C97.9002%2017.4868%2096.0982%2016.9996%2094.2963%2017.0374C92.1923%2017.0043%2090.3998%2017.5057%2088.914%2018.5227C87.4706%2019.4781%2086.3478%2020.8356%2085.6686%2022.4485C84.9751%2024.0852%2084.6213%2025.8494%2084.6213%2027.6942C84.6213%2031.0288%2085.5554%2033.6728%2087.3998%2035.5602C89.2112%2037.4474%2091.7254%2038.384%2095.0652%2038.417C95.2397%2038.4264%2095.4189%2038.4264%2095.5934%2038.4264C97.8577%2038.4264%20100.089%2037.8117%20102.075%2036.6338C102.853%2036.2034%20103.249%2035.631%20103.249%2034.9357C103.249%2034.4344%20103.032%2033.9425%20102.679%2033.6256C102.113%2033.1005%20101.278%2032.9729%20100.532%2033.3086C99.7823%2033.7012%2098.9898%2034.0039%2098.1832%2034.2026C97.301%2034.4012%2096.3341%2034.5054%2095.3859%2034.5054C93.4236%2034.5054%2091.8717%2034.0135%2090.7773%2033.0437C89.7537%2032.1355%2089.112%2030.8774%2088.8762%2029.2929H101.98C103.08%2029.2503%20103.943%2028.3185%20103.9%2027.2259C103.933%2025.4663%20103.561%2023.7635%20102.778%2022.1694C102.014%2020.5991%20100.867%2019.3173%2099.4615%2018.4565L99.4569%2018.447ZM99.7729%2025.7502H88.8479C88.9281%2024.7758%2089.2535%2023.8061%2089.7725%2022.9926C90.2631%2022.2074%2090.9801%2021.5687%2091.8009%2021.1904C93.3859%2020.4099%2095.2019%2020.4099%2096.7868%2021.1904C97.6313%2021.6161%2098.3483%2022.2404%2098.8531%2022.9972C99.3719%2023.8061%2099.6974%2024.7758%2099.7775%2025.7502H99.7729Z'%20fill='%23273344'/%3e%3cpath%20d='M118.905%2034.7939C118.58%2034.4676%20118.165%2034.2972%20117.707%2034.2972C117.556%2034.2972%20117.363%2034.2972%20117.207%2034.335L116.83%2034.4108C116.372%2034.562%20115.905%2034.633%20115.339%2034.633C114.74%2034.6662%20114.141%2034.5338%20113.66%2034.2594C113.283%2034.0417%20113.094%2033.4742%20113.094%2032.5708V21.006H117.203C117.707%2021.0486%20118.203%2020.8451%20118.528%2020.4761C118.868%2020.1356%20119.056%2019.6815%20119.056%2019.2038C119.056%2018.1916%20118.236%2017.3686%20117.226%2017.3686H113.094V14.5211C113.094%2014.2373%20112.995%2013.9724%20112.825%2013.7879C112.674%2013.5656%20112.382%2013.4332%20112.042%2013.4379C111.669%2013.4852%20111.377%2013.6366%20111.188%2013.8636L105.886%2019.0762C105.598%2019.3173%20105.438%2019.6389%20105.438%2019.989C105.438%2020.5661%20105.91%2021.039%20106.485%2021.039H108.985V32.9113C108.985%2036.5344%20111.014%2038.3698%20115.009%2038.3698C116.184%2038.3698%20117.316%2038.1191%20118.368%2037.6271C119.014%2037.3434%20119.434%2036.7001%20119.434%2035.9859C119.434%2035.546%20119.25%2035.1297%20118.905%2034.7844V34.7939Z'%20fill='%23273344'/%3e%3cpath%20d='M137.133%2011.5696C136.901%2011.0729%20136.567%2010.633%20136.156%2010.2925C135.713%209.95664%20135.18%209.78635%20134.581%209.78635H134.227C133.675%209.74852%20133.118%209.92352%20132.623%2010.2972C132.217%2010.6283%20131.882%2011.0682%20131.651%2011.5743L121.679%2035.1959C121.519%2035.475%20121.434%2035.7966%20121.439%2036.1087C121.401%2036.6716%20121.599%2037.2014%20122%2037.6034C122.368%2037.9723%20122.877%2038.1757%20123.429%2038.1757C123.476%2038.1757%20123.528%2038.1758%20123.575%2038.1711C123.981%2038.1711%20124.377%2038.0481%20124.727%2037.8116C125.099%2037.5608%20125.363%2037.2393%20125.519%2036.8609L128%2030.9246H140.897L143.373%2036.8561C143.529%2037.244%20143.793%2037.5656%20144.152%2037.8021C144.464%2038.0339%20144.887%2038.1711%20145.317%2038.1711C145.887%2038.1711%20146.397%2037.9629%20146.798%2037.5608C147.157%2037.1635%20147.35%2036.6432%20147.35%2036.0615C147.312%2035.7492%20147.232%2035.4514%20147.124%2035.1959L137.133%2011.5696ZM139.213%2027.117H129.538L134.378%2015.4434L139.218%2027.117H139.213Z'%20fill='%23FF7900'/%3e%3cpath%20d='M159.874%2020.8782C160.628%2020.8782%20161.35%2020.9776%20162.057%2021.1714C162.902%2021.4647%20163.624%2021.7722%20164.232%2022.089C164.501%2022.283%20164.855%2022.3823%20165.255%2022.3823C165.747%2022.3823%20166.194%2022.179%20166.487%2021.8242C166.596%2021.7391%20166.666%2021.6209%20166.722%2021.5263L166.77%2021.4553C167.015%2021.0532%20167.09%2020.5755%20166.973%2020.1072C166.85%2019.6153%20166.529%2019.1848%20166.09%2018.9247C165.077%2018.3004%20164.143%2017.8415%20163.237%2017.5294C162.076%2017.1178%20160.831%2016.9287%20159.558%2016.9665C157.647%2016.9665%20155.797%2017.4158%20154.204%2018.2672C152.585%2019.114%20151.222%2020.4052%20150.27%2022.004C149.269%2023.6973%20148.759%2025.665%20148.798%2027.6894C148.759%2029.7234%20149.269%2031.691%20150.27%2033.3844C151.222%2034.9783%20152.585%2036.2696%20154.204%2037.1163C155.822%2037.9487%20157.591%2038.384%20159.326%2038.384C159.393%2038.384%20159.458%2038.384%20159.52%2038.384C160.807%2038.384%20162.044%2038.1948%20163.194%2037.8211C164.1%2037.5088%20165.033%2037.0501%20166.058%2036.421C166.166%2036.35%20166.289%2036.2696%20166.412%2036.1467C167.147%2035.4088%20167.161%2034.2215%20166.468%2033.531C166.176%2033.1525%20165.718%2032.9397%20165.209%2032.9397C164.817%2032.9397%20164.491%2033.0769%20164.219%2033.2141C163.595%2033.5404%20162.902%2033.8384%20162.048%2034.1505C161.326%2034.3824%20160.619%2034.477%20159.855%2034.4438C157.689%2034.4438%20155.981%2033.8195%20154.784%2032.585C153.571%2031.3363%20152.957%2029.6808%20152.957%2027.6658C152.957%2025.6508%20153.571%2023.9952%20154.784%2022.7466C155.981%2021.5121%20157.685%2020.8877%20159.855%2020.8877L159.874%2020.8782Z'%20fill='%23FF7900'/%3e%3cpath%20d='M180.394%2020.8782C181.15%2020.8782%20181.866%2020.9776%20182.579%2021.1714C183.423%2021.4647%20184.145%2021.7722%20184.753%2022.089C185.022%2022.283%20185.375%2022.3823%20185.777%2022.3823C186.267%2022.3823%20186.715%2022.179%20187.008%2021.8242C187.116%2021.7391%20187.187%2021.6209%20187.244%2021.5263L187.29%2021.4553C187.535%2021.0532%20187.611%2020.5755%20187.493%2020.112C187.372%2019.6201%20187.05%2019.1896%20186.612%2018.9295C185.597%2018.305%20184.664%2017.8463%20183.758%2017.5341C182.598%2017.1226%20181.352%2016.9334%20180.078%2016.9712C178.167%2016.9712%20176.319%2017.4206%20174.724%2018.272C173.107%2019.1186%20171.742%2020.4099%20170.79%2022.0086C169.79%2023.702%20169.281%2025.6697%20169.319%2027.6942C169.281%2029.728%20169.79%2031.6958%20170.79%2033.389C171.742%2034.9831%20173.107%2036.2744%20174.724%2037.121C176.342%2037.9535%20178.111%2038.3886%20179.848%2038.3886C179.913%2038.3886%20179.98%2038.3886%20180.04%2038.3886C181.328%2038.3886%20182.564%2038.1994%20183.715%2037.8259C184.62%2037.5136%20185.555%2037.0548%20186.579%2036.4258C186.687%2036.3548%20186.809%2036.2744%20186.932%2036.1514C187.286%2035.7967%20187.485%2035.3284%20187.498%2034.8365C187.508%2034.335%20187.319%2033.8621%20186.993%2033.5356C186.7%2033.1573%20186.244%2032.9445%20185.733%2032.9445C185.342%2032.9445%20185.017%2033.0817%20184.743%2033.2187C184.121%2033.5452%20183.427%2033.8431%20182.573%2034.1553C181.851%2034.3872%20181.139%2034.4816%20180.38%2034.4486C178.215%2034.4486%20176.508%2033.8242%20175.309%2032.5896C174.097%2031.3409%20173.484%2029.6854%20173.484%2027.6706C173.484%2025.6555%20174.078%2023.981%20175.309%2022.7513C176.508%2021.5167%20178.215%2020.8924%20180.38%2020.8924L180.394%2020.8782Z'%20fill='%23FF7900'/%3e%3cpath%20d='M204.682%2018.447C203.125%2017.4868%20201.315%2016.9996%20199.521%2017.0375C197.428%2017.0044%20195.626%2017.5057%20194.14%2018.5227C192.696%2019.4781%20191.573%2020.8357%20190.894%2022.4485C190.201%2024.0852%20189.848%2025.8494%20189.848%2027.6942C189.848%2031.0289%20190.781%2033.6728%20192.625%2035.5602C194.437%2037.4426%20197.008%2038.417%20200.258%2038.4548C200.432%2038.4644%20200.612%2038.4644%20200.786%2038.4644C203.05%2038.4644%20205.281%2037.8495%20207.267%2036.6717C208.046%2036.2412%20208.441%2035.6689%20208.441%2034.9737C208.441%2034.4722%20208.225%2033.9803%20207.876%2033.6682C207.527%2033.3228%20207.079%2033.1383%20206.574%2033.1383C206.296%2033.1383%20205.98%2033.2141%20205.72%2033.3418C204.971%2033.7344%20204.178%2034.0371%20203.372%2034.2357C202.489%2034.4344%20201.522%2034.5384%20200.574%2034.5384C198.611%2034.5384%20197.06%2034.0465%20195.965%2033.0769C194.942%2032.1687%20194.3%2030.9105%20194.065%2029.3259H207.202C208.301%2029.2835%20209.163%2028.3517%20209.121%2027.2591C209.155%2025.4995%20208.782%2023.7966%20208.004%2022.2026C207.263%2020.6417%20206.145%2019.3835%20204.687%2018.4517L204.682%2018.447ZM204.998%2025.7502H194.073C194.153%2024.7758%20194.479%2023.8061%20194.998%2022.9926C195.488%2022.2074%20196.206%2021.5687%20197.027%2021.1904C198.611%2020.4099%20200.427%2020.4099%20202.012%2021.1904C202.857%2021.6161%20203.573%2022.2404%20204.079%2022.9972C204.598%2023.8061%20204.923%2024.7758%20205.003%2025.7502H204.998Z'%20fill='%23FF7900'/%3e%3cpath%20d='M228.292%2018.272C226.815%2017.4442%20225.174%2017.0043%20223.546%2017.0043C221.155%2017.0043%20219.008%2017.8651%20217.16%2019.5681V19.27C217.197%2018.7167%20216.965%2018.1396%20216.559%2017.7753C216.168%2017.3828%20215.659%2017.1746%20215.046%2017.1746C213.909%2017.2124%20213.022%2018.1254%20213.022%2019.251V45.1242C213.022%2045.6965%20213.23%2046.2074%20213.621%2046.5999C214.012%2046.9878%20214.513%2047.229%20215.06%2047.2668H215.205C216.325%2047.229%20217.202%2046.2736%20217.164%2045.1572V35.8581C218.985%2037.5562%20221.126%2038.417%20223.546%2038.417C225.24%2038.417%20226.881%2037.9771%20228.296%2037.1447C229.82%2036.2554%20231.069%2034.9641%20231.919%2033.408C232.871%2031.6768%20233.353%2029.7138%20233.319%2027.732C233.353%2025.7548%20232.871%2023.7777%20231.919%2022.0134C231.056%2020.4241%20229.801%2019.1328%20228.292%2018.272ZM217.192%2031.7146V23.7067C217.913%2022.9074%20218.801%2022.2357%20219.829%2021.7013C220.791%2021.1856%20221.909%2020.916%20223.064%2020.916C224.918%2020.916%20226.377%2021.4884%20227.522%2022.6709C228.66%2023.844%20229.211%2025.4853%20229.211%2027.6942C229.211%2029.903%20228.66%2031.5444%20227.522%2032.7174C226.385%2033.8905%20224.929%2034.4722%20223.064%2034.5054C221.942%2034.5054%20220.82%2034.2309%20219.824%2033.7202C218.801%2033.1903%20217.913%2032.514%20217.187%2031.7194L217.192%2031.7146Z'%20fill='%23FF7900'/%3e%3cpath%20d='M248.473%2034.8317C248.147%2034.5054%20247.732%2034.335%20247.274%2034.335C247.123%2034.335%20246.93%2034.335%20246.774%2034.373L246.397%2034.4534C245.939%2034.6046%20245.472%2034.6756%20244.907%2034.6756C244.331%2034.7087%20243.745%2034.5762%20243.264%2034.302C242.887%2034.0843%20242.699%2033.5168%20242.699%2032.6134V21.0486H246.807C247.312%2021.091%20247.807%2020.8877%20248.132%2020.5187C248.481%2020.1688%20248.661%2019.7193%20248.661%2019.2132V19.0998C248.618%2018.1112%20247.812%2017.3402%20246.83%2017.378H242.699V14.5306C242.699%2014.2468%20242.599%2013.9819%20242.429%2013.7974C242.278%2013.5751%20242.014%2013.4427%20241.646%2013.4474C241.274%2013.4947%20240.981%2013.6461%20240.792%2013.8731L235.457%2019.0856C235.17%2019.3268%20235.01%2019.6485%20235.01%2019.9984C235.01%2020.5755%20235.481%2021.0486%20236.056%2021.0486H238.557V32.9208C238.557%2036.5298%20240.581%2038.3792%20244.58%2038.4124C245.755%2038.4124%20246.887%2038.1616%20247.939%2037.6697C248.586%2037.386%20249.005%2036.7427%20249.005%2036.0283C249.005%2035.5884%20248.821%2035.1723%20248.477%2034.827L248.473%2034.8317Z'%20fill='%23FF7900'/%3e%3cpath%20d='M43.6196%2010.3445L47.2755%205.12259C47.6717%204.55971%2047.8603%203.91171%2047.8603%203.27316C47.8603%202.25621%2047.3839%201.25818%2046.4923%200.629089C45.0395%20-0.39259%2043.0299%20-0.04257%2042.0111%201.419L39.1666%205.4868C35.0249%202.05755%2029.7228%200%2023.9349%200C10.7174%200%200%2010.7466%200%2024C0%2037.2534%2010.7174%2048%2023.9349%2048C37.1524%2048%2047.8697%2037.2534%2047.8697%2024C47.8697%2018.9247%2046.299%2014.2231%2043.6196%2010.3445Z'%20fill='%23FF7900'/%3e%3cpath%20d='M15.2747%2019.5633C14.02%2018.3004%2011.9821%2018.3004%2010.7274%2019.5585C10.0953%2020.1876%209.78394%2021.0154%209.78394%2021.8432C9.78394%2022.6661%2010.0953%2023.4891%2010.7227%2024.1182L21.6712%2035.1249C22.275%2035.7351%2023.0958%2036.0709%2023.9496%2036.0709C24.0439%2036.0709%2024.1336%2036.0709%2024.2278%2036.0567C25.1761%2035.9763%2026.0392%2035.475%2026.5817%2034.6945L43.6202%2010.3445C42.3607%208.52347%2040.8606%206.88689%2039.1624%205.48208L23.5156%2027.8502L15.2747%2019.5633Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e", Mj = {}, $j = {
  src: Cj,
  alt: "GetAccept logo"
};
function Sj(t, e) {
  return d(), h("img", $j);
}
const jj = /* @__PURE__ */ T(Mj, [["render", Sj]]), Oj = "data:image/svg+xml,%3csvg%20viewBox='0%200%2048%2049'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M43.7376%2011.3459L47.4029%206.12251C47.8941%205.42234%2048.0871%204.55569%2047.9394%203.71321C47.7917%202.87074%2047.3153%202.12145%2046.6152%201.63019C45.915%201.13892%2045.0484%200.945919%2044.2059%201.09364C43.3634%201.24136%2042.6141%201.7177%2042.1229%202.41787L39.2697%206.48347C34.5802%202.61575%2028.5977%200.671614%2022.5304%201.04366C16.463%201.41571%2010.7629%204.07621%206.58102%208.48792C2.39916%2012.8996%200.0471687%2018.7338%20-8.77681e-06%2024.8124C-0.0471863%2030.891%202.21397%2036.761%206.32684%2041.2371C10.4397%2045.7131%2016.0979%2048.4618%2022.1587%2048.928C28.2196%2049.3942%2034.2315%2047.5431%2038.9805%2043.7487C43.7295%2039.9542%2046.8618%2034.499%2047.7447%2028.4847C48.6277%2022.4705%2047.1956%2016.3452%2043.7376%2011.3459'%20fill='%23FF7900'/%3e%3cpath%20d='M15.314%2020.5629C14.71%2019.9574%2013.8901%2019.6167%2013.0349%2019.6157C12.1796%2019.6147%2011.359%2019.9535%2010.7535%2020.5576C10.1481%2021.1617%209.80739%2021.9815%209.8064%2022.8367C9.80541%2023.692%2010.1442%2024.5126%2010.7483%2025.1181L21.7287%2036.1245C22.0283%2036.4248%2022.3841%2036.6631%2022.7758%2036.8257C23.1675%2036.9882%2023.5875%2037.072%2024.0116%2037.072C24.1076%2037.072%2024.1969%2037.072%2024.29%2037.0605C24.7593%2037.0198%2025.214%2036.8768%2025.6222%2036.6417C26.0303%2036.4065%2026.382%2036.0848%2026.6526%2035.6992L43.7406%2011.3459C42.4809%209.52829%2040.9775%207.89221%2039.2727%206.48352L23.5806%2028.8515L15.314%2020.5629Z'%20fill='white'/%3e%3c/svg%3e", Tj = {}, zj = {
  src: Oj,
  alt: "GetAccept logo"
};
function Bj(t, e) {
  return d(), h("img", zj);
}
const Ej = /* @__PURE__ */ T(Tj, [["render", Bj]]), Pj = /* @__PURE__ */ A({
  __name: "FriedHelpMessage",
  props: {
    error: { type: Boolean, default: !1 },
    message: { default: "" }
  },
  setup(t) {
    return (e, o) => (d(), h("div", {
      class: S(["helper-text-container", { error: e.error }])
    }, [
      $(Te, {
        size: _(Ye).Small,
        class: "helper-text"
      }, {
        default: O(() => [
          C(e.$slots, "default", {}, () => [
            K(F(e.message), 1)
          ], !0)
        ]),
        _: 3
      }, 8, ["size"])
    ], 2));
  }
}), Aj = /* @__PURE__ */ T(Pj, [["__scopeId", "data-v-10ba0687"]]), Lj = { class: "info-container" }, Hj = /* @__PURE__ */ A({
  __name: "FriedInlineInfo",
  props: {
    text: { default: "" },
    icon: { default: void 0 },
    paragraphSize: { default: Ye.Medium }
  },
  setup(t) {
    return (e, o) => (d(), h("div", Lj, [
      e.icon ? (d(), P(U, {
        key: 0,
        class: "icon",
        icon: e.icon
      }, null, 8, ["icon"])) : E("", !0),
      $(_(Te), { class: "text" }, {
        default: O(() => [
          K(F(e.text), 1)
        ]),
        _: 1
      }),
      C(e.$slots, "default", {}, void 0, !0)
    ]));
  }
}), Vj = /* @__PURE__ */ T(Hj, [["__scopeId", "data-v-921e1fb2"]]), Fj = /* @__PURE__ */ A({
  __name: "FriedLink",
  props: {
    href: { default: "" }
  },
  setup(t) {
    const e = t, o = z(() => e.href ? "a" : "button");
    return (n, r) => (d(), P(ro(o.value), {
      class: "link",
      href: n.href
    }, {
      default: O(() => [
        C(n.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["href"]));
  }
}), Ij = /* @__PURE__ */ T(Fj, [["__scopeId", "data-v-1bb240e2"]]), Dj = {}, Nj = { class: "list" };
function Rj(t, e) {
  return d(), h("ul", Nj, [
    C(t.$slots, "default", {}, void 0, !0)
  ]);
}
const qj = /* @__PURE__ */ T(Dj, [["render", Rj], ["__scopeId", "data-v-5c837aed"]]), Wj = { class: "list-item" }, Uj = /* @__PURE__ */ A({
  __name: "FriedListItem",
  props: {
    title: { default: "" },
    description: { default: "" },
    showDescription: { type: Boolean, default: !0 }
  },
  setup(t) {
    return (e, o) => (d(), h("li", Wj, [
      l("div", {
        class: S(["list-item-main-content", { "has-right-slot": e.$slots.right }])
      }, [
        C(e.$slots, "left", {}, void 0, !0),
        l("div", {
          class: S(["list-information", { "has-left-slot": e.$slots.left }])
        }, [
          $(ho, { class: "list-title" }, {
            default: O(() => [
              K(F(e.title || " "), 1)
            ]),
            _: 1
          }),
          e.showDescription ? (d(), P(_(Te), {
            key: 0,
            size: _(Ye).Small,
            class: "list-description"
          }, {
            default: O(() => [
              K(F(e.description || " "), 1)
            ]),
            _: 1
          }, 8, ["size"])) : E("", !0)
        ], 2)
      ], 2),
      C(e.$slots, "right", {}, void 0, !0)
    ]));
  }
}), Zj = /* @__PURE__ */ T(Uj, [["__scopeId", "data-v-8a35cbc4"]]);
var We = /* @__PURE__ */ ((t) => (t.Info = "info", t.Error = "error", t.Warning = "warning", t.Success = "success", t))(We || {});
const Gj = { class: "message-info" }, Yj = /* @__PURE__ */ A({
  __name: "FriedMessage",
  props: {
    title: { default: "" },
    type: { default: We.Info }
  },
  setup(t) {
    const e = t, { type: o } = Ke(e);
    return (n, r) => (d(), h("div", {
      class: S([
        "message",
        {
          error: _(o) === _(We).Error,
          info: _(o) === _(We).Info,
          warning: _(o) === _(We).Warning,
          success: _(o) === _(We).Success,
          "has-button": n.$slots.button
        }
      ])
    }, [
      n.$slots.icon ? E("", !0) : (d(), P(U, {
        key: 0,
        class: S([
          "icon",
          {
            error: _(o) === _(We).Error,
            info: _(o) === _(We).Info,
            warning: _(o) === _(We).Warning,
            success: _(o) === _(We).Success
          }
        ]),
        icon: "info-circle"
      }, null, 8, ["class"])),
      C(n.$slots, "icon", {}, void 0, !0),
      l("div", Gj, [
        $(ho, null, {
          default: O(() => [
            K(F(n.title), 1)
          ]),
          _: 1
        }),
        C(n.$slots, "default", {}, void 0, !0)
      ]),
      C(n.$slots, "button", {}, void 0, !0)
    ], 2));
  }
}), Xj = /* @__PURE__ */ T(Yj, [["__scopeId", "data-v-ba6fa41f"]]);
var hs = /* @__PURE__ */ ((t) => (t.XXLarge = "xxlarge", t.XLarge = "xlarge", t.Large = "large", t.Small = "small", t))(hs || {});
const Kj = { class: "modal-body" }, Jj = {
  key: 1,
  class: "modal-footer-container"
}, Qj = /* @__PURE__ */ A({
  __name: "FriedModalSubContainer",
  props: {
    loading: { type: Boolean },
    padded: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !0 }
  },
  setup(t) {
    return (e, o) => (d(), h("div", {
      class: S(["modal-sub-container", [{ padded: e.padded, "has-footer": !!e.$slots.footer }]])
    }, [
      e.$slots.header ? (d(), h("div", {
        key: 0,
        class: S(["modal-header-container", { closable: e.closable }])
      }, [
        C(e.$slots, "header", {}, void 0, !0)
      ], 2)) : E("", !0),
      l("div", Kj, [
        e.loading ? (d(), P(_(Kr), {
          key: 0,
          class: "modal-loader"
        })) : C(e.$slots, "default", { key: 1 }, void 0, !0)
      ]),
      e.$slots.footer ? (d(), h("div", Jj, [
        C(e.$slots, "footer", {}, void 0, !0)
      ])) : E("", !0)
    ], 2));
  }
}), $2 = /* @__PURE__ */ T(Qj, [["__scopeId", "data-v-009014cd"]]), eO = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FriedModal",
  props: {
    size: { default: hs.Small },
    useLegacySize: { type: Boolean, default: !1 },
    closable: { type: Boolean, default: !0 },
    loading: { type: Boolean, default: !1 },
    padded: { type: Boolean, default: !0 },
    showBackdrop: { type: Boolean, default: !0 },
    blurBackground: { type: Boolean },
    teleportTo: { default: void 0 }
  },
  emits: ["close", "enter"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = () => {
      o.closable && n("close");
    }, s = o.teleportTo || No.modalTeleportTo, i = (a) => {
      a.key === "Escape" ? r() : a.key === "Enter" && n("enter");
    };
    return ht(() => {
      o.closable && window.addEventListener("keyup", i);
    }), xi(() => {
      window.removeEventListener("keyup", i);
    }), (a, c) => (d(), P(Ur, {
      to: _(s),
      disabled: !_(s)
    }, [
      $(Ro, {
        name: "modal",
        appear: ""
      }, {
        default: O(() => [
          l("div", Oe({ class: "modal-outer-container" }, a.$attrs), [
            a.showBackdrop ? C(a.$slots, "backdrop", { key: 0 }, () => [
              l("div", {
                class: S(["modal-backdrop", { "modal-blur-background": a.blurBackground }]),
                onMousedown: _e(r, ["self", "stop"])
              }, null, 34)
            ], !0) : E("", !0),
            l("div", {
              class: S(["modal-container", a.size])
            }, [
              C(a.$slots, "topRightCorner", {}, () => [
                a.closable ? (d(), P(_(me), {
                  key: 0,
                  class: "close-icon-container",
                  "data-external": "base-modal-close-button",
                  onClick: r
                }, {
                  default: O(() => [
                    $(U, {
                      size: _(He).Small,
                      class: "close-icon",
                      icon: "close"
                    }, null, 8, ["size"])
                  ]),
                  _: 1
                })) : E("", !0)
              ], !0),
              C(a.$slots, "container", {}, () => [
                $($2, {
                  loading: a.loading,
                  padded: a.padded,
                  closable: a.closable
                }, X2({
                  default: O(() => [
                    C(a.$slots, "default", {}, void 0, !0)
                  ]),
                  _: 2
                }, [
                  a.$slots.header ? {
                    name: "header",
                    fn: O(() => [
                      C(a.$slots, "header", {}, void 0, !0)
                    ]),
                    key: "0"
                  } : void 0,
                  a.$slots.footer ? {
                    name: "footer",
                    fn: O(() => [
                      C(a.$slots, "footer", {}, void 0, !0)
                    ]),
                    key: "1"
                  } : void 0
                ]), 1032, ["loading", "padded", "closable"])
              ], !0)
            ], 2)
          ], 16)
        ]),
        _: 3
      })
    ], 8, ["to", "disabled"]));
  }
}), tO = /* @__PURE__ */ T(eO, [["__scopeId", "data-v-10ade351"]]), oO = {}, nO = { class: "modal-footer" };
function rO(t, e) {
  return d(), h("div", nO, [
    C(t.$slots, "default")
  ]);
}
const S2 = /* @__PURE__ */ T(oO, [["render", rO]]), sO = {
  key: 0,
  class: "left-container"
}, iO = { class: "right-container" }, aO = /* @__PURE__ */ A({
  __name: "FriedModalButtonsFooter",
  props: {
    reverseButtonsMobile: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, o) => (d(), P(S2, null, {
      default: O(() => [
        l("div", {
          class: S(["modal-footer-buttons-container", { "has-left-slot": e.$slots.left, "reverse-buttons-mobile": e.reverseButtonsMobile }])
        }, [
          e.$slots.left ? (d(), h("div", sO, [
            C(e.$slots, "left", {}, void 0, !0)
          ])) : E("", !0),
          l("div", iO, [
            C(e.$slots, "default", {}, void 0, !0)
          ])
        ], 2)
      ]),
      _: 3
    }));
  }
}), lO = /* @__PURE__ */ T(aO, [["__scopeId", "data-v-d39bd42e"]]), dO = /* @__PURE__ */ A({
  __name: "FriedModalHeader",
  props: {
    header: {},
    description: { default: "" }
  },
  setup(t) {
    return (e, o) => (d(), h("div", null, [
      $(_(fu), { class: "modal-header-heading" }, {
        default: O(() => [
          K(F(e.header), 1)
        ]),
        _: 1
      }),
      e.description ? (d(), P(_(Te), {
        key: 0,
        class: "modal-header-description"
      }, {
        default: O(() => [
          K(F(e.description), 1)
        ]),
        _: 1
      })) : E("", !0),
      C(e.$slots, "custom", {}, void 0, !0)
    ]));
  }
}), uO = /* @__PURE__ */ T(dO, [["__scopeId", "data-v-c0e47ab8"]]), cO = ["id", "disabled", "value", "max", "min", "autocomplete"], hO = {
  inheritAttrs: !1
}, fO = /* @__PURE__ */ A(R(j({}, hO), {
  __name: "FriedNumericalStepper",
  props: {
    modelValue: { default: 0 },
    min: { default: 0 },
    max: { default: 1e6 },
    id: { default: "" },
    autocomplete: { default: "value-that-chrome-doesnt-recognize" },
    disabled: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    helpMessage: { default: "" },
    errorMessage: { default: "" },
    error: { type: Boolean, default: !1 },
    delayedFocus: { type: Boolean, default: !1 }
  },
  emits: ["focus", "blur", "update:modelValue"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = xe(5), s = I(null), i = I(!1), a = I(!1), c = z(() => o.id || "input-" + r), u = z(
      () => i.value || a.value || Number.isInteger(o.modelValue)
    ), f = (k) => Math.min(Math.max(k, o.min), o.max), p = (k) => {
      i.value = !0, n("focus", k);
    }, v = (k) => {
      i.value = !1, n("blur", k);
    }, m = (k) => {
      if (a.value = !1, o.disabled) return;
      const { value: x } = k.target;
      y(f(Number(x)));
    }, g = () => {
      o.disabled || y(f(o.modelValue + 1));
    }, w = () => {
      o.disabled || y(f(o.modelValue - 1));
    }, y = (k) => n("update:modelValue", k), M = (k) => {
      k.animationName.includes("onAutoFillStart") && (a.value = !0);
    }, B = () => {
      var k;
      (k = s.value) == null || k.focus();
    };
    return ht(() => {
      y(f(o.modelValue)), o.delayedFocus && setTimeout(() => B(), 1500);
    }), (k, x) => (d(), P(_(Uo), {
      class: "input-box",
      success: k.success,
      active: u.value,
      disabled: k.disabled,
      "help-message": k.helpMessage,
      "error-message": k.errorMessage,
      error: k.error,
      for: c.value
    }, {
      default: O(() => [
        $(_(me), {
          tabindex: "-1",
          disabled: k.disabled || k.modelValue === k.min,
          onClick: w
        }, {
          default: O(() => [
            $(_(U), { icon: "minus-bold" })
          ]),
          _: 1
        }, 8, ["disabled"]),
        l("input", Oe({
          id: c.value,
          ref_key: "inputElement",
          ref: s,
          class: "input",
          type: "number",
          disabled: k.disabled,
          value: k.modelValue,
          max: k.max,
          min: k.min,
          autocomplete: k.autocomplete
        }, k.$attrs, {
          onFocus: p,
          onBlur: v,
          onAnimationstart: M,
          onInput: m
        }), null, 16, cO),
        $(_(me), {
          tabindex: "-1",
          disabled: k.disabled || k.modelValue === k.max,
          onClick: g
        }, {
          default: O(() => [
            $(_(U), { icon: "plus-bold" })
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["success", "active", "disabled", "help-message", "error-message", "error", "for"]));
  }
})), pO = /* @__PURE__ */ T(fO, [["__scopeId", "data-v-8bf102ad"]]), mO = { class: "pagination-numbers" }, vO = { class: "pagination-buttons" }, gO = /* @__PURE__ */ A({
  __name: "FriedPagination",
  props: {
    divider: { default: "/" },
    pageOffset: {},
    limit: {},
    totalCount: {},
    align: { default: "right" },
    showPageNumber: { type: Boolean },
    prefix: { default: void 0 }
  },
  emits: ["next", "previous"],
  setup(t) {
    const e = t, { isXSmallScreenAndDown: o, isXSmallScreenAndUp: n } = gu(), r = z(() => e.pageOffset === 0), s = z(() => c.value >= e.totalCount), i = z(() => Math.ceil(e.totalCount / e.limit)), a = z(() => e.totalCount > 0 ? e.pageOffset * e.limit + 1 : 0), c = z(() => Math.min(a.value + e.limit - 1, e.totalCount)), u = z(() => `${a.value}-${c.value}`), f = z(
      () => e.showPageNumber ? e.pageOffset + 1 : u.value
    ), p = z(() => e.showPageNumber ? i.value : e.totalCount);
    return (v, m) => v.totalCount > 0 ? (d(), h("div", {
      key: 0,
      class: S(["pagination", v.align])
    }, [
      _(o) ? (d(), P(_(me), {
        key: 0,
        "data-external": "pagination-prev-button",
        disabled: r.value,
        onClick: m[0] || (m[0] = (g) => v.$emit("previous"))
      }, {
        default: O(() => [
          $(_(U), { icon: "chevron-left" })
        ]),
        _: 1
      }, 8, ["disabled"])) : E("", !0),
      l("div", mO, [
        K(F(v.prefix) + " ", 1),
        l("strong", null, F(f.value), 1),
        K(" " + F(v.divider) + " ", 1),
        l("strong", null, F(p.value), 1)
      ]),
      l("div", vO, [
        _(n) ? (d(), P(_(me), {
          key: 0,
          "data-external": "pagination-prev-button",
          disabled: r.value,
          onClick: m[1] || (m[1] = (g) => v.$emit("previous"))
        }, {
          default: O(() => [
            $(_(U), { icon: "chevron-left" })
          ]),
          _: 1
        }, 8, ["disabled"])) : E("", !0),
        $(_(me), {
          "data-external": "pagination-next-button",
          disabled: s.value,
          onClick: m[2] || (m[2] = (g) => v.$emit("next"))
        }, {
          default: O(() => [
            $(_(U), { icon: "chevron-right" })
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 2)) : E("", !0);
  }
}), _O = /* @__PURE__ */ T(gO, [["__scopeId", "data-v-961092e5"]]);
var fs = /* @__PURE__ */ ((t) => (t.Default = "default", t.Success = "success", t.Danger = "danger", t.Warning = "warning", t))(fs || {});
const wO = ["aria-valuemin", "aria-valuemax", "aria-valuenow"], bO = /* @__PURE__ */ A({
  __name: "FriedProgressBar",
  props: {
    value: { default: 0 },
    min: { default: 0 },
    max: { default: 100 },
    error: { type: Boolean, default: !1 },
    completed: { type: Boolean, default: !1 },
    type: { default: fs.Default },
    disableWaveAnimation: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, o = z(() => e.completed || e.error ? "100%" : `${e.value / e.max * 100}%`);
    return (n, r) => (d(), h("div", {
      class: S(["progress-bar", [{ error: n.error, completed: n.completed, "wave-disabled": n.disableWaveAnimation }, n.type]]),
      role: "progressbar",
      "aria-valuemin": n.min,
      "aria-valuemax": n.max,
      "aria-valuenow": n.value
    }, [
      l("div", {
        class: S(["progress-value"]),
        style: re({ width: o.value })
      }, null, 4)
    ], 10, wO));
  }
}), kO = /* @__PURE__ */ T(bO, [["__scopeId", "data-v-0869c88d"]]), yO = ["disabled"], xO = { class: "icon" }, CO = /* @__PURE__ */ A({
  __name: "FriedRoundedButton",
  props: {
    iconAlignRight: { type: Boolean, default: !1 },
    hideTextMobile: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = (s) => {
      o.disabled || n("click", s);
    };
    return (s, i) => se((d(), h("button", {
      class: S(["button", { "icon-right": s.iconAlignRight, active: s.active, disabled: s.disabled }]),
      disabled: s.disabled,
      onClick: r
    }, [
      l("div", xO, [
        C(s.$slots, "icon", {}, void 0, !0)
      ]),
      s.$slots.default ? (d(), P(_(ho), {
        key: 0,
        class: S([
          "text",
          {
            "icon-right": s.iconAlignRight,
            "icon-left": !s.iconAlignRight,
            "hidden-xs-and-down": s.hideTextMobile
          }
        ])
      }, {
        default: O(() => [
          C(s.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["class"])) : E("", !0)
    ], 10, yO)), [
      [_(ut)]
    ]);
  }
}), MO = /* @__PURE__ */ T(CO, [["__scopeId", "data-v-7521cf80"]]);
var ps = /* @__PURE__ */ ((t) => (t.Small = "small", t.Medium = "medium", t))(ps || {});
const $O = {
  key: 0,
  class: "icons-container left"
}, SO = ["value", "placeholder", "disabled", "data-external"], jO = {
  key: 1,
  class: "icons-container"
}, OO = /* @__PURE__ */ A({
  __name: "FriedSearchInput",
  props: {
    modelValue: { default: "" },
    autofocus: { type: Boolean, default: !1 },
    size: { default: ps.Medium },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    dataExternal: { default: void 0 }
  },
  emits: ["update:modelValue", "click", "focus", "keyup", "keydown", "paste"],
  setup(t, { expose: e, emit: o }) {
    const n = t, r = o, s = I(null), i = (u) => {
      n.disabled || r("update:modelValue", u.target.value);
    }, a = () => {
      var u, f;
      (u = s.value) == null || u.focus(), (f = s.value) == null || f.setSelectionRange(n.modelValue.length, n.modelValue.length);
    }, c = () => {
      var u;
      (u = s.value) == null || u.blur();
    };
    return ht(() => {
      n.autofocus && a();
    }), e({
      focus: a,
      blur: c
    }), (u, f) => (d(), h("div", {
      class: S(["search-input", [u.size]])
    }, [
      u.$slots.left ? (d(), h("div", $O, [
        C(u.$slots, "left", {}, void 0, !0)
      ])) : E("", !0),
      C(u.$slots, "content", {}, () => [
        l("input", {
          ref_key: "searchInput",
          ref: s,
          class: S(["search-bar-input", { first: !u.$slots.left }]),
          value: u.modelValue,
          placeholder: u.placeholder,
          disabled: u.disabled,
          "data-external": u.dataExternal,
          onInput: i,
          onClick: f[0] || (f[0] = (p) => u.disabled ? null : r("click", p)),
          onKeyup: f[1] || (f[1] = (p) => u.disabled ? null : r("keyup", p)),
          onKeydown: f[2] || (f[2] = (p) => u.disabled ? null : r("keydown", p)),
          onPaste: f[3] || (f[3] = (p) => u.disabled ? null : r("paste", p)),
          onFocus: f[4] || (f[4] = (p) => u.disabled ? null : r("focus", p))
        }, null, 42, SO)
      ], !0),
      u.$slots.right ? (d(), h("div", jO, [
        C(u.$slots, "right", {}, void 0, !0)
      ])) : E("", !0)
    ], 2));
  }
}), TO = /* @__PURE__ */ T(OO, [["__scopeId", "data-v-cdf336ee"]]), zO = {
  key: 0,
  class: "footer-container"
}, BO = /* @__PURE__ */ A({
  __name: "FriedSideSheet",
  props: {
    closeButtonDataExternal: { default: "slide-sheet-close-button" },
    appendToBody: { type: Boolean },
    container: { default: void 0 },
    title: { default: "" },
    width: { default: 600 },
    blurredHeader: { type: Boolean },
    blurBackground: { type: Boolean },
    modelValue: { type: Boolean, default: !0 },
    preventCloseOnClickOutside: { type: Boolean, default: !1 },
    showBackdrop: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = I(), s = I(!1), i = () => {
      s.value = r.value.scrollTop > 0;
    };
    ht(() => {
      var u;
      (u = r.value) == null || u.addEventListener("scroll", i, { passive: !0 });
    }), K2(() => {
      var u;
      (u = r.value) == null || u.removeEventListener("scroll", i);
    });
    const a = () => {
      n("update:modelValue", !1);
    }, c = () => {
      o.preventCloseOnClickOutside || a();
    };
    return (u, f) => (d(), P(Ur, {
      to: u.container || "body",
      disabled: !u.container && !u.appendToBody
    }, [
      u.showBackdrop ? (d(), P(_(Jr), {
        key: 0,
        class: "backdrop-container",
        show: u.modelValue,
        appear: "",
        blur: u.blurBackground
      }, null, 8, ["show", "blur"])) : E("", !0),
      $(ts, {
        appear: "",
        origin: _(Yo).Right
      }, {
        default: O(() => [
          u.modelValue ? se((d(), h("aside", {
            key: 0,
            class: "side-sheet-container",
            style: re({ width: `${u.width}px` })
          }, [
            l("div", {
              ref_key: "sideSheetContainer",
              ref: r,
              class: "side-sheet-main-content"
            }, [
              l("div", {
                class: S([
                  "header-container",
                  {
                    "blurred-header": u.blurredHeader,
                    scrolling: s.value,
                    "has-subheader": u.$slots.subheader
                  }
                ])
              }, [
                C(u.$slots, "header", {}, () => [
                  u.title ? (d(), P(_(Go), { key: 0 }, {
                    default: O(() => [
                      K(F(u.title), 1)
                    ]),
                    _: 1
                  })) : E("", !0)
                ], !0),
                $(_(me), {
                  "data-external": u.closeButtonDataExternal,
                  onClick: a
                }, {
                  default: O(() => [
                    $(_(U), {
                      size: _(He).Small,
                      icon: "close"
                    }, null, 8, ["size"])
                  ]),
                  _: 1
                }, 8, ["data-external"]),
                C(u.$slots, "subheader", {}, void 0, !0)
              ], 2),
              C(u.$slots, "default", {}, void 0, !0)
            ], 512),
            u.$slots.footer ? (d(), h("div", zO, [
              C(u.$slots, "footer", {}, void 0, !0)
            ])) : E("", !0)
          ], 4)), [
            [_(io), c]
          ]) : E("", !0)
        ]),
        _: 3
      }, 8, ["origin"])
    ], 8, ["to", "disabled"]));
  }
}), EO = /* @__PURE__ */ T(BO, [["__scopeId", "data-v-02d175b2"]]);
var Po = /* @__PURE__ */ ((t) => (t.Unknown = "", t.Input = "input", t.Textarea = "textarea", t.Select = "select", t.Checkbox = "checkbox", t.Radio = "radio", t.Avatar = "avatar", t.StatusBadge = "status-badge", t.Button = "button", t.ButtonIcon = "button-icon", t.ButtonCompact = "button-compact", t.H1 = "h1", t.H2 = "h2", t.H3 = "h3", t.H4 = "h4", t.H5 = "h5", t.Paragraph = "paragraph", t))(Po || {});
const PO = {
  key: 0,
  class: "paragraph-skeleton"
}, AO = /* @__PURE__ */ A({
  __name: "FriedSkeleton",
  props: {
    type: { default: Po.Unknown },
    rows: { default: 4 },
    size: { default: Ye.Medium },
    avatarSize: { default: so.Medium },
    fullWidth: { type: Boolean, default: !1 },
    label: { type: Boolean, default: !0 }
  },
  setup(t) {
    Mi((n) => ({
      "01b7235e": o.value
    }));
    const e = t, o = z(() => e.type === Po.Textarea ? `${e.rows * 1.125 + 1.5}rem` : null);
    return (n, r) => n.type === _(Po).Paragraph ? (d(), h("div", PO, [
      (d(!0), h(oe, null, ce(n.rows, (s) => (d(), h("div", {
        key: s,
        class: S(["skeleton", n.type, n.size])
      }, null, 2))), 128))
    ])) : (d(), h("div", {
      key: 1,
      class: S(["skeleton", n.type, n.avatarSize, { "full-width": n.fullWidth, label: n.label }])
    }, null, 2));
  }
}), LO = /* @__PURE__ */ T(AO, [["__scopeId", "data-v-4b5aafa8"]]), HO = /* @__PURE__ */ A({
  __name: "FriedStatusBadge",
  props: {
    text: { default: "" },
    icon: { default: void 0 },
    statusType: { default: "default" },
    enableMinWidth: { type: Boolean, default: !0 },
    color: { default: void 0 },
    border: { type: Boolean }
  },
  setup(t) {
    const e = t, o = z(() => e.color ? eo.text(e.color) : ""), n = z(() => e.color ? eo.background(e.color) : ""), r = z(() => !e.text && e.icon);
    return (s, i) => (d(), h("div", {
      class: S([
        "status-badge",
        { "enable-min-width": s.enableMinWidth, color: s.color, border: s.border, "icon-only": r.value },
        s.statusType,
        n.value
      ])
    }, [
      C(s.$slots, "icon", {}, () => [
        s.icon ? (d(), P(U, {
          key: 0,
          class: S(["icon", o.value]),
          icon: s.icon,
          size: _(He).Small
        }, null, 8, ["class", "icon", "size"])) : E("", !0)
      ], !0),
      s.text ? (d(), P(es, {
        key: 0,
        class: S(["text", o.value])
      }, {
        default: O(() => [
          K(F(s.text), 1)
        ]),
        _: 1
      }, 8, ["class"])) : E("", !0)
    ], 2));
  }
}), VO = /* @__PURE__ */ T(HO, [["__scopeId", "data-v-098193c6"]]);
var j2 = /* @__PURE__ */ ((t) => (t.Info = "info", t.Success = "success", t.Error = "error", t.LightBlue = "light-blue", t.Branded = "branded", t.Default = "default", t.None = "none", t))(j2 || {});
const FO = ["id", "aria-labelledby", "aria-checked", "aria-disabled"], IO = /* @__PURE__ */ A({
  __name: "FriedSwitch",
  props: {
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    id: { default: "" },
    modelValue: { type: Boolean, default: !1 },
    showLabelFirst: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const o = t, n = e, { id: r, disabled: s, modelValue: i } = Ke(o), a = xe(), c = z(() => `input-switch-${r.value || a}`), u = z(() => `input-switch-label-${r.value || a}`), f = () => {
      s.value || n("update:modelValue", !i.value);
    };
    return (p, v) => (d(), h("div", {
      class: S(["switch-outer-container", { "has-label": !!p.label, reverse: p.showLabelFirst }]),
      onClick: f,
      onKeydown: [
        q(f, ["enter"]),
        q(f, ["space"])
      ]
    }, [
      l("div", {
        id: c.value,
        "aria-labelledby": u.value,
        class: S(["switch-container", { "switch-on": _(i), disabled: _(s) }]),
        role: "switch",
        "aria-checked": _(i) ? "true" : "false",
        "aria-disabled": _(s),
        tabindex: "0",
        onKeydown: [
          q(f, ["enter"]),
          q(f, ["space"])
        ]
      }, v[0] || (v[0] = [
        l("div", { class: "switch-dot" }, null, -1)
      ]), 42, FO),
      p.label ? (d(), P(Fn, {
        key: 0,
        id: u.value,
        size: _(qt).Medium,
        class: S({ disabled: _(s) }),
        for: c.value
      }, {
        default: O(() => [
          K(F(p.label), 1)
        ]),
        _: 1
      }, 8, ["id", "size", "class", "for"])) : E("", !0)
    ], 34));
  }
}), DO = /* @__PURE__ */ T(IO, [["__scopeId", "data-v-db8af6d5"]]);
var Ao = /* @__PURE__ */ ((t) => (t.Primary = "primary", t.Branding = "branding", t))(Ao || {});
const NO = ["data-external", "aria-checked"], RO = /* @__PURE__ */ A({
  __name: "FriedTab",
  props: {
    modelValue: { default: void 0 },
    value: {},
    type: { default: Ao.Branding },
    dataExternal: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const o = t, n = e, { value: r, modelValue: s } = Ke(o), i = z(() => r.value === (s == null ? void 0 : s.value)), a = z(() => {
      switch (o.type) {
        case Ao.Branding:
          return "branding";
        case Ao.Primary:
          return "primary";
        default:
          return null;
      }
    }), c = () => {
      n("update:modelValue", r.value);
    };
    return (u, f) => (d(), h("button", {
      class: S(["tab-button", { active: i.value }, a.value]),
      "data-external": u.dataExternal || `displayed-tabs-container-${_(r)}-tab`,
      role: "radio",
      "aria-checked": i.value,
      onClick: c
    }, [
      C(u.$slots, "default", {}, void 0, !0)
    ], 10, NO));
  }
}), qO = /* @__PURE__ */ T(RO, [["__scopeId", "data-v-a649c31d"]]), WO = {}, UO = { class: "table-container" };
function ZO(t, e) {
  return d(), h("table", UO, [
    C(t.$slots, "header", {}, void 0, !0),
    C(t.$slots, "bodies", {}, () => [
      l("tbody", null, [
        C(t.$slots, "body", {}, void 0, !0)
      ])
    ], !0),
    C(t.$slots, "footer", {}, void 0, !0)
  ]);
}
const GO = /* @__PURE__ */ T(WO, [["render", ZO], ["__scopeId", "data-v-abffcc3c"]]);
var tn = /* @__PURE__ */ ((t) => (t.Left = "left", t.Center = "center", t.Right = "right", t))(tn || {});
const YO = /* @__PURE__ */ A({
  __name: "FriedTableCell",
  props: {
    align: { default: tn.Left },
    minWidth: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, o) => (d(), h("td", {
      class: S(["table-cell", [e.align, { "min-width": e.minWidth }]])
    }, [
      C(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), O2 = /* @__PURE__ */ T(YO, [["__scopeId", "data-v-355280f3"]]);
var Bn = /* @__PURE__ */ ((t) => (t.None = "", t.Asc = "ASC", t.Desc = "DESC", t))(Bn || {});
const XO = {
  key: 0,
  class: "table-header-cell-sortable"
}, KO = ["data-external"], JO = /* @__PURE__ */ A({
  __name: "FriedTableHeaderCell",
  props: {
    align: { default: tn.Left },
    sortable: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    direction: { default: Bn.None },
    dataExternal: { default: "" }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const o = e;
    return (n, r) => n.sortable ? (d(), h("th", XO, [
      l("button", {
        class: S(["table-sort-button", [n.align]]),
        "data-external": n.dataExternal,
        tabindex: 0,
        onClick: r[0] || (r[0] = (s) => o("click"))
      }, [
        C(n.$slots, "default", {}, void 0, !0),
        se($(U, {
          class: S(["arrow", { rotate: n.direction === _(Bn).Desc }]),
          icon: "chevron-down"
        }, null, 8, ["class"]), [
          [yt, n.active]
        ])
      ], 10, KO)
    ])) : (d(), h("th", {
      key: 1,
      class: S(["table-header-cell", n.align])
    }, [
      C(n.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), T2 = /* @__PURE__ */ T(JO, [["__scopeId", "data-v-462c909d"]]), QO = /* @__PURE__ */ A({
  __name: "FriedTableCheckboxCell",
  props: {
    header: { type: Boolean, default: !1 },
    modelValue: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    id: { default: "" },
    labelSize: { default: qt.Medium },
    dataExternal: { default: "" },
    labelDataExternal: { default: "" }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(t, { emit: e }) {
    const o = e;
    return (n, r) => n.header ? (d(), P(T2, {
      key: 0,
      class: "checkbox-header"
    }, {
      default: O(() => [
        $(Tr, Oe(n.$props, {
          "onUpdate:modelValue": r[0] || (r[0] = (s) => o("update:modelValue", s)),
          onBlur: r[1] || (r[1] = (s) => o("blur")),
          onFocus: r[2] || (r[2] = (s) => o("focus"))
        }), null, 16)
      ]),
      _: 1
    })) : (d(), P(O2, {
      key: 1,
      "min-width": ""
    }, {
      default: O(() => [
        $(Tr, Oe(n.$props, {
          "onUpdate:modelValue": r[3] || (r[3] = (s) => o("update:modelValue", s)),
          onBlur: r[4] || (r[4] = (s) => o("blur")),
          onFocus: r[5] || (r[5] = (s) => o("focus"))
        }), null, 16)
      ]),
      _: 1
    }));
  }
}), eT = /* @__PURE__ */ T(QO, [["__scopeId", "data-v-ea01e114"]]), tT = {}, oT = { class: "table-footer" };
function nT(t, e) {
  return d(), h("tfoot", oT, [
    C(t.$slots, "default")
  ]);
}
const rT = /* @__PURE__ */ T(tT, [["render", nT]]), sT = /* @__PURE__ */ A({
  __name: "FriedTableFooterCell",
  props: {
    align: { default: tn.Left }
  },
  setup(t) {
    return (e, o) => (d(), h("th", {
      class: S(["table-footer-cell", e.align])
    }, [
      C(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), iT = /* @__PURE__ */ T(sT, [["__scopeId", "data-v-6795c545"]]), aT = {}, lT = { class: "table-head" };
function dT(t, e) {
  return d(), h("thead", lT, [
    l("tr", null, [
      C(t.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const uT = /* @__PURE__ */ T(aT, [["render", dT], ["__scopeId", "data-v-ec450cff"]]), cT = ["tabindex"], hT = /* @__PURE__ */ A({
  __name: "FriedTableRow",
  props: {
    clickable: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = () => {
      o.clickable && n("click");
    };
    return (s, i) => (d(), h("tr", Oe({
      class: ["table-row", { clickable: s.clickable }]
    }, s.$attrs, {
      tabindex: s.clickable ? 0 : void 0,
      onClick: r,
      onKeydown: [
        q(r, ["enter"]),
        q(r, ["space"])
      ]
    }), [
      C(s.$slots, "default", {}, void 0, !0)
    ], 16, cT));
  }
}), fT = /* @__PURE__ */ T(hT, [["__scopeId", "data-v-2392ca36"]]), pT = ["id", "rows", "disabled", "value", "maxLength", "minLength", "autocomplete", "placeholder", "readonly", "data-external"], mT = /* @__PURE__ */ A({
  __name: "FriedTextarea",
  props: {
    autocomplete: { default: "value-that-chrome-doesnt-recognize" },
    label: { default: "" },
    resizable: { type: Boolean, default: !1 },
    id: { default: "" },
    modelValue: { default: "" },
    success: { type: Boolean, default: !1 },
    helpMessage: { default: "" },
    errorMessage: { default: "" },
    error: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    rows: { default: 4 },
    fixedLabel: { type: Boolean, default: !1 },
    minLength: { default: void 0 },
    maxLength: { default: void 0 },
    placeholder: { default: "" },
    readonly: { type: Boolean },
    autofocus: { type: Boolean },
    dataExternal: { default: void 0 },
    placeholderAsDefault: { type: Boolean, default: !1 }
  },
  emits: ["focus", "blur", "update:modelValue", "input", "change"],
  setup(t, { expose: e, emit: o }) {
    const n = t, r = o, s = xe(5), { fixedLabel: i, id: a, modelValue: c } = Ke(n), u = I(!1), f = I(null), p = z(() => u.value || !!c.value || i.value), v = z(() => a.value || `textarea-${s}`), m = (k) => {
      n.disabled || r("update:modelValue", k);
    }, g = (k) => {
      n.placeholderAsDefault && !n.modelValue && m(n.placeholder), u.value = !0, r("focus", k);
    }, w = (k) => {
      n.placeholderAsDefault && n.modelValue === n.placeholder && m(""), u.value = !1, r("blur", k);
    }, y = (k) => {
      var x;
      n.disabled || (r("input", k), m((x = k == null ? void 0 : k.target) == null ? void 0 : x.value));
    }, M = () => {
      var k;
      return (k = f == null ? void 0 : f.value) == null ? void 0 : k.focus();
    }, B = () => {
      var k;
      return (k = f == null ? void 0 : f.value) == null ? void 0 : k.blur();
    };
    return ht(() => {
      n.autofocus && M();
    }), e({
      focus: M,
      blur: B
    }), (k, x) => (d(), P(Uo, {
      class: "input-box",
      label: k.label,
      success: k.success,
      active: p.value,
      disabled: k.disabled,
      "help-message": k.helpMessage,
      "error-message": k.errorMessage,
      error: k.error,
      for: v.value
    }, {
      default: O(() => [
        l("textarea", {
          id: v.value,
          ref_key: "textarea",
          ref: f,
          class: S(["textarea", { resizable: k.resizable }]),
          rows: k.rows,
          disabled: k.disabled,
          value: _(c),
          maxLength: k.maxLength,
          minLength: k.minLength,
          autocomplete: k.autocomplete,
          placeholder: k.placeholder,
          readonly: k.readonly,
          "data-external": k.dataExternal,
          onFocus: g,
          onBlur: w,
          onInput: y,
          onChange: x[0] || (x[0] = (b) => r("change", b))
        }, null, 42, pT)
      ]),
      _: 1
    }, 8, ["label", "success", "active", "disabled", "help-message", "error-message", "error", "for"]));
  }
}), vT = /* @__PURE__ */ T(mT, [["__scopeId", "data-v-e77eeaed"]]), gT = { class: "split-button-wrapper" }, _T = ["disabled", "data-external"], wT = { class: "button-text" }, bT = {
  key: 0,
  class: "button-icon left"
}, kT = ["disabled"], yT = /* @__PURE__ */ A({
  __name: "FriedButtonSplit",
  props: {
    buttonType: { default: jt.Primary },
    disabled: { type: Boolean, default: !1 },
    dataExternal: { default: "" }
  },
  emits: ["click"],
  setup(t, { emit: e }) {
    const o = t, n = e, { buttonType: r, disabled: s } = Ke(o), i = z(() => `ga-${r.value}`), a = (c) => {
      o.disabled || n("click", c);
    };
    return (c, u) => (d(), h("div", gT, [
      se((d(), h("button", {
        ref: "button",
        class: S(["button", i.value, { disabled: _(s) }]),
        disabled: _(s),
        "data-external": c.dataExternal,
        onClick: a
      }, [
        l("span", wT, [
          c.$slots.leftIcon ? (d(), h("span", bT, [
            C(c.$slots, "leftIcon", {}, void 0, !0)
          ])) : E("", !0),
          C(c.$slots, "default", {}, void 0, !0)
        ])
      ], 10, _T)), [
        [_(ut)]
      ]),
      $(os, {
        "main-axis-offset": 4,
        placement: _(co).BottomEnd,
        "append-to-body": "",
        class: "dropdown-wrapper"
      }, {
        trigger: O(({ open: f }) => [
          se((d(), h("button", {
            ref: "dropdown-toggle",
            class: S(["dropdown-toggle", i.value, { disabled: _(s), open: f }]),
            disabled: _(s)
          }, [
            $(U, {
              class: "chevron-icon",
              icon: "chevron-down"
            })
          ], 10, kT)), [
            [_(ut)]
          ])
        ]),
        content: O(() => [
          l("span", {
            onMousedown: u[0] || (u[0] = _e(() => {
            }, ["stop"]))
          }, [
            C(c.$slots, "dropdownItems", {}, void 0, !0)
          ], 32)
        ]),
        _: 3
      }, 8, ["placement"])
    ]));
  }
}), xT = /* @__PURE__ */ T(yT, [["__scopeId", "data-v-0cfd1038"]]), CT = /* @__PURE__ */ A({
  __name: "FriedButtonFooterContainer",
  props: {
    keepButtonOrder: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, o) => (d(), h("div", {
      class: S(["button-footer-container", { reverse: !e.keepButtonOrder }])
    }, [
      C(e.$slots, "left", {}, void 0, !0),
      C(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), MT = /* @__PURE__ */ T(CT, [["__scopeId", "data-v-66a06fb6"]]), $T = { class: "tree-structure" }, ST = { class: "expand-container" }, jT = {
  key: 0,
  class: "tree-children"
}, OT = /* @__PURE__ */ A({
  __name: "FriedTreeStructure",
  props: {
    root: { type: Boolean },
    item: { default: () => ({}) },
    children: { default: () => [] },
    childrenKey: {},
    rootExpanded: { type: Boolean }
  },
  emits: ["expand", "collapse"],
  setup(t, { emit: e }) {
    const o = J2(() => Promise.resolve().then(() => TT)), n = t, r = e, s = z(() => {
      var c;
      return !!((c = n.children) != null && c.length);
    }), i = I(n.rootExpanded), a = () => {
      i.value = !i.value, i.value ? r("expand", n.item) : r("collapse", n.item);
    };
    return (c, u) => (d(), h("div", $T, [
      l("div", {
        class: S(["tree-row", { root: c.root }]),
        onDblclick: a
      }, [
        C(c.$slots, "default", {
          item: c.item,
          root: !0,
          expanded: i.value
        }, void 0, !0),
        l("div", ST, [
          s.value ? (d(), P(_(me), {
            key: 0,
            active: i.value,
            onClick: a
          }, {
            default: O(() => [
              $(_(U), {
                class: S(["expand-button", { expanded: i.value }]),
                icon: "chevron-right"
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 8, ["active"])) : E("", !0)
        ])
      ], 34),
      i.value ? (d(), h("div", jT, [
        (d(!0), h(oe, null, ce(c.children, (f, p) => (d(), P(_(o), {
          key: p,
          "children-key": c.childrenKey,
          children: f[c.childrenKey],
          item: f,
          onExpand: u[0] || (u[0] = (v) => c.$emit("expand", v)),
          onCollapse: u[1] || (u[1] = (v) => c.$emit("collapse", v))
        }, {
          default: O(({ item: v, expanded: m }) => [
            C(c.$slots, "default", {
              item: v,
              expanded: m
            }, void 0, !0)
          ]),
          _: 2
        }, 1032, ["children-key", "children", "item"]))), 128))
      ])) : E("", !0)
    ]));
  }
}), z2 = /* @__PURE__ */ T(OT, [["__scopeId", "data-v-3d3d5375"]]), TT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z2
}, Symbol.toStringTag, { value: "Module" })), zT = /* @__PURE__ */ A({
  __name: "FriedTree",
  props: {
    items: {},
    childrenKey: {},
    rootExpanded: { type: Boolean }
  },
  emits: ["expand", "collapse"],
  setup(t) {
    return (e, o) => (d(), h("div", null, [
      (d(!0), h(oe, null, ce(e.items, (n, r) => (d(), P(z2, {
        key: r,
        "children-key": e.childrenKey,
        children: n[e.childrenKey],
        item: n,
        "root-expanded": e.rootExpanded,
        root: "",
        onExpand: o[0] || (o[0] = (s) => e.$emit("expand", s)),
        onCollapse: o[1] || (o[1] = (s) => e.$emit("collapse", s))
      }, {
        default: O(({ item: s, root: i, expanded: a }) => [
          C(e.$slots, "default", {
            item: s,
            root: i,
            expanded: a
          })
        ]),
        _: 2
      }, 1032, ["children-key", "children", "item", "root-expanded"]))), 128))
    ]));
  }
}), BT = { class: "icon" }, ET = /* @__PURE__ */ A({
  __name: "FriedTreeItem",
  props: {
    expanded: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    root: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t) {
    return (e, o) => (d(), h("div", {
      class: S(["tree-item", { root: e.root }])
    }, [
      l("button", {
        class: S(["item-content-button", { selected: e.selected }]),
        onClick: o[0] || (o[0] = (n) => e.$emit("click"))
      }, [
        l("div", BT, [
          C(e.$slots, "icon", {}, void 0, !0)
        ]),
        C(e.$slots, "default", {}, void 0, !0)
      ], 2)
    ], 2));
  }
}), PT = /* @__PURE__ */ T(ET, [["__scopeId", "data-v-245e0ae9"]]);
var AT = function() {
  var t = document.getSelection();
  if (!t.rangeCount)
    return function() {
    };
  for (var e = document.activeElement, o = [], n = 0; n < t.rangeCount; n++)
    o.push(t.getRangeAt(n));
  switch (e.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      e.blur();
      break;
    default:
      e = null;
      break;
  }
  return t.removeAllRanges(), function() {
    t.type === "Caret" && t.removeAllRanges(), t.rangeCount || o.forEach(function(r) {
      t.addRange(r);
    }), e && e.focus();
  };
}, LT = AT, ki = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, HT = "Copy to clipboard: #{key}, Enter";
function VT(t) {
  var e = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return t.replace(/#{\s*key\s*}/g, e);
}
function FT(t, e) {
  var o, n, r, s, i, a, c = !1;
  e || (e = {}), o = e.debug || !1;
  try {
    r = LT(), s = document.createRange(), i = document.getSelection(), a = document.createElement("span"), a.textContent = t, a.ariaHidden = "true", a.style.all = "unset", a.style.position = "fixed", a.style.top = 0, a.style.clip = "rect(0, 0, 0, 0)", a.style.whiteSpace = "pre", a.style.webkitUserSelect = "text", a.style.MozUserSelect = "text", a.style.msUserSelect = "text", a.style.userSelect = "text", a.addEventListener("copy", function(f) {
      if (f.stopPropagation(), e.format)
        if (f.preventDefault(), typeof f.clipboardData == "undefined") {
          o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var p = ki[e.format] || ki.default;
          window.clipboardData.setData(p, t);
        } else
          f.clipboardData.clearData(), f.clipboardData.setData(e.format, t);
      e.onCopy && (f.preventDefault(), e.onCopy(f.clipboardData));
    }), document.body.appendChild(a), s.selectNodeContents(a), i.addRange(s);
    var u = document.execCommand("copy");
    if (!u)
      throw new Error("copy command was unsuccessful");
    c = !0;
  } catch (f) {
    o && console.error("unable to copy using execCommand: ", f), o && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(e.format || "text", t), e.onCopy && e.onCopy(window.clipboardData), c = !0;
    } catch (p) {
      o && console.error("unable to copy using clipboardData: ", p), o && console.error("falling back to prompt"), n = VT("message" in e ? e.message : HT), window.prompt(n, t);
    }
  } finally {
    i && (typeof i.removeRange == "function" ? i.removeRange(s) : i.removeAllRanges()), a && document.body.removeChild(a), r();
  }
  return c;
}
var IT = FT;
const DT = /* @__PURE__ */ tc(IT), NT = /* @__PURE__ */ A({
  __name: "FriedInputReadOnly",
  props: {
    label: {},
    value: {},
    dataExternal: { default: void 0 },
    tooltipText: { default: () => ({ copy: "Copy to clipboard", copied: "Copied" }) }
  },
  emits: ["copy"],
  setup(t, { emit: e }) {
    const o = t, n = e, r = I(!1), s = z(
      () => r.value ? o.tooltipText.copied : o.tooltipText.copy
    ), i = () => {
      DT(o.value), r.value = !0, n("copy");
    }, a = () => {
      setTimeout(() => {
        r.value = !1;
      }, 500);
    };
    return (c, u) => (d(), P(_(Wn), {
      "data-external": c.dataExternal,
      label: c.label,
      "model-value": c.value,
      readonly: "",
      active: ""
    }, {
      append: O(() => [
        se((d(), P(_(me), {
          type: "button",
          onClick: i,
          onMouseleave: a,
          onBlur: a
        }, {
          default: O(() => [
            $(_(U), {
              class: "copy-icon",
              icon: "copy"
            })
          ]),
          _: 1
        })), [
          [_(yn), {
            placement: "top",
            distance: 8,
            content: s.value,
            delay: { show: 300, hide: 100 }
          }]
        ])
      ]),
      _: 1
    }, 8, ["data-external", "label", "model-value"]));
  }
}), RT = { class: "popper-info-container" }, qT = /* @__PURE__ */ A({
  __name: "FriedInfoPopper",
  props: {
    placement: { default: "bottom-start" },
    triggerDataExternal: { default: "information-popper-show-button" },
    iconSize: { default: "medium" },
    icon: { default: "info-circle" }
  },
  setup(t) {
    const e = I(!1), o = () => {
      e.value = !1;
    };
    return (n, r) => se((d(), h("div", null, [
      $(_(Zo), {
        show: e.value,
        "main-axis-offset": 8,
        "cross-axis-offset": 0,
        placement: n.placement
      }, {
        reference: O(() => [
          $(_(me), {
            "data-external": n.triggerDataExternal,
            type: "button",
            onClick: r[0] || (r[0] = _e((s) => e.value = !e.value, ["stop", "prevent"])),
            onKeydown: q(o, ["escape"])
          }, {
            default: O(() => [
              $(_(U), {
                size: n.iconSize,
                icon: n.icon
              }, null, 8, ["size", "icon"])
            ]),
            _: 1
          }, 8, ["data-external"])
        ]),
        default: O(() => [
          l("div", RT, [
            C(n.$slots, "default", {}, void 0, !0)
          ])
        ]),
        _: 3
      }, 8, ["show", "placement"])
    ])), [
      [_(io), o]
    ]);
  }
}), WT = /* @__PURE__ */ T(qT, [["__scopeId", "data-v-0f544a74"]]);
var Ft = /* @__PURE__ */ ((t) => (t.Info = "info", t.Success = "success", t.Warning = "warning", t.Danger = "danger", t.Plain = "plain", t))(Ft || {}), Xt = /* @__PURE__ */ ((t) => (t.TopLeft = "top-left", t.TopRight = "top-right", t.BottomLeft = "bottom-left", t.BottomRight = "bottom-right", t))(Xt || {});
const Gt = I([]), gt = I({
  timeout: 5e3,
  placement: Xt.TopRight,
  hideProgress: !1,
  closable: !0,
  type: Ft.Info,
  pauseOnHover: !0,
  listeners: {},
  props: {}
}), ms = () => {
  const t = (u) => {
    const f = Gt.value.findIndex((p) => p.id === u);
    Gt.value.splice(f, 1);
  }, e = (u) => (Gt.value = [...Gt.value, u], u), o = (u, {
    content: f,
    options: p
  }) => {
    const v = Gt.value.find((m) => m.id === u);
    v && (f && (v.content = f), p && (v.options = j(j({}, v.options), p)));
  }, n = (u, f = {}) => {
    const p = {
      id: xe(),
      content: u,
      options: R(j(j({}, gt.value), f), { type: Ft.Success })
    };
    return e(p);
  }, r = (u, f = {}) => {
    const p = {
      id: xe(),
      content: u,
      options: R(j(j({}, gt.value), f), { type: Ft.Info })
    };
    return e(p);
  }, s = (u, f = {}) => {
    const p = {
      id: xe(),
      content: u,
      options: R(j(j({}, gt.value), f), { type: Ft.Warning })
    };
    return e(p);
  }, i = (u, f = {}) => {
    const p = {
      id: xe(),
      content: u,
      options: R(j(j({}, gt.value), f), { type: Ft.Danger })
    };
    return e(p);
  }, a = (u, f = {}) => {
    const p = {
      id: xe(),
      content: u,
      options: R(j(j({}, gt.value), f), { type: Ft.Plain })
    };
    return e(p);
  }, c = ({
    content: u,
    options: f
  }) => {
    const p = {
      id: xe(),
      content: u,
      options: j(j({}, gt.value), f)
    };
    return e(p);
  };
  return c.success = n, c.info = r, c.danger = i, c.warning = s, c.plain = a, {
    queue: Gt,
    toast: c,
    remove: t,
    defaultOptions: gt,
    update: o
  };
}, UT = /* @__PURE__ */ A({
  __name: "FriedToast",
  props: {
    toast: { default: void 0 }
  },
  setup(t) {
    const e = t, { remove: o } = ms(), n = I(null), r = z(() => ({
      "animation-name": "width-animation",
      "animation-direction": "forwards",
      "animation-duration": `${e.toast.options.timeout}ms`,
      "animation-timing-function": "linear"
    }));
    vu(n, "animationend", () => {
      o(e.toast.id);
    });
    const s = z(() => typeof e.toast.content == "string" ? e.toast.content : "");
    return (i, a) => (d(), h("div", {
      class: S(["toast-item", i.toast.options.type]),
      role: "alert"
    }, [
      s.value ? (d(), P(_(ho), {
        key: 0,
        "data-external": `alert-content-msg:${s.value}`
      }, {
        default: O(() => [
          K(F(s.value), 1)
        ]),
        _: 1
      }, 8, ["data-external"])) : (d(), P(ro(i.toast.content), Oe({
        key: 1,
        toast: i.toast
      }, i.toast.options.props, Q2(i.toast.options.listeners)), null, 16, ["toast"])),
      i.toast.options.closable ? (d(), P(_(me), {
        key: 2,
        class: "close-button",
        "data-external": "alert-container-popup",
        "aria-label": "close",
        onClick: a[0] || (a[0] = (c) => _(o)(i.toast.id))
      }, {
        default: O(() => [
          $(_(U), {
            size: "small",
            icon: "close"
          })
        ]),
        _: 1
      })) : E("", !0),
      i.toast.options.timeout ? (d(), h("div", {
        key: 3,
        ref_key: "toastProgress",
        ref: n,
        class: S(["progress", { hide: i.toast.options.hideProgress, pause: i.toast.options.pauseOnHover }]),
        style: re(r.value)
      }, null, 6)) : E("", !0)
    ], 2));
  }
}), Mo = /* @__PURE__ */ T(UT, [["__scopeId", "data-v-40740133"]]), ZT = { class: "toast-wrapper" }, GT = /* @__PURE__ */ A({
  __name: "FriedToasts",
  props: {
    offset: { default: () => ({ top: 16, right: 16, bottom: 16, left: 16 }) }
  },
  setup(t) {
    const e = t, { queue: o } = ms(), n = z(
      () => o.value.filter((u) => u.options.placement === Xt.TopLeft).reverse()
    ), r = z(
      () => o.value.filter((u) => u.options.placement === Xt.TopRight).reverse()
    ), s = z(
      () => o.value.filter((u) => u.options.placement === Xt.BottomLeft)
    ), i = z(
      () => o.value.filter((u) => u.options.placement === Xt.BottomRight)
    ), a = (u) => {
      u instanceof HTMLElement && (u.style.top = `${u.offsetTop}px`, u.style.position = "absolute");
    }, c = z(() => ({
      top: `${e.offset.top}px`,
      right: `${e.offset.right}px`,
      bottom: `${e.offset.bottom}px`,
      left: `${e.offset.left}px`
    }));
    return (u, f) => (d(), h("div", ZT, [
      $(yo, {
        tag: "div",
        name: "toast",
        class: "toast-container top-left",
        style: re(c.value),
        onLeave: a
      }, {
        default: O(() => [
          (d(!0), h(oe, null, ce(n.value, (p) => (d(), P(Mo, {
            key: p.id,
            toast: p
          }, null, 8, ["toast"]))), 128))
        ]),
        _: 1
      }, 8, ["style"]),
      $(yo, {
        tag: "div",
        name: "toast",
        class: "toast-container top-right",
        style: re(c.value),
        onLeave: a
      }, {
        default: O(() => [
          (d(!0), h(oe, null, ce(r.value, (p) => (d(), P(Mo, {
            key: p.id,
            toast: p
          }, null, 8, ["toast"]))), 128))
        ]),
        _: 1
      }, 8, ["style"]),
      $(yo, {
        tag: "div",
        name: "toast",
        class: "toast-container bottom-left",
        style: re(c.value),
        onLeave: a
      }, {
        default: O(() => [
          (d(!0), h(oe, null, ce(s.value, (p) => (d(), P(Mo, {
            key: p.id,
            toast: p
          }, null, 8, ["toast"]))), 128))
        ]),
        _: 1
      }, 8, ["style"]),
      $(yo, {
        tag: "div",
        name: "toast",
        class: "toast-container bottom-right",
        style: re(c.value),
        onLeave: a
      }, {
        default: O(() => [
          (d(!0), h(oe, null, ce(i.value, (p) => (d(), P(Mo, {
            key: p.id,
            toast: p
          }, null, 8, ["toast"]))), 128))
        ]),
        _: 1
      }, 8, ["style"])
    ]));
  }
}), YT = /* @__PURE__ */ T(GT, [["__scopeId", "data-v-6bc2b83b"]]), XT = {}, KT = { class: "segment-button-container" };
function JT(t, e) {
  return d(), h("div", KT, [
    C(t.$slots, "default", {}, void 0, !0)
  ]);
}
const QT = /* @__PURE__ */ T(XT, [["render", JT], ["__scopeId", "data-v-62f5edbd"]]), ez = ["data-external", "disabled"], tz = /* @__PURE__ */ A({
  __name: "FriedSegmentMenuButton",
  props: {
    modelValue: { default: void 0 },
    value: {},
    disabled: { type: Boolean },
    dataExternal: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const o = t, n = z(() => o.value === o.modelValue), r = e, s = () => {
      o.disabled || r("update:modelValue", o.value);
    };
    return (i, a) => se((d(), h("button", {
      class: S(["segment-button", { active: n.value, disabled: i.disabled }]),
      "data-external": i.dataExternal,
      disabled: i.disabled,
      onClick: s
    }, [
      C(i.$slots, "default", {}, void 0, !0)
    ], 10, ez)), [
      [_(ut)]
    ]);
  }
}), oz = /* @__PURE__ */ T(tz, [["__scopeId", "data-v-8763e934"]]), ko = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AvatarSize: so,
  ButtonType: jt,
  FriedAccordion: l9,
  FriedAvatar: To,
  FriedAvatarCounter: Lb,
  FriedAvatarGroup: Vb,
  FriedBackdrop: Jr,
  FriedBottomBar: Kb,
  FriedBreadcrumb: Rb,
  FriedBreadcrumbItem: Zb,
  FriedButton: pn,
  FriedButtonFooterContainer: MT,
  FriedButtonSplit: xT,
  FriedCard: tk,
  FriedCheckbox: Tr,
  FriedChip: hk,
  FriedColorPicker: su,
  FriedColorPickerInput: Yx,
  FriedDatePicker: _2,
  FriedDateTimeInput: F$,
  FriedDropdown: os,
  FriedDropdownItem: U$,
  FriedDropzone: oS,
  FriedEmojiPicker: uj,
  FriedEmptyState: xj,
  FriedFieldSet: Uo,
  FriedFloater: Zo,
  FriedGetAcceptLogo: jj,
  FriedGetAcceptLogoSmall: Ej,
  FriedH1: ax,
  FriedH2: fu,
  FriedH3: Go,
  FriedH4: ho,
  FriedH5: es,
  FriedHelpMessage: Aj,
  FriedIcon: U,
  FriedIconButton: me,
  FriedInfoPopper: WT,
  FriedInlineEmoji: _j,
  FriedInlineInfo: Vj,
  FriedInput: Wn,
  FriedInputReadOnly: NT,
  FriedLabel: Fn,
  FriedLink: Ij,
  FriedList: qj,
  FriedListItem: Zj,
  FriedMessage: Xj,
  FriedMobileContainer: pu,
  FriedModal: tO,
  FriedModalButtonsFooter: lO,
  FriedModalFooter: S2,
  FriedModalHeader: uO,
  FriedModalSubContainer: $2,
  FriedNumericalStepper: pO,
  FriedPagination: _O,
  FriedParagraph: Te,
  FriedProgressBar: kO,
  FriedRadioButton: Ir,
  FriedRoundedButton: MO,
  FriedSearchInput: TO,
  FriedSegmentMenu: QT,
  FriedSegmentMenuButton: oz,
  FriedSelect: Nr,
  FriedSelectInput: w2,
  FriedSelectOption: Dr,
  FriedSideSheet: EO,
  FriedSkeleton: LO,
  FriedSpinner: Kr,
  FriedStatusBadge: VO,
  FriedSwitch: DO,
  FriedTab: qO,
  FriedTable: GO,
  FriedTableCell: O2,
  FriedTableCheckboxCell: eT,
  FriedTableFooter: rT,
  FriedTableFooterCell: iT,
  FriedTableHeader: uT,
  FriedTableHeaderCell: T2,
  FriedTableRow: fT,
  FriedTextarea: vT,
  FriedToast: Mo,
  FriedToasts: YT,
  FriedTooltip: yb,
  FriedTree: zT,
  FriedTreeItem: PT,
  IconSize: He,
  InputType: xn,
  LabelSize: qt,
  MessageType: We,
  ModalSize: hs,
  ParagraphSize: Ye,
  Placement: co,
  ProgressBarType: fs,
  SearchInputSize: ps,
  SkeletonType: Po,
  SortOrder: Bn,
  StatusType: j2,
  TabType: Ao,
  TableAlign: tn,
  defaultOptions: gt,
  useToast: ms
}, Symbol.toStringTag, { value: "Module" })), iz = {
  install: (t) => {
    Object.keys(ko).filter((n) => n.includes("Fried")).forEach((n) => {
      ko[n] && t.component(n, ko[n]);
    }), Object.keys($x).filter((n) => n.includes("Transition")).forEach((n) => {
      ko[n] && t.component(n, ko[n]);
    }), t.directive("wave", ut), t.directive("Autofocus", _9), t.directive("ClickOutside", io), t.directive("AppendToBody", v9), t.directive("tooltip", yn);
  }
};
export {
  so as AvatarSize,
  qe as Breakpoint,
  jt as ButtonType,
  l9 as FriedAccordion,
  To as FriedAvatar,
  Lb as FriedAvatarCounter,
  Vb as FriedAvatarGroup,
  Jr as FriedBackdrop,
  Kb as FriedBottomBar,
  Rb as FriedBreadcrumb,
  Zb as FriedBreadcrumbItem,
  pn as FriedButton,
  MT as FriedButtonFooterContainer,
  xT as FriedButtonSplit,
  tk as FriedCard,
  Tr as FriedCheckbox,
  hk as FriedChip,
  su as FriedColorPicker,
  Yx as FriedColorPickerInput,
  _2 as FriedDatePicker,
  F$ as FriedDateTimeInput,
  os as FriedDropdown,
  U$ as FriedDropdownItem,
  oS as FriedDropzone,
  uj as FriedEmojiPicker,
  xj as FriedEmptyState,
  Uo as FriedFieldSet,
  Zo as FriedFloater,
  jj as FriedGetAcceptLogo,
  Ej as FriedGetAcceptLogoSmall,
  ax as FriedH1,
  fu as FriedH2,
  Go as FriedH3,
  ho as FriedH4,
  es as FriedH5,
  Aj as FriedHelpMessage,
  U as FriedIcon,
  me as FriedIconButton,
  WT as FriedInfoPopper,
  _j as FriedInlineEmoji,
  Vj as FriedInlineInfo,
  Wn as FriedInput,
  NT as FriedInputReadOnly,
  Fn as FriedLabel,
  Ij as FriedLink,
  qj as FriedList,
  Zj as FriedListItem,
  Xj as FriedMessage,
  pu as FriedMobileContainer,
  tO as FriedModal,
  lO as FriedModalButtonsFooter,
  S2 as FriedModalFooter,
  uO as FriedModalHeader,
  $2 as FriedModalSubContainer,
  pO as FriedNumericalStepper,
  _O as FriedPagination,
  Te as FriedParagraph,
  kO as FriedProgressBar,
  Ir as FriedRadioButton,
  MO as FriedRoundedButton,
  TO as FriedSearchInput,
  QT as FriedSegmentMenu,
  oz as FriedSegmentMenuButton,
  Nr as FriedSelect,
  w2 as FriedSelectInput,
  Dr as FriedSelectOption,
  EO as FriedSideSheet,
  LO as FriedSkeleton,
  Kr as FriedSpinner,
  VO as FriedStatusBadge,
  DO as FriedSwitch,
  qO as FriedTab,
  GO as FriedTable,
  O2 as FriedTableCell,
  eT as FriedTableCheckboxCell,
  rT as FriedTableFooter,
  iT as FriedTableFooterCell,
  uT as FriedTableHeader,
  T2 as FriedTableHeaderCell,
  fT as FriedTableRow,
  vT as FriedTextarea,
  Mo as FriedToast,
  YT as FriedToasts,
  yb as FriedTooltip,
  zT as FriedTree,
  PT as FriedTreeItem,
  He as IconSize,
  xn as InputType,
  qt as LabelSize,
  We as MessageType,
  hs as ModalSize,
  Ye as ParagraphSize,
  co as Placement,
  fs as ProgressBarType,
  ou as RainbowColor,
  eo as RainbowColorHelper,
  ps as SearchInputSize,
  Po as SkeletonType,
  Yo as SlideOrigin,
  Bn as SortOrder,
  j2 as StatusType,
  Ao as TabType,
  tn as TableAlign,
  Mx as TransitionAppearList,
  $d as TransitionExpand,
  nu as TransitionFadeInOut,
  yx as TransitionSlideAndFadeInOut,
  ts as TransitionSlideInOut,
  iz as default,
  gt as defaultOptions,
  No as friedTofuSettings,
  ms as useToast,
  v9 as vAppendToBody,
  _9 as vAutofocus,
  io as vClickOutside,
  yn as vTooltip,
  ut as vWave
};
